webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18f37940",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return windowMessaging; });
/**
 * Used to interact with the parent window when the designer
 * is loaded in an iframe, etc. Javascript on the parent side
 * can intercept these messages and interpret as needed.
 * @type {Object}
 */
var windowMessaging = {
    data: function data() {
        return {};
    },

    methods: {
        /**
         * Default function used to post to iframe window
         * @param  {Object}
         */
        postMsg: function postMsg(data) {
            parent.window.postMessage(data, '*');
        },

        /**
         * Called to post to parent window when the page is resized
         * @param  {Number}
         * @param  {Number}
         */
        windowMsgTemplateResize: function windowMsgTemplateResize(height, width) {
            this.postMsg({ 'type': 'templateResize', 'height': height, 'width': width });
        },
        windowMsgLoaded: function windowMsgLoaded() {
            this.postMsg({ 'type': 'loaded' });
        },

        /**
         * Called to post to the parent window when the template has been updated (saved)
         * @param  {Object}
         */
        windowMsgTemplateUpdate: function windowMsgTemplateUpdate(data) {
            this.postMsg({ 'type': 'templateUpdate', 'data': data });
        },

        /**
         * Called to post to the parent window when the template status has changed (saved / unsaved)
         * @param  {Object}
         */
        windowMsgTemplateStatus: function windowMsgTemplateStatus(data) {
            this.postMsg({ 'type': 'templateStatus', 'data': data });
        },
        windowMsgScrollToIframe: function windowMsgScrollToIframe() {
            this.postMsg({ 'type': 'scrollToiFrame', 'data': { 'scroll': true } });
        },
        windowMsgLockWindow: function windowMsgLockWindow() {
            var $status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.postMsg({ 'type': 'windowLock', 'data': { 'status': $status } });
        },
        windowMsgDownloadFiles: function windowMsgDownloadFiles(url) {
            this.postMsg({ 'type': 'downloadFiles', 'data': { 'url': url } });
        }
    }
};

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

module.exports = {
    getCurrentVendorID: function getCurrentVendorID(user, url) {
        if (user && url) {
            var currentVendor = user.vendor && user.vendor.data ? user.vendor.data : null;

            if (currentVendor) {
                // check if an admin user of a vendor is trying to see a children vendor
                if (user.vendor.data.admins && user.vendor.data.admins.includes(user.email) && user.vendor.data.childrens && user.vendor.data.childrens.length) {
                    var cvendor = user.vendor.data.childrens.filter(function (vendor) {
                        return url.includes(vendor.slug);
                    });
                    if (cvendor.length) return cvendor[0].id;
                }

                // check if it's trying to see a vendor that has permission to see
                if (user.vendors_template_access !== undefined && user.vendors_template_access.length) {
                    var _cvendor = user.vendors_template_access.filter(function (vendor) {
                        return url.includes(vendor.slug);
                    });
                    if (_cvendor.length) return _cvendor[0].id;
                }

                return currentVendor.id;
            }
        }
        return null;
    }
};

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return templateSaving; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * Used to interact with the parent window when the designer
 * is loaded in an iframe, etc. Javascript on the parent side
 * can intercept these messages and interpret as needed.
 * @type {Object}
 */
/* global Helpers */

var templateSaving = {
    data: function data() {
        return {
            canvas: null,
            canvasData: [],
            templateName: null
            // savedTemplateUuid: null
        };
    },

    methods: {
        initNewSavedTemplate: function initNewSavedTemplate() {
            var _this = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.templateName = new Date().getUTCMilliseconds();

            var data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: '{}'
            };

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName);
                this.$store.commit('savedTemplate', this.$store.state.template);
            }

            this.axios.post('templates/saved/create', data).then(function (response) {
                _this.savedTemplateUuid = response.data.data.id;
            }).catch(function (err) {
                Helpers.errorPop('Error', err.response.data.message);
            });
            if (callback !== null) {
                callback();
            }
        },
        saveAsNewTemplate: function saveAsNewTemplate() {
            var _this2 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var $event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var currentText = null;
            if ($event) {
                currentText = $event.target.innerText;
                $('.saveButtons').attr('disabled', 'disabled');
                $event.target.innerText = 'Processing, please wait..';
            }
            var templateData = this.extractTemplateData();
            var data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: templateData
            };

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName);
                this.$store.commit('savedTemplate', this.$store.state.template);
            }

            // this.axios.put('templates/saved/' + this.savedTemplateUuid, data)
            this.axios.post('templates/saved/create', data).then(function (response) {
                _this2.setTemplateFiles(response.data.data.data);
                _this2.setTemplateData(response.data.data);
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled');
                    $event.target.innerText = currentText;
                }
            }).catch(function (err) {
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled');
                    $event.target.innerText = currentText;
                }
                Helpers.errorPop('Error', err.response.data.message);
            });
            if (callback !== null) {
                callback();
            }
        },
        deleteSavedTemplate: function deleteSavedTemplate(id) {},
        updateExistingTemplate: function updateExistingTemplate() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var $event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var currentText = null;
            if ($event) {
                currentText = $event.target.innerText;
                $('.saveButtons').attr('disabled', 'disabled');
                $event.target.innerText = 'Processing, please wait..';
            }
            var templateId = this.$store.state.savedTemplate.id;
            var templateData = this.extractTemplateData();
            var data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: templateData
            };

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName);
                this.$store.commit('savedTemplate', this.$store.state.template);
            }

            this.axios.put('templates/saved/' + templateId, data).then(function (response) {
                _this3.setTemplateFiles(response.data.data.data);
                _this3.setTemplateData(response.data.data);
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled');
                    $event.target.innerText = currentText;
                }
            }).catch(function (err) {
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled');
                    $event.target.innerText = currentText;
                }
                Helpers.errorPop('Error', err.response.data.message);
            });
            if (callback !== null) {
                callback();
            }
        },
        extractTemplateData: function extractTemplateData() {
            this.generateImage();
            this.exportData();
            var files = this.$store.state.template.files;
            var data = {};
            for (var x in files) {
                if (data[x] === undefined) {
                    data[x] = {};
                    data[x].json = {};
                }

                data[x].name = files[x].name;
                data[x].json.objects = files[x].json.objects;
                data[x].preview = files[x].preview;

                if (files[x].printReady) {
                    data[x].printReady = files[x].printReady;
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        },
        injectTemplateData: function injectTemplateData(data) {
            var activeTemplate = this.$store.state.activeTemplate;
            var savedTemplateData = data.data;

            // Unclip All Masks
            for (var i in this.canvasData) {
                if (this.canvasData[i].clipTo !== null) {
                    this.canvasData[i].clipTo = null;
                }
            }

            var template = this.$store.state.template;
            var files = template.files;
            for (var x in files) {
                if (savedTemplateData[x] !== undefined) {
                    for (var _i in savedTemplateData[x].json.objects) {
                        var item = savedTemplateData[x].json.objects[_i];
                        if (item.custom !== undefined && item.custom.confirmed !== undefined) {
                            item.custom.confirmed = false;
                        }
                    }
                    files[x].json.objects = savedTemplateData[x].json.objects;
                }
            }

            template.files = files;
            this.$store.commit('template', template);
            this.setTemplateData(data);

            // Reapply All Masks
            this.applyAllMasks();

            this.canvasLoad(activeTemplate);
        },
        setTemplateData: function setTemplateData(data) {
            this.templateName = data.name;
            this.$store.commit('templateName', data.name);
            this.$store.commit('savedTemplate', data);
        },
        setTemplateFiles: function setTemplateFiles(data) {
            var template = this.$store.state.template;
            var files = template.files;

            for (var x in files) {
                files[x].preview = data[x].preview;
                if (data[x].printReady) {
                    files[x].printReady = data[x].printReady;
                }
            }

            template.files = files;
            this.$store.commit('savedTemplate', template);
        }
    }
};

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
__webpack_require__(123);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
module.exports = __webpack_require__(127);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function (a, b) {
  "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(module)) && "object" == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(module.exports) ? module.exports = a.document ? b(a, !0) : function (a) {
    if (!a.document) throw new Error("jQuery requires a window with a document");return b(a);
  } : b(a);
}("undefined" != typeof window ? window : this, function (a, b) {
  var c = [],
      d = c.slice,
      e = c.concat,
      f = c.push,
      g = c.indexOf,
      h = {},
      i = h.toString,
      j = h.hasOwnProperty,
      k = {},
      l = a.document,
      m = "2.1.4",
      n = function n(a, b) {
    return new n.fn.init(a, b);
  },
      o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      p = /^-ms-/,
      q = /-([\da-z])/gi,
      r = function r(a, b) {
    return b.toUpperCase();
  };n.fn = n.prototype = { jquery: m, constructor: n, selector: "", length: 0, toArray: function toArray() {
      return d.call(this);
    }, get: function get(a) {
      return null != a ? 0 > a ? this[a + this.length] : this[a] : d.call(this);
    }, pushStack: function pushStack(a) {
      var b = n.merge(this.constructor(), a);return b.prevObject = this, b.context = this.context, b;
    }, each: function each(a, b) {
      return n.each(this, a, b);
    }, map: function map(a) {
      return this.pushStack(n.map(this, function (b, c) {
        return a.call(b, c, b);
      }));
    }, slice: function slice() {
      return this.pushStack(d.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(a) {
      var b = this.length,
          c = +a + (0 > a ? b : 0);return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
    }, end: function end() {
      return this.prevObject || this.constructor(null);
    }, push: f, sort: c.sort, splice: c.splice }, n.extend = n.fn.extend = function () {
    var a,
        b,
        c,
        d,
        e,
        f,
        g = arguments[0] || {},
        h = 1,
        i = arguments.length,
        j = !1;for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == (typeof g === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(g)) || n.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++) {
      if (null != (a = arguments[h])) for (b in a) {
        c = g[b], d = a[b], g !== d && (j && d && (n.isPlainObject(d) || (e = n.isArray(d))) ? (e ? (e = !1, f = c && n.isArray(c) ? c : []) : f = c && n.isPlainObject(c) ? c : {}, g[b] = n.extend(j, f, d)) : void 0 !== d && (g[b] = d));
      }
    }return g;
  }, n.extend({ expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(a) {
      throw new Error(a);
    }, noop: function noop() {}, isFunction: function isFunction(a) {
      return "function" === n.type(a);
    }, isArray: Array.isArray, isWindow: function isWindow(a) {
      return null != a && a === a.window;
    }, isNumeric: function isNumeric(a) {
      return !n.isArray(a) && a - parseFloat(a) + 1 >= 0;
    }, isPlainObject: function isPlainObject(a) {
      return "object" !== n.type(a) || a.nodeType || n.isWindow(a) ? !1 : a.constructor && !j.call(a.constructor.prototype, "isPrototypeOf") ? !1 : !0;
    }, isEmptyObject: function isEmptyObject(a) {
      var b;for (b in a) {
        return !1;
      }return !0;
    }, type: function type(a) {
      return null == a ? a + "" : "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) || "function" == typeof a ? h[i.call(a)] || "object" : typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a);
    }, globalEval: function globalEval(a) {
      var b,
          c = eval;a = n.trim(a), a && (1 === a.indexOf("use strict") ? (b = l.createElement("script"), b.text = a, l.head.appendChild(b).parentNode.removeChild(b)) : c(a));
    }, camelCase: function camelCase(a) {
      return a.replace(p, "ms-").replace(q, r);
    }, nodeName: function nodeName(a, b) {
      return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
    }, each: function each(a, b, c) {
      var d,
          e = 0,
          f = a.length,
          g = s(a);if (c) {
        if (g) {
          for (; f > e; e++) {
            if (d = b.apply(a[e], c), d === !1) break;
          }
        } else for (e in a) {
          if (d = b.apply(a[e], c), d === !1) break;
        }
      } else if (g) {
        for (; f > e; e++) {
          if (d = b.call(a[e], e, a[e]), d === !1) break;
        }
      } else for (e in a) {
        if (d = b.call(a[e], e, a[e]), d === !1) break;
      }return a;
    }, trim: function trim(a) {
      return null == a ? "" : (a + "").replace(o, "");
    }, makeArray: function makeArray(a, b) {
      var c = b || [];return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [a] : a) : f.call(c, a)), c;
    }, inArray: function inArray(a, b, c) {
      return null == b ? -1 : g.call(b, a, c);
    }, merge: function merge(a, b) {
      for (var c = +b.length, d = 0, e = a.length; c > d; d++) {
        a[e++] = b[d];
      }return a.length = e, a;
    }, grep: function grep(a, b, c) {
      for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) {
        d = !b(a[f], f), d !== h && e.push(a[f]);
      }return e;
    }, map: function map(a, b, c) {
      var d,
          f = 0,
          g = a.length,
          h = s(a),
          i = [];if (h) for (; g > f; f++) {
        d = b(a[f], f, c), null != d && i.push(d);
      } else for (f in a) {
        d = b(a[f], f, c), null != d && i.push(d);
      }return e.apply([], i);
    }, guid: 1, proxy: function proxy(a, b) {
      var c, e, f;return "string" == typeof b && (c = a[b], b = a, a = c), n.isFunction(a) ? (e = d.call(arguments, 2), f = function f() {
        return a.apply(b || this, e.concat(d.call(arguments)));
      }, f.guid = a.guid = a.guid || n.guid++, f) : void 0;
    }, now: Date.now, support: k }), n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (a, b) {
    h["[object " + b + "]"] = b.toLowerCase();
  });function s(a) {
    var b = "length" in a && a.length,
        c = n.type(a);return "function" === c || n.isWindow(a) ? !1 : 1 === a.nodeType && b ? !0 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a;
  }var t = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u = "sizzle" + 1 * new Date(),
        v = a.document,
        w = 0,
        x = 0,
        y = ha(),
        z = ha(),
        A = ha(),
        B = function B(a, b) {
      return a === b && (l = !0), 0;
    },
        C = 1 << 31,
        D = {}.hasOwnProperty,
        E = [],
        F = E.pop,
        G = E.push,
        H = E.push,
        I = E.slice,
        J = function J(a, b) {
      for (var c = 0, d = a.length; d > c; c++) {
        if (a[c] === b) return c;
      }return -1;
    },
        K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        L = "[\\x20\\t\\r\\n\\f]",
        M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        N = M.replace("w", "w#"),
        O = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + N + "))|)" + L + "*\\]",
        P = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + O + ")*)|.*)\\)|)",
        Q = new RegExp(L + "+", "g"),
        R = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
        S = new RegExp("^" + L + "*," + L + "*"),
        T = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
        U = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
        V = new RegExp(P),
        W = new RegExp("^" + N + "$"),
        X = { ID: new RegExp("^#(" + M + ")"), CLASS: new RegExp("^\\.(" + M + ")"), TAG: new RegExp("^(" + M.replace("w", "w*") + ")"), ATTR: new RegExp("^" + O), PSEUDO: new RegExp("^" + P), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"), bool: new RegExp("^(?:" + K + ")$", "i"), needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i") },
        Y = /^(?:input|select|textarea|button)$/i,
        Z = /^h\d$/i,
        $ = /^[^{]+\{\s*\[native \w/,
        _ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        aa = /[+~]/,
        ba = /'|\\/g,
        ca = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
        da = function da(a, b, c) {
      var d = "0x" + b - 65536;return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
    },
        ea = function ea() {
      m();
    };try {
      H.apply(E = I.call(v.childNodes), v.childNodes), E[v.childNodes.length].nodeType;
    } catch (fa) {
      H = { apply: E.length ? function (a, b) {
          G.apply(a, I.call(b));
        } : function (a, b) {
          var c = a.length,
              d = 0;while (a[c++] = b[d++]) {}a.length = c - 1;
        } };
    }function ga(a, b, d, e) {
      var f, h, j, k, l, o, r, s, w, x;if ((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, d = d || [], k = b.nodeType, "string" != typeof a || !a || 1 !== k && 9 !== k && 11 !== k) return d;if (!e && p) {
        if (11 !== k && (f = _.exec(a))) if (j = f[1]) {
          if (9 === k) {
            if (h = b.getElementById(j), !h || !h.parentNode) return d;if (h.id === j) return d.push(h), d;
          } else if (b.ownerDocument && (h = b.ownerDocument.getElementById(j)) && t(b, h) && h.id === j) return d.push(h), d;
        } else {
          if (f[2]) return H.apply(d, b.getElementsByTagName(a)), d;if ((j = f[3]) && c.getElementsByClassName) return H.apply(d, b.getElementsByClassName(j)), d;
        }if (c.qsa && (!q || !q.test(a))) {
          if (s = r = u, w = b, x = 1 !== k && a, 1 === k && "object" !== b.nodeName.toLowerCase()) {
            o = g(a), (r = b.getAttribute("id")) ? s = r.replace(ba, "\\$&") : b.setAttribute("id", s), s = "[id='" + s + "'] ", l = o.length;while (l--) {
              o[l] = s + ra(o[l]);
            }w = aa.test(a) && pa(b.parentNode) || b, x = o.join(",");
          }if (x) try {
            return H.apply(d, w.querySelectorAll(x)), d;
          } catch (y) {} finally {
            r || b.removeAttribute("id");
          }
        }
      }return i(a.replace(R, "$1"), b, d, e);
    }function ha() {
      var a = [];function b(c, e) {
        return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e;
      }return b;
    }function ia(a) {
      return a[u] = !0, a;
    }function ja(a) {
      var b = n.createElement("div");try {
        return !!a(b);
      } catch (c) {
        return !1;
      } finally {
        b.parentNode && b.parentNode.removeChild(b), b = null;
      }
    }function ka(a, b) {
      var c = a.split("|"),
          e = a.length;while (e--) {
        d.attrHandle[c[e]] = b;
      }
    }function la(a, b) {
      var c = b && a,
          d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);if (d) return d;if (c) while (c = c.nextSibling) {
        if (c === b) return -1;
      }return a ? 1 : -1;
    }function ma(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return "input" === c && b.type === a;
      };
    }function na(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();return ("input" === c || "button" === c) && b.type === a;
      };
    }function oa(a) {
      return ia(function (b) {
        return b = +b, ia(function (c, d) {
          var e,
              f = a([], c.length, b),
              g = f.length;while (g--) {
            c[e = f[g]] && (c[e] = !(d[e] = c[e]));
          }
        });
      });
    }function pa(a) {
      return a && "undefined" != typeof a.getElementsByTagName && a;
    }c = ga.support = {}, f = ga.isXML = function (a) {
      var b = a && (a.ownerDocument || a).documentElement;return b ? "HTML" !== b.nodeName : !1;
    }, m = ga.setDocument = function (a) {
      var b,
          e,
          g = a ? a.ownerDocument || a : v;return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = g.documentElement, e = g.defaultView, e && e !== e.top && (e.addEventListener ? e.addEventListener("unload", ea, !1) : e.attachEvent && e.attachEvent("onunload", ea)), p = !f(g), c.attributes = ja(function (a) {
        return a.className = "i", !a.getAttribute("className");
      }), c.getElementsByTagName = ja(function (a) {
        return a.appendChild(g.createComment("")), !a.getElementsByTagName("*").length;
      }), c.getElementsByClassName = $.test(g.getElementsByClassName), c.getById = ja(function (a) {
        return o.appendChild(a).id = u, !g.getElementsByName || !g.getElementsByName(u).length;
      }), c.getById ? (d.find.ID = function (a, b) {
        if ("undefined" != typeof b.getElementById && p) {
          var c = b.getElementById(a);return c && c.parentNode ? [c] : [];
        }
      }, d.filter.ID = function (a) {
        var b = a.replace(ca, da);return function (a) {
          return a.getAttribute("id") === b;
        };
      }) : (delete d.find.ID, d.filter.ID = function (a) {
        var b = a.replace(ca, da);return function (a) {
          var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");return c && c.value === b;
        };
      }), d.find.TAG = c.getElementsByTagName ? function (a, b) {
        return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0;
      } : function (a, b) {
        var c,
            d = [],
            e = 0,
            f = b.getElementsByTagName(a);if ("*" === a) {
          while (c = f[e++]) {
            1 === c.nodeType && d.push(c);
          }return d;
        }return f;
      }, d.find.CLASS = c.getElementsByClassName && function (a, b) {
        return p ? b.getElementsByClassName(a) : void 0;
      }, r = [], q = [], (c.qsa = $.test(g.querySelectorAll)) && (ja(function (a) {
        o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\f]' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]");
      }), ja(function (a) {
        var b = g.createElement("input");b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:");
      })), (c.matchesSelector = $.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ja(function (a) {
        c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", P);
      }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = $.test(o.compareDocumentPosition), t = b || $.test(o.contains) ? function (a, b) {
        var c = 9 === a.nodeType ? a.documentElement : a,
            d = b && b.parentNode;return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
      } : function (a, b) {
        if (b) while (b = b.parentNode) {
          if (b === a) return !0;
        }return !1;
      }, B = b ? function (a, b) {
        if (a === b) return l = !0, 0;var d = !a.compareDocumentPosition - !b.compareDocumentPosition;return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === g || a.ownerDocument === v && t(v, a) ? -1 : b === g || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1);
      } : function (a, b) {
        if (a === b) return l = !0, 0;var c,
            d = 0,
            e = a.parentNode,
            f = b.parentNode,
            h = [a],
            i = [b];if (!e || !f) return a === g ? -1 : b === g ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;if (e === f) return la(a, b);c = a;while (c = c.parentNode) {
          h.unshift(c);
        }c = b;while (c = c.parentNode) {
          i.unshift(c);
        }while (h[d] === i[d]) {
          d++;
        }return d ? la(h[d], i[d]) : h[d] === v ? -1 : i[d] === v ? 1 : 0;
      }, g) : n;
    }, ga.matches = function (a, b) {
      return ga(a, null, null, b);
    }, ga.matchesSelector = function (a, b) {
      if ((a.ownerDocument || a) !== n && m(a), b = b.replace(U, "='$1']"), !(!c.matchesSelector || !p || r && r.test(b) || q && q.test(b))) try {
        var d = s.call(a, b);if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
      } catch (e) {}return ga(b, n, null, [a]).length > 0;
    }, ga.contains = function (a, b) {
      return (a.ownerDocument || a) !== n && m(a), t(a, b);
    }, ga.attr = function (a, b) {
      (a.ownerDocument || a) !== n && m(a);var e = d.attrHandle[b.toLowerCase()],
          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null;
    }, ga.error = function (a) {
      throw new Error("Syntax error, unrecognized expression: " + a);
    }, ga.uniqueSort = function (a) {
      var b,
          d = [],
          e = 0,
          f = 0;if (l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l) {
        while (b = a[f++]) {
          b === a[f] && (e = d.push(f));
        }while (e--) {
          a.splice(d[e], 1);
        }
      }return k = null, a;
    }, e = ga.getText = function (a) {
      var b,
          c = "",
          d = 0,
          f = a.nodeType;if (f) {
        if (1 === f || 9 === f || 11 === f) {
          if ("string" == typeof a.textContent) return a.textContent;for (a = a.firstChild; a; a = a.nextSibling) {
            c += e(a);
          }
        } else if (3 === f || 4 === f) return a.nodeValue;
      } else while (b = a[d++]) {
        c += e(b);
      }return c;
    }, d = ga.selectors = { cacheLength: 50, createPseudo: ia, match: X, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(a) {
          return a[1] = a[1].replace(ca, da), a[3] = (a[3] || a[4] || a[5] || "").replace(ca, da), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
        }, CHILD: function CHILD(a) {
          return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || ga.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && ga.error(a[0]), a;
        }, PSEUDO: function PSEUDO(a) {
          var b,
              c = !a[6] && a[2];return X.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && V.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
        } }, filter: { TAG: function TAG(a) {
          var b = a.replace(ca, da).toLowerCase();return "*" === a ? function () {
            return !0;
          } : function (a) {
            return a.nodeName && a.nodeName.toLowerCase() === b;
          };
        }, CLASS: function CLASS(a) {
          var b = y[a + " "];return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) && y(a, function (a) {
            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(a, b, c) {
          return function (d) {
            var e = ga.attr(d, a);return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(Q, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0;
          };
        }, CHILD: function CHILD(a, b, c, d, e) {
          var f = "nth" !== a.slice(0, 3),
              g = "last" !== a.slice(-4),
              h = "of-type" === b;return 1 === d && 0 === e ? function (a) {
            return !!a.parentNode;
          } : function (b, c, i) {
            var j,
                k,
                l,
                m,
                n,
                o,
                p = f !== g ? "nextSibling" : "previousSibling",
                q = b.parentNode,
                r = h && b.nodeName.toLowerCase(),
                s = !i && !h;if (q) {
              if (f) {
                while (p) {
                  l = b;while (l = l[p]) {
                    if (h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) return !1;
                  }o = p = "only" === a && !o && "nextSibling";
                }return !0;
              }if (o = [g ? q.firstChild : q.lastChild], g && s) {
                k = q[u] || (q[u] = {}), j = k[a] || [], n = j[0] === w && j[1], m = j[0] === w && j[2], l = n && q.childNodes[n];while (l = ++n && l && l[p] || (m = n = 0) || o.pop()) {
                  if (1 === l.nodeType && ++m && l === b) {
                    k[a] = [w, n, m];break;
                  }
                }
              } else if (s && (j = (b[u] || (b[u] = {}))[a]) && j[0] === w) m = j[1];else while (l = ++n && l && l[p] || (m = n = 0) || o.pop()) {
                if ((h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) && ++m && (s && ((l[u] || (l[u] = {}))[a] = [w, m]), l === b)) break;
              }return m -= e, m === d || m % d === 0 && m / d >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(a, b) {
          var c,
              e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || ga.error("unsupported pseudo: " + a);return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ia(function (a, c) {
            var d,
                f = e(a, b),
                g = f.length;while (g--) {
              d = J(a, f[g]), a[d] = !(c[d] = f[g]);
            }
          }) : function (a) {
            return e(a, 0, c);
          }) : e;
        } }, pseudos: { not: ia(function (a) {
          var b = [],
              c = [],
              d = h(a.replace(R, "$1"));return d[u] ? ia(function (a, b, c, e) {
            var f,
                g = d(a, null, e, []),
                h = a.length;while (h--) {
              (f = g[h]) && (a[h] = !(b[h] = f));
            }
          }) : function (a, e, f) {
            return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop();
          };
        }), has: ia(function (a) {
          return function (b) {
            return ga(a, b).length > 0;
          };
        }), contains: ia(function (a) {
          return a = a.replace(ca, da), function (b) {
            return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
          };
        }), lang: ia(function (a) {
          return W.test(a || "") || ga.error("unsupported lang: " + a), a = a.replace(ca, da).toLowerCase(), function (b) {
            var c;do {
              if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-");
            } while ((b = b.parentNode) && 1 === b.nodeType);return !1;
          };
        }), target: function target(b) {
          var c = a.location && a.location.hash;return c && c.slice(1) === b.id;
        }, root: function root(a) {
          return a === o;
        }, focus: function focus(a) {
          return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
        }, enabled: function enabled(a) {
          return a.disabled === !1;
        }, disabled: function disabled(a) {
          return a.disabled === !0;
        }, checked: function checked(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && !!a.checked || "option" === b && !!a.selected;
        }, selected: function selected(a) {
          return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
        }, empty: function empty(a) {
          for (a = a.firstChild; a; a = a.nextSibling) {
            if (a.nodeType < 6) return !1;
          }return !0;
        }, parent: function parent(a) {
          return !d.pseudos.empty(a);
        }, header: function header(a) {
          return Z.test(a.nodeName);
        }, input: function input(a) {
          return Y.test(a.nodeName);
        }, button: function button(a) {
          var b = a.nodeName.toLowerCase();return "input" === b && "button" === a.type || "button" === b;
        }, text: function text(a) {
          var b;return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
        }, first: oa(function () {
          return [0];
        }), last: oa(function (a, b) {
          return [b - 1];
        }), eq: oa(function (a, b, c) {
          return [0 > c ? c + b : c];
        }), even: oa(function (a, b) {
          for (var c = 0; b > c; c += 2) {
            a.push(c);
          }return a;
        }), odd: oa(function (a, b) {
          for (var c = 1; b > c; c += 2) {
            a.push(c);
          }return a;
        }), lt: oa(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; --d >= 0;) {
            a.push(d);
          }return a;
        }), gt: oa(function (a, b, c) {
          for (var d = 0 > c ? c + b : c; ++d < b;) {
            a.push(d);
          }return a;
        }) } }, d.pseudos.nth = d.pseudos.eq;for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      d.pseudos[b] = ma(b);
    }for (b in { submit: !0, reset: !0 }) {
      d.pseudos[b] = na(b);
    }function qa() {}qa.prototype = d.filters = d.pseudos, d.setFilters = new qa(), g = ga.tokenize = function (a, b) {
      var c,
          e,
          f,
          g,
          h,
          i,
          j,
          k = z[a + " "];if (k) return b ? 0 : k.slice(0);h = a, i = [], j = d.preFilter;while (h) {
        (!c || (e = S.exec(h))) && (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = T.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(R, " ") }), h = h.slice(c.length));for (g in d.filter) {
          !(e = X[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length));
        }if (!c) break;
      }return b ? h.length : h ? ga.error(a) : z(a, i).slice(0);
    };function ra(a) {
      for (var b = 0, c = a.length, d = ""; c > b; b++) {
        d += a[b].value;
      }return d;
    }function sa(a, b, c) {
      var d = b.dir,
          e = c && "parentNode" === d,
          f = x++;return b.first ? function (b, c, f) {
        while (b = b[d]) {
          if (1 === b.nodeType || e) return a(b, c, f);
        }
      } : function (b, c, g) {
        var h,
            i,
            j = [w, f];if (g) {
          while (b = b[d]) {
            if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
          }
        } else while (b = b[d]) {
          if (1 === b.nodeType || e) {
            if (i = b[u] || (b[u] = {}), (h = i[d]) && h[0] === w && h[1] === f) return j[2] = h[2];if (i[d] = j, j[2] = a(b, c, g)) return !0;
          }
        }
      };
    }function ta(a) {
      return a.length > 1 ? function (b, c, d) {
        var e = a.length;while (e--) {
          if (!a[e](b, c, d)) return !1;
        }return !0;
      } : a[0];
    }function ua(a, b, c) {
      for (var d = 0, e = b.length; e > d; d++) {
        ga(a, b[d], c);
      }return c;
    }function va(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++) {
        (f = a[h]) && (!c || c(f, d, e)) && (g.push(f), j && b.push(h));
      }return g;
    }function wa(a, b, c, d, e, f) {
      return d && !d[u] && (d = wa(d)), e && !e[u] && (e = wa(e, f)), ia(function (f, g, h, i) {
        var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            p = f || ua(b || "*", h.nodeType ? [h] : h, []),
            q = !a || !f && b ? p : va(p, m, a, h, i),
            r = c ? e || (f ? a : o || d) ? [] : g : q;if (c && c(q, r, h, i), d) {
          j = va(r, n), d(j, [], h, i), k = j.length;while (k--) {
            (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
          }
        }if (f) {
          if (e || a) {
            if (e) {
              j = [], k = r.length;while (k--) {
                (l = r[k]) && j.push(q[k] = l);
              }e(null, r = [], j, i);
            }k = r.length;while (k--) {
              (l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l));
            }
          }
        } else r = va(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : H.apply(g, r);
      });
    }function xa(a) {
      for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = sa(function (a) {
        return a === b;
      }, h, !0), l = sa(function (a) {
        return J(b, a) > -1;
      }, h, !0), m = [function (a, c, d) {
        var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));return b = null, e;
      }]; f > i; i++) {
        if (c = d.relative[a[i].type]) m = [sa(ta(m), c)];else {
          if (c = d.filter[a[i].type].apply(null, a[i].matches), c[u]) {
            for (e = ++i; f > e; e++) {
              if (d.relative[a[e].type]) break;
            }return wa(i > 1 && ta(m), i > 1 && ra(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(R, "$1"), c, e > i && xa(a.slice(i, e)), f > e && xa(a = a.slice(e)), f > e && ra(a));
          }m.push(c);
        }
      }return ta(m);
    }function ya(a, b) {
      var c = b.length > 0,
          e = a.length > 0,
          f = function f(_f, g, h, i, k) {
        var l,
            m,
            o,
            p = 0,
            q = "0",
            r = _f && [],
            s = [],
            t = j,
            u = _f || e && d.find.TAG("*", k),
            v = w += null == t ? 1 : Math.random() || .1,
            x = u.length;for (k && (j = g !== n && g); q !== x && null != (l = u[q]); q++) {
          if (e && l) {
            m = 0;while (o = a[m++]) {
              if (o(l, g, h)) {
                i.push(l);break;
              }
            }k && (w = v);
          }c && ((l = !o && l) && p--, _f && r.push(l));
        }if (p += q, c && q !== p) {
          m = 0;while (o = b[m++]) {
            o(r, s, g, h);
          }if (_f) {
            if (p > 0) while (q--) {
              r[q] || s[q] || (s[q] = F.call(i));
            }s = va(s);
          }H.apply(i, s), k && !_f && s.length > 0 && p + b.length > 1 && ga.uniqueSort(i);
        }return k && (w = v, j = t), r;
      };return c ? ia(f) : f;
    }return h = ga.compile = function (a, b) {
      var c,
          d = [],
          e = [],
          f = A[a + " "];if (!f) {
        b || (b = g(a)), c = b.length;while (c--) {
          f = xa(b[c]), f[u] ? d.push(f) : e.push(f);
        }f = A(a, ya(e, d)), f.selector = a;
      }return f;
    }, i = ga.select = function (a, b, e, f) {
      var i,
          j,
          k,
          l,
          m,
          n = "function" == typeof a && a,
          o = !f && g(a = n.selector || a);if (e = e || [], 1 === o.length) {
        if (j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
          if (b = (d.find.ID(k.matches[0].replace(ca, da), b) || [])[0], !b) return e;n && (b = b.parentNode), a = a.slice(j.shift().value.length);
        }i = X.needsContext.test(a) ? 0 : j.length;while (i--) {
          if (k = j[i], d.relative[l = k.type]) break;if ((m = d.find[l]) && (f = m(k.matches[0].replace(ca, da), aa.test(j[0].type) && pa(b.parentNode) || b))) {
            if (j.splice(i, 1), a = f.length && ra(j), !a) return H.apply(e, f), e;break;
          }
        }
      }return (n || h(a, o))(f, b, !p, e, aa.test(a) && pa(b.parentNode) || b), e;
    }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ja(function (a) {
      return 1 & a.compareDocumentPosition(n.createElement("div"));
    }), ja(function (a) {
      return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
    }) || ka("type|href|height|width", function (a, b, c) {
      return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
    }), c.attributes && ja(function (a) {
      return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
    }) || ka("value", function (a, b, c) {
      return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue;
    }), ja(function (a) {
      return null == a.getAttribute("disabled");
    }) || ka(K, function (a, b, c) {
      var d;return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
    }), ga;
  }(a);n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;var u = n.expr.match.needsContext,
      v = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      w = /^.[^:#\[\.,]*$/;function x(a, b, c) {
    if (n.isFunction(b)) return n.grep(a, function (a, d) {
      return !!b.call(a, d, a) !== c;
    });if (b.nodeType) return n.grep(a, function (a) {
      return a === b !== c;
    });if ("string" == typeof b) {
      if (w.test(b)) return n.filter(b, a, c);b = n.filter(b, a);
    }return n.grep(a, function (a) {
      return g.call(b, a) >= 0 !== c;
    });
  }n.filter = function (a, b, c) {
    var d = b[0];return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [d] : [] : n.find.matches(a, n.grep(b, function (a) {
      return 1 === a.nodeType;
    }));
  }, n.fn.extend({ find: function find(a) {
      var b,
          c = this.length,
          d = [],
          e = this;if ("string" != typeof a) return this.pushStack(n(a).filter(function () {
        for (b = 0; c > b; b++) {
          if (n.contains(e[b], this)) return !0;
        }
      }));for (b = 0; c > b; b++) {
        n.find(a, e[b], d);
      }return d = this.pushStack(c > 1 ? n.unique(d) : d), d.selector = this.selector ? this.selector + " " + a : a, d;
    }, filter: function filter(a) {
      return this.pushStack(x(this, a || [], !1));
    }, not: function not(a) {
      return this.pushStack(x(this, a || [], !0));
    }, is: function is(a) {
      return !!x(this, "string" == typeof a && u.test(a) ? n(a) : a || [], !1).length;
    } });var y,
      z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      A = n.fn.init = function (a, b) {
    var c, d;if (!a) return this;if ("string" == typeof a) {
      if (c = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : z.exec(a), !c || !c[1] && b) return !b || b.jquery ? (b || y).find(a) : this.constructor(b).find(a);if (c[1]) {
        if (b = b instanceof n ? b[0] : b, n.merge(this, n.parseHTML(c[1], b && b.nodeType ? b.ownerDocument || b : l, !0)), v.test(c[1]) && n.isPlainObject(b)) for (c in b) {
          n.isFunction(this[c]) ? this[c](b[c]) : this.attr(c, b[c]);
        }return this;
      }return d = l.getElementById(c[2]), d && d.parentNode && (this.length = 1, this[0] = d), this.context = l, this.selector = a, this;
    }return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : n.isFunction(a) ? "undefined" != typeof y.ready ? y.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), n.makeArray(a, this));
  };A.prototype = n.fn, y = n(l);var B = /^(?:parents|prev(?:Until|All))/,
      C = { children: !0, contents: !0, next: !0, prev: !0 };n.extend({ dir: function dir(a, b, c) {
      var d = [],
          e = void 0 !== c;while ((a = a[b]) && 9 !== a.nodeType) {
        if (1 === a.nodeType) {
          if (e && n(a).is(c)) break;d.push(a);
        }
      }return d;
    }, sibling: function sibling(a, b) {
      for (var c = []; a; a = a.nextSibling) {
        1 === a.nodeType && a !== b && c.push(a);
      }return c;
    } }), n.fn.extend({ has: function has(a) {
      var b = n(a, this),
          c = b.length;return this.filter(function () {
        for (var a = 0; c > a; a++) {
          if (n.contains(this, b[a])) return !0;
        }
      });
    }, closest: function closest(a, b) {
      for (var c, d = 0, e = this.length, f = [], g = u.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++) {
        for (c = this[d]; c && c !== b; c = c.parentNode) {
          if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
            f.push(c);break;
          }
        }
      }return this.pushStack(f.length > 1 ? n.unique(f) : f);
    }, index: function index(a) {
      return a ? "string" == typeof a ? g.call(n(a), this[0]) : g.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(a, b) {
      return this.pushStack(n.unique(n.merge(this.get(), n(a, b))));
    }, addBack: function addBack(a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
    } });function D(a, b) {
    while ((a = a[b]) && 1 !== a.nodeType) {}return a;
  }n.each({ parent: function parent(a) {
      var b = a.parentNode;return b && 11 !== b.nodeType ? b : null;
    }, parents: function parents(a) {
      return n.dir(a, "parentNode");
    }, parentsUntil: function parentsUntil(a, b, c) {
      return n.dir(a, "parentNode", c);
    }, next: function next(a) {
      return D(a, "nextSibling");
    }, prev: function prev(a) {
      return D(a, "previousSibling");
    }, nextAll: function nextAll(a) {
      return n.dir(a, "nextSibling");
    }, prevAll: function prevAll(a) {
      return n.dir(a, "previousSibling");
    }, nextUntil: function nextUntil(a, b, c) {
      return n.dir(a, "nextSibling", c);
    }, prevUntil: function prevUntil(a, b, c) {
      return n.dir(a, "previousSibling", c);
    }, siblings: function siblings(a) {
      return n.sibling((a.parentNode || {}).firstChild, a);
    }, children: function children(a) {
      return n.sibling(a.firstChild);
    }, contents: function contents(a) {
      return a.contentDocument || n.merge([], a.childNodes);
    } }, function (a, b) {
    n.fn[a] = function (c, d) {
      var e = n.map(this, b, c);return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = n.filter(d, e)), this.length > 1 && (C[a] || n.unique(e), B.test(a) && e.reverse()), this.pushStack(e);
    };
  });var E = /\S+/g,
      F = {};function G(a) {
    var b = F[a] = {};return n.each(a.match(E) || [], function (a, c) {
      b[c] = !0;
    }), b;
  }n.Callbacks = function (a) {
    a = "string" == typeof a ? F[a] || G(a) : n.extend({}, a);var b,
        c,
        d,
        e,
        f,
        g,
        h = [],
        i = !a.once && [],
        j = function j(l) {
      for (b = a.memory && l, c = !0, g = e || 0, e = 0, f = h.length, d = !0; h && f > g; g++) {
        if (h[g].apply(l[0], l[1]) === !1 && a.stopOnFalse) {
          b = !1;break;
        }
      }d = !1, h && (i ? i.length && j(i.shift()) : b ? h = [] : k.disable());
    },
        k = { add: function add() {
        if (h) {
          var c = h.length;!function g(b) {
            n.each(b, function (b, c) {
              var d = n.type(c);"function" === d ? a.unique && k.has(c) || h.push(c) : c && c.length && "string" !== d && g(c);
            });
          }(arguments), d ? f = h.length : b && (e = c, j(b));
        }return this;
      }, remove: function remove() {
        return h && n.each(arguments, function (a, b) {
          var c;while ((c = n.inArray(b, h, c)) > -1) {
            h.splice(c, 1), d && (f >= c && f--, g >= c && g--);
          }
        }), this;
      }, has: function has(a) {
        return a ? n.inArray(a, h) > -1 : !(!h || !h.length);
      }, empty: function empty() {
        return h = [], f = 0, this;
      }, disable: function disable() {
        return h = i = b = void 0, this;
      }, disabled: function disabled() {
        return !h;
      }, lock: function lock() {
        return i = void 0, b || k.disable(), this;
      }, locked: function locked() {
        return !i;
      }, fireWith: function fireWith(a, b) {
        return !h || c && !i || (b = b || [], b = [a, b.slice ? b.slice() : b], d ? i.push(b) : j(b)), this;
      }, fire: function fire() {
        return k.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!c;
      } };return k;
  }, n.extend({ Deferred: function Deferred(a) {
      var b = [["resolve", "done", n.Callbacks("once memory"), "resolved"], ["reject", "fail", n.Callbacks("once memory"), "rejected"], ["notify", "progress", n.Callbacks("memory")]],
          c = "pending",
          d = { state: function state() {
          return c;
        }, always: function always() {
          return e.done(arguments).fail(arguments), this;
        }, then: function then() {
          var a = arguments;return n.Deferred(function (c) {
            n.each(b, function (b, f) {
              var g = n.isFunction(a[b]) && a[b];e[f[1]](function () {
                var a = g && g.apply(this, arguments);a && n.isFunction(a.promise) ? a.promise().done(c.resolve).fail(c.reject).progress(c.notify) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments);
              });
            }), a = null;
          }).promise();
        }, promise: function promise(a) {
          return null != a ? n.extend(a, d) : d;
        } },
          e = {};return d.pipe = d.then, n.each(b, function (a, f) {
        var g = f[2],
            h = f[3];d[f[1]] = g.add, h && g.add(function () {
          c = h;
        }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function () {
          return e[f[0] + "With"](this === e ? d : this, arguments), this;
        }, e[f[0] + "With"] = g.fireWith;
      }), d.promise(e), a && a.call(e, e), e;
    }, when: function when(a) {
      var b = 0,
          c = d.call(arguments),
          e = c.length,
          f = 1 !== e || a && n.isFunction(a.promise) ? e : 0,
          g = 1 === f ? a : n.Deferred(),
          h = function h(a, b, c) {
        return function (e) {
          b[a] = this, c[a] = arguments.length > 1 ? d.call(arguments) : e, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
        };
      },
          i,
          j,
          k;if (e > 1) for (i = new Array(e), j = new Array(e), k = new Array(e); e > b; b++) {
        c[b] && n.isFunction(c[b].promise) ? c[b].promise().done(h(b, k, c)).fail(g.reject).progress(h(b, j, i)) : --f;
      }return f || g.resolveWith(k, c), g.promise();
    } });var H;n.fn.ready = function (a) {
    return n.ready.promise().done(a), this;
  }, n.extend({ isReady: !1, readyWait: 1, holdReady: function holdReady(a) {
      a ? n.readyWait++ : n.ready(!0);
    }, ready: function ready(a) {
      (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a !== !0 && --n.readyWait > 0 || (H.resolveWith(l, [n]), n.fn.triggerHandler && (n(l).triggerHandler("ready"), n(l).off("ready"))));
    } });function I() {
    l.removeEventListener("DOMContentLoaded", I, !1), a.removeEventListener("load", I, !1), n.ready();
  }n.ready.promise = function (b) {
    return H || (H = n.Deferred(), "complete" === l.readyState ? setTimeout(n.ready) : (l.addEventListener("DOMContentLoaded", I, !1), a.addEventListener("load", I, !1))), H.promise(b);
  }, n.ready.promise();var J = n.access = function (a, b, c, d, e, f, g) {
    var h = 0,
        i = a.length,
        j = null == c;if ("object" === n.type(c)) {
      e = !0;for (h in c) {
        n.access(a, b, h, c[h], !0, f, g);
      }
    } else if (void 0 !== d && (e = !0, n.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function b(a, _b, c) {
      return j.call(n(a), c);
    })), b)) for (; i > h; h++) {
      b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
    }return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
  };n.acceptData = function (a) {
    return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType;
  };function K() {
    Object.defineProperty(this.cache = {}, 0, { get: function get() {
        return {};
      } }), this.expando = n.expando + K.uid++;
  }K.uid = 1, K.accepts = n.acceptData, K.prototype = { key: function key(a) {
      if (!K.accepts(a)) return 0;var b = {},
          c = a[this.expando];if (!c) {
        c = K.uid++;try {
          b[this.expando] = { value: c }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(a, b);
        } catch (d) {
          b[this.expando] = c, n.extend(a, b);
        }
      }return this.cache[c] || (this.cache[c] = {}), c;
    }, set: function set(a, b, c) {
      var d,
          e = this.key(a),
          f = this.cache[e];if ("string" == typeof b) f[b] = c;else if (n.isEmptyObject(f)) n.extend(this.cache[e], b);else for (d in b) {
        f[d] = b[d];
      }return f;
    }, get: function get(a, b) {
      var c = this.cache[this.key(a)];return void 0 === b ? c : c[b];
    }, access: function access(a, b, c) {
      var d;return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, n.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
    }, remove: function remove(a, b) {
      var c,
          d,
          e,
          f = this.key(a),
          g = this.cache[f];if (void 0 === b) this.cache[f] = {};else {
        n.isArray(b) ? d = b.concat(b.map(n.camelCase)) : (e = n.camelCase(b), b in g ? d = [b, e] : (d = e, d = d in g ? [d] : d.match(E) || [])), c = d.length;while (c--) {
          delete g[d[c]];
        }
      }
    }, hasData: function hasData(a) {
      return !n.isEmptyObject(this.cache[a[this.expando]] || {});
    }, discard: function discard(a) {
      a[this.expando] && delete this.cache[a[this.expando]];
    } };var L = new K(),
      M = new K(),
      N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      O = /([A-Z])/g;function P(a, b, c) {
    var d;if (void 0 === c && 1 === a.nodeType) if (d = "data-" + b.replace(O, "-$1").toLowerCase(), c = a.getAttribute(d), "string" == typeof c) {
      try {
        c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : N.test(c) ? n.parseJSON(c) : c;
      } catch (e) {}M.set(a, b, c);
    } else c = void 0;return c;
  }n.extend({ hasData: function hasData(a) {
      return M.hasData(a) || L.hasData(a);
    }, data: function data(a, b, c) {
      return M.access(a, b, c);
    }, removeData: function removeData(a, b) {
      M.remove(a, b);
    }, _data: function _data(a, b, c) {
      return L.access(a, b, c);
    }, _removeData: function _removeData(a, b) {
      L.remove(a, b);
    } }), n.fn.extend({ data: function data(a, b) {
      var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes;if (void 0 === a) {
        if (this.length && (e = M.get(f), 1 === f.nodeType && !L.get(f, "hasDataAttrs"))) {
          c = g.length;while (c--) {
            g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)), P(f, d, e[d])));
          }L.set(f, "hasDataAttrs", !0);
        }return e;
      }return "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) ? this.each(function () {
        M.set(this, a);
      }) : J(this, function (b) {
        var c,
            d = n.camelCase(a);if (f && void 0 === b) {
          if (c = M.get(f, a), void 0 !== c) return c;if (c = M.get(f, d), void 0 !== c) return c;if (c = P(f, d, void 0), void 0 !== c) return c;
        } else this.each(function () {
          var c = M.get(this, d);M.set(this, d, b), -1 !== a.indexOf("-") && void 0 !== c && M.set(this, a, b);
        });
      }, null, b, arguments.length > 1, null, !0);
    }, removeData: function removeData(a) {
      return this.each(function () {
        M.remove(this, a);
      });
    } }), n.extend({ queue: function queue(a, b, c) {
      var d;return a ? (b = (b || "fx") + "queue", d = L.get(a, b), c && (!d || n.isArray(c) ? d = L.access(a, b, n.makeArray(c)) : d.push(c)), d || []) : void 0;
    }, dequeue: function dequeue(a, b) {
      b = b || "fx";var c = n.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = n._queueHooks(a, b),
          g = function g() {
        n.dequeue(a, b);
      };"inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
    }, _queueHooks: function _queueHooks(a, b) {
      var c = b + "queueHooks";return L.get(a, c) || L.access(a, c, { empty: n.Callbacks("once memory").add(function () {
          L.remove(a, [b + "queue", c]);
        }) });
    } }), n.fn.extend({ queue: function queue(a, b) {
      var c = 2;return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function () {
        var c = n.queue(this, a, b);n._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
      });
    }, dequeue: function dequeue(a) {
      return this.each(function () {
        n.dequeue(this, a);
      });
    }, clearQueue: function clearQueue(a) {
      return this.queue(a || "fx", []);
    }, promise: function promise(a, b) {
      var c,
          d = 1,
          e = n.Deferred(),
          f = this,
          g = this.length,
          h = function h() {
        --d || e.resolveWith(f, [f]);
      };"string" != typeof a && (b = a, a = void 0), a = a || "fx";while (g--) {
        c = L.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));
      }return h(), e.promise(b);
    } });var Q = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      R = ["Top", "Right", "Bottom", "Left"],
      S = function S(a, b) {
    return a = b || a, "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a);
  },
      T = /^(?:checkbox|radio)$/i;!function () {
    var a = l.createDocumentFragment(),
        b = a.appendChild(l.createElement("div")),
        c = l.createElement("input");c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), k.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", k.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
  }();var U = "undefined";k.focusinBubbles = "onfocusin" in a;var V = /^key/,
      W = /^(?:mouse|pointer|contextmenu)|click/,
      X = /^(?:focusinfocus|focusoutblur)$/,
      Y = /^([^.]*)(?:\.(.+)|)$/;function Z() {
    return !0;
  }function $() {
    return !1;
  }function _() {
    try {
      return l.activeElement;
    } catch (a) {}
  }n.event = { global: {}, add: function add(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = L.get(a);if (r) {
        c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = n.guid++), (i = r.events) || (i = r.events = {}), (g = r.handle) || (g = r.handle = function (b) {
          return (typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(n)) !== U && n.event.triggered !== b.type ? n.event.dispatch.apply(a, arguments) : void 0;
        }), b = (b || "").match(E) || [""], j = b.length;while (j--) {
          h = Y.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o && (l = n.event.special[o] || {}, o = (e ? l.delegateType : l.bindType) || o, l = n.event.special[o] || {}, k = n.extend({ type: o, origType: q, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && n.expr.match.needsContext.test(e), namespace: p.join(".") }, f), (m = i[o]) || (m = i[o] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, p, g) !== !1 || a.addEventListener && a.addEventListener(o, g, !1)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), n.event.global[o] = !0);
        }
      }
    }, remove: function remove(a, b, c, d, e) {
      var f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r = L.hasData(a) && L.get(a);if (r && (i = r.events)) {
        b = (b || "").match(E) || [""], j = b.length;while (j--) {
          if (h = Y.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o) {
            l = n.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, m = i[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length;while (f--) {
              k = m[f], !e && q !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));
            }g && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle), delete i[o]);
          } else for (o in i) {
            n.event.remove(a, o + b[j], c, d, !0);
          }
        }n.isEmptyObject(i) && (delete r.handle, L.remove(a, "events"));
      }
    }, trigger: function trigger(b, c, d, e) {
      var f,
          g,
          h,
          i,
          k,
          m,
          o,
          p = [d || l],
          q = j.call(b, "type") ? b.type : b,
          r = j.call(b, "namespace") ? b.namespace.split(".") : [];if (g = h = d = d || l, 3 !== d.nodeType && 8 !== d.nodeType && !X.test(q + n.event.triggered) && (q.indexOf(".") >= 0 && (r = q.split("."), q = r.shift(), r.sort()), k = q.indexOf(":") < 0 && "on" + q, b = b[n.expando] ? b : new n.Event(q, "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(b)) && b), b.isTrigger = e ? 2 : 3, b.namespace = r.join("."), b.namespace_re = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : n.makeArray(c, [b]), o = n.event.special[q] || {}, e || !o.trigger || o.trigger.apply(d, c) !== !1)) {
        if (!e && !o.noBubble && !n.isWindow(d)) {
          for (i = o.delegateType || q, X.test(i + q) || (g = g.parentNode); g; g = g.parentNode) {
            p.push(g), h = g;
          }h === (d.ownerDocument || l) && p.push(h.defaultView || h.parentWindow || a);
        }f = 0;while ((g = p[f++]) && !b.isPropagationStopped()) {
          b.type = f > 1 ? i : o.bindType || q, m = (L.get(g, "events") || {})[b.type] && L.get(g, "handle"), m && m.apply(g, c), m = k && g[k], m && m.apply && n.acceptData(g) && (b.result = m.apply(g, c), b.result === !1 && b.preventDefault());
        }return b.type = q, e || b.isDefaultPrevented() || o._default && o._default.apply(p.pop(), c) !== !1 || !n.acceptData(d) || k && n.isFunction(d[q]) && !n.isWindow(d) && (h = d[k], h && (d[k] = null), n.event.triggered = q, d[q](), n.event.triggered = void 0, h && (d[k] = h)), b.result;
      }
    }, dispatch: function dispatch(a) {
      a = n.event.fix(a);var b,
          c,
          e,
          f,
          g,
          h = [],
          i = d.call(arguments),
          j = (L.get(this, "events") || {})[a.type] || [],
          k = n.event.special[a.type] || {};if (i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1) {
        h = n.event.handlers.call(this, a, j), b = 0;while ((f = h[b++]) && !a.isPropagationStopped()) {
          a.currentTarget = f.elem, c = 0;while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped()) {
            (!a.namespace_re || a.namespace_re.test(g.namespace)) && (a.handleObj = g, a.data = g.data, e = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== e && (a.result = e) === !1 && (a.preventDefault(), a.stopPropagation()));
          }
        }return k.postDispatch && k.postDispatch.call(this, a), a.result;
      }
    }, handlers: function handlers(a, b) {
      var c,
          d,
          e,
          f,
          g = [],
          h = b.delegateCount,
          i = a.target;if (h && i.nodeType && (!a.button || "click" !== a.type)) for (; i !== this; i = i.parentNode || this) {
        if (i.disabled !== !0 || "click" !== a.type) {
          for (d = [], c = 0; h > c; c++) {
            f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) >= 0 : n.find(e, this, null, [i]).length), d[e] && d.push(f);
          }d.length && g.push({ elem: i, handlers: d });
        }
      }return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
    }, props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(a, b) {
        return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
      } }, mouseHooks: { props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(a, b) {
        var c,
            d,
            e,
            f = b.button;return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || l, d = c.documentElement, e = c.body, a.pageX = b.clientX + (d && d.scrollLeft || e && e.scrollLeft || 0) - (d && d.clientLeft || e && e.clientLeft || 0), a.pageY = b.clientY + (d && d.scrollTop || e && e.scrollTop || 0) - (d && d.clientTop || e && e.clientTop || 0)), a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0), a;
      } }, fix: function fix(a) {
      if (a[n.expando]) return a;var b,
          c,
          d,
          e = a.type,
          f = a,
          g = this.fixHooks[e];g || (this.fixHooks[e] = g = W.test(e) ? this.mouseHooks : V.test(e) ? this.keyHooks : {}), d = g.props ? this.props.concat(g.props) : this.props, a = new n.Event(f), b = d.length;while (b--) {
        c = d[b], a[c] = f[c];
      }return a.target || (a.target = l), 3 === a.target.nodeType && (a.target = a.target.parentNode), g.filter ? g.filter(a, f) : a;
    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
          return this !== _() && this.focus ? (this.focus(), !1) : void 0;
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          return this === _() && this.blur ? (this.blur(), !1) : void 0;
        }, delegateType: "focusout" }, click: { trigger: function trigger() {
          return "checkbox" === this.type && this.click && n.nodeName(this, "input") ? (this.click(), !1) : void 0;
        }, _default: function _default(a) {
          return n.nodeName(a.target, "a");
        } }, beforeunload: { postDispatch: function postDispatch(a) {
          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
        } } }, simulate: function simulate(a, b, c, d) {
      var e = n.extend(new n.Event(), c, { type: a, isSimulated: !0, originalEvent: {} });d ? n.event.trigger(e, null, b) : n.event.dispatch.call(b, e), e.isDefaultPrevented() && c.preventDefault();
    } }, n.removeEvent = function (a, b, c) {
    a.removeEventListener && a.removeEventListener(b, c, !1);
  }, n.Event = function (a, b) {
    return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? Z : $) : this.type = a, b && n.extend(this, b), this.timeStamp = a && a.timeStamp || n.now(), void (this[n.expando] = !0)) : new n.Event(a, b);
  }, n.Event.prototype = { isDefaultPrevented: $, isPropagationStopped: $, isImmediatePropagationStopped: $, preventDefault: function preventDefault() {
      var a = this.originalEvent;this.isDefaultPrevented = Z, a && a.preventDefault && a.preventDefault();
    }, stopPropagation: function stopPropagation() {
      var a = this.originalEvent;this.isPropagationStopped = Z, a && a.stopPropagation && a.stopPropagation();
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      var a = this.originalEvent;this.isImmediatePropagationStopped = Z, a && a.stopImmediatePropagation && a.stopImmediatePropagation(), this.stopPropagation();
    } }, n.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (a, b) {
    n.event.special[a] = { delegateType: b, bindType: b, handle: function handle(a) {
        var c,
            d = this,
            e = a.relatedTarget,
            f = a.handleObj;return (!e || e !== d && !n.contains(d, e)) && (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
      } };
  }), k.focusinBubbles || n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
    var c = function c(a) {
      n.event.simulate(b, a.target, n.event.fix(a), !0);
    };n.event.special[b] = { setup: function setup() {
        var d = this.ownerDocument || this,
            e = L.access(d, b);e || d.addEventListener(a, c, !0), L.access(d, b, (e || 0) + 1);
      }, teardown: function teardown() {
        var d = this.ownerDocument || this,
            e = L.access(d, b) - 1;e ? L.access(d, b, e) : (d.removeEventListener(a, c, !0), L.remove(d, b));
      } };
  }), n.fn.extend({ on: function on(a, b, c, d, e) {
      var f, g;if ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a))) {
        "string" != typeof b && (c = c || b, b = void 0);for (g in a) {
          this.on(g, b, c, a[g], e);
        }return this;
      }if (null == c && null == d ? (d = b, c = b = void 0) : null == d && ("string" == typeof b ? (d = c, c = void 0) : (d = c, c = b, b = void 0)), d === !1) d = $;else if (!d) return this;return 1 === e && (f = d, d = function d(a) {
        return n().off(a), f.apply(this, arguments);
      }, d.guid = f.guid || (f.guid = n.guid++)), this.each(function () {
        n.event.add(this, a, d, c, b);
      });
    }, one: function one(a, b, c, d) {
      return this.on(a, b, c, d, 1);
    }, off: function off(a, b, c) {
      var d, e;if (a && a.preventDefault && a.handleObj) return d = a.handleObj, n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;if ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a))) {
        for (e in a) {
          this.off(e, b, a[e]);
        }return this;
      }return (b === !1 || "function" == typeof b) && (c = b, b = void 0), c === !1 && (c = $), this.each(function () {
        n.event.remove(this, a, c, b);
      });
    }, trigger: function trigger(a, b) {
      return this.each(function () {
        n.event.trigger(a, b, this);
      });
    }, triggerHandler: function triggerHandler(a, b) {
      var c = this[0];return c ? n.event.trigger(a, b, c, !0) : void 0;
    } });var aa = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      ba = /<([\w:]+)/,
      ca = /<|&#?\w+;/,
      da = /<(?:script|style|link)/i,
      ea = /checked\s*(?:[^=]|=\s*.checked.)/i,
      fa = /^$|\/(?:java|ecma)script/i,
      ga = /^true\/(.*)/,
      ha = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      ia = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };ia.optgroup = ia.option, ia.tbody = ia.tfoot = ia.colgroup = ia.caption = ia.thead, ia.th = ia.td;function ja(a, b) {
    return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a;
  }function ka(a) {
    return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
  }function la(a) {
    var b = ga.exec(a.type);return b ? a.type = b[1] : a.removeAttribute("type"), a;
  }function ma(a, b) {
    for (var c = 0, d = a.length; d > c; c++) {
      L.set(a[c], "globalEval", !b || L.get(b[c], "globalEval"));
    }
  }function na(a, b) {
    var c, d, e, f, g, h, i, j;if (1 === b.nodeType) {
      if (L.hasData(a) && (f = L.access(a), g = L.set(b, f), j = f.events)) {
        delete g.handle, g.events = {};for (e in j) {
          for (c = 0, d = j[e].length; d > c; c++) {
            n.event.add(b, e, j[e][c]);
          }
        }
      }M.hasData(a) && (h = M.access(a), i = n.extend({}, h), M.set(b, i));
    }
  }function oa(a, b) {
    var c = a.getElementsByTagName ? a.getElementsByTagName(b || "*") : a.querySelectorAll ? a.querySelectorAll(b || "*") : [];return void 0 === b || b && n.nodeName(a, b) ? n.merge([a], c) : c;
  }function pa(a, b) {
    var c = b.nodeName.toLowerCase();"input" === c && T.test(a.type) ? b.checked = a.checked : ("input" === c || "textarea" === c) && (b.defaultValue = a.defaultValue);
  }n.extend({ clone: function clone(a, b, c) {
      var d,
          e,
          f,
          g,
          h = a.cloneNode(!0),
          i = n.contains(a.ownerDocument, a);if (!(k.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a))) for (g = oa(h), f = oa(a), d = 0, e = f.length; e > d; d++) {
        pa(f[d], g[d]);
      }if (b) if (c) for (f = f || oa(a), g = g || oa(h), d = 0, e = f.length; e > d; d++) {
        na(f[d], g[d]);
      } else na(a, h);return g = oa(h, "script"), g.length > 0 && ma(g, !i && oa(a, "script")), h;
    }, buildFragment: function buildFragment(a, b, c, d) {
      for (var e, f, g, h, i, j, k = b.createDocumentFragment(), l = [], m = 0, o = a.length; o > m; m++) {
        if (e = a[m], e || 0 === e) if ("object" === n.type(e)) n.merge(l, e.nodeType ? [e] : e);else if (ca.test(e)) {
          f = f || k.appendChild(b.createElement("div")), g = (ba.exec(e) || ["", ""])[1].toLowerCase(), h = ia[g] || ia._default, f.innerHTML = h[1] + e.replace(aa, "<$1></$2>") + h[2], j = h[0];while (j--) {
            f = f.lastChild;
          }n.merge(l, f.childNodes), f = k.firstChild, f.textContent = "";
        } else l.push(b.createTextNode(e));
      }k.textContent = "", m = 0;while (e = l[m++]) {
        if ((!d || -1 === n.inArray(e, d)) && (i = n.contains(e.ownerDocument, e), f = oa(k.appendChild(e), "script"), i && ma(f), c)) {
          j = 0;while (e = f[j++]) {
            fa.test(e.type || "") && c.push(e);
          }
        }
      }return k;
    }, cleanData: function cleanData(a) {
      for (var b, c, d, e, f = n.event.special, g = 0; void 0 !== (c = a[g]); g++) {
        if (n.acceptData(c) && (e = c[L.expando], e && (b = L.cache[e]))) {
          if (b.events) for (d in b.events) {
            f[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle);
          }L.cache[e] && delete L.cache[e];
        }delete M.cache[c[M.expando]];
      }
    } }), n.fn.extend({ text: function text(a) {
      return J(this, function (a) {
        return void 0 === a ? n.text(this) : this.empty().each(function () {
          (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = a);
        });
      }, null, a, arguments.length);
    }, append: function append() {
      return this.domManip(arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = ja(this, a);b.appendChild(a);
        }
      });
    }, prepend: function prepend() {
      return this.domManip(arguments, function (a) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var b = ja(this, a);b.insertBefore(a, b.firstChild);
        }
      });
    }, before: function before() {
      return this.domManip(arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this);
      });
    }, after: function after() {
      return this.domManip(arguments, function (a) {
        this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
      });
    }, remove: function remove(a, b) {
      for (var c, d = a ? n.filter(a, this) : this, e = 0; null != (c = d[e]); e++) {
        b || 1 !== c.nodeType || n.cleanData(oa(c)), c.parentNode && (b && n.contains(c.ownerDocument, c) && ma(oa(c, "script")), c.parentNode.removeChild(c));
      }return this;
    }, empty: function empty() {
      for (var a, b = 0; null != (a = this[b]); b++) {
        1 === a.nodeType && (n.cleanData(oa(a, !1)), a.textContent = "");
      }return this;
    }, clone: function clone(a, b) {
      return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function () {
        return n.clone(this, a, b);
      });
    }, html: function html(a) {
      return J(this, function (a) {
        var b = this[0] || {},
            c = 0,
            d = this.length;if (void 0 === a && 1 === b.nodeType) return b.innerHTML;if ("string" == typeof a && !da.test(a) && !ia[(ba.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = a.replace(aa, "<$1></$2>");try {
            for (; d > c; c++) {
              b = this[c] || {}, 1 === b.nodeType && (n.cleanData(oa(b, !1)), b.innerHTML = a);
            }b = 0;
          } catch (e) {}
        }b && this.empty().append(a);
      }, null, a, arguments.length);
    }, replaceWith: function replaceWith() {
      var a = arguments[0];return this.domManip(arguments, function (b) {
        a = this.parentNode, n.cleanData(oa(this)), a && a.replaceChild(b, this);
      }), a && (a.length || a.nodeType) ? this : this.remove();
    }, detach: function detach(a) {
      return this.remove(a, !0);
    }, domManip: function domManip(a, b) {
      a = e.apply([], a);var c,
          d,
          f,
          g,
          h,
          i,
          j = 0,
          l = this.length,
          m = this,
          o = l - 1,
          p = a[0],
          q = n.isFunction(p);if (q || l > 1 && "string" == typeof p && !k.checkClone && ea.test(p)) return this.each(function (c) {
        var d = m.eq(c);q && (a[0] = p.call(this, c, d.html())), d.domManip(a, b);
      });if (l && (c = n.buildFragment(a, this[0].ownerDocument, !1, this), d = c.firstChild, 1 === c.childNodes.length && (c = d), d)) {
        for (f = n.map(oa(c, "script"), ka), g = f.length; l > j; j++) {
          h = c, j !== o && (h = n.clone(h, !0, !0), g && n.merge(f, oa(h, "script"))), b.call(this[j], h, j);
        }if (g) for (i = f[f.length - 1].ownerDocument, n.map(f, la), j = 0; g > j; j++) {
          h = f[j], fa.test(h.type || "") && !L.access(h, "globalEval") && n.contains(i, h) && (h.src ? n._evalUrl && n._evalUrl(h.src) : n.globalEval(h.textContent.replace(ha, "")));
        }
      }return this;
    } }), n.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (a, b) {
    n.fn[a] = function (a) {
      for (var c, d = [], e = n(a), g = e.length - 1, h = 0; g >= h; h++) {
        c = h === g ? this : this.clone(!0), n(e[h])[b](c), f.apply(d, c.get());
      }return this.pushStack(d);
    };
  });var qa,
      ra = {};function sa(b, c) {
    var d,
        e = n(c.createElement(b)).appendTo(c.body),
        f = a.getDefaultComputedStyle && (d = a.getDefaultComputedStyle(e[0])) ? d.display : n.css(e[0], "display");return e.detach(), f;
  }function ta(a) {
    var b = l,
        c = ra[a];return c || (c = sa(a, b), "none" !== c && c || (qa = (qa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = qa[0].contentDocument, b.write(), b.close(), c = sa(a, b), qa.detach()), ra[a] = c), c;
  }var ua = /^margin/,
      va = new RegExp("^(" + Q + ")(?!px)[a-z%]+$", "i"),
      wa = function wa(b) {
    return b.ownerDocument.defaultView.opener ? b.ownerDocument.defaultView.getComputedStyle(b, null) : a.getComputedStyle(b, null);
  };function xa(a, b, c) {
    var d,
        e,
        f,
        g,
        h = a.style;return c = c || wa(a), c && (g = c.getPropertyValue(b) || c[b]), c && ("" !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)), va.test(g) && ua.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f)), void 0 !== g ? g + "" : g;
  }function ya(a, b) {
    return { get: function get() {
        return a() ? void delete this.get : (this.get = b).apply(this, arguments);
      } };
  }!function () {
    var b,
        c,
        d = l.documentElement,
        e = l.createElement("div"),
        f = l.createElement("div");if (f.style) {
      var _g = function _g() {
        f.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", f.innerHTML = "", d.appendChild(e);var g = a.getComputedStyle(f, null);b = "1%" !== g.top, c = "4px" === g.width, d.removeChild(e);
      };

      f.style.backgroundClip = "content-box", f.cloneNode(!0).style.backgroundClip = "", k.clearCloneStyle = "content-box" === f.style.backgroundClip, e.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute", e.appendChild(f);a.getComputedStyle && n.extend(k, { pixelPosition: function pixelPosition() {
          return _g(), b;
        }, boxSizingReliable: function boxSizingReliable() {
          return null == c && _g(), c;
        }, reliableMarginRight: function reliableMarginRight() {
          var b,
              c = f.appendChild(l.createElement("div"));return c.style.cssText = f.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", c.style.marginRight = c.style.width = "0", f.style.width = "1px", d.appendChild(e), b = !parseFloat(a.getComputedStyle(c, null).marginRight), d.removeChild(e), f.removeChild(c), b;
        } });
    }
  }(), n.swap = function (a, b, c, d) {
    var e,
        f,
        g = {};for (f in b) {
      g[f] = a.style[f], a.style[f] = b[f];
    }e = c.apply(a, d || []);for (f in b) {
      a.style[f] = g[f];
    }return e;
  };var za = /^(none|table(?!-c[ea]).+)/,
      Aa = new RegExp("^(" + Q + ")(.*)$", "i"),
      Ba = new RegExp("^([+-])=(" + Q + ")", "i"),
      Ca = { position: "absolute", visibility: "hidden", display: "block" },
      Da = { letterSpacing: "0", fontWeight: "400" },
      Ea = ["Webkit", "O", "Moz", "ms"];function Fa(a, b) {
    if (b in a) return b;var c = b[0].toUpperCase() + b.slice(1),
        d = b,
        e = Ea.length;while (e--) {
      if (b = Ea[e] + c, b in a) return b;
    }return d;
  }function Ga(a, b, c) {
    var d = Aa.exec(b);return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b;
  }function Ha(a, b, c, d, e) {
    for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) {
      "margin" === c && (g += n.css(a, c + R[f], !0, e)), d ? ("content" === c && (g -= n.css(a, "padding" + R[f], !0, e)), "margin" !== c && (g -= n.css(a, "border" + R[f] + "Width", !0, e))) : (g += n.css(a, "padding" + R[f], !0, e), "padding" !== c && (g += n.css(a, "border" + R[f] + "Width", !0, e)));
    }return g;
  }function Ia(a, b, c) {
    var d = !0,
        e = "width" === b ? a.offsetWidth : a.offsetHeight,
        f = wa(a),
        g = "border-box" === n.css(a, "boxSizing", !1, f);if (0 >= e || null == e) {
      if (e = xa(a, b, f), (0 > e || null == e) && (e = a.style[b]), va.test(e)) return e;d = g && (k.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0;
    }return e + Ha(a, b, c || (g ? "border" : "content"), d, f) + "px";
  }function Ja(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) {
      d = a[g], d.style && (f[g] = L.get(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && S(d) && (f[g] = L.access(d, "olddisplay", ta(d.nodeName)))) : (e = S(d), "none" === c && e || L.set(d, "olddisplay", e ? c : n.css(d, "display"))));
    }for (g = 0; h > g; g++) {
      d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));
    }return a;
  }n.extend({ cssHooks: { opacity: { get: function get(a, b) {
          if (b) {
            var c = xa(a, "opacity");return "" === c ? "1" : c;
          }
        } } }, cssNumber: { columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { "float": "cssFloat" }, style: function style(a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
            f,
            g,
            h = n.camelCase(b),
            i = a.style;return b = n.cssProps[h] || (n.cssProps[h] = Fa(i, h)), g = n.cssHooks[b] || n.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(c), "string" === f && (e = Ba.exec(c)) && (c = (e[1] + 1) * e[2] + parseFloat(n.css(a, b)), f = "number"), null != c && c === c && ("number" !== f || n.cssNumber[h] || (c += "px"), k.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c)), void 0);
      }
    }, css: function css(a, b, c, d) {
      var e,
          f,
          g,
          h = n.camelCase(b);return b = n.cssProps[h] || (n.cssProps[h] = Fa(a.style, h)), g = n.cssHooks[b] || n.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = xa(a, b, d)), "normal" === e && b in Da && (e = Da[b]), "" === c || c ? (f = parseFloat(e), c === !0 || n.isNumeric(f) ? f || 0 : e) : e;
    } }), n.each(["height", "width"], function (a, b) {
    n.cssHooks[b] = { get: function get(a, c, d) {
        return c ? za.test(n.css(a, "display")) && 0 === a.offsetWidth ? n.swap(a, Ca, function () {
          return Ia(a, b, d);
        }) : Ia(a, b, d) : void 0;
      }, set: function set(a, c, d) {
        var e = d && wa(a);return Ga(a, c, d ? Ha(a, b, d, "border-box" === n.css(a, "boxSizing", !1, e), e) : 0);
      } };
  }), n.cssHooks.marginRight = ya(k.reliableMarginRight, function (a, b) {
    return b ? n.swap(a, { display: "inline-block" }, xa, [a, "marginRight"]) : void 0;
  }), n.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
    n.cssHooks[a + b] = { expand: function expand(c) {
        for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) {
          e[a + R[d] + b] = f[d] || f[d - 2] || f[0];
        }return e;
      } }, ua.test(a) || (n.cssHooks[a + b].set = Ga);
  }), n.fn.extend({ css: function css(a, b) {
      return J(this, function (a, b, c) {
        var d,
            e,
            f = {},
            g = 0;if (n.isArray(b)) {
          for (d = wa(a), e = b.length; e > g; g++) {
            f[b[g]] = n.css(a, b[g], !1, d);
          }return f;
        }return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
      }, a, b, arguments.length > 1);
    }, show: function show() {
      return Ja(this, !0);
    }, hide: function hide() {
      return Ja(this);
    }, toggle: function toggle(a) {
      return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
        S(this) ? n(this).show() : n(this).hide();
      });
    } });function Ka(a, b, c, d, e) {
    return new Ka.prototype.init(a, b, c, d, e);
  }n.Tween = Ka, Ka.prototype = { constructor: Ka, init: function init(a, b, c, d, e, f) {
      this.elem = a, this.prop = c, this.easing = e || "swing", this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (n.cssNumber[c] ? "" : "px");
    }, cur: function cur() {
      var a = Ka.propHooks[this.prop];return a && a.get ? a.get(this) : Ka.propHooks._default.get(this);
    }, run: function run(a) {
      var b,
          c = Ka.propHooks[this.prop];return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : Ka.propHooks._default.set(this), this;
    } }, Ka.prototype.init.prototype = Ka.prototype, Ka.propHooks = { _default: { get: function get(a) {
        var b;return null == a.elem[a.prop] || a.elem.style && null != a.elem.style[a.prop] ? (b = n.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0) : a.elem[a.prop];
      }, set: function set(a) {
        n.fx.step[a.prop] ? n.fx.step[a.prop](a) : a.elem.style && (null != a.elem.style[n.cssProps[a.prop]] || n.cssHooks[a.prop]) ? n.style(a.elem, a.prop, a.now + a.unit) : a.elem[a.prop] = a.now;
      } } }, Ka.propHooks.scrollTop = Ka.propHooks.scrollLeft = { set: function set(a) {
      a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
    } }, n.easing = { linear: function linear(a) {
      return a;
    }, swing: function swing(a) {
      return .5 - Math.cos(a * Math.PI) / 2;
    } }, n.fx = Ka.prototype.init, n.fx.step = {};var La,
      Ma,
      Na = /^(?:toggle|show|hide)$/,
      Oa = new RegExp("^(?:([+-])=|)(" + Q + ")([a-z%]*)$", "i"),
      Pa = /queueHooks$/,
      Qa = [Va],
      Ra = { "*": [function (a, b) {
      var c = this.createTween(a, b),
          d = c.cur(),
          e = Oa.exec(b),
          f = e && e[3] || (n.cssNumber[a] ? "" : "px"),
          g = (n.cssNumber[a] || "px" !== f && +d) && Oa.exec(n.css(c.elem, a)),
          h = 1,
          i = 20;if (g && g[3] !== f) {
        f = f || g[3], e = e || [], g = +d || 1;do {
          h = h || ".5", g /= h, n.style(c.elem, a, g + f);
        } while (h !== (h = c.cur() / d) && 1 !== h && --i);
      }return e && (g = c.start = +g || +d || 0, c.unit = f, c.end = e[1] ? g + (e[1] + 1) * e[2] : +e[2]), c;
    }] };function Sa() {
    return setTimeout(function () {
      La = void 0;
    }), La = n.now();
  }function Ta(a, b) {
    var c,
        d = 0,
        e = { height: a };for (b = b ? 1 : 0; 4 > d; d += 2 - b) {
      c = R[d], e["margin" + c] = e["padding" + c] = a;
    }return b && (e.opacity = e.width = a), e;
  }function Ua(a, b, c) {
    for (var d, e = (Ra[b] || []).concat(Ra["*"]), f = 0, g = e.length; g > f; f++) {
      if (d = e[f].call(c, b, a)) return d;
    }
  }function Va(a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = this,
        m = {},
        o = a.style,
        p = a.nodeType && S(a),
        q = L.get(a, "fxshow");c.queue || (h = n._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function () {
      h.unqueued || i();
    }), h.unqueued++, l.always(function () {
      l.always(function () {
        h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
      });
    })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [o.overflow, o.overflowX, o.overflowY], j = n.css(a, "display"), k = "none" === j ? L.get(a, "olddisplay") || ta(a.nodeName) : j, "inline" === k && "none" === n.css(a, "float") && (o.display = "inline-block")), c.overflow && (o.overflow = "hidden", l.always(function () {
      o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2];
    }));for (d in b) {
      if (e = b[d], Na.exec(e)) {
        if (delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show")) {
          if ("show" !== e || !q || void 0 === q[d]) continue;p = !0;
        }m[d] = q && q[d] || n.style(a, d);
      } else j = void 0;
    }if (n.isEmptyObject(m)) "inline" === ("none" === j ? ta(a.nodeName) : j) && (o.display = j);else {
      q ? "hidden" in q && (p = q.hidden) : q = L.access(a, "fxshow", {}), f && (q.hidden = !p), p ? n(a).show() : l.done(function () {
        n(a).hide();
      }), l.done(function () {
        var b;L.remove(a, "fxshow");for (b in m) {
          n.style(a, b, m[b]);
        }
      });for (d in m) {
        g = Ua(p ? q[d] : 0, d, l), d in q || (q[d] = g.start, p && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0));
      }
    }
  }function Wa(a, b) {
    var c, d, e, f, g;for (c in a) {
      if (d = n.camelCase(c), e = b[d], f = a[c], n.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = n.cssHooks[d], g && "expand" in g) {
        f = g.expand(f), delete a[d];for (c in f) {
          c in a || (a[c] = f[c], b[c] = e);
        }
      } else b[d] = e;
    }
  }function Xa(a, b, c) {
    var d,
        e,
        f = 0,
        g = Qa.length,
        h = n.Deferred().always(function () {
      delete i.elem;
    }),
        i = function i() {
      if (e) return !1;for (var b = La || Sa(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) {
        j.tweens[g].run(f);
      }return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1);
    },
        j = h.promise({ elem: a, props: n.extend({}, b), opts: n.extend(!0, { specialEasing: {} }, c), originalProperties: b, originalOptions: c, startTime: La || Sa(), duration: c.duration, tweens: [], createTween: function createTween(b, c) {
        var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);return j.tweens.push(d), d;
      }, stop: function stop(b) {
        var c = 0,
            d = b ? j.tweens.length : 0;if (e) return this;for (e = !0; d > c; c++) {
          j.tweens[c].run(1);
        }return b ? h.resolveWith(a, [j, b]) : h.rejectWith(a, [j, b]), this;
      } }),
        k = j.props;for (Wa(k, j.opts.specialEasing); g > f; f++) {
      if (d = Qa[f].call(j, a, k, j.opts)) return d;
    }return n.map(k, Ua, j), n.isFunction(j.opts.start) && j.opts.start.call(a, j), n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always);
  }n.Animation = n.extend(Xa, { tweener: function tweener(a, b) {
      n.isFunction(a) ? (b = a, a = ["*"]) : a = a.split(" ");for (var c, d = 0, e = a.length; e > d; d++) {
        c = a[d], Ra[c] = Ra[c] || [], Ra[c].unshift(b);
      }
    }, prefilter: function prefilter(a, b) {
      b ? Qa.unshift(a) : Qa.push(a);
    } }), n.speed = function (a, b, c) {
    var d = a && "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) ? n.extend({}, a) : { complete: c || !c && b || n.isFunction(a) && a, duration: a, easing: c && b || b && !n.isFunction(b) && b };return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default, (null == d.queue || d.queue === !0) && (d.queue = "fx"), d.old = d.complete, d.complete = function () {
      n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue);
    }, d;
  }, n.fn.extend({ fadeTo: function fadeTo(a, b, c, d) {
      return this.filter(S).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d);
    }, animate: function animate(a, b, c, d) {
      var e = n.isEmptyObject(a),
          f = n.speed(b, c, d),
          g = function g() {
        var b = Xa(this, n.extend({}, a), f);(e || L.get(this, "finish")) && b.stop(!0);
      };return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
    }, stop: function stop(a, b, c) {
      var d = function d(a) {
        var b = a.stop;delete a.stop, b(c);
      };return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function () {
        var b = !0,
            e = null != a && a + "queueHooks",
            f = n.timers,
            g = L.get(this);if (e) g[e] && g[e].stop && d(g[e]);else for (e in g) {
          g[e] && g[e].stop && Pa.test(e) && d(g[e]);
        }for (e = f.length; e--;) {
          f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));
        }(b || !c) && n.dequeue(this, a);
      });
    }, finish: function finish(a) {
      return a !== !1 && (a = a || "fx"), this.each(function () {
        var b,
            c = L.get(this),
            d = c[a + "queue"],
            e = c[a + "queueHooks"],
            f = n.timers,
            g = d ? d.length : 0;for (c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) {
          f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));
        }for (b = 0; g > b; b++) {
          d[b] && d[b].finish && d[b].finish.call(this);
        }delete c.finish;
      });
    } }), n.each(["toggle", "show", "hide"], function (a, b) {
    var c = n.fn[b];n.fn[b] = function (a, d, e) {
      return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(Ta(b, !0), a, d, e);
    };
  }), n.each({ slideDown: Ta("show"), slideUp: Ta("hide"), slideToggle: Ta("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (a, b) {
    n.fn[a] = function (a, c, d) {
      return this.animate(b, a, c, d);
    };
  }), n.timers = [], n.fx.tick = function () {
    var a,
        b = 0,
        c = n.timers;for (La = n.now(); b < c.length; b++) {
      a = c[b], a() || c[b] !== a || c.splice(b--, 1);
    }c.length || n.fx.stop(), La = void 0;
  }, n.fx.timer = function (a) {
    n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
  }, n.fx.interval = 13, n.fx.start = function () {
    Ma || (Ma = setInterval(n.fx.tick, n.fx.interval));
  }, n.fx.stop = function () {
    clearInterval(Ma), Ma = null;
  }, n.fx.speeds = { slow: 600, fast: 200, _default: 400 }, n.fn.delay = function (a, b) {
    return a = n.fx ? n.fx.speeds[a] || a : a, b = b || "fx", this.queue(b, function (b, c) {
      var d = setTimeout(b, a);c.stop = function () {
        clearTimeout(d);
      };
    });
  }, function () {
    var a = l.createElement("input"),
        b = l.createElement("select"),
        c = b.appendChild(l.createElement("option"));a.type = "checkbox", k.checkOn = "" !== a.value, k.optSelected = c.selected, b.disabled = !0, k.optDisabled = !c.disabled, a = l.createElement("input"), a.value = "t", a.type = "radio", k.radioValue = "t" === a.value;
  }();var Ya,
      Za,
      $a = n.expr.attrHandle;n.fn.extend({ attr: function attr(a, b) {
      return J(this, n.attr, a, b, arguments.length > 1);
    }, removeAttr: function removeAttr(a) {
      return this.each(function () {
        n.removeAttr(this, a);
      });
    } }), n.extend({ attr: function attr(a, b, c) {
      var d,
          e,
          f = a.nodeType;if (a && 3 !== f && 8 !== f && 2 !== f) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a.getAttribute) === U ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(), d = n.attrHooks[b] || (n.expr.match.bool.test(b) ? Za : Ya)), void 0 === c ? d && "get" in d && null !== (e = d.get(a, b)) ? e : (e = n.find.attr(a, b), null == e ? void 0 : e) : null !== c ? d && "set" in d && void 0 !== (e = d.set(a, c, b)) ? e : (a.setAttribute(b, c + ""), c) : void n.removeAttr(a, b));
    }, removeAttr: function removeAttr(a, b) {
      var c,
          d,
          e = 0,
          f = b && b.match(E);if (f && 1 === a.nodeType) while (c = f[e++]) {
        d = n.propFix[c] || c, n.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c);
      }
    }, attrHooks: { type: { set: function set(a, b) {
          if (!k.radioValue && "radio" === b && n.nodeName(a, "input")) {
            var c = a.value;return a.setAttribute("type", b), c && (a.value = c), b;
          }
        } } } }), Za = { set: function set(a, b, c) {
      return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c), c;
    } }, n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
    var c = $a[b] || n.find.attr;$a[b] = function (a, b, d) {
      var e, f;return d || (f = $a[b], $a[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, $a[b] = f), e;
    };
  });var _a = /^(?:input|select|textarea|button)$/i;n.fn.extend({ prop: function prop(a, b) {
      return J(this, n.prop, a, b, arguments.length > 1);
    }, removeProp: function removeProp(a) {
      return this.each(function () {
        delete this[n.propFix[a] || a];
      });
    } }), n.extend({ propFix: { "for": "htmlFor", "class": "className" }, prop: function prop(a, b, c) {
      var d,
          e,
          f,
          g = a.nodeType;if (a && 3 !== g && 8 !== g && 2 !== g) return f = 1 !== g || !n.isXMLDoc(a), f && (b = n.propFix[b] || b, e = n.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
    }, propHooks: { tabIndex: { get: function get(a) {
          return a.hasAttribute("tabindex") || _a.test(a.nodeName) || a.href ? a.tabIndex : -1;
        } } } }), k.optSelected || (n.propHooks.selected = { get: function get(a) {
      var b = a.parentNode;return b && b.parentNode && b.parentNode.selectedIndex, null;
    } }), n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    n.propFix[this.toLowerCase()] = this;
  });var ab = /[\t\r\n\f]/g;n.fn.extend({ addClass: function addClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h = "string" == typeof a && a,
          i = 0,
          j = this.length;if (n.isFunction(a)) return this.each(function (b) {
        n(this).addClass(a.call(this, b, this.className));
      });if (h) for (b = (a || "").match(E) || []; j > i; i++) {
        if (c = this[i], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : " ")) {
          f = 0;while (e = b[f++]) {
            d.indexOf(" " + e + " ") < 0 && (d += e + " ");
          }g = n.trim(d), c.className !== g && (c.className = g);
        }
      }return this;
    }, removeClass: function removeClass(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h = 0 === arguments.length || "string" == typeof a && a,
          i = 0,
          j = this.length;if (n.isFunction(a)) return this.each(function (b) {
        n(this).removeClass(a.call(this, b, this.className));
      });if (h) for (b = (a || "").match(E) || []; j > i; i++) {
        if (c = this[i], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : "")) {
          f = 0;while (e = b[f++]) {
            while (d.indexOf(" " + e + " ") >= 0) {
              d = d.replace(" " + e + " ", " ");
            }
          }g = a ? n.trim(d) : "", c.className !== g && (c.className = g);
        }
      }return this;
    }, toggleClass: function toggleClass(a, b) {
      var c = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a);return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : this.each(n.isFunction(a) ? function (c) {
        n(this).toggleClass(a.call(this, c, this.className, b), b);
      } : function () {
        if ("string" === c) {
          var b,
              d = 0,
              e = n(this),
              f = a.match(E) || [];while (b = f[d++]) {
            e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
          }
        } else (c === U || "boolean" === c) && (this.className && L.set(this, "__className__", this.className), this.className = this.className || a === !1 ? "" : L.get(this, "__className__") || "");
      });
    }, hasClass: function hasClass(a) {
      for (var b = " " + a + " ", c = 0, d = this.length; d > c; c++) {
        if (1 === this[c].nodeType && (" " + this[c].className + " ").replace(ab, " ").indexOf(b) >= 0) return !0;
      }return !1;
    } });var bb = /\r/g;n.fn.extend({ val: function val(a) {
      var b,
          c,
          d,
          e = this[0];{
        if (arguments.length) return d = n.isFunction(a), this.each(function (c) {
          var e;1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function (a) {
            return null == a ? "" : a + "";
          })), b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
        });if (e) return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(bb, "") : null == c ? "" : c);
      }
    } }), n.extend({ valHooks: { option: { get: function get(a) {
          var b = n.find.attr(a, "value");return null != b ? b : n.trim(n.text(a));
        } }, select: { get: function get(a) {
          for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++) {
            if (c = d[i], !(!c.selected && i !== e || (k.optDisabled ? c.disabled : null !== c.getAttribute("disabled")) || c.parentNode.disabled && n.nodeName(c.parentNode, "optgroup"))) {
              if (b = n(c).val(), f) return b;g.push(b);
            }
          }return g;
        }, set: function set(a, b) {
          var c,
              d,
              e = a.options,
              f = n.makeArray(b),
              g = e.length;while (g--) {
            d = e[g], (d.selected = n.inArray(d.value, f) >= 0) && (c = !0);
          }return c || (a.selectedIndex = -1), f;
        } } } }), n.each(["radio", "checkbox"], function () {
    n.valHooks[this] = { set: function set(a, b) {
        return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) >= 0 : void 0;
      } }, k.checkOn || (n.valHooks[this].get = function (a) {
      return null === a.getAttribute("value") ? "on" : a.value;
    });
  }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (a, b) {
    n.fn[b] = function (a, c) {
      return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
    };
  }), n.fn.extend({ hover: function hover(a, b) {
      return this.mouseenter(a).mouseleave(b || a);
    }, bind: function bind(a, b, c) {
      return this.on(a, null, b, c);
    }, unbind: function unbind(a, b) {
      return this.off(a, null, b);
    }, delegate: function delegate(a, b, c, d) {
      return this.on(b, a, c, d);
    }, undelegate: function undelegate(a, b, c) {
      return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
    } });var cb = n.now(),
      db = /\?/;n.parseJSON = function (a) {
    return JSON.parse(a + "");
  }, n.parseXML = function (a) {
    var b, c;if (!a || "string" != typeof a) return null;try {
      c = new DOMParser(), b = c.parseFromString(a, "text/xml");
    } catch (d) {
      b = void 0;
    }return (!b || b.getElementsByTagName("parsererror").length) && n.error("Invalid XML: " + a), b;
  };var eb = /#.*$/,
      fb = /([?&])_=[^&]*/,
      gb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      hb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      ib = /^(?:GET|HEAD)$/,
      jb = /^\/\//,
      kb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      lb = {},
      mb = {},
      nb = "*/".concat("*"),
      ob = a.location.href,
      pb = kb.exec(ob.toLowerCase()) || [];function qb(a) {
    return function (b, c) {
      "string" != typeof b && (c = b, b = "*");var d,
          e = 0,
          f = b.toLowerCase().match(E) || [];if (n.isFunction(c)) while (d = f[e++]) {
        "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
      }
    };
  }function rb(a, b, c, d) {
    var e = {},
        f = a === mb;function g(h) {
      var i;return e[h] = !0, n.each(a[h] || [], function (a, h) {
        var j = h(b, c, d);return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1);
      }), i;
    }return g(b.dataTypes[0]) || !e["*"] && g("*");
  }function sb(a, b) {
    var c,
        d,
        e = n.ajaxSettings.flatOptions || {};for (c in b) {
      void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
    }return d && n.extend(!0, a, d), a;
  }function tb(a, b, c) {
    var d,
        e,
        f,
        g,
        h = a.contents,
        i = a.dataTypes;while ("*" === i[0]) {
      i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
    }if (d) for (e in h) {
      if (h[e] && h[e].test(d)) {
        i.unshift(e);break;
      }
    }if (i[0] in c) f = i[0];else {
      for (e in c) {
        if (!i[0] || a.converters[e + " " + i[0]]) {
          f = e;break;
        }g || (g = e);
      }f = f || g;
    }return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
  }function ub(a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j = {},
        k = a.dataTypes.slice();if (k[1]) for (g in a.converters) {
      j[g.toLowerCase()] = a.converters[g];
    }f = k.shift();while (f) {
      if (a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift()) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
        if (g = j[i + " " + f] || j["* " + f], !g) for (e in j) {
          if (h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
            g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));break;
          }
        }if (g !== !0) if (g && a["throws"]) b = g(b);else try {
          b = g(b);
        } catch (l) {
          return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f };
        }
      }
    }return { state: "success", data: b };
  }n.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: ob, type: "GET", isLocal: hb.test(pb[1]), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": nb, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /xml/, html: /html/, json: /json/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": n.parseJSON, "text xml": n.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(a, b) {
      return b ? sb(sb(a, n.ajaxSettings), b) : sb(n.ajaxSettings, a);
    }, ajaxPrefilter: qb(lb), ajaxTransport: qb(mb), ajax: function ajax(a, b) {
      "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) && (b = a, a = void 0), b = b || {};var c,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = n.ajaxSetup({}, b),
          l = k.context || k,
          m = k.context && (l.nodeType || l.jquery) ? n(l) : n.event,
          o = n.Deferred(),
          p = n.Callbacks("once memory"),
          q = k.statusCode || {},
          r = {},
          s = {},
          t = 0,
          u = "canceled",
          v = { readyState: 0, getResponseHeader: function getResponseHeader(a) {
          var b;if (2 === t) {
            if (!f) {
              f = {};while (b = gb.exec(e)) {
                f[b[1].toLowerCase()] = b[2];
              }
            }b = f[a.toLowerCase()];
          }return null == b ? null : b;
        }, getAllResponseHeaders: function getAllResponseHeaders() {
          return 2 === t ? e : null;
        }, setRequestHeader: function setRequestHeader(a, b) {
          var c = a.toLowerCase();return t || (a = s[c] = s[c] || a, r[a] = b), this;
        }, overrideMimeType: function overrideMimeType(a) {
          return t || (k.mimeType = a), this;
        }, statusCode: function statusCode(a) {
          var b;if (a) if (2 > t) for (b in a) {
            q[b] = [q[b], a[b]];
          } else v.always(a[v.status]);return this;
        }, abort: function abort(a) {
          var b = a || u;return c && c.abort(b), x(0, b), this;
        } };if (o.promise(v).complete = p.add, v.success = v.done, v.error = v.fail, k.url = ((a || k.url || ob) + "").replace(eb, "").replace(jb, pb[1] + "//"), k.type = b.method || b.type || k.method || k.type, k.dataTypes = n.trim(k.dataType || "*").toLowerCase().match(E) || [""], null == k.crossDomain && (h = kb.exec(k.url.toLowerCase()), k.crossDomain = !(!h || h[1] === pb[1] && h[2] === pb[2] && (h[3] || ("http:" === h[1] ? "80" : "443")) === (pb[3] || ("http:" === pb[1] ? "80" : "443")))), k.data && k.processData && "string" != typeof k.data && (k.data = n.param(k.data, k.traditional)), rb(lb, k, b, v), 2 === t) return v;i = n.event && k.global, i && 0 === n.active++ && n.event.trigger("ajaxStart"), k.type = k.type.toUpperCase(), k.hasContent = !ib.test(k.type), d = k.url, k.hasContent || (k.data && (d = k.url += (db.test(d) ? "&" : "?") + k.data, delete k.data), k.cache === !1 && (k.url = fb.test(d) ? d.replace(fb, "$1_=" + cb++) : d + (db.test(d) ? "&" : "?") + "_=" + cb++)), k.ifModified && (n.lastModified[d] && v.setRequestHeader("If-Modified-Since", n.lastModified[d]), n.etag[d] && v.setRequestHeader("If-None-Match", n.etag[d])), (k.data && k.hasContent && k.contentType !== !1 || b.contentType) && v.setRequestHeader("Content-Type", k.contentType), v.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + ("*" !== k.dataTypes[0] ? ", " + nb + "; q=0.01" : "") : k.accepts["*"]);for (j in k.headers) {
        v.setRequestHeader(j, k.headers[j]);
      }if (k.beforeSend && (k.beforeSend.call(l, v, k) === !1 || 2 === t)) return v.abort();u = "abort";for (j in { success: 1, error: 1, complete: 1 }) {
        v[j](k[j]);
      }if (c = rb(mb, k, b, v)) {
        v.readyState = 1, i && m.trigger("ajaxSend", [v, k]), k.async && k.timeout > 0 && (g = setTimeout(function () {
          v.abort("timeout");
        }, k.timeout));try {
          t = 1, c.send(r, x);
        } catch (w) {
          if (!(2 > t)) throw w;x(-1, w);
        }
      } else x(-1, "No Transport");function x(a, b, f, h) {
        var j,
            r,
            s,
            u,
            w,
            x = b;2 !== t && (t = 2, g && clearTimeout(g), c = void 0, e = h || "", v.readyState = a > 0 ? 4 : 0, j = a >= 200 && 300 > a || 304 === a, f && (u = tb(k, v, f)), u = ub(k, u, v, j), j ? (k.ifModified && (w = v.getResponseHeader("Last-Modified"), w && (n.lastModified[d] = w), w = v.getResponseHeader("etag"), w && (n.etag[d] = w)), 204 === a || "HEAD" === k.type ? x = "nocontent" : 304 === a ? x = "notmodified" : (x = u.state, r = u.data, s = u.error, j = !s)) : (s = x, (a || !x) && (x = "error", 0 > a && (a = 0))), v.status = a, v.statusText = (b || x) + "", j ? o.resolveWith(l, [r, x, v]) : o.rejectWith(l, [v, x, s]), v.statusCode(q), q = void 0, i && m.trigger(j ? "ajaxSuccess" : "ajaxError", [v, k, j ? r : s]), p.fireWith(l, [v, x]), i && (m.trigger("ajaxComplete", [v, k]), --n.active || n.event.trigger("ajaxStop")));
      }return v;
    }, getJSON: function getJSON(a, b, c) {
      return n.get(a, b, c, "json");
    }, getScript: function getScript(a, b) {
      return n.get(a, void 0, b, "script");
    } }), n.each(["get", "post"], function (a, b) {
    n[b] = function (a, c, d, e) {
      return n.isFunction(c) && (e = e || d, d = c, c = void 0), n.ajax({ url: a, type: b, dataType: e, data: c, success: d });
    };
  }), n._evalUrl = function (a) {
    return n.ajax({ url: a, type: "GET", dataType: "script", async: !1, global: !1, "throws": !0 });
  }, n.fn.extend({ wrapAll: function wrapAll(a) {
      var b;return n.isFunction(a) ? this.each(function (b) {
        n(this).wrapAll(a.call(this, b));
      }) : (this[0] && (b = n(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
        var a = this;while (a.firstElementChild) {
          a = a.firstElementChild;
        }return a;
      }).append(this)), this);
    }, wrapInner: function wrapInner(a) {
      return this.each(n.isFunction(a) ? function (b) {
        n(this).wrapInner(a.call(this, b));
      } : function () {
        var b = n(this),
            c = b.contents();c.length ? c.wrapAll(a) : b.append(a);
      });
    }, wrap: function wrap(a) {
      var b = n.isFunction(a);return this.each(function (c) {
        n(this).wrapAll(b ? a.call(this, c) : a);
      });
    }, unwrap: function unwrap() {
      return this.parent().each(function () {
        n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
      }).end();
    } }), n.expr.filters.hidden = function (a) {
    return a.offsetWidth <= 0 && a.offsetHeight <= 0;
  }, n.expr.filters.visible = function (a) {
    return !n.expr.filters.hidden(a);
  };var vb = /%20/g,
      wb = /\[\]$/,
      xb = /\r?\n/g,
      yb = /^(?:submit|button|image|reset|file)$/i,
      zb = /^(?:input|select|textarea|keygen)/i;function Ab(a, b, c, d) {
    var e;if (n.isArray(b)) n.each(b, function (b, e) {
      c || wb.test(a) ? d(a, e) : Ab(a + "[" + ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e)) ? b : "") + "]", e, c, d);
    });else if (c || "object" !== n.type(b)) d(a, b);else for (e in b) {
      Ab(a + "[" + e + "]", b[e], c, d);
    }
  }n.param = function (a, b) {
    var c,
        d = [],
        e = function e(a, b) {
      b = n.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
    };if (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a) || a.jquery && !n.isPlainObject(a)) n.each(a, function () {
      e(this.name, this.value);
    });else for (c in a) {
      Ab(c, a[c], b, e);
    }return d.join("&").replace(vb, "+");
  }, n.fn.extend({ serialize: function serialize() {
      return n.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var a = n.prop(this, "elements");return a ? n.makeArray(a) : this;
      }).filter(function () {
        var a = this.type;return this.name && !n(this).is(":disabled") && zb.test(this.nodeName) && !yb.test(a) && (this.checked || !T.test(a));
      }).map(function (a, b) {
        var c = n(this).val();return null == c ? null : n.isArray(c) ? n.map(c, function (a) {
          return { name: b.name, value: a.replace(xb, "\r\n") };
        }) : { name: b.name, value: c.replace(xb, "\r\n") };
      }).get();
    } }), n.ajaxSettings.xhr = function () {
    try {
      return new XMLHttpRequest();
    } catch (a) {}
  };var Bb = 0,
      Cb = {},
      Db = { 0: 200, 1223: 204 },
      Eb = n.ajaxSettings.xhr();a.attachEvent && a.attachEvent("onunload", function () {
    for (var a in Cb) {
      Cb[a]();
    }
  }), k.cors = !!Eb && "withCredentials" in Eb, k.ajax = Eb = !!Eb, n.ajaxTransport(function (a) {
    var _b2;return k.cors || Eb && !a.crossDomain ? { send: function send(c, d) {
        var e,
            f = a.xhr(),
            g = ++Bb;if (f.open(a.type, a.url, a.async, a.username, a.password), a.xhrFields) for (e in a.xhrFields) {
          f[e] = a.xhrFields[e];
        }a.mimeType && f.overrideMimeType && f.overrideMimeType(a.mimeType), a.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");for (e in c) {
          f.setRequestHeader(e, c[e]);
        }_b2 = function b(a) {
          return function () {
            _b2 && (delete Cb[g], _b2 = f.onload = f.onerror = null, "abort" === a ? f.abort() : "error" === a ? d(f.status, f.statusText) : d(Db[f.status] || f.status, f.statusText, "string" == typeof f.responseText ? { text: f.responseText } : void 0, f.getAllResponseHeaders()));
          };
        }, f.onload = _b2(), f.onerror = _b2("error"), _b2 = Cb[g] = _b2("abort");try {
          f.send(a.hasContent && a.data || null);
        } catch (h) {
          if (_b2) throw h;
        }
      }, abort: function abort() {
        _b2 && _b2();
      } } : void 0;
  }), n.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /(?:java|ecma)script/ }, converters: { "text script": function textScript(a) {
        return n.globalEval(a), a;
      } } }), n.ajaxPrefilter("script", function (a) {
    void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
  }), n.ajaxTransport("script", function (a) {
    if (a.crossDomain) {
      var b, _c;return { send: function send(d, e) {
          b = n("<script>").prop({ async: !0, charset: a.scriptCharset, src: a.url }).on("load error", _c = function c(a) {
            b.remove(), _c = null, a && e("error" === a.type ? 404 : 200, a.type);
          }), l.head.appendChild(b[0]);
        }, abort: function abort() {
          _c && _c();
        } };
    }
  });var Fb = [],
      Gb = /(=)\?(?=&|$)|\?\?/;n.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
      var a = Fb.pop() || n.expando + "_" + cb++;return this[a] = !0, a;
    } }), n.ajaxPrefilter("json jsonp", function (b, c, d) {
    var e,
        f,
        g,
        h = b.jsonp !== !1 && (Gb.test(b.url) ? "url" : "string" == typeof b.data && !(b.contentType || "").indexOf("application/x-www-form-urlencoded") && Gb.test(b.data) && "data");return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Gb, "$1" + e) : b.jsonp !== !1 && (b.url += (db.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
      return g || n.error(e + " was not called"), g[0];
    }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
      g = arguments;
    }, d.always(function () {
      a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Fb.push(e)), g && n.isFunction(f) && f(g[0]), g = f = void 0;
    }), "script") : void 0;
  }), n.parseHTML = function (a, b, c) {
    if (!a || "string" != typeof a) return null;"boolean" == typeof b && (c = b, b = !1), b = b || l;var d = v.exec(a),
        e = !c && [];return d ? [b.createElement(d[1])] : (d = n.buildFragment([a], b, e), e && e.length && n(e).remove(), n.merge([], d.childNodes));
  };var Hb = n.fn.load;n.fn.load = function (a, b, c) {
    if ("string" != typeof a && Hb) return Hb.apply(this, arguments);var d,
        e,
        f,
        g = this,
        h = a.indexOf(" ");return h >= 0 && (d = n.trim(a.slice(h)), a = a.slice(0, h)), n.isFunction(b) ? (c = b, b = void 0) : b && "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(b)) && (e = "POST"), g.length > 0 && n.ajax({ url: a, type: e, dataType: "html", data: b }).done(function (a) {
      f = arguments, g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
    }).complete(c && function (a, b) {
      g.each(c, f || [a.responseText, b, a]);
    }), this;
  }, n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
    n.fn[b] = function (a) {
      return this.on(b, a);
    };
  }), n.expr.filters.animated = function (a) {
    return n.grep(n.timers, function (b) {
      return a === b.elem;
    }).length;
  };var Ib = a.document.documentElement;function Jb(a) {
    return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView;
  }n.offset = { setOffset: function setOffset(a, b, c) {
      var d,
          e,
          f,
          g,
          h,
          i,
          j,
          k = n.css(a, "position"),
          l = n(a),
          m = {};"static" === k && (a.style.position = "relative"), h = l.offset(), f = n.css(a, "top"), i = n.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), n.isFunction(b) && (b = b.call(a, c, h)), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
    } }, n.fn.extend({ offset: function offset(a) {
      if (arguments.length) return void 0 === a ? this : this.each(function (b) {
        n.offset.setOffset(this, a, b);
      });var b,
          c,
          d = this[0],
          e = { top: 0, left: 0 },
          f = d && d.ownerDocument;if (f) return b = f.documentElement, n.contains(b, d) ? (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(d.getBoundingClientRect) !== U && (e = d.getBoundingClientRect()), c = Jb(f), { top: e.top + c.pageYOffset - b.clientTop, left: e.left + c.pageXOffset - b.clientLeft }) : e;
    }, position: function position() {
      if (this[0]) {
        var a,
            b,
            c = this[0],
            d = { top: 0, left: 0 };return "fixed" === n.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), n.nodeName(a[0], "html") || (d = a.offset()), d.top += n.css(a[0], "borderTopWidth", !0), d.left += n.css(a[0], "borderLeftWidth", !0)), { top: b.top - d.top - n.css(c, "marginTop", !0), left: b.left - d.left - n.css(c, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        var a = this.offsetParent || Ib;while (a && !n.nodeName(a, "html") && "static" === n.css(a, "position")) {
          a = a.offsetParent;
        }return a || Ib;
      });
    } }), n.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (b, c) {
    var d = "pageYOffset" === c;n.fn[b] = function (e) {
      return J(this, function (b, e, f) {
        var g = Jb(b);return void 0 === f ? g ? g[c] : b[e] : void (g ? g.scrollTo(d ? a.pageXOffset : f, d ? f : a.pageYOffset) : b[e] = f);
      }, b, e, arguments.length, null);
    };
  }), n.each(["top", "left"], function (a, b) {
    n.cssHooks[b] = ya(k.pixelPosition, function (a, c) {
      return c ? (c = xa(a, b), va.test(c) ? n(a).position()[b] + "px" : c) : void 0;
    });
  }), n.each({ Height: "height", Width: "width" }, function (a, b) {
    n.each({ padding: "inner" + a, content: b, "": "outer" + a }, function (c, d) {
      n.fn[d] = function (d, e) {
        var f = arguments.length && (c || "boolean" != typeof d),
            g = c || (d === !0 || e === !0 ? "margin" : "border");return J(this, function (b, c, d) {
          var e;return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g);
        }, b, f ? d : void 0, f, null);
      };
    });
  }), n.fn.size = function () {
    return this.length;
  }, n.fn.andSelf = n.fn.addBack, "function" == typeof define && __webpack_require__(67) && define("jquery", [], function () {
    return n;
  });var Kb = a.jQuery,
      Lb = a.$;return n.noConflict = function (b) {
    return a.$ === n && (a.$ = Lb), b && a.jQuery === n && (a.jQuery = Kb), n;
  }, (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(b)) === U && (a.jQuery = a.$ = n), n;
});
//# sourceMappingURL=jquery.min.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)(module)))

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");+function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1 || b[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4");
}(jQuery), +function (a) {
  "use strict";
  function b() {
    var a = document.createElement("bootstrap"),
        b = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd otransitionend", transition: "transitionend" };for (var c in b) {
      if (void 0 !== a.style[c]) return { end: b[c] };
    }return !1;
  }a.fn.emulateTransitionEnd = function (b) {
    var c = !1,
        d = this;a(this).one("bsTransitionEnd", function () {
      c = !0;
    });var e = function e() {
      c || a(d).trigger(a.support.transition.end);
    };return setTimeout(e, b), this;
  }, a(function () {
    a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = { bindType: a.support.transition.end, delegateType: a.support.transition.end, handle: function handle(b) {
        if (a(b.target).is(this)) return b.handleObj.handler.apply(this, arguments);
      } });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.alert");e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c);
    });
  }var c = '[data-dismiss="alert"]',
      d = function d(b) {
    a(b).on("click", c, this.close);
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 150, d.prototype.close = function (b) {
    function c() {
      g.detach().trigger("closed.bs.alert").remove();
    }var e = a(this),
        f = e.attr("data-target");f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));var g = a("#" === f ? [] : f);b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c());
  };var e = a.fn.alert;a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function () {
    return a.fn.alert = e, this;
  }, a(document).on("click.bs.alert.data-api", c, d.prototype.close);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.button"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b);
    });
  }var c = function c(b, d) {
    this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1;
  };c.VERSION = "3.3.7", c.DEFAULTS = { loadingText: "loading..." }, c.prototype.setState = function (b) {
    var c = "disabled",
        d = this.$element,
        e = d.is("input") ? "val" : "html",
        f = d.data();b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function () {
      d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c).prop(c, !0)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c).prop(c, !1));
    }, this), 0);
  }, c.prototype.toggle = function () {
    var a = !0,
        b = this.$element.closest('[data-toggle="buttons"]');if (b.length) {
      var c = this.$element.find("input");"radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change");
    } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active");
  };var d = a.fn.button;a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function () {
    return a.fn.button = d, this;
  }, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function (c) {
    var d = a(c.target).closest(".btn");b.call(d, "toggle"), a(c.target).is('input[type="radio"], input[type="checkbox"]') || (c.preventDefault(), d.is("input,button") ? d.trigger("focus") : d.find("input:visible,button:visible").first().trigger("focus"));
  }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function (b) {
    a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type));
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b),
          g = "string" == typeof b ? b : f.slide;e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle();
    });
  }var c = function c(b, _c) {
    this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = _c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 600, c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }, c.prototype.keydown = function (a) {
    if (!/input|textarea/i.test(a.target.tagName)) {
      switch (a.which) {case 37:
          this.prev();break;case 39:
          this.next();break;default:
          return;}a.preventDefault();
    }
  }, c.prototype.cycle = function (b) {
    return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this;
  }, c.prototype.getItemIndex = function (a) {
    return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active);
  }, c.prototype.getItemForDirection = function (a, b) {
    var c = this.getItemIndex(b),
        d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;if (d && !this.options.wrap) return b;var e = "prev" == a ? -1 : 1,
        f = (c + e) % this.$items.length;return this.$items.eq(f);
  }, c.prototype.to = function (a) {
    var b = this,
        c = this.getItemIndex(this.$active = this.$element.find(".item.active"));if (!(a > this.$items.length - 1 || a < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function () {
      b.to(a);
    }) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
  }, c.prototype.pause = function (b) {
    return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this;
  }, c.prototype.next = function () {
    if (!this.sliding) return this.slide("next");
  }, c.prototype.prev = function () {
    if (!this.sliding) return this.slide("prev");
  }, c.prototype.slide = function (b, d) {
    var e = this.$element.find(".item.active"),
        f = d || this.getItemForDirection(b, e),
        g = this.interval,
        h = "next" == b ? "left" : "right",
        i = this;if (f.hasClass("active")) return this.sliding = !1;var j = f[0],
        k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });if (this.$element.trigger(k), !k.isDefaultPrevented()) {
      if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
        this.$indicators.find(".active").removeClass("active");var l = a(this.$indicators.children()[this.getItemIndex(f)]);l && l.addClass("active");
      }var m = a.Event("slid.bs.carousel", { relatedTarget: j, direction: h });return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function () {
        f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function () {
          i.$element.trigger(m);
        }, 0);
      }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this;
    }
  };var d = a.fn.carousel;a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function () {
    return a.fn.carousel = d, this;
  };var e = function e(c) {
    var d,
        e = a(this),
        f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));if (f.hasClass("carousel")) {
      var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault();
    }
  };a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function () {
    a('[data-ride="carousel"]').each(function () {
      var c = a(this);b.call(c, c.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c,
        d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");return a(d);
  }function c(b) {
    return this.each(function () {
      var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]();
    });
  }var d = function d(b, c) {
    this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle();
  };d.VERSION = "3.3.7", d.TRANSITION_DURATION = 350, d.DEFAULTS = { toggle: !0 }, d.prototype.dimension = function () {
    var a = this.$element.hasClass("width");return a ? "width" : "height";
  }, d.prototype.show = function () {
    if (!this.transitioning && !this.$element.hasClass("in")) {
      var b,
          e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
        var f = a.Event("show.bs.collapse");if (this.$element.trigger(f), !f.isDefaultPrevented()) {
          e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));var g = this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;var h = function h() {
            this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse");
          };if (!a.support.transition) return h.call(this);var i = a.camelCase(["scroll", g].join("-"));this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i]);
        }
      }
    }
  }, d.prototype.hide = function () {
    if (!this.transitioning && this.$element.hasClass("in")) {
      var b = a.Event("hide.bs.collapse");if (this.$element.trigger(b), !b.isDefaultPrevented()) {
        var c = this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;var e = function e() {
          this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse");
        };return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this);
      }
    }
  }, d.prototype.toggle = function () {
    this[this.$element.hasClass("in") ? "hide" : "show"]();
  }, d.prototype.getParent = function () {
    return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function (c, d) {
      var e = a(d);this.addAriaAndCollapsedClass(b(e), e);
    }, this)).end();
  }, d.prototype.addAriaAndCollapsedClass = function (a, b) {
    var c = a.hasClass("in");a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c);
  };var e = a.fn.collapse;a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function () {
    return a.fn.collapse = e, this;
  }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (d) {
    var e = a(this);e.attr("data-target") || d.preventDefault();var f = b(e),
        g = f.data("bs.collapse"),
        h = g ? "toggle" : e.data();c.call(f, h);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    var c = b.attr("data-target");c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));var d = c && a(c);return d && d.length ? d : b.parent();
  }function c(c) {
    c && 3 === c.which || (a(e).remove(), a(f).each(function () {
      var d = a(this),
          e = b(d),
          f = { relatedTarget: this };e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger(a.Event("hidden.bs.dropdown", f)))));
    }));
  }function d(b) {
    return this.each(function () {
      var c = a(this),
          d = c.data("bs.dropdown");d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c);
    });
  }var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function g(b) {
    a(b).on("click.bs.dropdown", this.toggle);
  };g.VERSION = "3.3.7", g.prototype.toggle = function (d) {
    var e = a(this);if (!e.is(".disabled, :disabled")) {
      var f = b(e),
          g = f.hasClass("open");if (c(), !g) {
        "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);var h = { relatedTarget: this };if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
      }return !1;
    }
  }, g.prototype.keydown = function (c) {
    if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
      var d = a(this);if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
        var e = b(d),
            g = e.hasClass("open");if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");var h = " li:not(.disabled):visible a",
            i = e.find(".dropdown-menu" + h);if (i.length) {
          var j = i.index(c.target);38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus");
        }
      }
    }
  };var h = a.fn.dropdown;a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function () {
    return a.fn.dropdown = h, this;
  }, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
    a.stopPropagation();
  }).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown);
}(jQuery), +function (a) {
  "use strict";
  function b(b, d) {
    return this.each(function () {
      var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b);f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d);
    });
  }var c = function c(b, _c2) {
    this.options = _c2, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function () {
      this.$element.trigger("loaded.bs.modal");
    }, this));
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }, c.prototype.toggle = function (a) {
    return this.isShown ? this.hide() : this.show(a);
  }, c.prototype.show = function (b) {
    var d = this,
        e = a.Event("show.bs.modal", { relatedTarget: b });this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function () {
      d.$element.one("mouseup.dismiss.bs.modal", function (b) {
        a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
      });
    }), this.backdrop(function () {
      var e = a.support.transition && d.$element.hasClass("fade");d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();var f = a.Event("shown.bs.modal", { relatedTarget: b });e ? d.$dialog.one("bsTransitionEnd", function () {
        d.$element.trigger("focus").trigger(f);
      }).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f);
    }));
  }, c.prototype.hide = function (b) {
    b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal());
  }, c.prototype.enforceFocus = function () {
    a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function (a) {
      document === a.target || this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus");
    }, this));
  }, c.prototype.escape = function () {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function (a) {
      27 == a.which && this.hide();
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
  }, c.prototype.resize = function () {
    this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal");
  }, c.prototype.hideModal = function () {
    var a = this;this.$element.hide(), this.backdrop(function () {
      a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal");
    });
  }, c.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null;
  }, c.prototype.backdrop = function (b) {
    var d = this,
        e = this.$element.hasClass("fade") ? "fade" : "";if (this.isShown && this.options.backdrop) {
      var f = a.support.transition && e;if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function (a) {
        return this.ignoreBackdropClick ? void (this.ignoreBackdropClick = !1) : void (a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()));
      }, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b();
    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass("in");var g = function g() {
        d.removeBackdrop(), b && b();
      };a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g();
    } else b && b();
  }, c.prototype.handleUpdate = function () {
    this.adjustDialog();
  }, c.prototype.adjustDialog = function () {
    var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;this.$element.css({ paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "", paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "" });
  }, c.prototype.resetAdjustments = function () {
    this.$element.css({ paddingLeft: "", paddingRight: "" });
  }, c.prototype.checkScrollbar = function () {
    var a = window.innerWidth;if (!a) {
      var b = document.documentElement.getBoundingClientRect();a = b.right - Math.abs(b.left);
    }this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar();
  }, c.prototype.setScrollbar = function () {
    var a = parseInt(this.$body.css("padding-right") || 0, 10);this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth);
  }, c.prototype.resetScrollbar = function () {
    this.$body.css("padding-right", this.originalBodyPad);
  }, c.prototype.measureScrollbar = function () {
    var a = document.createElement("div");a.className = "modal-scrollbar-measure", this.$body.append(a);var b = a.offsetWidth - a.clientWidth;return this.$body[0].removeChild(a), b;
  };var d = a.fn.modal;a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function () {
    return a.fn.modal = d, this;
  }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (c) {
    var d = a(this),
        e = d.attr("href"),
        f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
        g = f.data("bs.modal") ? "toggle" : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());d.is("a") && c.preventDefault(), f.one("show.bs.modal", function (a) {
      a.isDefaultPrevented() || f.one("hidden.bs.modal", function () {
        d.is(":visible") && d.trigger("focus");
      });
    }), b.call(f, g, this);
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.DEFAULTS = { animation: !0, placement: "top", selector: !1, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', trigger: "hover focus", title: "", delay: 0, html: !1, container: !1, viewport: { selector: "body", padding: 0 } }, c.prototype.init = function (b, c, d) {
    if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = { click: !1, hover: !1, focus: !1 }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
      var g = e[f];if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));else if ("manual" != g) {
        var h = "hover" == g ? "mouseenter" : "focusin",
            i = "hover" == g ? "mouseleave" : "focusout";this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this));
      }
    }this.options.selector ? this._options = a.extend({}, this.options, { trigger: "manual", selector: "" }) : this.fixTitle();
  }, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.getOptions = function (b) {
    return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = { show: b.delay, hide: b.delay }), b;
  }, c.prototype.getDelegateOptions = function () {
    var b = {},
        c = this.getDefaults();return this._options && a.each(this._options, function (a, d) {
      c[a] != d && (b[a] = d);
    }), b;
  }, c.prototype.enter = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void (c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void (c.timeout = setTimeout(function () {
      "in" == c.hoverState && c.show();
    }, c.options.delay.show)) : c.show());
  }, c.prototype.isInStateTrue = function () {
    for (var a in this.inState) {
      if (this.inState[a]) return !0;
    }return !1;
  }, c.prototype.leave = function (b) {
    var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);if (c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), !c.isInStateTrue()) return clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void (c.timeout = setTimeout(function () {
      "out" == c.hoverState && c.hide();
    }, c.options.delay.hide)) : c.hide();
  }, c.prototype.show = function () {
    var b = a.Event("show.bs." + this.type);if (this.hasContent() && this.enabled) {
      this.$element.trigger(b);var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);if (b.isDefaultPrevented() || !d) return;var e = this,
          f = this.tip(),
          g = this.getUID(this.type);this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
          i = /\s?auto?\s?/i,
          j = i.test(h);j && (h = h.replace(i, "") || "top"), f.detach().css({ top: 0, left: 0, display: "block" }).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);var k = this.getPosition(),
          l = f[0].offsetWidth,
          m = f[0].offsetHeight;if (j) {
        var n = h,
            o = this.getPosition(this.$viewport);h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h);
      }var p = this.getCalculatedOffset(h, k, l, m);this.applyPlacement(p, h);var q = function q() {
        var a = e.hoverState;e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e);
      };a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q();
    }
  }, c.prototype.applyPlacement = function (b, c) {
    var d = this.tip(),
        e = d[0].offsetWidth,
        f = d[0].offsetHeight,
        g = parseInt(d.css("margin-top"), 10),
        h = parseInt(d.css("margin-left"), 10);isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({ using: function using(a) {
        d.css({ top: Math.round(a.top), left: Math.round(a.left) });
      } }, b), 0), d.addClass("in");var i = d[0].offsetWidth,
        j = d[0].offsetHeight;"top" == c && j != f && (b.top = b.top + f - j);var k = this.getViewportAdjustedDelta(c, b, i, j);k.left ? b.left += k.left : b.top += k.top;var l = /top|bottom/.test(c),
        m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
        n = l ? "offsetWidth" : "offsetHeight";d.offset(b), this.replaceArrow(m, d[0][n], l);
  }, c.prototype.replaceArrow = function (a, b, c) {
    this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "");
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle();a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right");
  }, c.prototype.hide = function (b) {
    function d() {
      "in" != e.hoverState && f.detach(), e.$element && e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b();
    }var e = this,
        f = a(this.$tip),
        g = a.Event("hide.bs." + this.type);if (this.$element.trigger(g), !g.isDefaultPrevented()) return f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this;
  }, c.prototype.fixTitle = function () {
    var a = this.$element;(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "");
  }, c.prototype.hasContent = function () {
    return this.getTitle();
  }, c.prototype.getPosition = function (b) {
    b = b || this.$element;var c = b[0],
        d = "BODY" == c.tagName,
        e = c.getBoundingClientRect();null == e.width && (e = a.extend({}, e, { width: e.right - e.left, height: e.bottom - e.top }));var f = window.SVGElement && c instanceof window.SVGElement,
        g = d ? { top: 0, left: 0 } : f ? null : b.offset(),
        h = { scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop() },
        i = d ? { width: a(window).width(), height: a(window).height() } : null;return a.extend({}, e, h, i, g);
  }, c.prototype.getCalculatedOffset = function (a, b, c, d) {
    return "bottom" == a ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 } : "top" == a ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 } : "left" == a ? { top: b.top + b.height / 2 - d / 2, left: b.left - c } : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
  }, c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
    var e = { top: 0, left: 0 };if (!this.$viewport) return e;var f = this.options.viewport && this.options.viewport.padding || 0,
        g = this.getPosition(this.$viewport);if (/right|left/.test(a)) {
      var h = b.top - f - g.scroll,
          i = b.top + f - g.scroll + d;h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i);
    } else {
      var j = b.left - f,
          k = b.left + f + c;j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k);
    }return e;
  }, c.prototype.getTitle = function () {
    var a,
        b = this.$element,
        c = this.options;return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title);
  }, c.prototype.getUID = function (a) {
    do {
      a += ~~(1e6 * Math.random());
    } while (document.getElementById(a));return a;
  }, c.prototype.tip = function () {
    if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");return this.$tip;
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
  }, c.prototype.enable = function () {
    this.enabled = !0;
  }, c.prototype.disable = function () {
    this.enabled = !1;
  }, c.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  }, c.prototype.toggle = function (b) {
    var c = this;b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c);
  }, c.prototype.destroy = function () {
    var a = this;clearTimeout(this.timeout), this.hide(function () {
      a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null, a.$element = null;
    });
  };var d = a.fn.tooltip;a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function () {
    return a.fn.tooltip = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;!e && /destroy|hide/.test(b) || (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]());
    });
  }var c = function c(a, b) {
    this.init("popover", a, b);
  };if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");c.VERSION = "3.3.7", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, { placement: "right", trigger: "click", content: "", template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>' }), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function () {
    return c.DEFAULTS;
  }, c.prototype.setContent = function () {
    var a = this.tip(),
        b = this.getTitle(),
        c = this.getContent();a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide();
  }, c.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  }, c.prototype.getContent = function () {
    var a = this.$element,
        b = this.options;return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content);
  }, c.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find(".arrow");
  };var d = a.fn.popover;a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function () {
    return a.fn.popover = d, this;
  };
}(jQuery), +function (a) {
  "use strict";
  function b(c, d) {
    this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process();
  }function c(c) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) && c;e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]();
    });
  }b.VERSION = "3.3.7", b.DEFAULTS = { offset: 10 }, b.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
  }, b.prototype.refresh = function () {
    var b = this,
        c = "offset",
        d = 0;this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function () {
      var b = a(this),
          e = b.data("target") || b.attr("href"),
          f = /^#./.test(e) && a(e);return f && f.length && f.is(":visible") && [[f[c]().top + d, e]] || null;
    }).sort(function (a, b) {
      return a[0] - b[0];
    }).each(function () {
      b.offsets.push(this[0]), b.targets.push(this[1]);
    });
  }, b.prototype.process = function () {
    var a,
        b = this.$scrollElement.scrollTop() + this.options.offset,
        c = this.getScrollHeight(),
        d = this.options.offset + c - this.$scrollElement.height(),
        e = this.offsets,
        f = this.targets,
        g = this.activeTarget;if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);if (g && b < e[0]) return this.activeTarget = null, this.clear();for (a = e.length; a--;) {
      g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a]);
    }
  }, b.prototype.activate = function (b) {
    this.activeTarget = b, this.clear();var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
        d = a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy");
  }, b.prototype.clear = function () {
    a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active");
  };var d = a.fn.scrollspy;a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function () {
    return a.fn.scrollspy = d, this;
  }, a(window).on("load.bs.scrollspy.data-api", function () {
    a('[data-spy="scroll"]').each(function () {
      var b = a(this);c.call(b, b.data());
    });
  });
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.tab");e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]();
    });
  }var c = function c(b) {
    this.element = a(b);
  };c.VERSION = "3.3.7", c.TRANSITION_DURATION = 150, c.prototype.show = function () {
    var b = this.element,
        c = b.closest("ul:not(.dropdown-menu)"),
        d = b.data("target");if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
      var e = c.find(".active:last a"),
          f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
          g = a.Event("show.bs.tab", { relatedTarget: e[0] });if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
        var h = a(d);this.activate(b.closest("li"), c), this.activate(h, h.parent(), function () {
          e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }), b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
        });
      }
    }
  }, c.prototype.activate = function (b, d, e) {
    function f() {
      g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e();
    }var g = d.find("> .active"),
        h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in");
  };var d = a.fn.tab;a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function () {
    return a.fn.tab = d, this;
  };var e = function e(c) {
    c.preventDefault(), b.call(a(this), "show");
  };a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
}(jQuery), +function (a) {
  "use strict";
  function b(b) {
    return this.each(function () {
      var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && b;e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]();
    });
  }var c = function c(b, d) {
    this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition();
  };c.VERSION = "3.3.7", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = { offset: 0, target: window }, c.prototype.getState = function (a, b, c, d) {
    var e = this.$target.scrollTop(),
        f = this.$element.offset(),
        g = this.$target.height();if (null != c && "top" == this.affixed) return e < c && "top";if ("bottom" == this.affixed) return null != c ? !(e + this.unpin <= f.top) && "bottom" : !(e + g <= a - d) && "bottom";var h = null == this.affixed,
        i = h ? e : f.top,
        j = h ? g : b;return null != c && e <= c ? "top" : null != d && i + j >= a - d && "bottom";
  }, c.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a = this.$target.scrollTop(),
        b = this.$element.offset();return this.pinnedOffset = b.top - a;
  }, c.prototype.checkPositionWithEventLoop = function () {
    setTimeout(a.proxy(this.checkPosition, this), 1);
  }, c.prototype.checkPosition = function () {
    if (this.$element.is(":visible")) {
      var b = this.$element.height(),
          d = this.options.offset,
          e = d.top,
          f = d.bottom,
          g = Math.max(a(document).height(), a(document.body).height());"object" != (typeof d === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(d)) && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));var h = this.getState(g, b, e, f);if (this.affixed != h) {
        null != this.unpin && this.$element.css("top", "");var i = "affix" + (h ? "-" + h : ""),
            j = a.Event(i + ".bs.affix");if (this.$element.trigger(j), j.isDefaultPrevented()) return;this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix");
      }"bottom" == h && this.$element.offset({ top: g - b - f });
    }
  };var d = a.fn.affix;a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function () {
    return a.fn.affix = d, this;
  }, a(window).on("load", function () {
    a('[data-spy="affix"]').each(function () {
      var c = a(this),
          d = c.data();d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d);
    });
  });
}(jQuery);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* Notify.js - http://notifyjs.com/ Copyright (c) 2015 MIT */
(function (factory) {
	// UMD start
	// https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
	if (typeof define === 'function' && __webpack_require__(67)) {
		// AMD. Register as an anonymous module.
		define(['jquery'], factory);
	} else if (( false ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(module)) === 'object' && module.exports) {
		// Node/CommonJS
		module.exports = function (root, jQuery) {
			if (jQuery === undefined) {
				// require('jQuery') returns a factory that requires window to
				// build a jQuery instance, we normalize how we use modules
				// that require this pattern but the window provided is a noop
				// if it's defined (how jquery works)
				if (typeof window !== 'undefined') {
					jQuery = __webpack_require__(68);
				} else {
					jQuery = __webpack_require__(68)(root);
				}
			}
			factory(jQuery);
			return jQuery;
		};
	} else {
		// Browser globals
		factory(jQuery);
	}
})(function ($) {
	//IE8 indexOf polyfill
	var indexOf = [].indexOf || function (item) {
		for (var i = 0, l = this.length; i < l; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	};

	var pluginName = "notify";
	var pluginClassName = pluginName + "js";
	var blankFieldName = pluginName + "!blank";

	var positions = {
		t: "top",
		m: "middle",
		b: "bottom",
		l: "left",
		c: "center",
		r: "right"
	};
	var hAligns = ["l", "c", "r"];
	var vAligns = ["t", "m", "b"];
	var mainPositions = ["t", "b", "l", "r"];
	var opposites = {
		t: "b",
		m: null,
		b: "t",
		l: "r",
		c: null,
		r: "l"
	};

	var parsePosition = function parsePosition(str) {
		var pos;
		pos = [];
		$.each(str.split(/\W+/), function (i, word) {
			var w;
			w = word.toLowerCase().charAt(0);
			if (positions[w]) {
				return pos.push(w);
			}
		});
		return pos;
	};

	var styles = {};

	var coreStyle = {
		name: "core",
		html: "<div class=\"" + pluginClassName + "-wrapper\">\n	<div class=\"" + pluginClassName + "-arrow\"></div>\n	<div class=\"" + pluginClassName + "-container\"></div>\n</div>",
		css: "." + pluginClassName + "-corner {\n	position: fixed;\n	margin: 5px;\n	z-index: 1050;\n}\n\n." + pluginClassName + "-corner ." + pluginClassName + "-wrapper,\n." + pluginClassName + "-corner ." + pluginClassName + "-container {\n	position: relative;\n	display: block;\n	height: inherit;\n	width: inherit;\n	margin: 3px;\n}\n\n." + pluginClassName + "-wrapper {\n	z-index: 1;\n	position: absolute;\n	display: inline-block;\n	height: 0;\n	width: 0;\n}\n\n." + pluginClassName + "-container {\n	display: none;\n	z-index: 1;\n	position: absolute;\n}\n\n." + pluginClassName + "-hidable {\n	cursor: pointer;\n}\n\n[data-notify-text],[data-notify-html] {\n	position: relative;\n}\n\n." + pluginClassName + "-arrow {\n	position: absolute;\n	z-index: 2;\n	width: 0;\n	height: 0;\n}"
	};

	var stylePrefixes = {
		"border-radius": ["-webkit-", "-moz-"]
	};

	var getStyle = function getStyle(name) {
		return styles[name];
	};

	var removeStyle = function removeStyle(name) {
		if (!name) {
			throw "Missing Style name";
		}
		if (styles[name]) {
			delete styles[name];
		}
	};

	var addStyle = function addStyle(name, def) {
		if (!name) {
			throw "Missing Style name";
		}
		if (!def) {
			throw "Missing Style definition";
		}
		if (!def.html) {
			throw "Missing Style HTML";
		}
		//remove existing style
		var existing = styles[name];
		if (existing && existing.cssElem) {
			if (window.console) {
				console.warn(pluginName + ": overwriting style '" + name + "'");
			}
			styles[name].cssElem.remove();
		}
		def.name = name;
		styles[name] = def;
		var cssText = "";
		if (def.classes) {
			$.each(def.classes, function (className, props) {
				cssText += "." + pluginClassName + "-" + def.name + "-" + className + " {\n";
				$.each(props, function (name, val) {
					if (stylePrefixes[name]) {
						$.each(stylePrefixes[name], function (i, prefix) {
							return cssText += "	" + prefix + name + ": " + val + ";\n";
						});
					}
					return cssText += "	" + name + ": " + val + ";\n";
				});
				return cssText += "}\n";
			});
		}
		if (def.css) {
			cssText += "/* styles for " + def.name + " */\n" + def.css;
		}
		if (cssText) {
			def.cssElem = insertCSS(cssText);
			def.cssElem.attr("id", "notify-" + def.name);
		}
		var fields = {};
		var elem = $(def.html);
		findFields("html", elem, fields);
		findFields("text", elem, fields);
		def.fields = fields;
	};

	var insertCSS = function insertCSS(cssText) {
		var e, elem, error;
		elem = createElem("style");
		elem.attr("type", 'text/css');
		$("head").append(elem);
		try {
			elem.html(cssText);
		} catch (_) {
			elem[0].styleSheet.cssText = cssText;
		}
		return elem;
	};

	var findFields = function findFields(type, elem, fields) {
		var attr;
		if (type !== "html") {
			type = "text";
		}
		attr = "data-notify-" + type;
		return find(elem, "[" + attr + "]").each(function () {
			var name;
			name = $(this).attr(attr);
			if (!name) {
				name = blankFieldName;
			}
			fields[name] = type;
		});
	};

	var find = function find(elem, selector) {
		if (elem.is(selector)) {
			return elem;
		} else {
			return elem.find(selector);
		}
	};

	var pluginOptions = {
		clickToHide: true,
		autoHide: true,
		autoHideDelay: 5000,
		arrowShow: true,
		arrowSize: 5,
		breakNewLines: true,
		elementPosition: "bottom",
		globalPosition: "top right",
		style: "bootstrap",
		className: "error",
		showAnimation: "slideDown",
		showDuration: 400,
		hideAnimation: "slideUp",
		hideDuration: 200,
		gap: 5
	};

	var inherit = function inherit(a, b) {
		var F;
		F = function F() {};
		F.prototype = a;
		return $.extend(true, new F(), b);
	};

	var defaults = function defaults(opts) {
		return $.extend(pluginOptions, opts);
	};

	var createElem = function createElem(tag) {
		return $("<" + tag + "></" + tag + ">");
	};

	var globalAnchors = {};

	var getAnchorElement = function getAnchorElement(element) {
		var radios;
		if (element.is('[type=radio]')) {
			radios = element.parents('form:first').find('[type=radio]').filter(function (i, e) {
				return $(e).attr("name") === element.attr("name");
			});
			element = radios.first();
		}
		return element;
	};

	var incr = function incr(obj, pos, val) {
		var opp, temp;
		if (typeof val === "string") {
			val = parseInt(val, 10);
		} else if (typeof val !== "number") {
			return;
		}
		if (isNaN(val)) {
			return;
		}
		opp = positions[opposites[pos.charAt(0)]];
		temp = pos;
		if (obj[opp] !== undefined) {
			pos = positions[opp.charAt(0)];
			val = -val;
		}
		if (obj[pos] === undefined) {
			obj[pos] = val;
		} else {
			obj[pos] += val;
		}
		return null;
	};

	var realign = function realign(alignment, inner, outer) {
		if (alignment === "l" || alignment === "t") {
			return 0;
		} else if (alignment === "c" || alignment === "m") {
			return outer / 2 - inner / 2;
		} else if (alignment === "r" || alignment === "b") {
			return outer - inner;
		}
		throw "Invalid alignment";
	};

	var encode = function encode(text) {
		encode.e = encode.e || createElem("div");
		return encode.e.text(text).html();
	};

	function Notification(elem, data, options) {
		if (typeof options === "string") {
			options = {
				className: options
			};
		}
		this.options = inherit(pluginOptions, $.isPlainObject(options) ? options : {});
		this.loadHTML();
		this.wrapper = $(coreStyle.html);
		if (this.options.clickToHide) {
			this.wrapper.addClass(pluginClassName + "-hidable");
		}
		this.wrapper.data(pluginClassName, this);
		this.arrow = this.wrapper.find("." + pluginClassName + "-arrow");
		this.container = this.wrapper.find("." + pluginClassName + "-container");
		this.container.append(this.userContainer);
		if (elem && elem.length) {
			this.elementType = elem.attr("type");
			this.originalElement = elem;
			this.elem = getAnchorElement(elem);
			this.elem.data(pluginClassName, this);
			this.elem.before(this.wrapper);
		}
		this.container.hide();
		this.run(data);
	}

	Notification.prototype.loadHTML = function () {
		var style;
		style = this.getStyle();
		this.userContainer = $(style.html);
		this.userFields = style.fields;
	};

	Notification.prototype.show = function (show, userCallback) {
		var args, callback, elems, fn, hidden;
		callback = function (_this) {
			return function () {
				if (!show && !_this.elem) {
					_this.destroy();
				}
				if (userCallback) {
					return userCallback();
				}
			};
		}(this);
		hidden = this.container.parent().parents(':hidden').length > 0;
		elems = this.container.add(this.arrow);
		args = [];
		if (hidden && show) {
			fn = "show";
		} else if (hidden && !show) {
			fn = "hide";
		} else if (!hidden && show) {
			fn = this.options.showAnimation;
			args.push(this.options.showDuration);
		} else if (!hidden && !show) {
			fn = this.options.hideAnimation;
			args.push(this.options.hideDuration);
		} else {
			return callback();
		}
		args.push(callback);
		return elems[fn].apply(elems, args);
	};

	Notification.prototype.setGlobalPosition = function () {
		var p = this.getPosition();
		var pMain = p[0];
		var pAlign = p[1];
		var main = positions[pMain];
		var align = positions[pAlign];
		var key = pMain + "|" + pAlign;
		var anchor = globalAnchors[key];
		if (!anchor || !document.contains(anchor[0])) {
			anchor = globalAnchors[key] = createElem("div");
			var css = {};
			css[main] = 0;
			if (align === "middle") {
				css.top = '45%';
			} else if (align === "center") {
				css.position = 'absolute';
				css.left = '50%';
				css.transform = 'translateX(-50%)';
			} else {
				css[align] = 0;
			}
			anchor.css(css).addClass(pluginClassName + "-corner");
			$("body").append(anchor);
		}
		return anchor.prepend(this.wrapper);
	};

	Notification.prototype.setElementPosition = function () {
		var arrowColor, arrowCss, arrowSize, color, contH, contW, css, elemH, elemIH, elemIW, elemPos, elemW, gap, j, k, len, len1, mainFull, margin, opp, oppFull, pAlign, pArrow, pMain, pos, posFull, position, ref, wrapPos;
		position = this.getPosition();
		pMain = position[0];
		pAlign = position[1];
		pArrow = position[2];
		elemPos = this.elem.position();
		elemH = this.elem.outerHeight();
		elemW = this.elem.outerWidth();
		elemIH = this.elem.innerHeight();
		elemIW = this.elem.innerWidth();
		wrapPos = this.wrapper.position();
		contH = this.container.height();
		contW = this.container.width();
		mainFull = positions[pMain];
		opp = opposites[pMain];
		oppFull = positions[opp];
		css = {};
		css[oppFull] = pMain === "b" ? elemH : pMain === "r" ? elemW : 0;
		incr(css, "top", elemPos.top - wrapPos.top);
		incr(css, "left", elemPos.left - wrapPos.left);
		ref = ["top", "left"];
		for (j = 0, len = ref.length; j < len; j++) {
			pos = ref[j];
			margin = parseInt(this.elem.css("margin-" + pos), 10);
			if (margin) {
				incr(css, pos, margin);
			}
		}
		gap = Math.max(0, this.options.gap - (this.options.arrowShow ? arrowSize : 0));
		incr(css, oppFull, gap);
		if (!this.options.arrowShow) {
			this.arrow.hide();
		} else {
			arrowSize = this.options.arrowSize;
			arrowCss = $.extend({}, css);
			arrowColor = this.userContainer.css("border-color") || this.userContainer.css("border-top-color") || this.userContainer.css("background-color") || "white";
			for (k = 0, len1 = mainPositions.length; k < len1; k++) {
				pos = mainPositions[k];
				posFull = positions[pos];
				if (pos === opp) {
					continue;
				}
				color = posFull === mainFull ? arrowColor : "transparent";
				arrowCss["border-" + posFull] = arrowSize + "px solid " + color;
			}
			incr(css, positions[opp], arrowSize);
			if (indexOf.call(mainPositions, pAlign) >= 0) {
				incr(arrowCss, positions[pAlign], arrowSize * 2);
			}
		}
		if (indexOf.call(vAligns, pMain) >= 0) {
			incr(css, "left", realign(pAlign, contW, elemW));
			if (arrowCss) {
				incr(arrowCss, "left", realign(pAlign, arrowSize, elemIW));
			}
		} else if (indexOf.call(hAligns, pMain) >= 0) {
			incr(css, "top", realign(pAlign, contH, elemH));
			if (arrowCss) {
				incr(arrowCss, "top", realign(pAlign, arrowSize, elemIH));
			}
		}
		if (this.container.is(":visible")) {
			css.display = "block";
		}
		this.container.removeAttr("style").css(css);
		if (arrowCss) {
			return this.arrow.removeAttr("style").css(arrowCss);
		}
	};

	Notification.prototype.getPosition = function () {
		var pos, ref, ref1, ref2, ref3, ref4, ref5, text;
		text = this.options.position || (this.elem ? this.options.elementPosition : this.options.globalPosition);
		pos = parsePosition(text);
		if (pos.length === 0) {
			pos[0] = "b";
		}
		if (ref = pos[0], indexOf.call(mainPositions, ref) < 0) {
			throw "Must be one of [" + mainPositions + "]";
		}
		if (pos.length === 1 || (ref1 = pos[0], indexOf.call(vAligns, ref1) >= 0) && (ref2 = pos[1], indexOf.call(hAligns, ref2) < 0) || (ref3 = pos[0], indexOf.call(hAligns, ref3) >= 0) && (ref4 = pos[1], indexOf.call(vAligns, ref4) < 0)) {
			pos[1] = (ref5 = pos[0], indexOf.call(hAligns, ref5) >= 0) ? "m" : "l";
		}
		if (pos.length === 2) {
			pos[2] = pos[1];
		}
		return pos;
	};

	Notification.prototype.getStyle = function (name) {
		var style;
		if (!name) {
			name = this.options.style;
		}
		if (!name) {
			name = "default";
		}
		style = styles[name];
		if (!style) {
			throw "Missing style: " + name;
		}
		return style;
	};

	Notification.prototype.updateClasses = function () {
		var classes, style;
		classes = ["base"];
		if ($.isArray(this.options.className)) {
			classes = classes.concat(this.options.className);
		} else if (this.options.className) {
			classes.push(this.options.className);
		}
		style = this.getStyle();
		classes = $.map(classes, function (n) {
			return pluginClassName + "-" + style.name + "-" + n;
		}).join(" ");
		return this.userContainer.attr("class", classes);
	};

	Notification.prototype.run = function (data, options) {
		var d, datas, name, type, value;
		if ($.isPlainObject(options)) {
			$.extend(this.options, options);
		} else if ($.type(options) === "string") {
			this.options.className = options;
		}
		if (this.container && !data) {
			this.show(false);
			return;
		} else if (!this.container && !data) {
			return;
		}
		datas = {};
		if ($.isPlainObject(data)) {
			datas = data;
		} else {
			datas[blankFieldName] = data;
		}
		for (name in datas) {
			d = datas[name];
			type = this.userFields[name];
			if (!type) {
				continue;
			}
			if (type === "text") {
				d = encode(d);
				if (this.options.breakNewLines) {
					d = d.replace(/\n/g, '<br/>');
				}
			}
			value = name === blankFieldName ? '' : '=' + name;
			find(this.userContainer, "[data-notify-" + type + value + "]").html(d);
		}
		this.updateClasses();
		if (this.elem) {
			this.setElementPosition();
		} else {
			this.setGlobalPosition();
		}
		this.show(true);
		if (this.options.autoHide) {
			clearTimeout(this.autohideTimer);
			this.autohideTimer = setTimeout(this.show.bind(this, false), this.options.autoHideDelay);
		}
	};

	Notification.prototype.destroy = function () {
		this.wrapper.data(pluginClassName, null);
		this.wrapper.remove();
	};

	$[pluginName] = function (elem, data, options) {
		if (elem && elem.nodeName || elem.jquery) {
			$(elem)[pluginName](data, options);
		} else {
			options = data;
			data = elem;
			new Notification(null, data, options);
		}
		return elem;
	};

	$.fn[pluginName] = function (data, options) {
		$(this).each(function () {
			var prev = getAnchorElement($(this)).data(pluginClassName);
			if (prev) {
				prev.destroy();
			}
			var curr = new Notification($(this), data, options);
		});
		return this;
	};

	$.extend($[pluginName], {
		defaults: defaults,
		addStyle: addStyle,
		removeStyle: removeStyle,
		pluginOptions: pluginOptions,
		getStyle: getStyle,
		insertCSS: insertCSS
	});

	//always include the default bootstrap style
	addStyle("bootstrap", {
		html: "<div>\n<span data-notify-text></span>\n</div>",
		classes: {
			base: {
				"font-weight": "bold",
				"padding": "8px 15px 8px 14px",
				"text-shadow": "0 1px 0 rgba(255, 255, 255, 0.5)",
				"background-color": "#fcf8e3",
				"border": "1px solid #fbeed5",
				"border-radius": "4px",
				"white-space": "nowrap",
				"padding-left": "25px",
				"background-repeat": "no-repeat",
				"background-position": "3px 7px"
			},
			error: {
				"color": "#B94A48",
				"background-color": "#F2DEDE",
				"border-color": "#EED3D7",
				"background-image": "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAtRJREFUeNqkVc1u00AQHq+dOD+0poIQfkIjalW0SEGqRMuRnHos3DjwAH0ArlyQeANOOSMeAA5VjyBxKBQhgSpVUKKQNGloFdw4cWw2jtfMOna6JOUArDTazXi/b3dm55socPqQhFka++aHBsI8GsopRJERNFlY88FCEk9Yiwf8RhgRyaHFQpPHCDmZG5oX2ui2yilkcTT1AcDsbYC1NMAyOi7zTX2Agx7A9luAl88BauiiQ/cJaZQfIpAlngDcvZZMrl8vFPK5+XktrWlx3/ehZ5r9+t6e+WVnp1pxnNIjgBe4/6dAysQc8dsmHwPcW9C0h3fW1hans1ltwJhy0GxK7XZbUlMp5Ww2eyan6+ft/f2FAqXGK4CvQk5HueFz7D6GOZtIrK+srupdx1GRBBqNBtzc2AiMr7nPplRdKhb1q6q6zjFhrklEFOUutoQ50xcX86ZlqaZpQrfbBdu2R6/G19zX6XSgh6RX5ubyHCM8nqSID6ICrGiZjGYYxojEsiw4PDwMSL5VKsC8Yf4VRYFzMzMaxwjlJSlCyAQ9l0CW44PBADzXhe7xMdi9HtTrdYjFYkDQL0cn4Xdq2/EAE+InCnvADTf2eah4Sx9vExQjkqXT6aAERICMewd/UAp/IeYANM2joxt+q5VI+ieq2i0Wg3l6DNzHwTERPgo1ko7XBXj3vdlsT2F+UuhIhYkp7u7CarkcrFOCtR3H5JiwbAIeImjT/YQKKBtGjRFCU5IUgFRe7fF4cCNVIPMYo3VKqxwjyNAXNepuopyqnld602qVsfRpEkkz+GFL1wPj6ySXBpJtWVa5xlhpcyhBNwpZHmtX8AGgfIExo0ZpzkWVTBGiXCSEaHh62/PoR0p/vHaczxXGnj4bSo+G78lELU80h1uogBwWLf5YlsPmgDEd4M236xjm+8nm4IuE/9u+/PH2JXZfbwz4zw1WbO+SQPpXfwG/BBgAhCNZiSb/pOQAAAAASUVORK5CYII=)"
			},
			success: {
				"color": "#468847",
				"background-color": "#DFF0D8",
				"border-color": "#D6E9C6",
				"background-image": "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAutJREFUeNq0lctPE0Ecx38zu/RFS1EryqtgJFA08YCiMZIAQQ4eRG8eDGdPJiYeTIwHTfwPiAcvXIwXLwoXPaDxkWgQ6islKlJLSQWLUraPLTv7Gme32zoF9KSTfLO7v53vZ3d/M7/fIth+IO6INt2jjoA7bjHCJoAlzCRw59YwHYjBnfMPqAKWQYKjGkfCJqAF0xwZjipQtA3MxeSG87VhOOYegVrUCy7UZM9S6TLIdAamySTclZdYhFhRHloGYg7mgZv1Zzztvgud7V1tbQ2twYA34LJmF4p5dXF1KTufnE+SxeJtuCZNsLDCQU0+RyKTF27Unw101l8e6hns3u0PBalORVVVkcaEKBJDgV3+cGM4tKKmI+ohlIGnygKX00rSBfszz/n2uXv81wd6+rt1orsZCHRdr1Imk2F2Kob3hutSxW8thsd8AXNaln9D7CTfA6O+0UgkMuwVvEFFUbbAcrkcTA8+AtOk8E6KiQiDmMFSDqZItAzEVQviRkdDdaFgPp8HSZKAEAL5Qh7Sq2lIJBJwv2scUqkUnKoZgNhcDKhKg5aH+1IkcouCAdFGAQsuWZYhOjwFHQ96oagWgRoUov1T9kRBEODAwxM2QtEUl+Wp+Ln9VRo6BcMw4ErHRYjH4/B26AlQoQQTRdHWwcd9AH57+UAXddvDD37DmrBBV34WfqiXPl61g+vr6xA9zsGeM9gOdsNXkgpEtTwVvwOklXLKm6+/p5ezwk4B+j6droBs2CsGa/gNs6RIxazl4Tc25mpTgw/apPR1LYlNRFAzgsOxkyXYLIM1V8NMwyAkJSctD1eGVKiq5wWjSPdjmeTkiKvVW4f2YPHWl3GAVq6ymcyCTgovM3FzyRiDe2TaKcEKsLpJvNHjZgPNqEtyi6mZIm4SRFyLMUsONSSdkPeFtY1n0mczoY3BHTLhwPRy9/lzcziCw9ACI+yql0VLzcGAZbYSM5CCSZg1/9oc/nn7+i8N9p/8An4JMADxhH+xHfuiKwAAAABJRU5ErkJggg==)"
			},
			info: {
				"color": "#3A87AD",
				"background-color": "#D9EDF7",
				"border-color": "#BCE8F1",
				"background-image": "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3QYFAhkSsdes/QAAA8dJREFUOMvVlGtMW2UYx//POaWHXg6lLaW0ypAtw1UCgbniNOLcVOLmAjHZolOYlxmTGXVZdAnRfXQm+7SoU4mXaOaiZsEpC9FkiQs6Z6bdCnNYruM6KNBw6YWewzl9z+sHImEWv+vz7XmT95f/+3/+7wP814v+efDOV3/SoX3lHAA+6ODeUFfMfjOWMADgdk+eEKz0pF7aQdMAcOKLLjrcVMVX3xdWN29/GhYP7SvnP0cWfS8caSkfHZsPE9Fgnt02JNutQ0QYHB2dDz9/pKX8QjjuO9xUxd/66HdxTeCHZ3rojQObGQBcuNjfplkD3b19Y/6MrimSaKgSMmpGU5WevmE/swa6Oy73tQHA0Rdr2Mmv/6A1n9w9suQ7097Z9lM4FlTgTDrzZTu4StXVfpiI48rVcUDM5cmEksrFnHxfpTtU/3BFQzCQF/2bYVoNbH7zmItbSoMj40JSzmMyX5qDvriA7QdrIIpA+3cdsMpu0nXI8cV0MtKXCPZev+gCEM1S2NHPvWfP/hL+7FSr3+0p5RBEyhEN5JCKYr8XnASMT0xBNyzQGQeI8fjsGD39RMPk7se2bd5ZtTyoFYXftF6y37gx7NeUtJJOTFlAHDZLDuILU3j3+H5oOrD3yWbIztugaAzgnBKJuBLpGfQrS8wO4FZgV+c1IxaLgWVU0tMLEETCos4xMzEIv9cJXQcyagIwigDGwJgOAtHAwAhisQUjy0ORGERiELgG4iakkzo4MYAxcM5hAMi1WWG1yYCJIcMUaBkVRLdGeSU2995TLWzcUAzONJ7J6FBVBYIggMzmFbvdBV44Corg8vjhzC+EJEl8U1kJtgYrhCzgc/vvTwXKSib1paRFVRVORDAJAsw5FuTaJEhWM2SHB3mOAlhkNxwuLzeJsGwqWzf5TFNdKgtY5qHp6ZFf67Y/sAVadCaVY5YACDDb3Oi4NIjLnWMw2QthCBIsVhsUTU9tvXsjeq9+X1d75/KEs4LNOfcdf/+HthMnvwxOD0wmHaXr7ZItn2wuH2SnBzbZAbPJwpPx+VQuzcm7dgRCB57a1uBzUDRL4bfnI0RE0eaXd9W89mpjqHZnUI5Hh2l2dkZZUhOqpi2qSmpOmZ64Tuu9qlz/SEXo6MEHa3wOip46F1n7633eekV8ds8Wxjn37Wl63VVa+ej5oeEZ/82ZBETJjpJ1Rbij2D3Z/1trXUvLsblCK0XfOx0SX2kMsn9dX+d+7Kf6h8o4AIykuffjT8L20LU+w4AZd5VvEPY+XpWqLV327HR7DzXuDnD8r+ovkBehJ8i+y8YAAAAASUVORK5CYII=)"
			},
			warn: {
				"color": "#C09853",
				"background-color": "#FCF8E3",
				"border-color": "#FBEED5",
				"background-image": "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAABJlBMVEXr6eb/2oD/wi7/xjr/0mP/ykf/tQD/vBj/3o7/uQ//vyL/twebhgD/4pzX1K3z8e349vK6tHCilCWbiQymn0jGworr6dXQza3HxcKkn1vWvV/5uRfk4dXZ1bD18+/52YebiAmyr5S9mhCzrWq5t6ufjRH54aLs0oS+qD751XqPhAybhwXsujG3sm+Zk0PTwG6Shg+PhhObhwOPgQL4zV2nlyrf27uLfgCPhRHu7OmLgAafkyiWkD3l49ibiAfTs0C+lgCniwD4sgDJxqOilzDWowWFfAH08uebig6qpFHBvH/aw26FfQTQzsvy8OyEfz20r3jAvaKbhgG9q0nc2LbZxXanoUu/u5WSggCtp1anpJKdmFz/zlX/1nGJiYmuq5Dx7+sAAADoPUZSAAAAAXRSTlMAQObYZgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfdBgUBGhh4aah5AAAAlklEQVQY02NgoBIIE8EUcwn1FkIXM1Tj5dDUQhPU502Mi7XXQxGz5uVIjGOJUUUW81HnYEyMi2HVcUOICQZzMMYmxrEyMylJwgUt5BljWRLjmJm4pI1hYp5SQLGYxDgmLnZOVxuooClIDKgXKMbN5ggV1ACLJcaBxNgcoiGCBiZwdWxOETBDrTyEFey0jYJ4eHjMGWgEAIpRFRCUt08qAAAAAElFTkSuQmCC)"
			}
		}
	});

	$(function () {
		insertCSS(coreStyle.css).attr("id", "core-notify");
		$(document).on("click", "." + pluginClassName + "-hidable", function (e) {
			$(this).trigger("notify-hide");
		});
		$(document).on("notify-hide", "." + pluginClassName + "-wrapper", function (e) {
			var elem = $(this).data(pluginClassName);
			if (elem) {
				elem.show(false);
			}
		});
	});
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)(module)))

/***/ }),
/* 125 */
/***/ (function(module, exports) {

$.notify.addStyle("metro", {
    html: "<div>" + "<div class='image' data-notify-html='image'/>" + "<div class='text-wrapper'>" + "<div class='notifytitle' data-notify-html='title'/>" + "<div class='text' data-notify-html='text'/>" + "</div>" + "</div>",
    classes: {
        default: {
            "color": "#fafafa !important",
            "background-color": "#ABB7B7",
            "border": "1px solid #ABB7B7"
        },
        error: {
            "color": "#fafafa !important",
            "background-color": "#f05050",
            "border": "1px solid #ef5350"
        },
        custom: {
            "color": "#fafafa !important",
            "background-color": "#5fbeaa",
            "border": "1px solid #5fbeaa"
        },
        success: {
            "color": "#fafafa !important",
            "background-color": "#81c868",
            "border": "1px solid #33b86c"
        },
        info: {
            "color": "#fafafa !important",
            "background-color": "#34d3eb",
            "border": "1px solid #29b6f6"
        },
        warning: {
            "color": "#fafafa !important",
            "background-color": "#ffbd4a",
            "border": "1px solid #ffd740"
        },
        black: {
            "color": "#fafafa !important",
            "background-color": "#4c5667",
            "border": "1px solid #212121"
        },
        white: {
            "background-color": "#e6eaed",
            "border": "1px solid #ddd"
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

//portlets
!function ($) {
    "use strict";

    /**
    Portlet Widget
    */

    var Portlet = function Portlet() {
        this.$body = $("body"), this.$portletIdentifier = ".portlet", this.$portletCloser = '.portlet a[data-toggle="remove"]', this.$portletRefresher = '.portlet a[data-toggle="reload"]';
    };

    //on init
    Portlet.prototype.init = function () {
        // Panel closest
        var $this = this;
        $(document).on("click", this.$portletCloser, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
            var $portlet_parent = $portlet.parent();
            $portlet.remove();
            if ($portlet_parent.children().length == 0) {
                $portlet_parent.remove();
            }
        });

        // Panel Reload
        $(document).on("click", this.$portletRefresher, function (ev) {
            ev.preventDefault();
            var $portlet = $(this).closest($this.$portletIdentifier);
            // This is just a simulation, nothing is going to be reloaded
            $portlet.append('<div class="panel-disabled"><div class="loader-1"></div></div>');
            var $pd = $portlet.find('.panel-disabled');
            setTimeout(function () {
                $pd.fadeOut('fast', function () {
                    $pd.remove();
                });
            }, 500 + 300 * (Math.random() * 5));
        });
    },
    //
    $.Portlet = new Portlet(), $.Portlet.Constructor = Portlet;
}(window.jQuery),

/**
 * Notifications
 */
function ($) {
    "use strict";

    var Notification = function Notification() {};

    //simple notificaiton
    Notification.prototype.notify = function (style, position, title, text) {
        var icon = 'icon-adjust';
        if (style == "error") {
            icon = "icon-exclamation";
        } else if (style == "warning") {
            icon = "icon-warning";
        } else if (style == "success") {
            icon = "icon-check";
        } else if (style == "custom") {
            icon = "icon-album";
        } else if (style == "info") {
            icon = "icon-question";
        } else {
            icon = "icon-adjust";
        }
        $.notify({
            title: title,
            text: text,
            image: "<i class='" + icon + "'></i>"
        }, {
            style: 'metro',
            className: style,
            globalPosition: position,
            showAnimation: "show",
            showDuration: 0,
            hideDuration: 0,
            autoHide: true,
            clickToHide: true
        });
    },

    //auto hide notification
    Notification.prototype.autoHideNotify = function (style, position, title, text) {
        var icon = "icon-adjust";
        if (style == "error") {
            icon = "icon-exclamation";
        } else if (style == "warning") {
            icon = "icon-warning";
        } else if (style == "success") {
            icon = "icon-check";
        } else if (style == "custom") {
            icon = "icon-album";
        } else if (style == "info") {
            icon = "icon-question";
        } else {
            icon = "icon-adjust";
        }
        $.notify({
            title: title,
            text: text,
            image: "<i class='" + icon + "'></i>"
        }, {
            style: 'metro',
            className: style,
            globalPosition: position,
            showAnimation: "show",
            showDuration: 0,
            hideDuration: 0,
            autoHideDelay: 5000,
            autoHide: true,
            clickToHide: true
        });
    },
    //confirmation notification
    Notification.prototype.confirm = function (style, position, title) {
        var icon = "icon-adjust";
        if (style == "error") {
            icon = "icon-exclamation";
        } else if (style == "warning") {
            icon = "icon-warning";
        } else if (style == "success") {
            icon = "icon-check";
        } else if (style == "custom") {
            icon = "icon-album";
        } else if (style == "info") {
            icon = "icon-question";
        } else {
            icon = "icon-adjust";
        }
        $.notify({
            title: title,
            text: 'Are you sure you want to do nothing?<div class="clearfix"></div><br><a class="btn btn-sm btn-white yes">Yes</a> <a class="btn btn-sm btn-danger no">No</a>',
            image: "<i class='" + icon + "'></i>"
        }, {
            style: 'metro',
            className: style,
            globalPosition: position,
            showAnimation: "show",
            showDuration: 0,
            hideDuration: 0,
            autoHide: false,
            clickToHide: false
        });
        //listen for click events from this style
        $(document).on('click', '.notifyjs-metro-base .no', function () {
            //programmatically trigger propogating hide event
            $(this).trigger('notify-hide');
        });
        $(document).on('click', '.notifyjs-metro-base .yes', function () {
            //show button text
            alert($(this).text() + " clicked!");
            //hide notification
            $(this).trigger('notify-hide');
        });
    },
    //init - examples
    Notification.prototype.init = function () {},
    //init
    $.Notification = new Notification(), $.Notification.Constructor = Notification;
}(window.jQuery),

/**
 * Components
 */
function ($) {
    "use strict";

    var Components = function Components() {};

    //initializing tooltip
    Components.prototype.initTooltipPlugin = function () {
        $.fn.tooltip && $('[data-toggle="tooltip"]').tooltip();
    },

    //initializing popover
    Components.prototype.initPopoverPlugin = function () {
        $.fn.popover && $('[data-toggle="popover"]').popover();
    },

    //initializing custom modal
    Components.prototype.initCustomModalPlugin = function () {
        $('[data-plugin="custommodal"]').on('click', function (e) {
            Custombox.open({
                target: $(this).attr("href"),
                effect: $(this).attr("data-animation"),
                overlaySpeed: $(this).attr("data-overlaySpeed"),
                overlayColor: $(this).attr("data-overlayColor")
            });
            e.preventDefault();
        });
    },

    //initializing nicescroll
    Components.prototype.initNiceScrollPlugin = function () {
        //You can change the color of scroll bar here
        $.fn.niceScroll && $(".nicescroll").niceScroll({ cursorcolor: '#98a6ad', cursorwidth: '6px', cursorborderradius: '5px' });
    },

    //initializing Slimscroll
    Components.prototype.initSlimScrollPlugin = function () {
        //You can change the color of scroll bar here
        $.fn.niceScroll && $(".slimscroll-noti").slimScroll({ position: 'right', size: "5px", color: '#98a6ad', height: '230px', wheelStep: 10 });
    },

    //range slider
    Components.prototype.initRangeSlider = function () {
        $.fn.slider && $('[data-plugin="range-slider"]').slider({});
    },

    /* -------------
     * Form related controls
     */
    //switch
    Components.prototype.initSwitchery = function () {
        $('[data-plugin="switchery"]').each(function (idx, obj) {
            new Switchery($(this)[0], $(this).data());
        });
    },
    //multiselect
    Components.prototype.initMultiSelect = function () {
        if ($('[data-plugin="multiselect"]').length > 0) $('[data-plugin="multiselect"]').multiSelect($(this).data());
    },

    /* -------------
    * small charts related widgets
    */
    //peity charts
    Components.prototype.initPeityCharts = function () {
        $('[data-plugin="peity-pie"]').each(function (idx, obj) {
            var colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(",") : [];
            var width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            var height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity("pie", {
                fill: colors,
                width: width,
                height: height
            });
        });
        //donut
        $('[data-plugin="peity-donut"]').each(function (idx, obj) {
            var colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(",") : [];
            var width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            var height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity("donut", {
                fill: colors,
                width: width,
                height: height
            });
        });

        $('[data-plugin="peity-donut-alt"]').each(function (idx, obj) {
            $(this).peity("donut");
        });

        // line
        $('[data-plugin="peity-line"]').each(function (idx, obj) {
            $(this).peity("line", $(this).data());
        });

        // bar
        $('[data-plugin="peity-bar"]').each(function (idx, obj) {
            var colors = $(this).attr('data-colors') ? $(this).attr('data-colors').split(",") : [];
            var width = $(this).attr('data-width') ? $(this).attr('data-width') : 20; //default is 20
            var height = $(this).attr('data-height') ? $(this).attr('data-height') : 20; //default is 20
            $(this).peity("bar", {
                fill: colors,
                width: width,
                height: height
            });
        });
    }, Components.prototype.initCounterUp = function () {
        var delay = $(this).attr('data-delay') ? $(this).attr('data-delay') : 100; //default is 100
        var time = $(this).attr('data-time') ? $(this).attr('data-time') : 1200; //default is 1200
        $('[data-plugin="counterup"]').each(function (idx, obj) {
            $(this).counterUp({
                delay: 100,
                time: 1200
            });
        });
    },

    //initilizing
    Components.prototype.init = function () {
        var $this = this;
        this.initTooltipPlugin(), this.initPopoverPlugin(), this.initNiceScrollPlugin(), this.initSlimScrollPlugin(), this.initCustomModalPlugin(), this.initRangeSlider(), this.initSwitchery(), this.initMultiSelect(), this.initPeityCharts(), this.initCounterUp(),
        //creating portles
        $.Portlet.init();
    }, $.Components = new Components(), $.Components.Constructor = Components;
}(window.jQuery),
//initializing main application module
function ($) {
    "use strict";

    $.Components.init();
}(window.jQuery);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_paginate__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuejs_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_clipboard2__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_js_core_Helpers__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_js_core_FileFlip__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store_store__ = __webpack_require__(390);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({ routes: __WEBPACK_IMPORTED_MODULE_6__router___default.a }.routes);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = router;

var appOptions = {
    el: '#app',
    name: 'app',
    store: __WEBPACK_IMPORTED_MODULE_15__store_store__["a" /* default */],
    router: router,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a },
    mounted: function mounted() {}
};

/**
 * Clear old token if user auth data is passed.
 */
if (window.location.href.includes('user=')) {
    localStorage.removeItem('default_auth_token');
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('paginate', __WEBPACK_IMPORTED_MODULE_11_vuejs_paginate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_7_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth___default.a, {
    auth: __webpack_require__(392),
    http: __webpack_require__(393),
    router: __webpack_require__(394),
    tokenName: 'auth_token',
    refreshData: { url: 'auth/refresh', method: 'GET', enabled: true, interval: 15 },
    rolesVar: 'status'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default.a);

// Set our base url
var url = window.location.href;
var baseURL = 'https://qainterface.primoprint.com';
console.log('url', url);
// Production
if (!url.includes('localhost') && !url.includes('qadesigner')) {
    baseURL = 'https://interface.primoprint.com';

    // Sentry Error Tracking
    __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://90d2bab5ba4f4a5aac48ba3b0bcfacd9@sentry.io/303632', {
        'release': "undefined"
    }).addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.baseURL = baseURL + '/v1';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.defaults.headers.common['Accept'] = 'application/json';
// Vue.axios.defaults.headers["Access-Control-Allow-Origin"] = "*"

window.Helpers = __WEBPACK_IMPORTED_MODULE_13__assets_js_core_Helpers__["a" /* default */];
window.FileFlip = __WEBPACK_IMPORTED_MODULE_14__assets_js_core_FileFlip__["a" /* default */];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](appOptions);

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(224),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0bd37a80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */,
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_windowMessaging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_epic_spinners__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// /* global Helpers */



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: { FulfillingBouncingCircleSpinner: __WEBPACK_IMPORTED_MODULE_1_epic_spinners__["b" /* FulfillingBouncingCircleSpinner */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_windowMessaging__["a" /* windowMessaging */]],
    data: function data() {
        return {
            user: null,
            token: null,
            refreshToken: false,
            authenticated: false,
            loadingMsg: null,
            template: null
        };
    },

    watch: {
        '$route.path': function $routePath() {
            this.checkAuthentication();
        }
    },
    created: function created() {
        var _this = this;

        this.refreshToken = true;
        this.checkAuthentication();
        this.windowMsgLoaded();
        this.setAppVars();

        var unwatch = this.$watch(function () {
            return _this.$route;
        }, function (route, prevRoute) {
            _this.setAppVars();
            unwatch();
        });

        window.addEventListener('message', function (e) {
            // Window Resize
            if (e.data.type === 'url') {
                _this.setUrl(e.data.url);
            }
        });
    },

    methods: {
        setUrl: function setUrl(url) {
            var _this2 = this;

            if (this.$store) {
                this.$store.commit('pageUrl', url);
            } else {
                setTimeout(function () {
                    _this2.setUrl(url);
                }, 500);
            }
        },
        checkAuthentication: function checkAuthentication() {
            if (this.refreshToken === true || !this.$auth.check()) {
                this.authenticate();
            } else {
                this.authenticated = true;
            }
        },
        authenticate: function authenticate() {
            if (this.$route.query.user && this.$route.query.token) {
                this.$store.commit('user', this.$route.query.user);
                this.$store.commit('token', this.$route.query.token);
                this.user = this.$route.query.user;
                this.token = this.$route.query.token;

                this.$auth.login({
                    params: {
                        user: this.user,
                        token: this.token
                    },
                    success: function success(res) {
                        this.authenticated = true;
                    },
                    error: function error(_error) {
                        console.log(_error);
                        this.authenticated = false;
                        this.loadingMsg = 'Sorry, we could not verify your account';
                    },
                    rememberMe: true,
                    redirect: false,
                    fetchUser: true
                });
            } else if (this.$auth.check()) {
                this.authenticated = true;
            }
        },
        setAppVars: function setAppVars() {
            var config = this.$store.state.config;

            // Mode
            if (this.$route.query.mode !== undefined) {
                this.$store.commit('mode', this.$route.query.mode);
            }

            // Config
            config.hideSideNav = this.$route.query.hideSideNav === 'true';
            config.hideDeepLinks = this.$route.query.hideDeepLinks === 'true';

            this.$store.commit('config', config);
        }
    }

    // Get Current Route - If it's not the login route >
    // Check Auth, login or redirect if needed

});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(147),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-417c4938",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fbaf4902",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(50);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'pixel-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "pixel-spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-170f97a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallerDotAnimationBaseName: 'flower-spinner-smaller-dot-animation',
      biggerDotAnimationBaseName: 'flower-spinner-bigger-dot-animation',
      currentSmallerDotAnimationBaseName: '',
      currentBiggerDotAnimationBaseName: ''
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentSmallerDotAnimationBaseName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentBiggerDotAnimationBaseName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentSmallerDotAnimationBaseName, this.generateSmallerDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentBiggerDotAnimationBaseName, this.generateBiggerDotKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentSmallerDotAnimationBaseName = this.smallerDotAnimationBaseName + '-' + Date.now();
      this.currentBiggerDotAnimationBaseName = this.biggerDotAnimationBaseName + '-' + Date.now();
    },
    generateSmallerDotKeyframes: function generateSmallerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBiggerDotKeyframes: function generateBiggerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flower-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "dots-container",
    style: (_vm.dotsContainerStyle)
  }, [_c('div', {
    staticClass: "bigger-dot",
    style: (_vm.biggerDotStyle)
  }, [_c('div', {
    staticClass: "smaller-dot",
    style: (_vm.smallerDotStyle)
  })])])])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d0555f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intersecting-circles-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinnerBlock",
    style: (_vm.spinnerBlockStyle)
  }, _vm._l((_vm.circleStyles), function(cs, index) {
    return _c('span', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57d72b3b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orbit-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "orbit one",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit two",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit three",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62022761",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fingerprint-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "spinner-ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a10270f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trinity-rings-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle1",
    style: (_vm.ring1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle2",
    style: (_vm.ring2Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle3",
    style: (_vm.ring3Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-72f9215e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-square-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.spinnerInnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3790f621",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circles-to-rhombuses-spinner",
    style: (_vm.spinnertStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e4f3596",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d5cc867",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breeding-rhombus-spinner",
    style: (_vm.spinnerStyle)
  }, [_vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "rhombus",
      class: ("child-" + (index + 1)),
      style: (rs)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rhombus big",
    style: (_vm.bigRhombusStyle)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63760274",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swapping-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06553fe4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scaling-squares-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: ("square-" + (index + 1)),
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(199),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-003dd1f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fulfilling-bouncing-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle",
    style: (_vm.circleStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-453acaff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.circlesStyles), function(cs, index) {
    return _c('div', {
      key: index,
      staticClass: "circle",
      style: (cs)
    }, [_c('div', {
      staticClass: "circle-inner-container",
      style: (_vm.circleInnerContainerStyle)
    }, [_c('div', {
      staticClass: "circle-inner",
      style: (_vm.circleInnerStyle)
    })])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-45c10360",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-building-square-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.squaresStyles), function(ss, index) {
    return _c('div', {
      key: index,
      staticClass: "square",
      class: {
        'clear': index && index % 3 === 0
      },
      style: (ss)
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(211),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7761acb0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'spring-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spring-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-part top",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "spring-spinner-part bottom",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c04ca73e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "looping-rhombuses-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      staticClass: "rhombus",
      style: (rs),
      attrs: {
        "ikey": index
      }
    })
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1508f01a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-circle-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "circle circle-1",
    style: (_vm.circle1Style)
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2",
    style: (_vm.circle2Style)
  })])
},staticRenderFns: []}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c9225ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: 'red'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "atom-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spinner-inner"
  }, [_c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-line",
    style: (_vm.lineStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-circle",
    style: (_vm.circleStyle)
  }, [_vm._v("\n      ●\n    ")])])])
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "primo",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn fast",
      "leave-active-class": "animated fadeOut fast",
      "mode": "out-in"
    }
  }, [(this.authenticated) ? _c('router-view') : _c('div', {
    staticClass: "horizontal-align-ab"
  }, [(_vm.loadingMsg === null) ? _c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_vm._v(_vm._s(_vm.loadingMsg))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Login',
        component: __webpack_require__(229)
    }, {
        path: '/templates',
        name: 'templates',
        component: __webpack_require__(16),
        children: [{
            path: ':type',
            name: 'template-type',
            component: __webpack_require__(16),
            children: [{
                path: ':uuid',
                name: 'template-category',
                component: __webpack_require__(16),
                children: [{
                    path: 'subcategory/:subcat',
                    name: 'template-subcat',
                    component: __webpack_require__(16),
                    children: [{
                        path: ':page',
                        name: 'template-subcat-page',
                        component: __webpack_require__(16)
                    }]
                }, {
                    path: ':page',
                    name: 'template-page',
                    component: __webpack_require__(16)
                }]
            }]
        }]
    }, {
        path: '/designer/:uuid',
        name: 'designer',
        component: __webpack_require__(239)
    }, {
        path: '/options',
        name: 'template-options',
        component: __webpack_require__(325)
    }]
    // meta: {auth: ['customer']},

};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7058cb3e",
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* global Helpers */

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    data: function data() {
        return {
            user: null,
            token: null,
            destination: '/templates',
            loadingMsg: 'Loading...',
            template: null
        };
    },
    beforeMount: function beforeMount() {
        this.$store.commit('user', this.$route.query.user);
        this.$store.commit('token', this.$route.query.token);

        this.user = this.$route.query.user;
        this.token = this.$route.query.token;

        if (this.$route.query.show !== undefined) {
            this.$store.commit('show', this.$route.query.show);
        }

        if (this.$route.query.cat !== undefined) {
            this.$store.commit('cat', this.$route.query.cat);
        }

        if (this.$route.query.mode !== undefined) {
            this.$store.commit('mode', this.$route.query.mode);

            // Editor Mode - Check for template & fetch
            this.template = this.$route.query.template;

            if (this.$route.query.mode === 'editor') {
                if (this.template === undefined || this.template === null) {
                    this.loadingMsg = 'Sorry, we can\'t load the template you\'ve selected';
                }
            }
        }

        if (this.user && this.token) {
            this.$auth.login({
                params: {
                    user: this.user,
                    token: this.token
                },
                success: function success(res) {
                    var _this = this;

                    if (this.template !== null) {
                        this.axios.get('/templates/' + this.template + '?include=userversions,vendors').then(function (response) {
                            _this.$store.commit('template', response.data.data);
                            _this.$router.push({ name: 'Template Designer' });
                        }).catch(function (error) {
                            Helpers.errorPop('Error', error);
                        });
                    }
                },
                error: function error(_error) {
                    // let errorreturn = error.response.data
                    var errorlist = [];
                    // if (typeof errorreturn.message !== 'string') {
                    //     for (let i = 0; i < Object.keys(errorreturn).length; i++) {
                    //         errorlist.push(errorreturn[Object.keys(errorreturn)[i]][0])
                    //     }
                    // } else {
                    errorlist.push(_error.response.data.message);
                    // }
                    // Return Errors
                    this.form.goterrors = errorlist;
                    // Clear Form
                    this.form.email = '';
                    this.form.password = '';
                },
                rememberMe: true,
                redirect: this.destination,
                fetchUser: true
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "horizontal-align-ab"
  }, [_c('span', {
    staticClass: "icon-loading1"
  }), _vm._v(" " + _vm._s(_vm.loadingMsg) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_windowMessaging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_epic_spinners__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */





var _require = __webpack_require__(72),
    getCurrentVendorID = _require.getCurrentVendorID;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'templatePicker',
    components: { FulfillingBouncingCircleSpinner: __WEBPACK_IMPORTED_MODULE_4_epic_spinners__["b" /* FulfillingBouncingCircleSpinner */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_windowMessaging__["a" /* windowMessaging */]],
    data: function data() {
        return {
            filters: {
                product: null,
                size: null,
                spot_uv: null,
                foil: null,
                color: null
            },
            showUrlCopy: false,
            templates: null,
            hasUV: false,
            hasFoil: false,
            categories: [],
            type: 'all',
            category: null,
            subcategory: null,
            sizes: [],
            pagination: [],
            itemsPerPage: 24,
            isThumbnail: true,
            isList: false,
            showSideNav: false
        };
    },
    beforeMount: function beforeMount() {
        this.showSideNav = localStorage.getItem('showSideNav') === 'true' ? true : false;
    },
    mounted: function mounted() {
        Helpers.sytleInputs();
        this.createCategoryFilters();

        // Fetch & Cache Templates
        if (this.$store.state.templateList === null) {
            this.fetchTemplates();
        } else {
            this.setTemplates(this.$store.state.templateList);
        }
    },

    updated: function updated() {
        if (this.$refs.paginate !== undefined) {
            this.$refs.paginate.selected = this.$store.state.pickerPage - 1;
        }
    },
    watch: {
        $route: function $route(newVal, oldVal) {
            if (newVal.name === 'template-category' && this.checkSubcats(newVal.params.uuid) === false) {
                this.fetchTemplates();
            } else if (newVal.name === 'template-subcat') {
                this.fetchTemplates();
            }
        }
    },
    computed: {
        url: function url() {
            var url = this.$store.state.pageUrl;
            var queryString = '?';
            if (this.$route.params.uuid) {
                queryString += 'category=' + this.$route.params.uuid;
            }
            if (this.$route.params.subcat) {
                if (queryString !== '?') {
                    queryString += '&';
                }
                queryString += 'subcategory=' + this.$route.params.subcat;
            }
            if (queryString === '?') {
                queryString = '';
            }
            return url + queryString;
        }
    },
    methods: {
        fetchCategory: function fetchCategory(uuid) {
            for (var x in this.categories) {
                if (this.categories[x].id === uuid) {
                    return this.categories[x];
                } else if (this.categories[x].id === this.$route.params.uuid) {
                    for (var n in this.categories[x].subcategories.data) {
                        var subcat = this.categories[x].subcategories.data[n];
                        if (subcat.id === uuid) {
                            return subcat;
                        }
                    }
                }
            }

            return {
                id: '',
                name: 'Loading...'
            };
        },
        checkSubcats: function checkSubcats(uuid) {
            for (var x in this.categories) {
                if (this.categories[x].id === uuid && this.categories[x].subcategories && this.categories[x].subcategories.data.length > 0) {
                    return this.categories[x].subcategories.data;
                }
            }

            return false;
        },
        setTemplates: function setTemplates(data) {
            if (data.meta !== undefined) {
                this.pagination = data.meta.pagination;
            }
            this.templates = data.data;

            // Create Filters
            this.createSizeFilters();
            this.createSideFilters();
            if (this.$refs.paginate !== undefined) {
                this.$refs.paginate.selected = this.$store.state.pickerPage - 1;
            }
        },
        loadTemplate: function loadTemplate(id) {
            var _this = this;

            var template = this.$store.state.template;

            if (template !== null && template.id !== null && template.id !== this.templates[id].id) {
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                    title: 'Please Confirm',
                    html: 'Loading this template will cause any unsaved changes to the current template to be lost',
                    animation: true,
                    position: 'top',
                    useRejections: true,
                    width: 600,
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'I Approve'
                }).then(function () {
                    _this.injectTemplateStatus(id);
                    _this.$store.commit('template', _this.templates[id]);
                    _this.$store.commit('savedTemplate', null);
                    _this.$store.commit('templateName', null);
                    _this.$router.push('/designer/' + _this.templates[id].id);
                });
            } else if (template !== null && template.id !== null && template.id === this.templates[id].id) {
                this.$router.push('/designer/' + template.id);
            } else {
                this.injectTemplateStatus(id);
                this.$store.commit('template', this.templates[id]);
                this.$router.push('/designer/' + this.templates[id].id);
            }
        },
        fetchTemplates: function fetchTemplates() {
            var _this2 = this;

            var currentTemplates = this.templates;
            this.templates = [];
            var url = null;

            var type = this.$route.params.type;
            var cat = this.$route.params.uuid;
            var subcat = this.$route.params.subcat;

            // Push URL
            var destination = '/templates';
            destination += type ? '/' + type : '';

            destination += cat ? '/' + cat : '';
            // destination += ((!cat && this.$route.params.uuid) ? '/' + this.$route.params.uuid : '')

            destination += subcat ? '/subcategory/' + subcat : '';
            // destination += ((!cat && !subcat && this.$route.params.subcat) ? '/subcategory/' + this.$route.params.subcat : '')

            this.$router.push(destination);

            if (type === 'vendor' && this.$auth.user().vendor) {
                var currentVendorID = getCurrentVendorID(this.$auth.user(), this.url);
                url = '/templates/vendor/' + currentVendorID;

                if (subcat) {
                    url += '/' + subcat;
                } else if (cat) {
                    url += '/' + cat;
                }

                url += '?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page=';
            } else if (type === 'personal') {
                url = '/templates/user?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page=';
            } else if (cat) {
                // type = 'all'
                var uuid = this.$route.params.subcat ? this.$route.params.subcat : this.$route.params.uuid;
                url = '/templates/category/' + uuid + '?include=userversions,productsettings,userslist&limit=' + this.itemsPerPage + '&page=';
            }

            if (url) {
                var requestUrl = url + (this.$route.params.page ? this.$route.params.page : 1);

                this.axios.get(requestUrl).then(function (response) {
                    if (response.data.data.length > 0) {
                        var templates = _this2.filterTemplates(response.data);
                        _this2.$store.commit('pickerUrl', url);
                        _this2.$store.commit('templateList', templates);
                        _this2.setTemplates(templates);
                    } else {
                        if (currentTemplates !== null) {
                            // Helpers.errorPop('Error', 'No templates available for this selection.')
                        }
                        _this2.templates = currentTemplates;
                    }
                }).catch(function (error) {
                    Helpers.errorPop('Error', error);
                });
            } else {
                Helpers.errorPop('Error', 'Sorry, we can\'t load the templates for this category');
            }
        },
        injectTemplateStatus: function injectTemplateStatus(id) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.templates[id].files).forEach(function (key) {
                _this3.templates[id].files[key].confirmed = false;
            });
        },
        toggleSideNav: function toggleSideNav() {
            this.showSideNav = this.showSideNav === true ? false : true;
            localStorage.setItem('showSideNav', this.showSideNav);
        },
        computedClass: function computedClass(standard, extras) {
            var string = standard;
            for (var i in extras) {
                string += ' ' + extras[i];
            }
            return string.replace('.', '');
        },
        setHeight: function setHeight() {
            var _this4 = this;

            // this.windowMsgTemplateResize($('.templatePicker').height(), $('.templatePicker').width())
            setTimeout(function () {
                _this4.windowMsgTemplateResize($('.templatePicker').height(), $('.templatePicker').width());
            }, 250);
        },
        filterTemplates: function filterTemplates(templates) {
            var templatedata = templates.data;
            for (var key in templatedata) {
                if (templatedata[key].userslist.data !== undefined && templatedata[key].userslist.data.list.length > 0) {
                    if (!templatedata[key].userslist.data.list.includes(this.$auth.user().id)) {
                        templates.data.splice(key, 1);
                    }
                }
            }

            return templates;
        },
        filter: function filter(type, value) {
            this.filters[type] = value;

            var use = '';

            for (var key in this.filters) {
                if (this.filters[key] !== null && this.filters[key] !== '0') {
                    use += '.' + this.filters[key];
                }
            }

            if (use !== '' && value !== 'all') {
                $('.template').not(use).hide();
                $('.template').filter(use).slideDown('fast');
            } else {
                $('.template').slideDown('fast');
            }
            this.setHeight();
        },
        filterSpotUV: function filterSpotUV(e) {
            if ($(e).is(':checked')) {
                this.filter('spot_uv', 'spot_uv');
            } else {
                this.filter('spot_uv', null);
            }
        },
        filterFoil: function filterFoil(e) {
            if ($(e).is(':checked')) {
                this.filter('foil', 'foil');
            } else {
                this.filter('foil', null);
            }
        },
        createCategoryFilters: function createCategoryFilters() {
            var _this5 = this;

            // let added = []
            this.categories = [];

            // Add category names to templates
            for (var i in this.templates) {
                var list = '';
                for (var x in this.templates[i].categories) {
                    if (this.templates[i].categories[x][0] !== undefined && this.templates[i].categories[x][0].name !== undefined) {
                        list += this.templates[i].categories[x][0].list_name + ' ';
                    }
                }
                this.templates[i].category_list = list;
            }

            // Fetch Category List
            var data = {};

            if (this.$auth.user().vendor && this.$route.params.type === 'vendor') {
                // if a vendor admin user is watching a children vendor send id of the children vendor to get categories from this vendor
                var currentVendorID = getCurrentVendorID(this.$auth.user(), this.url);

                data = {
                    vendors: [currentVendorID]
                };
            }

            if (this.$route.params.uuid && this.$route.params.type !== 'vendor') {
                data = {
                    categories: [this.$route.params.uuid]
                };
            }

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length > 0) {
                this.axios.post('/templates/categories/search?limit=500&exclude=subcategories.vendor,subcategories.site,subcategories.type,vendor,site,type', data).then(function (response) {
                    if (response.data.data.length > 0) {
                        _this5.categories = response.data.data;
                        setTimeout(function () {
                            _this5.setHeight();
                        }, 100);
                    }
                }).catch(function (error) {
                    Helpers.errorPop('Error', error);
                });
            }

            if (this.$store.state.pickerState.category !== null) {
                var parent = this;
                setTimeout(function () {
                    $('.productDropdown').val(parent.$store.state.pickerState.category);
                    parent.filter('product', parent.$store.state.pickerState.category);
                }, 1);
            }
        },
        createSizeFilters: function createSizeFilters() {
            var added = [];
            this.sizes = [];

            for (var i in this.templates) {
                if (!added.includes(this.templates[i].finished_height + 'x' + this.templates[i].finished_width)) {
                    added.push(this.templates[i].finished_height + 'x' + this.templates[i].finished_width);
                    var height = String(this.templates[i].finished_height).replace('.', '');
                    var width = String(this.templates[i].finished_width).replace('.', '');
                    this.sizes.push({ list_name: height + 'x' + width, name: this.templates[i].finished_height + '" x ' + this.templates[i].finished_width + '"' });
                }
            }

            if (this.$store.state.pickerState.size !== null) {
                var parent = this;
                setTimeout(function () {
                    $('.sizeDropdown').val(parent.$store.state.pickerState.size);
                    parent.filter('size', parent.$store.state.pickerState.size);
                }, 1);
            }
        },
        createSideFilters: function createSideFilters() {
            this.hasUV = false;
            this.hasFoil = false;
            for (var i in this.templates) {
                this.templates[i].foil = '';
                this.templates[i].spot_uv = '';

                if (this.templates[i].foil_front === 1 || this.templates[i].foil_back === 1) {
                    this.templates[i].foil = 'foil';
                    this.hasFoil = true;
                }
                if (this.templates[i].spot_uv_front === 1 || this.templates[i].spot_uv_back === 1) {
                    this.templates[i].spot_uv = 'spot_uv';
                    this.hasUV = true;
                }
            }

            if ($('#spot_uv_cbox').is(':checked')) {
                this.filterSpotUV($('#spot_uv_cbox'));
            }
            if ($('#foil_cbox').is(':checked')) {
                this.filterFoil($('#foil_cbox'));
            }
        },

        paginateTemplates: function paginateTemplates(pageNum) {
            var _this6 = this;

            var destination = '/templates';
            destination += this.$route.params.type ? '/' + this.$route.params.type : '';
            destination += this.$route.params.uuid ? '/' + this.$route.params.uuid : '';
            destination += this.$route.params.subcat ? '/subcategory/' + this.$route.params.subcat : '';
            destination += '/' + pageNum;

            this.$router.push(destination);
            this.$store.commit('pickerPage', pageNum);

            this.templates = [];
            this.axios.get(this.$store.state.pickerUrl + pageNum).then(function (response) {
                _this6.pagination = response.data.meta.pagination;

                _this6.setTemplates(response.data);
                _this6.$store.commit('templateList', response.data);
            }).catch(function (error) {
                Helpers.errorPop('Error', error);
            });
            this.$refs.paginate.selected = pageNum - 1;
        },
        copyUrl: function copyUrl() {
            this.$copyText(this.url).then(function (e) {
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
                    type: 'success',
                    title: 'Link Copied!',
                    animation: true,
                    position: 'top'
                });
            }, function (e) {
                alert('Can not copy');
            });
        },
        flip: function flip(index) {
            var template = this.templates[index];
            if (template.previews[1]) {
                var current = template.previews[template.default_image];

                if (template.previews[0] === current) {
                    template.previews[0] = template.previews[1];
                    template.previews[1] = current;
                } else {
                    template.previews[1] = template.previews[0];
                    template.previews[0] = current;
                }
                this.$forceUpdate();
            }
        }
    }
});

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templatePicker group p-20"
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "background-color": "#f00",
      "width": "20px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "design-options p-10 p-b-0 primarybg",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "btn-group m-r-10",
    staticStyle: {
      "float": "left"
    }
  }, [(!_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-primary m-b-10 primaryborder",
    class: {
      'notactive primaryaltbg': (_vm.$route.params.type !== 'all')
    },
    on: {
      "click": function($event) {
        _vm.fetchTemplates('all')
      }
    }
  }, [_vm._v("All Templates")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-primary m-b-10 primaryborder",
    class: {
      'notactive primaryaltbg': (_vm.$route.params.type !== 'vendor')
    },
    on: {
      "click": function($event) {
        _vm.fetchTemplates('vendor')
      }
    }
  }, [_vm._v(_vm._s(_vm.$auth.user().vendor.data.name))]) : _vm._e()]), _vm._v(" "), (_vm.sizes.length > 1) ? _c('div', {
    staticClass: "selectwrap m-b-10 primaryaltborder"
  }, [_c('span', {
    staticClass: "icon-arrow-down"
  }), _vm._v(" "), _c('select', {
    staticClass: "sizeDropdown",
    on: {
      "change": function($event) {
        _vm.filter('size', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Filter by Size")]), _vm._v(" "), _vm._l((_vm.sizes), function(size) {
    return _c('option', {
      domProps: {
        "value": size.list_name
      }
    }, [_vm._v(_vm._s(size.name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkwrap group"
  }, [(_vm.hasUV) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "checkbox m-r-15 m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.pickerState.spot_uv),
      expression: "$store.state.pickerState.spot_uv"
    }],
    attrs: {
      "id": "spot_uv_cbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.pickerState.spot_uv) ? _vm._i(_vm.$store.state.pickerState.spot_uv, null) > -1 : (_vm.$store.state.pickerState.spot_uv)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.$store.state.pickerState.spot_uv,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.pickerState, "spot_uv", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.pickerState, "spot_uv", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.pickerState, "spot_uv", $$c)
        }
      }, function($event) {
        _vm.filterSpotUV($event.target)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "spot_uv_cbox"
    }
  }, [_vm._v("\n                            Spot UV\n                        ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasFoil) ? _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "checkbox m-r-15 m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.pickerState.foil),
      expression: "$store.state.pickerState.foil"
    }],
    attrs: {
      "id": "foil_cbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.pickerState.foil) ? _vm._i(_vm.$store.state.pickerState.foil, null) > -1 : (_vm.$store.state.pickerState.foil)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.$store.state.pickerState.foil,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.pickerState, "foil", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.pickerState, "foil", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.pickerState, "foil", $$c)
        }
      }, function($event) {
        _vm.filterFoil($event.target)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "foil_cbox"
    }
  }, [_vm._v("\n                            Foil\n                        ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.templates === null || _vm.templates.length < 1) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group row pickerContent"
  }, [_c('transition', {
    attrs: {
      "duration": {
        enter: 250
      },
      "enter-active-class": "animated fadeInLeft "
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(_vm.categories.length > 0 && _vm.showSideNav === true) ? _c('ul', {
    staticClass: "sideNav col-md-3 lineheight-3"
  }, [_c('li', {
    staticClass: "categoryList header py-1",
    on: {
      "click": function($event) {
        _vm.$store.state.selectedCategory = null;
        _vm.$router.push(("/templates/" + (_vm.$route.params.type)))
      }
    }
  }, [_vm._v("\n                    Categories\n                ")]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return (!cat.parent) ? _c('li', {
      staticClass: "categoryList py-md-1"
    }, [_c('router-link', {
      staticClass: "parent",
      class: {
        'active': (cat.id === _vm.$route.params.uuid)
      },
      attrs: {
        "to": '/templates/' + _vm.$route.params.type + '/' + cat.id
      }
    }, [_vm._v("\n                            " + _vm._s(cat.name) + "\n                    ")]), _vm._v(" "), _vm._l((cat.subcategories.data), function(subcat) {
      return _c('router-link', {
        key: subcat.id,
        staticClass: "child",
        class: {
          'active': (subcat.id === _vm.$route.params.subcat)
        },
        attrs: {
          "to": '/templates/' + _vm.$route.params.type + '/' + subcat.parent + '/subcategory/' + subcat.id
        }
      }, [_vm._v("\n                            " + _vm._s('-  ' + subcat.name) + "\n                    ")])
    })], 2) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'col-md-12': (_vm.categories.length < 1 || _vm.showSideNav === false), 'col-md-9': (_vm.categories.length > 0 && _vm.showSideNav === true)
    }
  }, [_c('div', {
    staticClass: "row m-b-20"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "design-options p-0 primarybg m-b-0",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated slideInLeft",
      "leave-active-class": "animated slideOutLeft"
    }
  }, [(_vm.categories.length > 0 && _vm.$store.state.config.hideSideNav !== true) ? _c('span', {
    staticClass: "icon-view-list btn btn-outline-primary toggle-cats",
    on: {
      "click": _vm.toggleSideNav
    }
  }) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb left m-b-0"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.category = null;
        _vm.$router.push(("/templates/" + (_vm.$route.params.type)))
      }
    }
  }, [_vm._v("All Categories")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.uuid) ? _c('li', {
    class: {
      'active': (_vm.$route.params.uuid), 'white': (_vm.$route.params.subcat)
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push(("/templates/" + (_vm.$route.params.type) + "/" + (_vm.$route.params.uuid)))
      }
    }
  }, [_vm._v(_vm._s(_vm.fetchCategory(_vm.$route.params.uuid).name))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.subcat) ? _c('li', {
    class: {
      'active': (_vm.$route.params.subcat)
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$router.push(("/templates/" + (_vm.$route.params.type) + "/" + (_vm.$route.params.uuid) + "/subcat/" + (_vm.$route.params.subcat)))
      }
    }
  }, [_vm._v(_vm._s(_vm.fetchCategory(_vm.$route.params.subcat).name))])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0) ? _c('div', {
    staticClass: "pr-4 right rightNavBtns"
  }, [_c('span', {
    staticClass: "icon-view-tile btn rnButton btn-outline-primary toggle-view mr-2",
    class: {
      active: _vm.isThumbnail
    },
    on: {
      "click": function($event) {
        _vm.isList = !_vm.isList;
        _vm.isThumbnail = !_vm.isThumbnail
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-menu btn rnButton btn-outline-primary toggle-view",
    class: {
      active: _vm.isList
    },
    on: {
      "click": function($event) {
        _vm.isList = !_vm.isList;
        _vm.isThumbnail = !_vm.isThumbnail
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.config.hideDeepLinks !== true) ? _c('div', {
    staticClass: "pr-4 right rightNavBtns"
  }, [_c('span', {
    staticClass: "icon-link rnButton btn btn-outline-primary toggle-view",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyUrl($event)
      }
    }
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(!_vm.$route.params.uuid) ? _c('div', {
    staticClass: "row display-flex"
  }, _vm._l((_vm.categories), function(cat) {
    return (!cat.parent) ? _c('div', {
      staticClass: "template col-lg-3 col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/templates/' + _vm.$route.params.type + '/' + cat.id)
        }
      }
    }, [(cat.image) ? _c('div', {
      staticClass: "imgCategory",
      style: ('background-image: url(\'' + cat.image + '\')')
    }) : _vm._e(), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle categoryTitle"
    }, [_c('div', [_vm._v(_vm._s(cat.name))])])])]) : _vm._e()
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [(_vm.$route.params.uuid && _vm.checkSubcats(_vm.$route.params.uuid) != false && !_vm.$route.params.subcat) ? _c('div', {
    staticClass: "row display-flex"
  }, _vm._l((_vm.checkSubcats(_vm.$route.params.uuid)), function(cat) {
    return _c('div', {
      staticClass: "template col-lg-3 col-md-4 col-sm-6 col-xs-12"
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$router.push('/templates/' + _vm.$route.params.type + '/' + _vm.$route.params.uuid + '/subcategory/' + cat.id)
        }
      }
    }, [(cat.image) ? _c('div', {
      staticClass: "imgCategory",
      style: ('background-image: url(\'' + cat.image + '\')')
    }) : _vm._e(), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle categoryTitle"
    }, [_c('div', [_vm._v(_vm._s(cat.name) + " " + _vm._s(cat.image))])])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templates !== null && _vm.templates.length < 1),
      expression: "templates !== null && templates.length < 1"
    }],
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isThumbnail && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0),
      expression: "isThumbnail && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0"
    }],
    staticClass: "row display-flex"
  }, _vm._l((_vm.templates), function(template, index) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-4 col-sm-6 col-xs-12",
      class: _vm.computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv]),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadTemplate(index)
        },
        "mouseenter": function($event) {
          _vm.flip(index)
        },
        "mouseleave": function($event) {
          _vm.flip(index)
        }
      }
    }, [_c('div', {
      staticClass: "gal-detail thumb m-t-0 m-b-20 clearfix"
    }, [_c('div', {
      staticClass: "imgContainer relative animate"
    }, [_c('img', {
      staticClass: "auto thumb-img animate",
      attrs: {
        "src": template.previews[template.default_image],
        "alt": "",
        "id": template.id
      }
    })]), _vm._v(" "), _c('h4', {
      staticClass: "left m-t-10 m-b-0 templateTitle"
    }, [_c('div', {
      staticClass: "templateName"
    }, [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('div', {
      staticClass: "templateDescription"
    }, [_vm._v(_vm._s(template.description))]), _vm._v(" "), _vm._l((template.categories.data), function(cat) {
      return _c('span', {
        staticClass: "m-r-5 left"
      }, [_c('small', [_vm._v(_vm._s(cat.name) + "  ")])])
    }), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 right"
    }, [_c('small', [_vm._v(_vm._s(template.finished_width) + " x " + _vm._s(template.finished_height))])])], 2)])])
  }), 0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "duration": {
        enter: 250,
        leave: 250
      },
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    },
    on: {
      "after-enter": _vm.setHeight
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isList && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0),
      expression: "isList && $route.params.uuid && (checkSubcats($route.params.uuid) === false || $route.params.subcat) && templates !== null && templates.length > 0"
    }],
    staticClass: "row"
  }, _vm._l((_vm.templates), function(template, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6"
    }, [_c('div', {
      class: _vm.computedClass('template', [template.category_list, template.finished_height + 'x' + template.finished_width, template.foil, template.spot_uv]),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadTemplate(index)
        }
      }
    }, [_c('div', {
      staticClass: "gal-detail listview thumb m-t-0 m-b-10"
    }, [_c('div', {
      staticClass: "imgContainer"
    }, [_c('img', {
      staticStyle: {
        "height": "100%",
        "width": "auto"
      },
      attrs: {
        "src": template.previews[template.default_image],
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-left listview-text"
    }, [_c('div', {
      staticClass: "vertical-align-ab animate description"
    }, [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('h4', {
      staticClass: "m-0 animate"
    }, [_c('span', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(template.name))]), _c('br'), _vm._v(" "), _vm._l((template.categories.data), function(cat) {
      return _c('span', {
        staticClass: "m-r-5 text-muted"
      }, [_vm._v("\n                                            " + _vm._s(cat.name) + "\n                                        ")])
    }), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 text-muted"
    }, [_vm._v("\n                                         /\n                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "m-r-5 text-muted"
    }, [_vm._v("\n                                            " + _vm._s(template.finished_width) + " x " + _vm._s(template.finished_height) + "\n                                        ")])], 2)])])])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.pagination.total_pages > 1 && _vm.$route.params.uuid && (_vm.checkSubcats(_vm.$route.params.uuid) === false || _vm.$route.params.subcat) && _vm.templates !== null && _vm.templates.length > 0) ? _c('nav', {
    staticClass: "mt-3"
  }, [_c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": Number(_vm.pagination.total_pages),
      "click-handler": _vm.paginateTemplates,
      "margin-pages": 2,
      "initial-page": ((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0),
      "force-page": ((this.$route.params.page) ? parseInt(this.$route.params.page - 1) : 0),
      "prev-text": '‹',
      "next-text": '›',
      "container-class": 'pagination justify-content-center',
      "page-class": 'page-item',
      "page-link-class": 'page-link',
      "next-link-class": 'page-link',
      "prev-link-class": 'page-link'
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e539686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Canvas_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Canvas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_Canvas_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mixins_windowMessaging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_epic_spinners__ = __webpack_require__(15);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'templateDesigner',
    components: { PrimoCanvas: __WEBPACK_IMPORTED_MODULE_2__partials_Canvas_vue___default.a, HalfCircleSpinner: __WEBPACK_IMPORTED_MODULE_6_epic_spinners__["c" /* HalfCircleSpinner */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_5__components_mixins_windowMessaging__["a" /* windowMessaging */]],
    data: function data() {
        return {
            msg: 'Template Designer',
            saveStatus: 'Save Design',
            zoom: 1,
            showUrlCopy: false
        };
    },
    beforeMount: function beforeMount() {
        var _this = this;

        this.axios.get('/templates/' + this.$route.params.uuid + '?include=userversions,productsettings,vendors').then(function (response) {
            var template = response.data.data;

            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(template.files).forEach(function (key) {
                template.files[key].confirmed = false;
            });

            _this.$store.commit('template', response.data.data);
        }).catch(function (error) {
            Helpers.errorPop('Error', error);
        });
    },

    computed: {
        url: function url() {
            var url = this.$store.state.pageUrl;
            var queryString = '?';
            if (this.$route.params.uuid) {
                queryString += 'template=' + this.$route.params.uuid;
            }
            if (queryString === '?') {
                queryString = '';
            }
            return url + queryString;
        },
        buttons: function buttons() {
            var nav = [];

            if (this.$store.state.template) {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                    nav.push(key.replace(new RegExp('_', 'g'), ' ').replace(/\b\w/g, function (l) {
                        return l.toUpperCase();
                    }).replace('Uv', 'UV'));
                });
            }

            return nav;
        },
        templateState: function templateState() {
            return this.$store.state.templateChanges;
        }
    },
    watch: {
        templateState: function templateState(newState, oldState) {
            this.windowMsgTemplateStatus({ 'changes': newState });
        }
    },
    methods: {
        saveTemplate: function saveTemplate() {
            if (this.templateChanges()) {
                this.saveStatus = 'Saving, Please Wait..';
                this.$refs.primoCanvas.exportData();
                this.$refs.primoCanvas.generateImage();

                var parnt = this;
                var templateId = this.$store.state.template.id;

                var template = this.$store.state.template;
                var files = template.files;
                var activeFonts = [];
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(files).forEach(function (key) {
                    var fonts = [];
                    if (files[key].json !== null) {
                        for (var i in files[key].json.objects) {
                            if (files[key].json.objects[i].fontFamily !== undefined && files[key].json.objects[i].fontFamily !== null && files[key].json.objects[i].fontFamily !== '') {
                                fonts.push(files[key].json.objects[i].fontFamily);
                                activeFonts.push(files[key].json.objects[i].fontFamily);
                            }
                        }
                    }
                    files[key].fonts = fonts;
                });
                template.files = files;
                this.$store.commit('template', template);
                this.$store.commit('activeFonts', activeFonts);

                var data = {
                    files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(files)
                };

                this.axios.put('/templates/' + templateId, data).then(function (res) {
                    parnt.saveStatus = 'Save Design';
                    parnt.$store.commit('templateChanges', false);

                    parnt.windowMsgTemplateUpdate(res.data.data.files);
                }).catch(function (err) {
                    Helpers.errorPop('Error', err);
                });
            }
        },
        switchTemplate: function switchTemplate(e) {
            this.$store.commit('activeTemplate', e.toLowerCase().replace(new RegExp(' ', 'g'), '_'));
        },
        templateChanges: function templateChanges() {
            return this.$store.state.templateChanges;
        },
        checkActive: function checkActive(e) {
            if (e.toLowerCase().replace(new RegExp(' ', 'g'), '_') === this.$store.state.activeTemplate) {
                return '';
            } else {
                return 'notactive primaryaltbg';
            }
        },
        resizeCanvas: function resizeCanvas(zoom) {
            this.zoom = zoom;
            this.$refs.primoCanvas.resizeCanvas(zoom);
        },
        copyUrl: function copyUrl() {
            this.$copyText(this.url).then(function (e) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
                    type: 'success',
                    title: 'Link Copied!',
                    animation: true,
                    position: 'top'
                });
            }, function (e) {
                alert('Can not copy');
            });
        }
    }
});

/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(323),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c228fa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fabric__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fabric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webfontloader__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_webfontloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_webfontloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmDelete_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConfirmDelete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ConfirmDelete_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_epic_spinners__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buttons_lock_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__buttons_lock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__buttons_lock_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buttons_editable_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__buttons_editable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__buttons_editable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buttons_visible_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buttons_visible_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__buttons_visible_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buttons_copy_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buttons_copy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__buttons_copy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buttons_flipx_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__buttons_flipx_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__buttons_flipx_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buttons_flipy_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buttons_flipy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__buttons_flipy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__buttons_alignCenter_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__buttons_alignCenter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__buttons_alignCenter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__buttons_alignJustify_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__buttons_alignJustify_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__buttons_alignJustify_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__buttons_alignLeft_vue__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__buttons_alignLeft_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__buttons_alignLeft_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__buttons_alignRight_vue__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__buttons_alignRight_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__buttons_alignRight_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__buttons_italic_vue__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__buttons_italic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__buttons_italic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__buttons_bold_vue__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__buttons_bold_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__buttons_bold_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__buttons_underline_vue__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__buttons_underline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__buttons_underline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__buttons_autoScale_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__buttons_autoScale_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__buttons_autoScale_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__buttons_smallCaps_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__buttons_smallCaps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__buttons_smallCaps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_mixins_windowMessaging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_mixins_templateSaving__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_mixins_keyboardShortcuts__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_mixins_textFilters__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_filters_all__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_filters_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_filters_all__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */









// Buttons
















// Mixins





// Filters


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Canvas',
    components: { lock: __WEBPACK_IMPORTED_MODULE_8__buttons_lock_vue___default.a, editable: __WEBPACK_IMPORTED_MODULE_9__buttons_editable_vue___default.a, visible: __WEBPACK_IMPORTED_MODULE_10__buttons_visible_vue___default.a, copy: __WEBPACK_IMPORTED_MODULE_11__buttons_copy_vue___default.a, flipx: __WEBPACK_IMPORTED_MODULE_12__buttons_flipx_vue___default.a, flipy: __WEBPACK_IMPORTED_MODULE_13__buttons_flipy_vue___default.a, alignCenter: __WEBPACK_IMPORTED_MODULE_14__buttons_alignCenter_vue___default.a, alignJustify: __WEBPACK_IMPORTED_MODULE_15__buttons_alignJustify_vue___default.a, alignLeft: __WEBPACK_IMPORTED_MODULE_16__buttons_alignLeft_vue___default.a, alignRight: __WEBPACK_IMPORTED_MODULE_17__buttons_alignRight_vue___default.a, italic: __WEBPACK_IMPORTED_MODULE_18__buttons_italic_vue___default.a, bold: __WEBPACK_IMPORTED_MODULE_19__buttons_bold_vue___default.a, underline: __WEBPACK_IMPORTED_MODULE_20__buttons_underline_vue___default.a, autoScale: __WEBPACK_IMPORTED_MODULE_21__buttons_autoScale_vue___default.a, smallCaps: __WEBPACK_IMPORTED_MODULE_22__buttons_smallCaps_vue___default.a, ConfirmDelete: __WEBPACK_IMPORTED_MODULE_6__ConfirmDelete_vue___default.a, FulfillingBouncingCircleSpinner: __WEBPACK_IMPORTED_MODULE_7_epic_spinners__["b" /* FulfillingBouncingCircleSpinner */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_23__components_mixins_windowMessaging__["a" /* windowMessaging */], __WEBPACK_IMPORTED_MODULE_24__components_mixins_templateSaving__["a" /* templateSaving */], __WEBPACK_IMPORTED_MODULE_25__components_mixins_keyboardShortcuts__["a" /* keyboardShortcuts */], __WEBPACK_IMPORTED_MODULE_26__components_mixins_textFilters__["a" /* textFilters */]],
    props: {
        prodWidth: {
            default: 3.5
        },
        prodHeight: {
            default: 2
        },
        prodSafe: {
            default: 0.0625
        },
        prodBleed: {
            default: 0.0625
        },
        displayType: {
            default: 'designer'
        },
        template: {
            default: null
        }
    },
    data: function data() {
        return {
            msg: 'Template Test',
            exampleContent: 'This is TEXT',
            canvas: null,
            searchSaved: '',
            productWidth: null,
            productHeight: null,
            productPixelWidth: null,
            productPixelHeight: null,
            canvasStartWidth: null,
            canvasStartHeight: null,
            canvasScale: 1,
            clippingMasks: [],
            tooltip: null,
            zoom: 1,
            resizeTimer1: null,
            resizeTimer2: null,
            lastScale: 0,
            canvasData: [],
            prevDirection: 'none',
            currentTrim: null,
            currentSafe: null,
            trimObject: null,
            safeObject: null,
            selected: null,
            newTemplate: false,
            savedTemplates: this.$store.state.template.userversions !== undefined ? this.$store.state.template.userversions.data : [],
            templateName: this.$store.state.templateName,
            templateTransition: false,
            json: null,
            proceed: {
                show: false,
                target: null
            },
            shortcuts: false,
            loadingStatus: 'Loading..',
            loadingComplete: false,
            noEditableLayers: false,
            dataAttributes: [],
            watcher: null
        };
    },

    computed: {
        canvasDataReverse: function canvasDataReverse() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.canvasData, [function (o) {
                return _this.canvasData.indexOf(o);
            }], ['desc']);
        },
        savedTemplatesToRender: function savedTemplatesToRender() {
            var parent = this;

            if (this.searchSaved === null) {
                return this.$store.state.template.userversions.data;
            } else {
                return this.$store.state.template.userversions.data.filter(function (version) {
                    return version.name.toLowerCase().includes(parent.searchSaved.toLowerCase());
                });
            }
        }
    },
    methods: {
        /**
         * Update Object fires when a form field for a canvas object has been modified
         * @param  {event} e Canvas objects array key
         * @return {void}
         */
        updateObject: function updateObject(key, e) {
            var item = this.canvasDataReverse[key];
            key = this.canvasData.indexOf(item);

            if (item.fontFamily !== undefined) {
                this.loadFonts([item.fontFamily], null, null, false);
            }

            this.$store.commit('templateChanges', true);

            // Reset The Confirmed State for the File
            this.dirtyCanvas();

            // Reset The Confirmed State for the Field
            this.canvasData[key].custom.confirmed = false;
            this.canvasData[key].dirty = true;

            if (this.canvasData[key].type === 'textbox') {
                this.updateTextElement(this.canvasData[key], e);
                this.limitChars(this.canvasData[key]);

                // Should we auto scale the font size
                if (this.canvasData[key].custom.autoscale === true) {
                    // Force Pixels
                    if (this.canvasData[key].custom.fontUnits !== 'px') {
                        this.canvasData[key].custom.fontUnits = 'px';
                        this.canvasData[key].setFontSize(this.canvasData[key].custom.fontSize + this.canvasData[key].custom.fontUnits);
                    }
                    // Scale
                    this.canvasData[key].scaleFontSize();
                } else {
                    // Set Font Size
                    this.canvasData[key].setFontSize(this.canvasData[key].custom.fontSize + this.canvasData[key].custom.fontUnits);
                }
            }

            // Sync Image Scaling
            if (this.canvasData[key].type === 'image') {
                if (this.canvasData[key].scaleX !== this.canvasData[key].scaleY) {
                    this.canvasData[key].scaleY = this.canvasData[key].scaleX;
                }
            }

            this.canvas.item(key).setCoords();
            this.canvas.renderAll();
            this.proceed.show = false;

            this.$forceUpdate();
        },
        updateTextElement: function updateTextElement(textBoxData, event) {
            var skip = ['telephone1', 'telephone2', 'telephone3', 'date1', 'date2', 'date3'];
            var start = event.target.selectionStart;
            var end = event.target.selectionEnd;
            textBoxData.text = this.textFormat(textBoxData.custom.mask, textBoxData.text);
            if (!skip.includes(textBoxData.custom.mask)) {
                setTimeout(function () {
                    event.target.setSelectionRange(start, end);
                }, 5);
            }
        },

        /**
         * Resize the canvas and scale page & artwork appropriately to fit
         * @return {void}
         */
        resizeCanvas: function resizeCanvas($size) {
            var _this2 = this;

            clearTimeout(this.resizeTimer1);
            clearTimeout(this.resizeTimer2);
            this.resizeTimer1 = setTimeout(function () {
                var maxWidth = $('.containerWrapper').width();
                if ($size !== null && $size.target === undefined) {
                    _this2.zoom = $size;
                }
                var width = maxWidth * _this2.zoom;

                var scale = (_this2.productWidth + _this2.currentTrim * 2) * 300 / ((_this2.productHeight + _this2.currentTrim * 2) * 300);
                _this2.canvas.setWidth(width);
                _this2.canvas.setHeight(width / scale);

                var idealWidth = Math.floor((_this2.productWidth + _this2.currentTrim * 2) * 300);
                _this2.resizeTimer2 = setTimeout(function () {
                    _this2.canvas.setZoom(_this2.canvas.width / idealWidth);
                    _this2.canvas.calcOffset();
                    _this2.canvas.renderAll();
                }, 50);

                _this2.canvasScale = _this2.canvas.width / idealWidth;
                if (_this2.lastScale !== _this2.canvasScale) {
                    _this2.lastScale = _this2.canvasScale;
                    _this2.windowMsgTemplateResize(_this2.canvas.height, _this2.canvas.width);
                }
            }, 100);
        },

        /**
         * Set the trim border on the canvas for reference
         * @param {float} trimSize The trim size to be used to generate the trim marks
         */
        setTrim: function setTrim(trimSize) {
            this.currentTrim = trimSize;

            if (this.trimObject !== null) {
                this.canvas.remove(this.trimObject);
            }

            if (this.canvasStartWidth === null) {
                this.canvasStartWidth = this.canvas.width;
                this.canvasStartHeight = this.canvas.height;
            }

            var productPixelWidth = this.productWidth * 300;
            var bleedWidth = this.canvasStartWidth;
            var bleedHeight = this.canvasStartHeight;

            var scale = bleedWidth / productPixelWidth * 100;

            trimSize = trimSize / 100 * scale;
            var trim = trimSize * 300; // 300 DPI
            var trimWidth = bleedWidth - trim * 2;
            var trimHeight = bleedHeight - trim * 2;

            // Trim
            this.addElement({
                type: 'rect',
                width: trimWidth,
                height: trimHeight,
                left: trim,
                top: trim,
                originX: 0,
                originY: 0,
                fill: null,
                stroke: 'blue',
                strokeWidth: 1,
                selectable: false,
                custom: {
                    name: 'Trim Area',
                    trimSize: trimSize,
                    editable: false
                }
            });
        },

        /**
         * Set the safe border on the canvas for reference
         * @param {float} safeSize The safe size to be used to generate the trim marks
         */
        setSafe: function setSafe(safeSize) {
            this.currentSafe = safeSize;

            if (this.safeObject !== null) {
                this.canvas.remove(this.safeObject);
            }

            var productPixelWidth = this.productWidth * 300;
            var bleedWidth = this.canvasStartWidth;
            var bleedHeight = this.canvasStartHeight;

            var scale = bleedWidth / productPixelWidth * 100;

            // let trimSize = ((this.currentTrim / 100) * scale)
            // let trim = trimSize * 300 // 300 DPI

            safeSize = safeSize / 100 * scale;
            var safe = safeSize * 300 * 2; // 300 DPI
            var safeWidth = bleedWidth - safe * 2;
            var safeHeight = bleedHeight - safe * 2;

            // Safe
            this.addElement({
                type: 'rect',
                width: safeWidth,
                height: safeHeight,
                left: safe,
                top: safe,
                originX: 0,
                originY: 0,
                fill: null,
                stroke: 'green',
                strokeWidth: 1,
                selectable: false,
                custom: {
                    name: 'Safe Area',
                    safeSize: safeSize,
                    editable: false
                }
            });
        },

        /**
         * Add a new element to the canvas
         * @param {object} data Configuration options to be merged with the config defined below as well as the object type that will be added to the canvas
         */
        addElement: function addElement(data) {
            var _this3 = this;

            var element = null;
            var config = {
                // Coordinates
                top: 0 - this.canvas.height,
                left: this.canvas.width / 2,
                width: 100,
                height: 100,
                originX: 'center',
                originY: 'center',
                selectable: true,

                // Sizes
                strokeWidth: 0,

                // Colors
                fill: '#7F7E80',
                borderColor: '#7F7E80',
                stroke: '#7F7E80',

                // Fonts
                fontSize: '36',

                // Corner Styling
                padding: 8,
                cornerSize: 14,
                cornerStyle: 'circle',
                cornerColor: '#76C15D',
                cornerStrokeColor: '#ffffff',
                rotatingPointOffset: 20,
                transparentCorners: false,
                uniScaleTransform: true,
                selectionBackgroundColor: 'rgba(210,210,210,0.2)',

                // Custom
                custom: {
                    name: '',
                    fontSize: 8,
                    fontUnits: 'pt',
                    charLimit: 0,
                    mask: 'standard',
                    editable: true,
                    locked: false,
                    autoscale: false,
                    smallcaps: false,
                    confirmed: false,
                    data_attribute: ''
                }
            };

            config = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.extend({}, config, data);

            if (data.type !== 'image') {
                if (data.type === 'text') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Textbox('Default Text', {
                        fontFamily: this.$store.state.activeFonts.length > 0 ? this.$store.state.activeFonts[0] : this.$store.state.fonts[2].name,
                        fontSize: config.fontSize,
                        left: config.left,
                        top: config.top,
                        width: 250,
                        caching: false,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                } else if (data.type === 'rect') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Rect({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        width: config.width,
                        height: config.height,
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,
                        perPixelTargetFind: true,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                } else if (data.type === 'clipping-area') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Rect({
                        left: config.left,
                        top: config.top,
                        fill: 'transparent',
                        stroke: config.stroke,
                        strokeWidth: 1,
                        strokeDashArray: [4, 2],
                        width: config.width,
                        height: config.height,
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                    this.clippingMasks.push(element);
                } else if (data.type === 'round-clipping-area') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Ellipse({
                        left: config.left,
                        top: config.top,
                        fill: 'transparent',
                        stroke: config.stroke,
                        strokeWidth: 1,
                        strokeDashArray: [4, 2],
                        originX: config.originX,
                        originY: config.originX,
                        selectable: config.selectable,
                        rx: config.width / 2,
                        ry: config.height / 2,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                    this.clippingMasks.push(element);
                } else if (data.type === 'ellipse') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Ellipse({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        selectable: config.selectable,
                        originX: config.originX,
                        originY: config.originX,
                        rx: config.width / 2,
                        ry: config.height / 2,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                } else if (data.type === 'triangle') {
                    element = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Triangle({
                        left: config.left,
                        top: config.top,
                        fill: config.fill,
                        stroke: config.stroke,
                        strokeWidth: config.strokeWidth,
                        selectable: config.selectable,
                        originX: config.originX,
                        originY: config.originX,
                        width: config.width,
                        height: config.height,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                }

                // If this isnt our safe or trim, let's animate the adding process
                if (element.custom.name !== 'Safe Area' && element.custom.name !== 'Trim Area') {
                    element.left = this.canvas.width / 2 - element.width / 2;
                    this.canvas.add(element);
                    element.animate('top', this.canvas.height / 2 - element.height / 2, {
                        duration: 500,
                        onChange: this.canvas.renderAll.bind(this.canvas),
                        onComplete: function onComplete() {
                            _this3.canvas.deactivateAll().renderAll();
                            _this3.canvas.setActiveObject(element);
                            if (data.type !== 'clipping-area') {
                                element.setFontSize('10pt');
                            }
                        },
                        easing: __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].util.ease['easeOutBack']
                    });
                } else {
                    this.canvas.add(element);
                }
            } else {
                config.custom.name = 'New Image';
                config.custom.clipto = '-1';
                config.custom.uploadButton = 'Select Image File';

                __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Image.fromURL('/static/1x1.png', function (img) {
                    img.set({
                        left: -10,
                        top: -10,
                        originX: config.originX,
                        originY: config.originX,
                        perPixelTargetFind: false,
                        selectable: false,
                        lockUniScaling: true,

                        padding: config.padding,
                        cornerSize: config.cornerSize,
                        cornerStyle: config.cornerStyle,
                        cornerColor: config.cornerColor,
                        cornerStrokeColor: config.cornerStrokeColor,
                        rotatingPointOffset: config.rotatingPointOffset,
                        transparentCorners: config.transparentCorners,
                        uniScaleTransform: config.uniScaleTransform,
                        selectionBackgroundColor: config.selectionBackgroundColor,
                        custom: config.custom
                    });
                    _this3.canvas.add(img);
                    setTimeout(function () {
                        _this3.canvas.deactivateAll().renderAll();
                        _this3.canvas.setActiveObject(img);
                    }, 250);
                }, { crossOrigin: 'Anonymous' });
            }

            // Surface out trim and safe lines to keep them visible
            if (this.trimObject !== null) {
                this.trimObject.bringToFront();
            }
            if (this.safeObject !== null) {
                this.safeObject.bringToFront();
            }

            this.canvasData = this.canvas.getObjects();
        },

        /**
         * Remove an object from the canvas
         * @return {void}
         */
        removeElement: function removeElement() {
            var _this4 = this;

            if (this.canvas.getActiveGroup()) {
                this.canvas.getActiveGroup().forEachObject(function (o) {
                    if (_this4.checkMaskUse(o)) {
                        _this4.canvas.remove(o);
                    }
                });
                this.canvas.discardActiveGroup().renderAll();
            } else {
                if (this.checkMaskUse(this.canvas.getActiveObject())) {
                    var item = this.canvas.getActiveObject();
                    var idx = this.canvasDataReverse.indexOf(item);
                    this.canvas.remove(item);
                    $('a[href=#collapse' + idx + ']').trigger('click');
                }
            }
        },

        /**
         * Check if the object is a clipping-mask and check if it is currently being used to clip an image on the canvas
         * @param  {object} obj A object from the canvas
         * @return {boolean}
         */
        checkMaskUse: function checkMaskUse(obj) {
            if (obj.custom.type === 'clipping-mask') {
                var target = null;
                for (var _i in this.clippingMasks) {
                    if (this.clippingMasks[_i] === obj) {
                        target = _i;
                    }
                }
                if (target !== null) {
                    for (var i in this.canvasData) {
                        // If mask is in use stop the execution and alert user
                        if (this.canvasData[i].custom !== undefined && this.canvasData[i].custom.clipto === target) {
                            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                                text: 'This mask is currently in use, you must detach image from this mask before removing.'
                            });
                            return false;
                        }
                    }
                    // Mask isn't in use so let's remove it from the masks array
                    this.clippingMasks.splice(target, 1);
                }
            }

            return true;
        },

        /**
         * Set current active object
         * @param {integer} index Index id of object to target int he canvas array
         */
        setActiveObject: function setActiveObject(index) {
            var item = this.canvasDataReverse[index];
            var target = this.canvasData.indexOf(item);
            this.canvas.setActiveObject(this.canvas.item(target));
        },

        /**
         * Export the canvas data out to the vuex store
         * @return {void}
         */
        exportData: function exportData() {
            var _this5 = this;

            // Unclip All Masks
            for (var i in this.canvasData) {
                if (this.canvasData[i].clipTo !== null) {
                    this.canvasData[i].clipTo = null;
                }
                // Set all starting fields that can be edited to unconfirmed
                if (this.$store.state.mode === 'editor' && this.canvasData[i].custom.editable === true) {
                    this.canvasData[i].custom.confirmed = false;
                }
            }

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                if (key === _this5.$store.state.activeTemplate) {
                    var template = _this5.$store.state.template;
                    template.files[key].json = _this5.canvas.toDatalessJSON(['custom']);
                    _this5.$store.commit('template', template);
                }
            });

            // Reapply All Masks
            this.applyAllMasks();
        },

        /**
         * Confirm changes to an object that has been edited
         * @param  {integer} e index id of object to be confirmed
         * @return {void}
         */
        confirmEdit: function confirmEdit(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);
            this.canvasData[e].custom.confirmed = true;
            this.canvas.discardActiveObject().renderAll();
            this.loopConfirm();
        },

        /**
         * Loop items from canvas object and check that all have been confirmed. This function also sets the next available template for the continue button.
         * @return {boolean}
         */
        loopConfirm: function loopConfirm() {
            var _this6 = this;

            for (var i in this.canvasDataReverse) {
                if (this.canvasDataReverse[i].custom.confirmed === false && this.canvasDataReverse[i].custom.editable === true) {
                    this.canvas.setActiveObject(this.canvasDataReverse[i]);
                    return true;
                }
            }

            var next = null;

            // Loop Templates & Check Confirmed
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                if (key !== _this6.$store.state.activeTemplate && _this6.$store.state.template.files[key].confirmed === false && next === null) {
                    next = key;
                    _this6.proceed.show = true;
                    _this6.proceed.target = key;
                }
            });

            if (next === null) {
                this.proceed.show = 'options';
            }

            $('.layers div a[aria-expanded="true"]').trigger('click');
        },

        /**
         * Load next template or the options page
         * @return {void}
         */
        loadNextTemplate: function loadNextTemplate() {
            var _this7 = this;

            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (this.checkConfirmed()) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                    if (key === _this7.$store.state.activeTemplate) {
                        var template = _this7.$store.state.template;
                        template.files[key].confirmed = true;
                        _this7.$store.commit('template', template);

                        if (_this7.proceed.show === 'options') {
                            _this7.$router.push('/options');
                        } else {
                            _this7.$store.commit('activeTemplate', _this7.proceed.target);
                        }
                    }
                });
            }
        },
        removeSavedTemplate: function removeSavedTemplate(index) {
            var template = this.$store.state.template;
            template.userversions.data.splice(index, 1);
            this.$store.commit('template', template);
        },

        /**
         * Check that all items in the canvas object have been confirmed
         * @return {boolean}
         */
        checkConfirmed: function checkConfirmed() {
            for (var i in this.canvasData) {
                if (this.canvasData[i].custom.editable === true && this.canvasData[i].custom.confirmed === false) {
                    return false;
                }
            }

            return true;
        },


        /* Layer Movement */
        /* -------------- */
        moveLayer: function moveLayer(id, direction) {
            var item = this.canvas.getActiveObject();
            var startingIndex = this.canvasDataReverse.indexOf(item);
            var endingIndex = null;

            if (direction === 'front') {
                item.bringToFront();
            } else if (direction === 'forward') {
                item.bringForward();
            } else if (direction === 'backward') {
                item.sendBackwards();
            } else if (direction === 'back') {
                item.sendToBack();
            }

            // Bring Trim & Bleed to Front
            if (this.trimObject !== null) {
                this.trimObject.bringToFront();
            }
            if (this.safeObject !== null) {
                this.safeObject.bringToFront();
            }

            endingIndex = this.canvasDataReverse.indexOf(item);
            if (startingIndex !== endingIndex) {
                this.$store.commit('templateChanges', true);
                $('a[href=#collapse' + endingIndex + ']').trigger('click');
            }
        },


        /* Group Functions */
        /* --------------- */
        /**
         * Refresh all items in canvas object group
         * @param  {object} group group of canvas items to be refreshed
         * @return {void}
         */
        groupItemsRefresh: function groupItemsRefresh(group) {
            group.forEachObject(function (item) {
                group.removeWithUpdate(item).addWithUpdate(item);
            });
            group.setCoords();
            this.canvas.renderAll();
        },

        /**
         * Align selected canvas items with each other
         * @param  {string} direction Alignment direction: left, right, center, top, bottom
         * @return {void}
         */
        groupAlign: function groupAlign(direction) {
            var _this8 = this;

            var group = this.canvas.getActiveGroup();
            var item = this.canvas.getActiveObject();

            if (direction === this.prevDirection || !group && !item) {
                return;
            }

            if (group) {
                var groupWidth = group.getBoundingRect(true).width;
                var groupHeight = group.getBoundingRect(true).height;
                var scaleFactor = group.getScaleX();

                group.forEachObject(function (item) {
                    var itemWidth = item.getBoundingRect().width * scaleFactor;
                    var itemHeight = item.getBoundingRect().height * scaleFactor;

                    if (direction === 'left') {
                        item.set({
                            left: -(groupWidth / 2),
                            originX: 'left'
                        });
                    } else if (direction === 'top') {
                        item.set({
                            top: -groupHeight / 2 + itemHeight / 2
                        });
                    } else if (direction === 'right') {
                        item.set({
                            left: groupWidth / 2 - itemWidth / 2,
                            originX: 'center'
                        });
                    } else if (direction === 'bottom') {
                        item.set({
                            top: groupHeight / 2 - itemHeight / 2
                        });
                    } else if (direction === 'center') {
                        item.set({
                            left: 0 - itemWidth / 2,
                            originX: 'left'
                        });
                    } else if (direction === 'vertical-center') {
                        item.set({
                            top: 0 - itemHeight / 2,
                            originY: 'top'
                        });
                    }

                    _this8.prevDirection = direction;
                });
                this.groupItemsRefresh(group);
            } else if (item) {
                var canvasWidth = this.canvasStartWidth;
                var canvasHeight = this.canvasStartHeight;

                if (direction === 'left') {
                    item.set({
                        left: 0,
                        originX: 'left'
                    });
                } else if (direction === 'top') {
                    item.set({
                        top: 0,
                        originY: 'top'
                    });
                } else if (direction === 'right') {
                    item.set({
                        left: canvasWidth,
                        originX: 'right'
                    });
                } else if (direction === 'bottom') {
                    item.set({
                        top: canvasHeight,
                        originY: 'bottom'
                    });
                } else if (direction === 'center') {
                    item.set({
                        left: canvasWidth / 2 - item.width * item.getScaleX() / 2,
                        originX: 'left'
                    });
                } else if (direction === 'vertical-center') {
                    item.set({
                        top: canvasHeight / 2 - item.height * item.getScaleX() / 2,
                        originY: 'top'
                    });
                }
                item.setCoords();
                this.canvas.renderAll();
            }
        },


        /**
         * Align selected canvas items with each other
         * @param  {string} direction Alignment direction: left, right, center, top, bottom
         * @return {void}
         */
        evenlySpace: function evenlySpace(direction) {
            var _this9 = this;

            var group = this.canvas.getActiveGroup();

            if (direction === this.prevDirection || !group) {
                return;
            }

            var groupWidth = group.getBoundingRect(true).width;
            var groupHeight = group.getBoundingRect(true).height;
            var scaleFactor = group.getScaleX();
            var total = group.getObjects().length;
            var current = 0;
            var orderHorizontal = [];
            var orderVertical = [];

            group.forEachObject(function (item) {
                // let bound = item.getBoundingRect();
                orderHorizontal.push(item.left);
                orderVertical.push(item.top);
                if (direction === 'horizontal' && (current === 0 || current === total - 1)) {
                    groupWidth -= item.width / 2;
                } else if (direction === 'vertical' && (current === 0 || current === total - 1)) {
                    groupHeight -= item.height / 2;
                }
                current++;
            });

            for (var i in orderHorizontal) {
                orderHorizontal[i] += groupWidth / 2;
            }
            for (var _i2 in orderVertical) {
                orderVertical[_i2] += groupHeight / 2;
            }
            orderHorizontal = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(orderHorizontal, function (num) {
                return num;
            });
            orderVertical = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(orderVertical, function (num) {
                return num;
            });

            current = 0;
            var spacing = direction === 'vertical' ? groupHeight * scaleFactor / (total - 1) : groupWidth * scaleFactor / (total - 1);

            group.forEachObject(function (item) {
                var horizontalIndex = orderHorizontal.indexOf(item.left + groupWidth / 2);
                var verticalIndex = orderVertical.indexOf(item.top + groupHeight / 2);
                if (direction === 'horizontal' && horizontalIndex !== 0 && horizontalIndex !== total - 1) {
                    item.set({
                        left: -(groupWidth / 2) + spacing * horizontalIndex,
                        originX: 'center'
                    });
                    orderHorizontal[horizontalIndex] = 0.01;
                } else if (direction === 'vertical' && verticalIndex !== 0 && verticalIndex !== total - 1) {
                    item.set({
                        top: -(groupHeight / 2) + spacing * verticalIndex,
                        originY: 'center'
                    });
                    orderVertical[verticalIndex] = 0.01;
                }

                current++;
                _this9.prevDirection = direction;
            });
            this.groupItemsRefresh(group);
        },


        /* Image Functions */
        /* --------------- */
        /**
         * Generate preview image from canvas
         * @return {void}
         */
        generateImage: function generateImage() {
            var _this10 = this;

            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            // let parnt = this
            var currentZoom = this.zoom;
            var pos = 0;
            target = target !== null ? target : this.$store.state.activeTemplate;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                if (key === target) {
                    // this.resizeCanvas(1 + (parseFloat(this.prodBleed) * 2))
                    // Hide Trim & Bleed Layers and Remove Clipping Strokes
                    var hidden = [];
                    var differentStrokes = [];
                    for (var i in _this10.canvasData) {
                        if (_this10.canvasData[i].custom !== undefined && (_this10.canvasData[i].custom.name === 'Trim Area' || _this10.canvasData[i].custom.name === 'Safe Area')) {
                            _this10.canvasData[i].visible = false;
                            hidden.push(i);
                        }

                        if (_this10.canvasData[i].custom !== undefined && _this10.canvasData[i].custom.type === 'clipping-mask') {
                            differentStrokes[i] = _this10.canvasData[i].strokeWidth;
                            _this10.canvasData[i].strokeWidth = 0;
                        }
                    }
                    _this10.canvas.setWidth(Math.ceil((_this10.productWidth + _this10.currentTrim * 2) * 300));
                    _this10.canvas.setHeight(Math.ceil((_this10.productHeight + _this10.currentTrim * 2) * 300));
                    _this10.canvas.setZoom(1);
                    _this10.canvas.calcOffset();
                    _this10.canvasScale = 1;

                    // Generate Image
                    var image = _this10.canvas.toDataURL({
                        format: 'jpeg',
                        quality: 1,
                        multiplier: 1
                    });

                    _this10.resizeCanvas(currentZoom);

                    // Restore Trim & Bleed
                    for (var x in hidden) {
                        _this10.canvasData[hidden[x]].visible = true;
                    }
                    // Restore Mask Strokes
                    for (var _x3 in differentStrokes) {
                        _this10.canvasData[_x3].strokeWidth = differentStrokes[_x3];
                    }
                    _this10.canvas.renderAll();
                    var template = _this10.$store.state.template;
                    template.files[key].preview = image;
                    if (_this10.$store.state.mode === 'editor') {
                        template.previews[pos] = image;
                    }
                    _this10.$store.commit('template', template);
                }
                pos += 1;
            });
        },

        /**
         * Apply selected mask to an image on the canvasData
         * @param  {object}  image      selected image to have mask applied to
         * @param  {object}  mask       mask to be applied to selected image
         * @param  {boolean} reposition should the image be reposition when the mask is applied
         * @param  {boolean} primaryArray does the image id point to the primary canvasData array or the secondary canvasDataReverse
         * @return {void}
         */
        applyMask: function applyMask(image, mask, reposition, primaryArray) {
            var _this11 = this;

            var img = null;
            if (primaryArray === true) {
                img = this.canvasData[image];
            } else {
                img = this.canvasDataReverse[image];
                img = this.canvasData.indexOf(img);
                img = this.canvasData[img];
            }

            if (mask === 'No Clipping Mask' || mask === '-1' || mask === -1) {
                img.clipTo = null;
            } else {
                var posLeft = this.clippingMasks[mask].getLeft() + this.clippingMasks[mask].getWidth() / 2;
                var posTop = this.clippingMasks[mask].getTop() + this.clippingMasks[mask].getHeight() / 2;

                if (reposition) {
                    img.top = posTop;
                    img.left = posLeft;
                }
                img.custom.clipto = mask;

                img.clipTo = function (ctx) {
                    ctx.save();

                    var pixelRatio = window.devicePixelRatio;
                    var scale = _this11.canvasScale * pixelRatio;
                    // * 2
                    ctx.setTransform(scale, 0, 0, scale, 0, 0);
                    // ctx.setTransform(scale, 0, 0, scale, this.clippingMasks[mask].getLeft(), this.clippingMasks[mask].getTop())
                    // ctx.setTransform(scale, 0, 0, scale, posLeft, posTop)

                    var w = _this11.clippingMasks[mask].getWidth();
                    var h = _this11.clippingMasks[mask].getHeight();

                    ctx.rect(0, 0, w, h);
                    _this11.clippingMasks[mask].render(ctx);
                    ctx.restore();
                };
            }
            this.canvas.renderAll();
        },

        /**
         * Reapply all masks on the canvas - mainly used when an existing template is loaded for the first time
         * @return {void}
         */
        applyAllMasks: function applyAllMasks() {
            // Reapply All Masks
            for (var i in this.canvasData) {
                if (this.canvasData[i].custom !== undefined && this.canvasData[i].custom.clipto !== undefined && this.canvasData[i].custom.clipto !== null) {
                    this.applyMask(i, this.canvasData[i].custom.clipto, false, true);
                }
            }
        },

        /**
         * Replace existing image with new upload
         * @param  {integer} index  image index in canvas object array
         * @param  {string}  target file uploader that has the newly selected file
         * @return {void}
         */
        updateImage: function updateImage(index, target) {
            var _this12 = this;

            var data = new FormData();
            // let origIndex = index
            var item = this.canvasDataReverse[index];
            index = this.canvasData.indexOf(item);

            data.append('file', target.files[0]);
            var config = {
                onUploadProgress: function onUploadProgress(progressEvent) {
                    var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                    _this12.canvas.item(index).custom.uploadButton = 'Uploading: ' + percentCompleted + '%';
                }
            };

            this.axios.post('/upload/image', data, config).then(function (response) {
                var positionLeft = _this12.canvas.item(index).getLeft() < 0 ? 0 : _this12.canvas.item(index).getLeft();
                var positionTop = _this12.canvas.item(index).getTop() < 0 ? 0 : _this12.canvas.item(index).getTop();
                var positionAngle = _this12.canvas.item(index).getAngle();
                var scaleX = _this12.canvas.item(index).getScaleX();
                var scaleY = _this12.canvas.item(index).getScaleY();

                __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Image.fromURL(response.data, function (img) {
                    img.set({
                        left: positionLeft,
                        top: positionTop,
                        angle: positionAngle,
                        scaleX: scaleX,
                        scaleY: scaleY,
                        centeredScaling: true,
                        originX: 'center',
                        originY: 'center',
                        perPixelTargetFind: false,
                        lockUniScaling: true,
                        src: response.data,
                        // selectable: true,
                        custom: _this12.canvas.item(index).custom
                    });
                    _this12.canvas.add(img);

                    // Check if we need to apply a clipping mask
                    var clipto = null;
                    if (_this12.canvas.item(index).custom.clipto !== null) {
                        clipto = _this12.canvas.item(index).custom.clipto; // *******************************************##########
                    }

                    _this12.canvas.item(index).remove();
                    img.moveTo(index);

                    // Apply Clipping Mask
                    if (clipto !== null) {
                        _this12.applyMask(index, clipto, true, true);
                    }

                    _this12.canvas.item(index).custom.uploadButton = 'Select Image File';
                }, { crossOrigin: 'Anonymous' });

                _this12.$store.commit('templateChanges', true);
                _this12.canvas.renderAll();
            }).catch(function (err) {
                Helpers.errorPop('Error', err.response.data.message);
            });
        },


        /**
         * Replace existing image with new upload
         * @param  {string}  target file uploader that has the newly selected file
         * @return {void}
         */
        updateBackground: function updateBackground(target) {
            var _this13 = this;

            var data = new FormData();
            var canvasWidth = this.canvasStartWidth;
            var canvasHeight = this.canvasStartHeight;

            data.append('file', target.files[0]);
            var config = {
                onUploadProgress: function onUploadProgress(progressEvent) {
                    // var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total )
                    // console.log(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                }

                // left: (canvasWidth / 2) - (item.width * item.getScaleX() / 2),
            };this.axios.post('/upload/image', data, config).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Image.fromURL(response.data, function (img) {
                    img.set({
                        originX: 'center',
                        originY: 'center',
                        left: canvasWidth / 2,
                        top: canvasHeight / 2
                    });
                    _this13.canvas.setBackgroundImage(img, _this13.canvas.renderAll.bind(_this13.canvas));

                    if (_this13.$store.state.template.files[_this13.$store.state.activeTemplate].json !== null && _this13.$store.state.template.files[_this13.$store.state.activeTemplate].json.backgroundImage !== undefined) {
                        _this13.$store.state.template.files[_this13.$store.state.activeTemplate].json.backgroundImage.src = response.data;
                    }
                    _this13.dirtyCanvas();
                    _this13.$store.commit('templateChanges', true);
                }, { crossOrigin: 'Anonymous' });
            }).catch(function (err) {
                Helpers.errorPop('Error', err.response.data.message);
            });
        },


        /* Layer Functions */
        /* --------------- */
        /**
         * Scale canvas item to value
         * @param  {integer} e     id of canvas item object
         * @param  {float}   value number to scale to
         * @return {void}
         */
        scale: function scale(e, value) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);
            this.canvasData[e].scaleX = value;
            this.canvasData[e].scaleY = value;
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Flip canvas item vertically
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        flipX: function flipX(e) {
            if (e !== null) {
                var item = this.canvasDataReverse[e];
                e = this.canvasData.indexOf(item);
                this.canvasData[e].flipX = !this.canvasData[e].flipX;
                this.canvasData[e].dirty = true;
            } else if (this.canvas.getActiveGroup() !== null) {
                e = this.canvas.getActiveGroup();
                e.toggle('flipX');
            } else if (this.canvas.getActiveObject() !== null) {
                e = this.canvas.getActiveObject();
                e.toggle('flipX');
            }
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Flip canvas item horizontally
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        flipY: function flipY(e) {
            if (e !== null) {
                var item = this.canvasDataReverse[e];
                e = this.canvasData.indexOf(item);
                this.canvasData[e].flipY = !this.canvasData[e].flipY;
                this.canvasData[e].dirty = true;
            } else if (this.canvas.getActiveGroup() !== null) {
                e = this.canvas.getActiveGroup();
                e.toggle('flipY');
            } else if (this.canvas.getActiveObject() !== null) {
                e = this.canvas.getActiveObject();
                e.toggle('flipY');
            }
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Toggle locked canvas item state so that it can't be edited or selected
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        lock: function lock(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);
            if (this.canvasData[e].lockMovementX !== false) {
                this.canvasData[e].custom.locked = false;
                this.canvasData[e].lockMovementX = false;
                this.canvasData[e].lockMovementY = false;
                this.canvasData[e].lockRotation = false;
                this.canvasData[e].lockScalingX = false;
                this.canvasData[e].lockScalingY = false;
                this.canvasData[e].setControlsVisibility({ bl: true, br: true, mb: true, ml: true, mr: true, mt: true, tl: true, tr: true, mtr: true });
                if (this.canvasData[e].custom.type === 'clipping-mask' || this.canvasData[e].type === 'image') {
                    this.canvasData[e].selectable = true;
                    this.canvasData[e].evented = true;
                }
            } else {
                this.canvasData[e].custom.locked = true;
                this.canvasData[e].lockMovementX = true;
                this.canvasData[e].lockMovementY = true;
                this.canvasData[e].lockRotation = true;
                this.canvasData[e].lockScalingX = true;
                this.canvasData[e].lockScalingY = true;
                this.canvasData[e].setControlsVisibility({ bl: false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false, mtr: false });
                if (this.canvasData[e].custom.type === 'clipping-mask' || this.canvasData[e].type === 'image') {
                    this.canvasData[e].selectable = false;
                    this.canvasData[e].evented = false;
                }
            }

            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Toggle editable canvas item state, non editable items won't show in designer mode
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        editable: function editable(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    editable: true
                };
            }

            if (this.canvasData[e].custom.editable === undefined || this.canvasData[e].custom.editable !== false) {
                this.canvasData[e].custom.editable = false;
            } else {
                this.canvasData[e].custom.editable = true;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
            this.$forceUpdate();
        },
        autoScale: function autoScale(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    autoscale: false
                };
            }

            if (this.canvasData[e].custom.autoscale === undefined || this.canvasData[e].custom.autoscale !== false) {
                this.canvasData[e].custom.autoscale = false;
                this.canvasData[e].custom.maxWidth = null;
                this.canvasData[e].custom.maxHeight = null;
                this.canvasData[e].custom.topOffset = null;
            } else {
                this.canvasData[e].custom.fontUnits = 'px';
                this.canvasData[e].setFontSize(this.canvasData[e].custom.fontSize + this.canvasData[e].custom.fontUnits);
                this.canvasData[e].custom.autoscale = true;
                this.canvasData[e].custom.maxWidth = this.canvasData[e].width;
                this.canvasData[e].custom.maxHeight = this.canvasData[e].height;
                this.canvasData[e].custom.topOffset = this.canvasData[e].top;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
            this.$forceUpdate();
        },
        smallCaps: function smallCaps(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].custom === undefined) {
                this.canvasData[e].custom = {
                    smallcaps: false
                };
            }

            if (this.canvasData[e].custom.smallcaps === false) {
                this.canvasData[e].fontStyle = 'small-caps';
                this.canvasData[e].custom.smallcaps = true;
            } else {
                this.canvasData[e].fontStyle = 'normal';
                this.canvasData[e].custom.smallcaps = false;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Toggle visibility of canvas item
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        visible: function visible(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].visible !== false) {
                // this.canvasData[e].hasControls = false
                this.canvasData[e].visible = false;
            } else {
                // this.canvasData[e].hasControls = true
                this.canvasData[e].visible = true;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
            this.$forceUpdate();
        },

        /**
         * Clones a canvas item and creates a duplicate
         * @return {void}
         */
        clone: function clone() {
            var object = this.canvas.getActiveObject().clone();
            object.top = object.top + 5;
            object.left = object.left + 5;

            // Corner Styling
            object.padding = 8;
            object.cornerSize = 14;
            object.cornerStyle = 'circle';
            object.cornerColor = '#76C15D';
            object.cornerStrokeColor = '#ffffff';
            object.rotatingPointOffset = 20;
            object.transparentCorners = false;
            object.uniScaleTransform = true;
            object.selectionBackgroundColor = 'rgba(210,210,210,0.2)';

            object.custom = {
                name: '',
                fontsize: 8,
                fontUnits: 'pt',
                charLimit: 0,
                mask: 'standard',
                editable: true,
                locked: false,
                confirmed: false
            };

            if (this.canvas.getActiveObject().type === 'textbox') {
                object.custom.fontSize = this.canvas.getActiveObject().custom.fontSize;
                object.custom.fontUnits = this.canvas.getActiveObject().custom.fontUnits;
                object.custom.charLimit = this.canvas.getActiveObject().custom.charLimit;
            }

            this.canvas.add(object);
            this.canvas.setActiveObject(object);
        },


        /* Font Modifiers */
        /* -------------- */
        limitChars: function limitChars(e) {
            if (e.custom.charLimit > 0) {
                e.text = e.text.substring(0, e.custom.charLimit);
            }
        },

        /**
         * Toggle canvas objects font style to italic
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontItalic: function fontItalic(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].fontStyle !== 'italic') {
                this.canvasData[e].fontStyle = 'italic';
            } else {
                this.canvasData[e].fontStyle = 'normal';
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
        },

        /**
         * Toggle canvas objects font style to bold
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontBold: function fontBold(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].fontWeight !== 'bold') {
                this.canvasData[e].fontWeight = 'bold';
            } else {
                this.canvasData[e].fontWeight = 'normal';
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
        },

        /**
         * Toggle canvas objects font style to underlined
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontUnderline: function fontUnderline(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].textDecoration !== 'underline') {
                this.canvasData[e].textDecoration = 'underline';
            } else {
                this.canvasData[e].textDecoration = null;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
        },

        /**
         * Toggle canvas objects font style to overlined
         * @param  {integer} e id of canvas item object
         * @return {void}
         */
        fontOverline: function fontOverline(e) {
            var item = this.canvasDataReverse[e];
            e = this.canvasData.indexOf(item);

            if (this.canvasData[e].textDecoration !== 'overline') {
                this.canvasData[e].textDecoration = 'overline';
            } else {
                this.canvasData[e].textDecoration = null;
            }
            this.canvasData[e].dirty = true;
            this.canvas.renderAll();
        },

        /**
         * Sets alignment of canvas items text
         * @param  {integer} index    id of canvas item object
         * @param  {string}  position left, center, right
         * @return {void}
         */
        textAlign: function textAlign(index, position) {
            var item = this.canvasDataReverse[index];
            index = this.canvasData.indexOf(item);

            this.canvas.item(index).textAlign = position;
            this.canvas.renderAll();
        },
        dirtyCanvas: function dirtyCanvas() {
            var template = this.$store.state.template;
            var file = this.$store.state.activeTemplate;
            template.files[file].confirmed = false;
            this.$store.commit('template', template);
            this.$store.commit('templateChanges', true);
        },

        /**
         * Initialize the canvas on load
         * @return {void}
         */
        canvasInit: function canvasInit() {
            this.canvas.clear();
            this.canvas.backgroundColor = 'white';

            this.setTrim(this.currentTrim);
            this.setSafe(this.currentSafe);
        },

        /**
         * Load the canvas and all objects associated with it from the template
         * @param  {object} template template to be loaded into the canvas
         * @return {void}
         */
        canvasLoad: function canvasLoad(template) {
            var _this14 = this;

            var editableLayers = false;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key) {
                if (key === template) {
                    _this14.json = _this14.$store.state.template.files[key].json;
                }
            });

            if (this.json === null) {
                this.canvas.clear();
                this.canvas.backgroundColor = 'white';

                this.setTrim(this.currentTrim);
                this.setSafe(this.currentSafe);
            } else {
                this.canvas.loadFromJSON(this.json, function () {
                    _this14.canvas.renderAll.bind(_this14.canvas);

                    if (_this14.checkConfirmed()) {
                        _this14.proceed.show = true;
                    } else {
                        _this14.proceed.show = false;
                    }

                    if (_this14.displayType === 'designer') {
                        setTimeout(function () {
                            _this14.loopConfirm();

                            if (editableLayers === false) {
                                _this14.noEditableLayers = true;
                                $('.saveButtons.continue').html('Continue >').removeAttr('disabled');
                            } else {
                                _this14.noEditableLayers = false;
                            }
                        }, 500);
                    }

                    _this14.applyAllMasks();

                    // this.setTrim(this.currentTrim)
                    // this.setSafe(this.currentSafe)
                }, function (o, object) {
                    // Load & Stage Each Object //

                    // Build Clipping Masks Array
                    if (object.custom !== undefined) {
                        if (object.custom.type === 'clipping-mask') {
                            var existing = [];
                            for (var i in _this14.clippingMasks) {
                                existing.push(_this14.clippingMasks[i].custom.name);
                            }
                            if (!existing.includes(object.custom.name)) {
                                _this14.clippingMasks.push(object);
                            }

                            if (_this14.$store.state.mode === 'designer') {
                                object.custom.strokeWidth = object.strokeWidth;
                                object.strokeWidth = 0;
                            } else if (_this14.$store.state.mode === 'editor' && object.custom.strokeWidth !== undefined && object.custom.strokeWidth !== null) {
                                object.strokeWidth = object.custom.strokeWidth;
                            }
                        }

                        if (_this14.$store.state.mode === 'editor') {
                            object.padding = 8;
                            object.cornerSize = 14;
                            object.cornerStyle = 'circle';
                            object.cornerColor = '#76C15D';
                            object.cornerStrokeColor = '#ffffff';
                            object.rotatingPointOffset = 20;
                            object.transparentCorners = false;
                            object.uniScaleTransform = true;
                            object.selectionBackgroundColor = 'rgba(210,210,210,0.2)';
                        }

                        if (object.custom.name === 'Trim Area' || object.custom.name === 'Safe Area' || _this14.$store.state.mode === 'designer') {
                            // || object.custom.editable === false || object.custom.editable === true
                            // Design Mode - Set all objects to non selectable and hide controls if it's not an image
                            if (object.type !== 'image') {
                                object.selectable = false;
                                object.editable = false;
                                object.setControlsVisibility({ bl: false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false, mtr: false });
                            } else if (object.custom.locked === true) {
                                object.selectable = false;
                            }

                            // Assign safe and trim targets
                            if (object.custom.name === 'Trim Area') {
                                _this14.trimObject = object;
                            } else if (object.custom.name === 'Safe Area') {
                                _this14.safeObject = object;
                            }
                        }

                        if (object.type === 'image' && !object.custom.uploadButton) {
                            object.custom.uploadButton = 'Select Image File';
                        }

                        if (!object.custom.data_attribute) {
                            object.custom.data_attribute = '';
                        } else {
                            if (object.custom.data_attribute !== '' && _this14.$store.state.mode === 'designer') {
                                // Add Injection Code Here
                                if (object.custom.data_attribute.includes('standard.')) {
                                    var attribute = object.custom.data_attribute.replace('standard.', '');
                                    if (_this14.$auth.user().data_attributes.standard && _this14.$auth.user().data_attributes.standard[attribute]) {
                                        object.text = _this14.$auth.user().data_attributes.standard[attribute];
                                    }
                                    object.setCoords();
                                    _this14.canvas.renderAll();
                                } else if (object.custom.data_attribute.includes('vendor.')) {
                                    var _attribute = object.custom.data_attribute.replace('vendor.', '');
                                    if (_this14.$auth.user().data_attributes.vendor && _this14.$auth.user().data_attributes.vendor[_attribute]) {
                                        object.text = _this14.$auth.user().data_attributes.vendor[_attribute];
                                    }
                                    object.setCoords();
                                    _this14.canvas.renderAll();
                                }
                            }
                        }

                        if (object.custom.editable === true) {
                            editableLayers = true;
                        }
                    } else {
                        object.custom = {
                            name: null,
                            mask: null,
                            confirmed: false,
                            data_attribute: ''
                        };
                    }

                    // Design Mode
                    // if (this.$store.state.mode === 'designer') {
                    //     editableLayers = true
                    // }

                    // Force caching off for all text areas
                    if (object.type === 'textbox') {
                        object.caching = false;
                    }
                });
            }
        },

        toggleShortcuts: function toggleShortcuts() {
            this.shortcuts = !this.shortcuts;
        },
        setTooltip: function setTooltip(index) {
            var tips = ['Left align selected objects', // 0
            'Center align selected objects', 'Right align selected objects', 'Vertical align selected objects to the top', 'Vertical align selected objects to the bottom', 'Move layer to the very top', 'Move layer up one position', 'Move layer down one position', 'Move layer to the very bottom', 'Add new object to the canvas', 'Delete selected object', // 10
            'Lock editing of layer so customers cannot make changes', 'Hide layer', 'Lock layer', 'Set font to italic', 'Set font to bold', 'Set font to underlined', 'Left align text', 'Center text', 'Right align text', 'Justify text', // 20
            'Duplicate this layer', 'Trim area is calculated based on bleed set by the template.', 'Safe area is calculated based on bleed settings', 'Flip layer horizontally', 'Flip layer vertically ', 'Center objects vertically', 'Distribute objects horizontally', 'Distribute objects vertically', 'Flip selected object horizontally', 'Flip selected object vertically', // 30
            'Automatically scale the font to fit the textbox', 'Toggle "Small Caps"'];
            this.tooltip = this.tooltip === tips[index] ? null : tips[index];
        },
        loadFonts: function loadFonts() {
            var googleFamilies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var loadFamilies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var _this15 = this;

            var loadUrls = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var wait = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var fontConfig = {};

            if (googleFamilies !== null && googleFamilies.length > 0) {
                fontConfig.google = { families: googleFamilies };
            }
            if (loadFamilies !== null && loadFamilies.length > 0) {
                fontConfig.custom = {
                    families: loadFamilies,
                    urls: loadUrls
                };
            }

            fontConfig.active = function () {
                if (wait === true) {
                    _this15.loadingComplete = true;
                    _this15.canvas.renderAll();
                } else {
                    _this15.canvas.renderAll();
                }
            };

            __WEBPACK_IMPORTED_MODULE_3_webfontloader___default.a.load(fontConfig);
        }
    },
    /**
     * Fired before mounting of the component
     * @return {void}
     */
    beforeMount: function beforeMount() {
        var _this16 = this;

        this.loadingStatus = 'Initializing..';

        this.windowMsgScrollToIframe();
        this.windowMsgLockWindow(true);

        // Setup Product Dimensions & Bleed
        this.productWidth = parseFloat(this.prodWidth);
        this.productHeight = parseFloat(this.prodHeight);
        this.currentTrim = parseFloat(this.prodBleed);
        this.currentSafe = parseFloat(this.prodSafe);
        this.productPixelWidth = (this.productWidth + this.currentTrim * 2) * 300;
        this.productPixelHeight = (this.productHeight + this.currentTrim * 2) * 300;

        // Set Active Tab > Triggers activeTemplate watcher
        var set = this.$store.state.activeTemplate;
        var files = this.$store.state.template.files;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(files).forEach(function (key) {
            if (set === null) {
                _this16.$store.commit('activeTemplate', key);
                set = key;
            }
        });

        this.loadingStatus = 'Building Template';

        /* Fetch Font List */
        /* --------------- */
        var activeFonts = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(files).forEach(function (key) {
            if (files[key].fonts !== undefined && files[key].fonts.length > 0) {
                for (var i in files[key].fonts) {
                    activeFonts.push(files[key].fonts[i]);
                }
            }
        });
        this.$store.commit('activeFonts', activeFonts);

        if (this.$store.state.fontsLoadedFor !== this.$store.state.template.id) {
            this.axios.get('/fonts/list?limit=500').then(function (response) {
                _this16.loadingStatus = 'Loading Fonts';

                var fonts = response.data.data;
                var loadFamilies = [];
                var loadUrls = [];
                var googleFamilies = [];

                for (var i in fonts) {
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(activeFonts, fonts[i].name) || _this16.displayType === 'editor') {
                        loadFamilies.push(fonts[i].name);
                        loadUrls.push(fonts[i].css);
                    }
                }
                if (_this16.displayType === 'editor') {
                    fonts.unshift({ name: 'Custom Fonts:' }, { name: '-----------------------' });
                }

                // Google Font
                _this16.axios.get('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAKgDGIZYO2npQx6c894aC1lkRUidSRwa8').then(function (response) {
                    var title2 = false;
                    for (var i in response.data.items) {
                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(activeFonts, response.data.items[i].family) || _this16.displayType === 'editor') {
                            if (title2 === false && _this16.displayType === 'editor') {
                                title2 = true;
                                fonts.push({ name: '' });
                                fonts.push({ name: 'Google Fonts:' });
                                fonts.push({ name: '-----------------------' });
                            }
                            fonts.push({ name: response.data.items[i].family });
                            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(activeFonts, response.data.items[i].family)) {
                                googleFamilies.push(response.data.items[i].family);
                            }
                        }
                    }

                    if (googleFamilies !== null && googleFamilies.length > 0 || loadFamilies !== null && loadFamilies.length > 0) {
                        _this16.loadFonts(googleFamilies, loadFamilies, loadUrls);
                        _this16.$store.commit('fonts', fonts);
                        _this16.$store.commit('fontsLoadedFor', _this16.$store.state.template.id);
                    } else {
                        _this16.loadingComplete = true;
                        _this16.canvas.renderAll();
                    }
                });
            });
        } else {
            this.loadingComplete = true;
        }

        this.dataAttributes.push('standard.first_name', 'standard.last_name', 'standard.full_name', 'standard.email', 'standard.company', 'standard.work_phone', 'standard.cell_phone', 'standard.fax', 'standard.address1', 'standard.address2', 'standard.city', 'standard.state', 'standard.zip', 'standard.country');
        if (this.$store.state.template.hasOwnProperty('vendors') && this.$store.state.template.vendors.data.length > 0) {
            this.dataAttributes.push('# Vendor Data Attributes ----------');
            for (var key in this.$store.state.template.vendors.data[0].data_attributes.vendor) {
                this.dataAttributes.push('vendor.' + key.replace('vendor.', ''));
            }
        }
    },

    /**
     * Fired once the component is mounted
     * @return {void}
     */
    mounted: function mounted() {
        var _this17 = this;

        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.objectCaching = false;
        // Default Style for Group Selection
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.padding = 8;
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.cornerSize = 14;
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.cornerStyle = 'circle';
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.cornerColor = '#76C15D';
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.cornerStrokeColor = '#ffffff';
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.rotatingPointOffset = 20;
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.transparentCorners = false;
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.uniScaleTransform = true;
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Object.prototype.selectionBackgroundColor = 'rgba(210,210,210,0.2)';
        // fabric.Object.prototype.noScaleCache

        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Textbox.prototype.setFontSize = function (size) {
            this.fontSize = __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].util.parseUnit(size);
            return this;
        };
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Textbox.prototype.scaleFontSize = function () {
            this.canvas.renderAll();

            var lineWidth = getLineWidth(this);
            var charWidth = getCharWidth(this, lineWidth);
            var tryWidth = lineWidth * this.scaleX + charWidth;

            if (tryWidth > this.custom.maxWidth) {
                scaleDown(this, tryWidth);
            } else if (this.fontSize * (this.custom.maxWidth / (this.width - 1)) < this.custom.fontSize) {
                scaleUp(this);
            }

            function getLineWidth(text) {
                var lineWidth = 0;
                for (var i in text.__lineWidths) {
                    lineWidth += text.__lineWidths[i];
                }
                return lineWidth;
            }

            function getCharWidth(text, lineWidth) {
                var textLength = text.text.length > 1 ? text.text.length : 2;
                return lineWidth / textLength;
            }

            function scaleDown(text, currentWidth) {
                var maxWidth = text.custom.maxWidth;
                text.fontSize *= maxWidth / currentWidth;
                text.width = maxWidth;

                text.canvas.renderAll();

                var lineWidth = getLineWidth(text);
                charWidth = getCharWidth(text, lineWidth);
                tryWidth = lineWidth * text.scaleX + charWidth;

                if (tryWidth > text.custom.maxWidth) {
                    scaleDown(text, tryWidth);
                }
            }

            function scaleUp(text) {
                text.fontSize *= text.custom.maxWidth / (text.width - 1);

                if (text.fontSize < text.custom.fontSize) {
                    text.fontSize = text.custom.fontSize;
                    text.canvas.renderAll();

                    lineWidth = getLineWidth(text);
                    charWidth = getCharWidth(text, lineWidth);
                    tryWidth = lineWidth * text.scaleX + charWidth;
                    if (tryWidth > text.custom.maxWidth) {
                        scaleDown(text, tryWidth);
                    }
                }
            }

            if (!this.custom.lastHeight) {
                this.custom.lastHeight = this.custom.maxHeight;
            }

            var adjustHeight = 0;
            if (this.height < this.custom.lastHeight) {
                adjustHeight = this.custom.maxHeight - this.height;
            } else {
                adjustHeight = this.custom.maxHeight - this.height;
            }
            this.top = this.custom.topOffset + adjustHeight / 2;
            this.custom.lastHeight = this.height;

            return this;
        };
        __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].DPI = 300;

        this.canvas = new __WEBPACK_IMPORTED_MODULE_1_fabric__["fabric"].Canvas('canvas');
        this.canvas.preserveObjectStacking = false;

        window.addEventListener('resize', this.resizeCanvas, false);

        this.canvasData = this.canvas.getObjects();

        // Watch for objects added to the canvas
        this.canvas.on('object:added', function (e) {
            if (e.target.custom !== undefined && e.target.custom.name === 'Trim Area') {
                _this17.trimObject = e.target;
            } else if (e.target.custom !== undefined && e.target.custom.name === 'Safe Area') {
                _this17.safeObject = e.target;
            }
        });

        // Watch for canvas object selection to toggle accordion
        this.canvas.on('object:selected', function (options) {
            var parnt = _this17;
            var idx = _this17.canvasDataReverse.indexOf(options.target);
            if (_this17.selected !== idx || $('a[href=#collapse' + idx + ']').attr('aria-expanded') !== 'true' && _this17.loadingComplete === true) {
                $('a[href=#collapse' + idx + ']').trigger('click');
                parnt.selected = idx;
                // Scroll the page to the active object after it has settled
                if (_this17.loadingComplete === true) {
                    window.scroll({
                        top: options.target.top - window.innerHeight / 2,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            }
        });

        this.canvas.on('selection:created', function (e) {
            var obj = e.target._objects[0];

            if (_this17.displayType === 'designer') {
                _this17.canvas.discardActiveGroup().setActiveObject(obj).renderAll();
            }
        });

        this.canvas.on('object:moving', function (options) {
            if (options.e.shiftKey === true) {
                options.target.lockMovementX = true;
            } else if (options.e.altKey === true) {
                options.target.lockMovementY = true;
            }
        });

        this.canvas.on('object:rotating', function (options) {
            _this17.$store.commit('templateChanges', true);

            _this17.tooltip = 'Hold shift to enable snap';
            if (options.e.shiftKey === true) {
                options.target.snapAngle = 22.5;
            } else {
                options.target.snapAngle = 0;
            }
        });

        this.canvas.on('mouse:up', function (options) {
            if (_this17.canvas.getActiveObject() === null) {
                $('a[aria-expanded=true]').trigger('click');
                _this17.selected = null;
            }
        });

        this.canvas.on('object:removed', function (options) {
            _this17.$store.commit('templateChanges', true);
        });

        this.canvas.on('object:modified', function (options) {
            _this17.$store.commit('templateChanges', true);

            _this17.tooltip = null;
            if (options.target.custom !== undefined && options.target.custom.locked !== true) {
                options.target.lockMovementX = false;
                options.target.lockMovementY = false;
            }

            // Reset our autoscale info if autoscaling is turned on for this element
            if (options.target.custom.autoscale === true) {
                options.target.custom.maxWidth = options.target.width;
                options.target.custom.maxHeight = options.target.height;
                options.target.custom.topOffset = options.target.top;
            }

            options.target.setCoords();
            _this17.canvas.renderAll();
        });
        // this.canvas.on('after:selection:cleared', function (options) {
        //     console.log(this.canvas.getActiveObject())
        //     var idx = this.canvas.getObjects().indexOf(options.target)
        //     console.log(idx)
        //     console.log(this.selected)
        //     if (this.selected !== idx) {
        //         $('a[href=#collapse' + idx + ']').trigger('click')
        //         this.selected = idx
        //     }
        // })

        // this.canvas.on('mouse:over', function (e) {
        //     e.target.set('active', true)
        //     this.canvas.renderAll()
        // })

        // this.canvas.on('mouse:out', function (e) {
        //     e.target.set('active', false)
        //     this.canvas.renderAll()
        // })

        // Watch Object Resizing
        this.canvas.on('object:scaling', function (e) {
            var obj = e.target;
            // Check Stroke Scaling
            if (!obj.strokeWidthUnscaled && obj.strokeWidth) {
                obj.strokeWidthUnscaled = obj.strokeWidth;
            }
            if (obj.strokeWidthUnscaled) {
                obj.strokeWidth = obj.strokeWidthUnscaled / obj.scaleX;
            }
            // Stop Images from being Upscaled to anything higher than 1x
            if (obj.get('type') === 'image') {
                if (obj.scaleX > 1) {
                    obj.scaleX = 1;
                }
                if (obj.scaleY > 1) {
                    obj.scaleY = 1;
                }
            }
        });

        // Watch Page Scrolling to Lock the Canvas Position
        window.addEventListener('scroll', function () {
            if (window.pageYOffset >= 78 && $(window).width() >= 768) {
                $('.secondary-nav').addClass('fixed');
                $('.layers').addClass('fixed');
                $('.artboard').addClass('fixed');

                var activeLayerTop = $('.layers').offset();
                if (activeLayerTop !== undefined) {
                    if (window.pageYOffset >= activeLayerTop.top - 80) {
                        $('.layers').addClass('fixed');
                    }
                }
            } else {
                $('.fixed').removeClass('fixed');
            }
        });

        if (this.displayType === 'editor') {
            //
        } else if (this.displayType === 'preview') {
            //
        }

        if (this.$store.state.template !== null) {
            this.canvasLoad();
        } else {
            this.canvasInit();
        }

        this.resizeCanvas(null);
    },

    /**
     * Fired when the component is created
     * @return {void}
     */
    created: function created() {
        var _this18 = this;

        if (this.$store.state.savedTemplate === null) {
            this.newTemplate = true;
            this.templateName = new Date().getUTCMilliseconds();
        }

        // Watch for activeTemplate to change so we can swap out the loaded template
        this.watcher = this.$store.watch(function (state) {
            return state.activeTemplate;
        }, function (newValue, oldValue) {
            _this18.templateTransition = true;
            _this18.generateImage(oldValue);

            // Confirm that a different template was selected / else do nothing
            if (newValue !== oldValue) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this18.$store.state.template.files).forEach(function (key) {
                    // Save our current template out so we don't lose changes when switching
                    if (key === oldValue) {
                        var template = _this18.$store.state.template;

                        // Unclip All Masks
                        for (var i in _this18.canvasData) {
                            if (_this18.canvasData[i].clipTo !== null) {
                                _this18.canvasData[i].clipTo = null;
                            }
                        }

                        // Set Template Confirmation Status
                        if (_this18.checkConfirmed()) {
                            template.files[key].confirmed = true;
                        }
                        template.files[key].json = _this18.canvas.toDatalessJSON(['custom']);
                        _this18.$store.commit('template', template);
                        _this18.$store.commit('activeTemplate', newValue);
                        _this18.templateTransition = false;
                    }
                });

                // Load Selected Template Side
                setTimeout(function () {
                    _this18.canvasLoad(newValue);
                }, oldValue === null ? 500 : 0);
                _this18.canvas.renderAll();
            }
        });
    },

    /**
     * Fired before the component is destroyed in the vue workflow
     * @return {void}
     */
    beforeDestroy: function beforeDestroy() {
        // Unset the activeTemplate
        this.$store.commit('activeTemplate', null);
        this.watcher();
    },

    /**
     * Directives for the component
     * @type {Object}
     */
    directives: {
        insertMessage: function insertMessage(canvasElement, binding) {
            // Get canvas context
            // var ctx = canvasElement.getContext('2d')
            // ctx.fillStyle = 'orange'
            // // Clear the canvas
            // ctx.clearRect(0, 0, 650, 400)
            // // Insert stuff into canvas
            // ctx.fillStyle = 'black'
            // ctx.font = '20px Helvetica'
            // ctx.fillText(binding.value, 10, 50)
        }
    },
    /**
     * Filters for the component
     * @type {Object}
     */
    filters: __WEBPACK_IMPORTED_MODULE_27__components_filters_all___default.a
});

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 251 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 259 */,
/* 260 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(271),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        path: {
            default: '/'
        },
        index: {
            default: null
        },
        item: {
            default: {}
        },
        title: {
            default: 'name'
        },
        label: {
            default: '<i class="icon-bin"></i>'
        },
        classes: {
            default: 'btn-icon btn-xs btn-danger'
        }
    },
    data: function data() {
        return {
            term: '',
            results: []
        };
    },

    methods: {
        confirmDelete: function confirmDelete() {
            var index = this.index;
            var parnt = this;

            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
                title: 'Deleting ' + this.item[this.title],
                text: "Are you sure? You won't be able to revert this!",
                type: 'warning',
                useRejections: true,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function () {
                parnt.axios.delete(parnt.path + parnt.item.id).then(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Deleted!', parnt.item[parnt.title] + ' has been deleted.', 'success').then(function () {
                    parnt.$emit('remove', index);
                }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop));
            }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop);
        }
    }
});

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn waves-effect waves-light",
    class: _vm.classes,
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.confirmDelete($event)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(274),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'lock',
    props: {
        shape: {
            default: {
                locked: false
            }
        },
        type: {
            default: 'designer'
        }
    },
    methods: {
        lock: function lock() {
            this.$emit('lock');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'editor') ? _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.locked === true || _vm.shape.custom.locked === true)
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.lock()
      }
    }
  }, [_c('i', {
    staticClass: "icon-lock"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(277),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'editable',
    props: {
        shape: {
            default: {
                locked: false
            }
        },
        type: {
            default: 'designer'
        }
    },
    methods: {
        editable: function editable() {
            this.$emit('editable');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'editor') ? _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.custom.editable === false)
    },
    on: {
      "click": function($event) {
        _vm.editable()
      },
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      }
    }
  }, [(_vm.shape.custom === undefined || _vm.shape.custom.editable === undefined || _vm.shape.custom.editable === true) ? _c('i', {
    staticClass: "icon-edit"
  }) : _c('i', {
    staticClass: "icon-no-edit"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(280),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'visible',
    props: {
        shape: {
            default: {
                locked: false
            }
        },
        type: {
            default: 'designer'
        }
    },
    methods: {
        visible: function visible() {
            this.$emit('visible');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'editor') ? _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.visible === false)
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.visible()
      }
    }
  }, [_c('i', {
    staticClass: "icon-eye-blocked"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(283),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'copy',
    props: {
        shape: {
            default: {
                locked: false
            }
        },
        type: {
            default: 'designer'
        }
    },
    methods: {
        clone: function clone() {
            this.$emit('clone');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'editor') ? _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.clone()
      }
    }
  }, [_c('i', {
    staticClass: "icon-copy"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(286),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'flipx',
    props: {},
    methods: {
        flipX: function flipX() {
            this.$emit('flipX');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.flipX()
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-horizontal"
  })])
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(289),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'flipy',
    props: {},
    methods: {
        flipY: function flipY() {
            this.$emit('flipY');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.flipY()
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-vertical"
  })])
},staticRenderFns: []}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(292),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'alignCenter',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        textAlign: function textAlign() {
            this.$emit('textAlign');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.textAlign === 'center')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.textAlign()
      }
    }
  }, [_c('i', {
    staticClass: "icon-paragraph-center"
  })])
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(295),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'alignJustify',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        textAlign: function textAlign() {
            this.$emit('textAlign');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.textAlign === 'justify')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.textAlign()
      }
    }
  }, [_c('i', {
    staticClass: "icon-paragraph-justify"
  })])
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(298),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'alignLeft',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        textAlign: function textAlign() {
            this.$emit('textAlign');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.textAlign === 'left')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.textAlign()
      }
    }
  }, [_c('i', {
    staticClass: "icon-paragraph-left"
  })])
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'alignRight',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        textAlign: function textAlign() {
            this.$emit('textAlign');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.textAlign === 'right')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.textAlign()
      }
    }
  }, [_c('i', {
    staticClass: "icon-paragraph-right"
  })])
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(304),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'italic',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        fontItalic: function fontItalic() {
            this.$emit('italic');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.fontStyle === 'italic')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.fontItalic()
      }
    }
  }, [_c('i', {
    staticClass: "icon-italic"
  })])
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(307),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bold',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        fontBold: function fontBold() {
            this.$emit('bold');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.fontWeight === 'bold')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.fontBold()
      }
    }
  }, [_c('i', {
    staticClass: "icon-bold"
  })])
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(310),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'underline',
    props: {
        shape: {
            default: {
                locked: false
            }
        }
    },
    methods: {
        fontUnderline: function fontUnderline() {
            this.$emit('underline');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.textDecoration === 'underline')
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.fontUnderline()
      }
    }
  }, [_c('i', {
    staticClass: "icon-underline"
  })])
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(313),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'autoScale',
    props: {
        shape: {
            default: {
                custom: {
                    autoscale: false
                }
            }
        }
    },
    methods: {
        autoScale: function autoScale() {
            this.$emit('autoScale');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.custom.autoscale === true)
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.autoScale()
      }
    }
  }, [_c('i', {
    staticClass: "icon-text-width"
  })])
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'smallCaps',
    props: {
        shape: {
            default: {
                custom: {
                    smallcaps: false
                }
            }
        }
    },
    methods: {
        smallCaps: function smallCaps() {
            this.$emit('smallCaps');
        },
        setTooltip: function setTooltip() {
            this.$emit('tooltip');
        }
    }
});

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-icon waves-effect btn-default waves-light",
    class: {
      active: (_vm.shape.custom.smallcaps === true)
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip()
      },
      "mouseleave": function($event) {
        _vm.setTooltip()
      },
      "click": function($event) {
        _vm.smallCaps()
      }
    }
  }, [_c('i', {
    staticClass: "icon-font-size"
  })])
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keyboardShortcuts; });
var keyboardShortcuts = {
    data: function data() {
        return {
            canvas: null
        };
    },
    mounted: function mounted() {
        var _this = this;

        // Detect Keystrokes For Modifiers in Editor Mode
        document.addEventListener('keydown', function (event) {
            if (_this.$store.state.mode === 'editor') {
                var target = _this.canvas.getActiveObject() === null ? _this.canvas.getActiveGroup() : _this.canvas.getActiveObject();

                if (target !== undefined && target !== null) {
                    var move = event.shiftKey === true ? 10 : 1;
                    if (event.altKey === true) {
                        move = 25;
                    }

                    if (target.custom === undefined || target.custom.locked === undefined || target.custom.locked === false || target.isConnected === true) {
                        if (event.keyCode === 37) {
                            event.preventDefault();
                            if (target.isConnected === true) {
                                _this.canvas.getActiveGroup().forEachObject(function (o) {
                                    if (_this.checkMaskUse(o)) {
                                        o.left -= move;
                                    }
                                });
                                _this.groupItemsRefresh(_this.canvas.getActiveGroup());
                            } else {
                                target.left -= move;
                            }
                        } else if (event.keyCode === 38) {
                            event.preventDefault();
                            if (target.isConnected === true) {
                                _this.canvas.getActiveGroup().forEachObject(function (o) {
                                    if (_this.checkMaskUse(o)) {
                                        o.top -= move;
                                    }
                                });
                                _this.groupItemsRefresh(_this.canvas.getActiveGroup());
                            } else {
                                target.top -= move;
                            }
                        } else if (event.keyCode === 39) {
                            event.preventDefault();
                            if (target.isConnected === true) {
                                _this.canvas.getActiveGroup().forEachObject(function (o) {
                                    if (_this.checkMaskUse(o)) {
                                        o.left += move;
                                    }
                                });
                                _this.groupItemsRefresh(_this.canvas.getActiveGroup());
                            } else {
                                target.left += move;
                            }
                        } else if (event.keyCode === 40) {
                            event.preventDefault();
                            if (target.isConnected === true) {
                                _this.canvas.getActiveGroup().forEachObject(function (o) {
                                    if (_this.checkMaskUse(o)) {
                                        o.top += move;
                                    }
                                });
                                _this.groupItemsRefresh(_this.canvas.getActiveGroup());
                            } else {
                                target.top += move;
                            }
                        } else if (event.keyCode === 46) {
                            event.preventDefault();
                            _this.removeElement();
                            _this.selected = -1;
                        }
                        _this.canvas.renderAll();
                    }
                }

                if (event.metaKey === true) {
                    if (event.keyCode === 49) {
                        event.preventDefault();
                        _this.addElement({ type: 'text' });
                    } else if (event.keyCode === 50) {
                        event.preventDefault();
                        _this.addElement({ type: 'rect', custom: { name: 'New Rectangle' } });
                    } else if (event.keyCode === 51) {
                        event.preventDefault();
                        _this.addElement({ type: 'ellipse', custom: { name: 'New Ellipse' } });
                    } else if (event.keyCode === 52) {
                        event.preventDefault();
                        _this.addElement({ type: 'triangle', custom: { name: 'New Triangle' } });
                    } else if (event.keyCode === 53) {
                        event.preventDefault();
                        _this.addElement({ type: 'image' });
                    } else if (event.keyCode === 54) {
                        event.preventDefault();
                        _this.addElement({ type: 'clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' } });
                    } else if (event.keyCode === 55) {
                        event.preventDefault();
                        _this.addElement({ type: 'round-clipping-area', custom: { name: 'Clipping Area', type: 'clipping-mask' } });
                    }
                }
            }
        });
    }
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return textFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_core_maskit__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_core_dynamic_mask__ = __webpack_require__(321);

// import StringMask from 'string-mask'




var textFilters = {
    data: function data() {
        return {
            formatMasks: {
                'standard': { name: 'Standard', format: null },
                'standardcaps': { name: 'Standard (Caps Only)', format: this.standardCapsOnly },
                'titlecase': { name: 'Title Case (Caps first letter of each word and lowercase the rest)', format: this.titleCase },
                'opentitlecase': { name: 'Open Title Case (Caps first letter of each word but otherwise makes no modifications)', format: this.openTitleCase },
                'letnum': { name: 'Letters & Numbers Only', format: this.letterNumbersOnly },
                'letnumcaps': { name: 'Letters & Numbers Only (Caps)', format: this.letterNumbersCapsOnly },
                'telephone1': { name: 'Telephone: X-XXX-XXX-XXXX', format: ['###-#####', '###-###-#####', '#-###-###-####'] },
                'telephone2': { name: 'Telephone: X.XXX.XXX.XXXX', format: ['###.#####', '###.###.#####', '#.###.###.####'] },
                'telephone3': { name: 'Telephone: (XXX) XXX-XXXX', format: ['###-#####', '(###) ###-#####', '# (###) ###-####'] },
                'date1': { name: 'Date: XX/XX/XXXX', format: ['##/##/####'] },
                'date2': { name: 'Date: XX.XX.XXXX', format: ['##.##.####'] },
                'date3': { name: 'Date: XX-XX-XXXX', format: ['##-##-####'] },
                'twitter': { name: 'Twitter: @xxxxxxxxxx', format: ['@XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'] }
            }
        };
    },

    methods: {
        fetchTextMask: function fetchTextMask(id) {
            // JSON.parse used to strip the vue observer
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formatMasks[id].format));
        },
        textFormat: function textFormat(mask, text) {
            var maskString = this.formatMasks[mask].format;
            if (maskString === null) {
                return text;
            } else if (this.isFunction(maskString)) {
                return maskString(text);
            } else {
                return this.mask(text, maskString);
            }
        },
        mask: function mask(value, _mask) {
            var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            return Array.isArray(_mask) ? Object(__WEBPACK_IMPORTED_MODULE_3__assets_js_core_dynamic_mask__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__assets_js_core_maskit__["a" /* default */], _mask, __WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens___default.a)(value, _mask, masked, __WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens___default.a) : Object(__WEBPACK_IMPORTED_MODULE_2__assets_js_core_maskit__["a" /* default */])(value, _mask, masked, __WEBPACK_IMPORTED_MODULE_1__assets_js_core_tokens___default.a);
        },
        isFunction: function isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        },
        standardCapsOnly: function standardCapsOnly(text) {
            return text.toUpperCase();
        },
        titleCase: function titleCase(text) {
            return text.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        openTitleCase: function openTitleCase(text) {
            return text.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1);
            });
        },
        letterNumbersOnly: function letterNumbersOnly(text) {
            return text.replace(/[^a-z0-9]/gi, '');
        },
        letterNumbersCapsOnly: function letterNumbersCapsOnly(text) {
            return text.replace(/[^a-z0-9]/gi, '').toUpperCase();
        }
    }
};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleUpperCase();
        } },
    'a': { pattern: /[a-zA-Z]/, transform: function transform(v) {
            return v.toLocaleLowerCase();
        } },
    '!': { escape: true }
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = maskit;
function maskit(value, mask) {
    var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var tokens = arguments[3];

    value = value || '';
    mask = mask || '';
    var iMask = 0;
    var iValue = 0;
    var output = '';
    while (iMask < mask.length && iValue < value.length) {
        var cMask = mask[iMask];
        var masker = tokens[cMask];
        var cValue = value[iValue];
        if (masker && !masker.escape) {
            if (masker.pattern.test(cValue)) {
                output += masker.transform ? masker.transform(cValue) : cValue;
                iMask++;
            }
            iValue++;
        } else {
            if (masker && masker.escape) {
                iMask++; // take the next mask char and treat it as char
                cMask = mask[iMask];
            }
            if (masked) output += cMask;
            if (cValue === cMask) iValue++; // user typed the same char
            iMask++;
        }
    }

    // fix mask that ends with a char: (#)
    var restOutput = '';
    while (iMask < mask.length && masked) {
        var cMask = mask[iMask];
        if (tokens[cMask]) {
            restOutput = '';
            break;
        }
        restOutput += cMask;
        iMask++;
    }

    return output + restOutput;
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicMask;
function dynamicMask(maskit, masks, tokens) {
    masks = masks.sort(function (a, b) {
        return a.length - b.length;
    });
    return function (value, mask) {
        var masked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var i = 0;
        while (i < masks.length) {
            var currentMask = masks[i];
            i++;
            var nextMask = masks[i];
            if (!(nextMask && maskit(value, nextMask, true, tokens).length > currentMask.length)) {
                return maskit(value, currentMask, masked, tokens);
            }
        }
        return ''; // empty masks
    };
}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = {
    shortenUrl: function shortenUrl(value) {
        return value.replace('http://localhost:8080/static/testing/', '');
    },
    capitalize: function capitalize(value) {
        if (!value) return '';
        value = value.toString();
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    },
    underlineSpace: function underlineSpace(value) {
        return value.split('_').join(' ');
    }
};

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvasBlock group row relative"
  }, [_c('transition', {
    attrs: {
      "leave-active-class": "animated fadeOut"
    }
  }, [(!_vm.loadingComplete) ? _c('div', {
    staticClass: "loadingBlock"
  }, [_c('div', {
    staticClass: "center-align-ab"
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "loadingText"
  }, [_vm._v(_vm._s(_vm.loadingStatus))])], 1)]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown"
    }
  }, [(_vm.loadingComplete && _vm.$store.state.mode === 'editor') ? _c('div', {
    staticClass: "secondary-nav primarybgdark m-b-20"
  }, [_c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn btn-success dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    },
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(9)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(9)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus m-r-5"
  }), _vm._v(" Add "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'text'
        })
      }
    }
  }, [_vm._v("Text "), _c('span', [_vm._v("(⌘ + 1)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'rect',
          custom: {
            name: 'New Rectangle'
          }
        })
      }
    }
  }, [_vm._v("Block "), _c('span', [_vm._v("(⌘ + 2)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'ellipse',
          custom: {
            name: 'New Ellipse'
          }
        })
      }
    }
  }, [_vm._v("Ellipse "), _c('span', [_vm._v("(⌘ + 3)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'triangle',
          custom: {
            name: 'New Triangle'
          }
        })
      }
    }
  }, [_vm._v("Triangle "), _c('span', [_vm._v("(⌘ + 4)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'image'
        })
      }
    }
  }, [_vm._v("Image "), _c('span', [_vm._v("(⌘ + 5)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'clipping-area',
          custom: {
            name: 'Clipping Area',
            type: 'clipping-mask'
          }
        })
      }
    }
  }, [_vm._v("Mask - Box "), _c('span', [_vm._v("(⌘ + 6)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addElement({
          type: 'round-clipping-area',
          custom: {
            name: 'Clipping Area',
            type: 'clipping-mask'
          }
        })
      }
    }
  }, [_vm._v("Mask - Circle "), _c('span', [_vm._v("(⌘ + 7)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("Zoom: " + _vm._s(_vm.zoom * 100 + '%') + " "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(1)
      }
    }
  }, [_vm._v("100%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.9)
      }
    }
  }, [_vm._v("90%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.8)
      }
    }
  }, [_vm._v("80%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.7)
      }
    }
  }, [_vm._v("70%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.6)
      }
    }
  }, [_vm._v("60%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.5)
      }
    }
  }, [_vm._v("50%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.4)
      }
    }
  }, [_vm._v("40%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.3)
      }
    }
  }, [_vm._v("30%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.2)
      }
    }
  }, [_vm._v("20%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.1)
      }
    }
  }, [_vm._v("10%")])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover m-b-10 m-r-5",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(10)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(10)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.removeElement()
      }
    }
  }, [_c('i', {
    staticClass: "icon-bin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(0)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(0)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('left')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(1)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(1)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('center')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-center-horizontal"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(2)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(2)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('right')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(3)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(3)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('top')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-top"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(26)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(26)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('vertical-center')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-center-vertical"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(4)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(4)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.groupAlign('bottom')
      }
    }
  }, [_c('i', {
    staticClass: "icon-align-bottom"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(27)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(27)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.evenlySpace('horizontal')
      }
    }
  }, [_c('i', {
    staticClass: "icon-menu"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(28)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(28)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.evenlySpace('vertical')
      }
    }
  }, [_c('i', {
    staticClass: "icon-more2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(29)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(29)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.flipX(null)
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-horizontal"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(30)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(30)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.flipY(null)
      }
    }
  }, [_c('i', {
    staticClass: "icon-flip-vertical"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-b-10 m-r-5"
  }, [_c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(5)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(5)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'front')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-double-up m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(6)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(6)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'forward')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-up m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(7)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(7)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'backward')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-down m-r-5"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn primarybg hover",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(8)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(8)
      },
      "click": function($event) {
        $event.preventDefault();
        _vm.moveLayer(null, 'back')
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-double-down m-r-5"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [(_vm.tooltip !== null) ? _c('p', {
    staticClass: "right primarytextlight"
  }, [_vm._v("\n                    " + _vm._s(_vm.tooltip) + "\n                ")]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 m-b-20 artboardWrapper",
    class: {
      fullArtboard: (_vm.displayType === 'preview'), artboard: true, 'designMode': _vm.displayType === 'designer', 'editMode': _vm.displayType === 'editor'
    }
  }, [_c('div', {
    staticClass: "containerWrapper"
  }, [_c('canvas', {
    directives: [{
      name: "insert-message",
      rawName: "v-insert-message",
      value: (_vm.exampleContent),
      expression: "exampleContent"
    }],
    staticStyle: {
      "width": "100%",
      "height": "635px",
      "border": "1px solid #BBB"
    },
    attrs: {
      "id": "canvas",
      "width": _vm.productPixelWidth,
      "height": _vm.productPixelHeight
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.displayType !== 'preview') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.template.userversions === undefined || _vm.$store.state.template.userversions.data.length < 1 || _vm.$store.state.savedTemplate !== null || _vm.newTemplate === true || _vm.$store.state.mode === 'editor'),
      expression: "$store.state.template.userversions === undefined || $store.state.template.userversions.data.length < 1 || $store.state.savedTemplate !== null || newTemplate === true || $store.state.mode === 'editor'"
    }],
    staticClass: "panel-group panel-group-joined layers col-sm-4 right",
    class: {
      'designMode': _vm.displayType === 'designer', 'editMode': _vm.displayType === 'editor'
    },
    attrs: {
      "id": "accordion-test"
    }
  }, [(_vm.noEditableLayers === true) ? _c('div', {
    staticClass: "noEdit m-b-20"
  }, [_vm._v("\n                This template has no layers to edit, please proceed below.\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.canvasDataReverse), function(shape, index) {
    return (
      shape.custom === undefined ||
      (_vm.displayType === 'designer' && shape.type !== 'rect' && shape.type !== 'ellipse' && shape.type !== 'triangle' && shape.custom.editable === true) ||
      (_vm.displayType === 'editor' && shape.custom !== undefined && shape.custom.name !== 'Trim Area' && shape.custom.name !== 'Safe Area')
    ) ? _c('div', {
      staticClass: "panel panel-default"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loadingComplete),
        expression: "loadingComplete"
      }],
      staticClass: "collapsed",
      class: {
        'confirmed': (shape.custom.confirmed === true)
      },
      attrs: {
        "data-toggle": "collapse",
        "data-parent": "#accordion-test",
        "href": ['#collapse' + index],
        "aria-expanded": "false"
      },
      on: {
        "click": function($event) {
          _vm.setActiveObject(index)
        }
      }
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [(shape.type === 'textbox') ? _c('i', {
      staticClass: "icon-format m-r-5"
    }) : (shape.custom.type === 'clipping-mask') ? _c('i', {
      staticClass: "icon-crop m-r-5"
    }) : (shape.type === 'rect') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'ellipse') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'triangle') ? _c('i', {
      staticClass: "icon-shapes m-r-5"
    }) : (shape.type === 'image') ? _c('i', {
      staticClass: "icon-image m-r-5"
    }) : _vm._e(), _vm._v(" "), ((shape.type === 'textbox') && (shape.custom && shape.custom.name === '')) ? _c('span', [_vm._v(_vm._s(shape.text))]) : (shape.custom) ? _c('span', [_vm._v(_vm._s(shape.custom.name))]) : (shape._originalElement && shape._originalElement.currentSrc) ? _c('span', [_vm._v(_vm._s(_vm._f("shortenUrl")(shape._originalElement.currentSrc)))]) : _vm._e(), _vm._v(" "), _c('transition-group', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "leave-active-class": "animated fadeOut"
      }
    }, [(shape.custom.confirmed === true) ? _c('i', {
      key: "1",
      staticClass: "icon-checkmark-circle right"
    }) : _vm._e(), _vm._v(" "), (shape.custom.locked === true && _vm.displayType === 'editor') ? _c('i', {
      key: "2",
      staticClass: "icon-lock right"
    }) : _vm._e(), _vm._v(" "), (shape.custom.editable === false && _vm.displayType === 'editor') ? _c('i', {
      key: "3",
      staticClass: "icon-no-edit right"
    }) : _vm._e(), _vm._v(" "), (shape.visible === false) ? _c('i', {
      key: "4",
      staticClass: "icon-eye-blocked right"
    }) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse",
      staticStyle: {
        "height": "0px"
      },
      attrs: {
        "id": ['collapse' + index],
        "aria-expanded": "false"
      }
    }, [(shape.type === 'textbox') ? _c('div', {
      staticClass: "panel-body"
    }, [(_vm.displayType === 'editor') ? _c('div', [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), _c('copy', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(21)
        },
        "clone": function($event) {
          _vm.clone()
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('italic', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(14)
        },
        "italic": function($event) {
          _vm.fontItalic(index)
        }
      }
    }), _vm._v(" "), _c('bold', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(15)
        },
        "bold": function($event) {
          _vm.fontBold(index)
        }
      }
    }), _vm._v(" "), _c('underline', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(16)
        },
        "underline": function($event) {
          _vm.fontUnderline(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('alignLeft', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(17)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'left')
        }
      }
    }), _vm._v(" "), _c('alignCenter', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(18)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'center')
        }
      }
    }), _vm._v(" "), _c('alignRight', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(19)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'right')
        }
      }
    }), _vm._v(" "), _c('alignJustify', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(20)
        },
        "textAlign": function($event) {
          _vm.textAlign(index, 'justify')
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, [_c('autoScale', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(31)
        },
        "autoScale": function($event) {
          _vm.autoScale(index)
        }
      }
    }), _vm._v(" "), _c('smallCaps', {
      attrs: {
        "shape": shape
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(32)
        },
        "smallCaps": function($event) {
          _vm.smallCaps(index)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "m-b-0"
    }, [(_vm.displayType === 'editor') ? _c('li', [_vm._v("\n                                Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), _c('li', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      class: {
        'col-md-12': (_vm.displayType !== 'designer'), 'col-md-8': (_vm.displayType === 'designer')
      }
    }, [_vm._v("\n                                        " + _vm._s((_vm.$store.state.mode === 'editor') ? 'Default Text:' : '') + "\n                                        "), (_vm.displayType === 'designer' && shape.custom.name.includes('Address')) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.text),
        expression: "shape.text"
      }],
      domProps: {
        "value": (shape.text)
      },
      on: {
        "focus": function($event) {
          $event.target.select()
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "text", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.text),
        expression: "shape.text"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.text)
      },
      on: {
        "focus": function($event) {
          $event.target.select()
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "text", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), (_vm.displayType === 'designer' || (_vm.$store.state.mode === 'editor' && shape.custom.autoscale)) ? _c('div', {
      staticClass: "col-md-4"
    }, [(_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e(), _vm._v("\n                                        " + _vm._s((_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? 'Max Width' : '') + "\n                                        "), (_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.maxWidth),
        expression: "shape.custom.maxWidth"
      }],
      attrs: {
        "type": "text",
        "disabled": shape.custom.autoscale
      },
      domProps: {
        "value": (shape.custom.maxWidth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "maxWidth", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.mode === 'editor' && shape.custom.autoscale) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('small', [_vm._v("* To set the autoscale width, please toggle autoscale off and on.")])])]) : _vm._e()]), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings"
    }, [_vm._v("\n                                Format:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.mask),
        expression: "shape.custom.mask"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "mask", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, _vm._l((_vm.formatMasks), function(mask, i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v(_vm._s(mask.name))])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings m-r-0"
    }, [_vm._v("\n                                Data Attribute:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.data_attribute),
        expression: "shape.custom.data_attribute"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "data_attribute", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("No Data Injection")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "#",
        "disabled": "disabled"
      }
    }, [_vm._v("# Standard Data Attributes ----------")]), _vm._v(" "), _vm._l((_vm.dataAttributes), function(value) {
      return _c('option', {
        attrs: {
          "disabled": value === '# Vendor Data Attributes ----------'
        },
        domProps: {
          "value": (value === '# Vendor Data Attributes ----------') ? '#' : value
        }
      }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm._f("underlineSpace")(value.replace('vendor.', '')))))])
    })], 2)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings"
    }, [_c('small', {
      staticClass: "right"
    }, [_c('a', {
      attrs: {
        "href": "https://fonts.google.com/",
        "target": "_blank"
      }
    }, [_vm._v("Google Fonts")])]), _vm._v("\n                                Font:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fontFamily),
        expression: "shape.fontFamily"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape, "fontFamily", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, _vm._l((_vm.$store.state.fonts), function(font, i) {
      return _c('option', {
        attrs: {
          "data-index": i,
          "disabled": font.name === 'Custom Fonts:' || font.name === 'Google Fonts:' || font.name === '-----------------------' || font.name === ''
        }
      }, [_vm._v("\n                                        " + _vm._s(font.name) + "\n                                    ")])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings m-r-0"
    }, [_vm._v("Limit Characters: (0 = unlimited) "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.charLimit),
        expression: "shape.custom.charLimit"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.custom.charLimit)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "charLimit", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Size: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.fontSize),
        expression: "shape.custom.fontSize"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.custom.fontSize)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "fontSize", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Units:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.fontUnits),
        expression: "shape.custom.fontUnits"
      }],
      attrs: {
        "disabled": shape.custom.autoscale
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "fontUnits", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "pt"
      }
    }, [_vm._v("pt")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "pc"
      }
    }, [_vm._v("pc")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "em"
      }
    }, [_vm._v("em")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "in"
      }
    }, [_vm._v("in")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "mm"
      }
    }, [_vm._v("mm")]) : _vm._e(), _vm._v(" "), (!shape.custom.autoscale) ? _c('option', {
      attrs: {
        "value": "cm"
      }
    }, [_vm._v("cm")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split"
    }, [_vm._v("Leading: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.lineHeight),
        expression: "shape.lineHeight"
      }],
      attrs: {
        "type": "number",
        "step": "0.10"
      },
      domProps: {
        "value": (shape.lineHeight)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "lineHeight", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left charSettings split m-r-0"
    }, [_vm._v("Kerning: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.charSpacing),
        expression: "shape.charSpacing"
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.charSpacing)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "charSpacing", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', {
      staticClass: "left"
    }, [_vm._v("Fill Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fill),
        expression: "shape.fill"
      }],
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.fill)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "fill", $event.target.value)
        }
      }
    })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor' && (shape.type === 'rect' || shape.type === 'ellipse' || shape.type === 'triangle')) ? _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [(shape.custom.type !== 'clipping-mask') ? _c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('copy', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(21)
        },
        "clone": function($event) {
          _vm.clone()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('li', [_vm._v("Stroke: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (shape.strokeWidth),
        expression: "shape.strokeWidth",
        modifiers: {
          "number": true
        }
      }],
      attrs: {
        "type": "number",
        "step": "1"
      },
      domProps: {
        "value": (shape.strokeWidth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "strokeWidth", _vm._n($event.target.value))
        }, function($event) {
          _vm.updateObject(index, $event)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (shape.custom.type !== 'clipping-mask') ? _c('li', {
      staticClass: "colorSettings left"
    }, [_vm._v("Fill Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.fill),
        expression: "shape.fill"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.fill)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "fill", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "animated fadeInLeft",
        "leave-active-class": "animated fadeOutLeft"
      }
    }, [(shape.custom.type !== 'clipping-mask' && shape.strokeWidth > 0) ? _c('li', {
      staticClass: "colorSettings left"
    }, [_vm._v("Stroke Color:"), _c('br'), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.stroke),
        expression: "shape.stroke"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (shape.stroke)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape, "stroke", $event.target.value)
        }
      }
    })]) : _vm._e()])], 1), _vm._v(" "), (_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (shape.type === 'image') ? _c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "btn-group m-r-5"
    }, [(shape.custom.type !== 'clipping-mask') ? _c('editable', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(11)
        },
        "editable": function($event) {
          _vm.editable(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('visible', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(12)
        },
        "visible": function($event) {
          _vm.visible(index)
        }
      }
    }), _vm._v(" "), _c('lock', {
      attrs: {
        "shape": shape,
        "type": _vm.displayType
      },
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(13)
        },
        "lock": function($event) {
          _vm.lock(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "btn-group m-r-5"
    }, [_c('flipx', {
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(24)
        },
        "flipX": function($event) {
          _vm.flipX(index)
        }
      }
    }), _vm._v(" "), _c('flipy', {
      on: {
        "tooltip": function($event) {
          _vm.setTooltip(25)
        },
        "flipY": function($event) {
          _vm.flipY(index)
        }
      }
    })], 1), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Name: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.name),
        expression: "shape.custom.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (shape.custom.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(shape.custom, "name", $event.target.value)
        }, function($event) {
          _vm.updateObject(index, $event)
        }]
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "img"
    }, [_c('span', [_vm._v("File Upload:")]), _vm._v(" "), (shape.src) ? _c('img', {
      attrs: {
        "src": shape.src
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "upload-btn-wrapper"
    }, [_c('button', {
      staticClass: "btn btn-success",
      class: {
        'btn-warning': shape.custom.uploadButton !== 'Select Image File'
      }
    }, [_vm._v(_vm._s(shape.custom.uploadButton))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.updateImage(index, $event.target)
        }
      }
    })])]), _vm._v(" "), _c('li', [_vm._v("Scale: " + _vm._s(shape.scaleX * 100) + "% "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.scaleX),
        expression: "shape.scaleX"
      }],
      attrs: {
        "type": "range",
        "min": "0",
        "max": "1",
        "step": "0.01"
      },
      domProps: {
        "value": (shape.scaleX)
      },
      on: {
        "change": function($event) {
          _vm.updateObject(index, $event)
        },
        "__r": function($event) {
          _vm.$set(shape, "scaleX", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.displayType === 'editor') ? _c('li', [_vm._v("\n                                Clipping Mask:\n                                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (shape.custom.clipto),
        expression: "shape.custom.clipto"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(shape.custom, "clipto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.applyMask(index, $event.target.value, true, false)
        }]
      }
    }, [_c('option', {
      attrs: {
        "data-index": -1,
        "value": "-1"
      }
    }, [_vm._v("No Clipping Mask")]), _vm._v(" "), _vm._l((_vm.clippingMasks), function(mask, i) {
      return _c('option', {
        domProps: {
          "value": i
        }
      }, [_vm._v("\n                                        " + _vm._s(mask.custom.name) + "\n                                    ")])
    })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.displayType === 'designer') ? _c('button', {
      staticClass: "btn confirmBtn btn-block m-b-5 m-t-5",
      class: {
        'confirmed': shape.custom.confirmed
      },
      on: {
        "click": function($event) {
          _vm.confirmEdit(index)
        }
      }
    }, [_vm._v(_vm._s((shape.custom.confirmed) ? 'Confirmed' : 'Confirm'))]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.displayType === 'editor') ? _c('div', {
    staticClass: "panel panel-default m-b-20"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-test",
      "href": "#collapse100",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-image m-r-5"
  }), _vm._v("\n                            Background & Margins\n                            "), _c('i', {
    staticClass: "icon-lock right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapse100",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ul', [_c('li', {
    staticClass: "left sizeSettings",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(23)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(23)
      }
    }
  }, [_vm._v("Safe Area: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prodSafe),
      expression: "prodSafe"
    }],
    attrs: {
      "type": "number",
      "step": "0.001",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.prodSafe)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.prodSafe = $event.target.value
      }, function($event) {
        _vm.setSafe($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "left sizeSettings m-r-0",
    on: {
      "mouseenter": function($event) {
        _vm.setTooltip(22)
      },
      "mouseleave": function($event) {
        _vm.setTooltip(22)
      }
    }
  }, [_vm._v("Trim: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prodBleed),
      expression: "prodBleed"
    }],
    attrs: {
      "type": "number",
      "step": "0.001",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.prodBleed)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.prodBleed = $event.target.value
      }, function($event) {
        _vm.setTrim($event.target.value)
      }]
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "img"
  }, [_c('span', [_vm._v("File Upload:")]), _vm._v(" "), (_vm.$store.state.template.files[_vm.$store.state.activeTemplate].json && _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage && _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage.src) ? _c('img', {
    attrs: {
      "src": _vm.$store.state.template.files[_vm.$store.state.activeTemplate].json.backgroundImage.src
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-success"
  }, [_vm._v("Select Image File")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.updateBackground($event.target)
      }
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'designer' && this.proceed.show !== false) ? _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.$store.state.savedTemplate !== null) ? _c('button', {
    key: 0,
    staticClass: "btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10",
    staticStyle: {
      "font-size": "1.1em",
      "padding": "8px 0"
    },
    attrs: {
      "disabled": (!_vm.templateName || _vm.$store.state.savedTemplate.id === this.$store.state.template.id),
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateExistingTemplate(_vm.loadNextTemplate, $event)
      }
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.$store.state.savedTemplate.id !== this.$store.state.template.id) ? 'Save & Continue' : 'Loading, Please Wait..') + "\n                ")]) : _c('button', {
    key: 1,
    staticClass: "btn block btn-md waves-effect waves-light saveButtons btn-success m-t-10",
    staticStyle: {
      "font-size": "1.1em",
      "padding": "8px 0"
    },
    attrs: {
      "disabled": !_vm.templateName,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveAsNewTemplate(_vm.loadNextTemplate, $event)
      }
    }
  }, [_vm._v("\n                    Save & Continue\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'designer' && this.proceed.show === false) ? _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    key: 0,
    staticClass: "noEdit m-t-20"
  }, [_vm._v("\n                    Please confirm all fields to continue.\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.displayType === 'editor') ? _c('div', {
    staticClass: "panel panel-default m-b-20"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.toggleShortcuts()
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-keyboard m-r-5"
  }), _vm._v("\n                        Keyboard Shortcuts\n                    ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.shortcuts) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table m-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Shortcut")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Shift")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Holding shift while dragging will lock the object so that it can only move up and down.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Command  ")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Holding command while dragging will lock the object so that it can only move left and right.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇦"), _c('br'), _vm._v("Shift + ⇦"), _c('br'), _vm._v("Option + ⇦")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel left."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 25 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇨"), _c('br'), _vm._v("Shift + ⇨"), _c('br'), _vm._v("Option + ⇨")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel right."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇧"), _c('br'), _vm._v("Shift + ⇧"), _c('br'), _vm._v("Option + ⇧")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel up."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("⇩"), _c('br'), _vm._v("Shift + ⇩"), _c('br'), _vm._v("Option + ⇩")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Move object 1 pixel down."), _c('br'), _vm._v("\n                                        Holding shift will move 10 pixels at a time."), _c('br'), _vm._v("\n                                        Holding option will move 10 pixels at a time.\n                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Delete ⌦")]), _vm._v(" "), _c('td', [_c('em', [_vm._v("With Selected Object:")]), _vm._v(" Deletes object from canvas\n                                    ")])])])])]) : _vm._e()])], 1) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "templateDesigner group p-20"
  }, [_c('div', {
    staticClass: "design-options p-10 p-b-0 primarybg",
    class: {
      'm-b-20': (_vm.$store.state.mode === 'designer')
    }
  }, [(_vm.$store.state.mode === 'designer' && _vm.$store.state.templateList !== null) ? _c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Templates")]) : (_vm.$store.state.mode === 'designer' && _vm.$store.state.template !== null && _vm.$store.state.template.vendors && _vm.$store.state.template.vendors.data.length > 0) ? _c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg left",
    on: {
      "click": function($event) {
        _vm.$router.push('/templates/vendor')
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Templates")]) : _vm._e(), _vm._v(" "), _vm._l((this.buttons), function(button, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder left",
      class: _vm.checkActive(button),
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.switchTemplate(button)
        }
      }
    }, [_vm._v(_vm._s(button))])
  }), _vm._v(" "), (this.$store.state.mode === 'editor') ? _c('button', {
    staticClass: "btn btn-outline-success m-b-10 right primaryborder m-r-5",
    class: {
      'animated pulse orange solid': (_vm.templateChanges())
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveTemplate()
      }
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.templateChanges()) ? _vm.saveStatus : 'Saved ') + "\n                    "), (_vm.templateChanges()) ? _c('span', {
    staticClass: "icon-save m-l-5"
  }) : _c('span', {
    staticClass: "icon-checkmark-circle m-l-5"
  })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.mode === 'designer') ? _c('div', {
    staticClass: "btn-group m-b-10 right"
  }, [_c('button', {
    staticClass: "btn btn-outline-success primaryborder dropdown-toggle waves-effect waves-light",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "false"
    }
  }, [_vm._v("Zoom: " + _vm._s(_vm.zoom * 100 + '%') + " "), _c('span', {
    staticClass: "icon-arrow-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(1)
      }
    }
  }, [_vm._v("100%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.9)
      }
    }
  }, [_vm._v("90%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.8)
      }
    }
  }, [_vm._v("80%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.7)
      }
    }
  }, [_vm._v("70%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.6)
      }
    }
  }, [_vm._v("60%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.5)
      }
    }
  }, [_vm._v("50%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.4)
      }
    }
  }, [_vm._v("40%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.3)
      }
    }
  }, [_vm._v("30%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.2)
      }
    }
  }, [_vm._v("20%")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resizeCanvas(.1)
      }
    }
  }, [_vm._v("10%")])])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.mode === 'designer' && _vm.$store.state.config.hideDeepLinks !== true) ? _c('span', {
    staticClass: "btn btn-outline-primary waves-effect waves-light right m-r-5",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyUrl($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-link"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "canvasEditors"
  }, [(_vm.$store.state.template) ? _c('PrimoCanvas', {
    ref: "primoCanvas",
    attrs: {
      "prod-height": (_vm.$store.state.template) ? _vm.$store.state.template.height : 0,
      "prod-width": (_vm.$store.state.template) ? _vm.$store.state.template.width : 0,
      "prod-safe": (_vm.$store.state.template.safe),
      "prod-bleed": (_vm.$store.state.template.bleed),
      "display-type": this.$store.state.mode
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a601bb88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_FilePreview_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_FilePreview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__partials_FilePreview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_FileApproval_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_FileApproval_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_FileApproval_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_EddmMap_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_EddmMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_EddmMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_ProductSelector_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_ProductSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_ProductSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_ShippingSelector_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_ShippingSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__partials_ShippingSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mixins_templateSaving__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_mixins_windowMessaging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_epic_spinners__ = __webpack_require__(15);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */
/* global FileFlip */

// import Eddm from '@/assets/js/core/Eddm'









var _require = __webpack_require__(72),
    getCurrentVendorID = _require.getCurrentVendorID;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'templateOptions',
    components: { FilePreview: __WEBPACK_IMPORTED_MODULE_1__partials_FilePreview_vue___default.a, FileApproval: __WEBPACK_IMPORTED_MODULE_2__partials_FileApproval_vue___default.a, ProductSelector: __WEBPACK_IMPORTED_MODULE_4__partials_ProductSelector_vue___default.a, ShippingSelector: __WEBPACK_IMPORTED_MODULE_5__partials_ShippingSelector_vue___default.a, EddmMap: __WEBPACK_IMPORTED_MODULE_3__partials_EddmMap_vue___default.a, FulfillingBouncingCircleSpinner: __WEBPACK_IMPORTED_MODULE_8_epic_spinners__["b" /* FulfillingBouncingCircleSpinner */], SpringSpinner: __WEBPACK_IMPORTED_MODULE_8_epic_spinners__["d" /* SpringSpinner */] },
    mixins: [__WEBPACK_IMPORTED_MODULE_6__components_mixins_templateSaving__["a" /* templateSaving */], __WEBPACK_IMPORTED_MODULE_7__components_mixins_windowMessaging__["a" /* windowMessaging */]],
    data: function data() {
        return {
            msg: 'Template Options',
            products: [],
            selected: {
                product: null,
                product_cost: null,
                runsize: null,
                runsizeDescription: null,
                colorspec: null,
                options: null,
                name: this.$store.state.savedTemplate.name,
                turnaround: null,
                shipping: null,
                blind: null,
                date: null,
                method: null
            },
            showFullService: false,
            downloadOnly: false,
            eddm_dates: [],
            eddm_token: null,
            eddmData: null,
            dm_fee: 0,
            cartButtonText: 'Add to Cart',
            imagesProcessing: [],
            watcher: null
        };
    },
    beforeMount: function beforeMount() {
        var _this = this;

        this.watcher = this.$store.watch(function (state) {
            return state.savedTemplate;
        }, function (newValue, oldValue) {
            _this.checkImages();
        });

        var data = {
            template: this.$store.state.template.id
        };
        this.axios.post('/products/search?include=option_groups.options.pricing,detail', data).then(function (res) {
            _this.products = res.data.data;
        }).catch(function (err) {
            _this.downloadOnly = true;
            console.log(err);
        });

        // Set Default Colorspec
        var template = this.$store.state.template;
        if (template.front && template.back && template.foil_front && template.foil_back) {
            this.selected.colorspec = '34527644-b4fd-4ffb-9092-1318eefcd9d9'; // 5/5
        } else if (template.front && template.back && template.foil_front) {
            this.selected.colorspec = 'e9e9dfb3-fba1-4d60-972c-fd9ca5904d33'; // 5/4
        } else if (template.front && template.back && template.foil_back) {
            this.selected.colorspec = '2ba18f74-0f96-487e-8b6e-985b404b3305'; // 4/5
        } else if (template.front && template.foil_front) {
            this.selected.colorspec = 'a75ac2f1-9911-48d6-841d-245b5ac08f27'; // 5/0
        } else if (template.front && template.back) {
            this.selected.colorspec = '13abbda7-1d64-4f25-8bb2-c179b224825d'; // 4/4
        } else if (template.front) {
            this.selected.colorspec = '32d3c223-f82c-492b-b915-ba065a00862f'; // 4/0
        }

        if (this.$store.state.template.eddm_only) {
            this.axios.get('/eddm/dates').then(function (response) {
                _this.eddm_dates = response.data.dates;
                _this.eddm_token = response.data.token;
            }).catch(function (err) {
                console.log(err);
            });
        }
        // this.confirmFiles()
    },
    mounted: function mounted() {
        // Check if we have pending files (processing)
        this.checkImages();

        // Eddm.init({
        //     product: selectedProds[0].uuid,
        //     runsize: $('select[name=runsize] option:selected').attr('data-runsize'),
        // Eddm.init()

        //     target_before: '.set:first'
        // })
        // Eddm.buildMap()
        // var eddm = new Eddm()
        FileFlip.init();

        // http://localhost:8080/?user=primo&token=qU39F6uHYvaDoR7C6Z7pe2tAr2iHTh3w&mode=designer&template=2748c1f0-1d83-11e8-9cd4-e9ea3c4ce806

        $('select[name=ship_to], select[name=blind]').on('change', function () {
            $(this).next('p').html($(this).children('option:selected').attr('data-partial'));
        });

        $('.order-options .btn-success').click(function () {
            $('.order-options .form-control').each(function () {
                if ($(this).val() === '-1') {
                    $(this).addClass('optionError');
                }
            });
        });

        $(document).on('change', 'select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]', function () {
            var service = $(this).val();
            if (service !== '' && service !== '3e5e9bdd-d78a-4c28-a41d-fe1407925ca6' && service !== '934e270e-9523-48b9-93c7-78b0896e16a6') {
                $('option[data-name="100"]').addClass('hide');
            } else {
                $('option[data-name="100"]').removeClass('hide');
            }
        });

        // $('.order-options .form-control').on('change', function () {
        //     let total = $('.order-options .form-control').length
        //     let totalval = 0
        //     $('.order-options .form-control').each(function () {
        //         if ($(this).val() !== '-1') {
        //             totalval = totalval + 1
        //         }
        //     })
        //     if (total === totalval) {
        //         $('.order-options .btn-success').removeClass('disabled')
        //     } else {
        //         $('.order-options .btn-success').addClass('disabled')
        //     }
        //     if ($(this).hasClass('optionError') && $(this).val() !== '-1') {
        //         $(this).removeClass('optionError')
        //     }
        // })

        this.setHeight();
    },
    beforeDestroy: function beforeDestroy() {
        this.watcher();
    },

    computed: {
        url: function url() {
            var url = this.$store.state.pageUrl;
            var queryString = '?';
            if (this.$route.params.uuid) {
                queryString += 'category=' + this.$route.params.uuid;
            }
            if (this.$route.params.subcat) {
                if (queryString !== '?') {
                    queryString += '&';
                }
                queryString += 'subcategory=' + this.$route.params.subcat;
            }
            if (queryString === '?') {
                queryString = '';
            }
            return url + queryString;
        }
    },
    methods: {
        setPreview: function setPreview(file) {
            this.$refs.preview.setPreview(file);
        },
        stillProcessing: function stillProcessing() {
            Helpers.blackPop('Processing', 'Oops! Looks like we\'re still processing your files. Sometimes this can take up to several minutes, thank you for your patience!');
        },
        checkImages: function checkImages() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.template.files).forEach(function (key, index) {
                if (_this2.$store.state.template.files[key].preview.includes('base64')) {
                    _this2.imagesProcessing.push(key);
                } else {
                    var _index = _this2.imagesProcessing.indexOf(key);
                    if (_index !== -1) {
                        _this2.imagesProcessing.splice(_index, 1);
                    }
                }
            });
        },

        /*
         * Loop files and make sure all objects are confirmed
         * If any are unconfirmed push back the the designer
         */
        confirmFiles: function confirmFiles() {
            var _this3 = this;

            var template = this.$store.state.template;
            var files = template.files;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(files).forEach(function (key) {
                var objects = files[key].json.objects;
                for (var i in objects) {
                    if (objects[i].custom.editable === true && objects[i].custom.confirmed === false) {
                        files[key].confirmed = false;
                        template.files = files;
                        _this3.$store.commit('template', template);
                        _this3.$router.push({ name: 'Template Designer' });
                        Helpers.errorPop('Error', 'Please confirm all fields before continuing');
                    }
                }
            });
        },
        updateSelected: function updateSelected(data) {
            this.selected = data;
        },
        saveEddmData: function saveEddmData(data) {
            this.eddmData = data.data;
            this.showFullService = false;

            this.selected.runsize = this.eddmData.product_data.runsize_uuid;
            this.selected.date = this.eddmData.delivery_date;
            this.selected.colorspec = this.eddmData.product_data.colorspec_uuid;
            this.selected.options = this.eddmData.product_data.options_uuids;
            this.selected.product_cost = this.eddmData.product_price;

            this.nextAccordion();
        },
        calculateCost: function calculateCost() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';

            var total = 0;
            var productType = '';
            var skipDirectMailCharge = ['3e5e9bdd-d78a-4c28-a41d-fe1407925ca6', '934e270e-9523-48b9-93c7-78b0896e16a6'];

            // Check for direct mail option on page
            if ($('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').length > 0 && $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val() !== '') {
                var service = $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val();
                // If direct mail is selected and not one of the options to skip it
                if (service !== '' && !skipDirectMailCharge.includes(service)) {
                    $('.prod-shipping').removeClass('panel-3').addClass('hide panel-skip');
                    $('.prod-summary').removeClass('panel-4').addClass('panel-3');
                    $('.panel-1 .btn-success').html('Continue to Summary');
                    $('span.shipping-type').html('Direct Mail Fee:');
                    productType = 'directmail';
                } else {
                    $('.prod-shipping').removeClass('hide panel-skip').addClass('panel-3');
                    $('.prod-summary').removeClass('panel-3').addClass('panel-4');
                    $('span.shipping-type').html('Shipping:');
                }
            }

            if (type === 'shipping' || type === 'all') {
                if (this.selected.turnaround && this.selected.turnaround.price) {
                    total += parseFloat(this.selected.turnaround.price);
                }
                if (this.selected.method && this.selected.method.service_price && !this.selected.method.group_with_cart) {
                    total += parseFloat(this.selected.method.service_price);
                }
                if (this.eddmData && this.eddmData.postage_price) {
                    total += parseFloat(this.eddmData.postage_price);
                }
            }

            if (type === 'shipping' && this.dm_fee > 0) {
                total += this.dm_fee;
            }

            if (type === 'eddm_service' || type === 'all') {
                if (this.eddmData && this.eddmData.eddm_service_price) {
                    total += parseFloat(this.eddmData.eddm_service_price);
                }
            }

            if (type === 'product' || type === 'all') {
                if (this.selected.product_cost) {
                    total += parseFloat(this.selected.product_cost);
                }
            }

            if (type === 'all') {
                if (productType === 'directmail') {
                    var ms = 0;
                    var option = $('select[name="87e09691-ef33-4cf4-8f17-48af06ce84f4"]').val();
                    var quantity = $('option[value="' + option + '"]').data('name');
                    if (parseFloat(quantity) === 250) {
                        ms = 50;
                    } else if (parseFloat(quantity) === 500) {
                        ms = 75;
                    } else if (parseFloat(quantity) === 1000) {
                        ms = 100;
                    } else if (parseFloat(quantity) === 2500) {
                        ms = 125;
                    } else if (parseFloat(quantity) === 5000) {
                        ms = 150;
                    } else if (parseFloat(quantity) === 7500) {
                        ms = 240;
                    } else if (parseFloat(quantity) === 10000) {
                        ms = 250;
                    } else if (parseFloat(quantity) === 15000) {
                        ms = 400;
                    } else if (parseFloat(quantity) === 20000) {
                        ms = 500;
                    } else if (parseFloat(quantity) === 25000) {
                        ms = 550;
                    } else if (parseFloat(quantity) === 30000) {
                        ms = 650;
                    } else if (parseFloat(quantity) === 35000) {
                        ms = 700;
                    } else if (parseFloat(quantity) === 40000) {
                        ms = 800;
                    } else if (parseFloat(quantity) === 45000) {
                        ms = 850;
                    } else if (parseFloat(quantity) === 50000) {
                        ms = 900;
                    } else if (parseFloat(quantity) === 55000) {
                        ms = 950;
                    } else if (parseFloat(quantity) === 60000) {
                        ms = 1000;
                    } else if (parseFloat(quantity) === 65000) {
                        ms = 1050;
                    } else if (parseFloat(quantity) === 70000) {
                        ms = 1100;
                    } else if (parseFloat(quantity) === 75000) {
                        ms = 1150;
                    } else if (parseFloat(quantity) === 80000) {
                        ms = 1200;
                    } else if (parseFloat(quantity) === 85000) {
                        ms = 1250;
                    } else if (parseFloat(quantity) === 90000) {
                        ms = 1300;
                    } else if (parseFloat(quantity) === 95000) {
                        ms = 1350;
                    } else if (parseFloat(quantity) === 100000) {
                        ms = 1400;
                    }

                    /* add mailing service cost */
                    var _service = $('select[name="05d933cb-0474-4e5a-bece-42504c6860fd"]').val(); // mailing_service
                    if (this.products.length && this.products[0].option_groups !== undefined) {
                        var ogMailingService = this.products[0].option_groups.data.filter(function (og) {
                            return og.uuid === '05d933cb-0474-4e5a-bece-42504c6860fd';
                        });
                        if (ogMailingService.length) {
                            ogMailingService = ogMailingService[0];
                            if (ogMailingService.options !== undefined && ogMailingService.options.data !== undefined) {
                                var msSelected = ogMailingService.options.data.find(function (item) {
                                    return item.uuid === _service;
                                });
                                var _option = $('select[name="87e09691-ef33-4cf4-8f17-48af06ce84f4"]').val(); // quantity
                                var _quantity = $('option[value="' + _option + '"]').data('name');
                                var optionprice = msSelected && msSelected.pricing !== undefined && msSelected.pricing.data !== undefined ? msSelected.pricing.data.filter(function (item) {
                                    return parseInt(item.startqty) === _quantity && parseInt(item.endqty) === _quantity;
                                }) : [];
                                if (optionprice.length) {
                                    optionprice = optionprice[0];
                                    ms += optionprice.price !== undefined ? optionprice.price : 0;
                                }
                            }
                        }
                    }

                    this.dm_fee = ms;
                    total += ms;
                } else {
                    this.dm_fee = 0;
                }
            }

            return total.toFixed(2);
        },
        nextAccordion: function nextAccordion() {
            if ($('.panel.active').hasClass('panel-1')) {
                $('.panel.active').removeClass('active');
                $('.panel-2').addClass('active');
                $('.panel-2 div h4 a').trigger('click');
            } else if ($('.panel.active').hasClass('panel-2')) {
                if (!this.$store.state.template.eddm_only) {
                    if (this.selected.turnaround === null) {
                        var comp = this.$refs.shipping;
                        comp.fetchTurnaround();
                    }
                    $('.panel.active').removeClass('active');
                    $('.panel-3').addClass('active');
                    $('.panel-3 div h4 a').trigger('click');

                    $('.job_name').focus().select();
                    $('.o_turnaround').removeAttr('disabled');
                } else if (this.eddmData === null) {
                    this.showFullService = true;
                } else {
                    $('.panel.active').removeClass('active');
                    $('.panel-4').addClass('active');
                    $('.panel-4 div h4 a').trigger('click');
                }
            } else if ($('.panel.active').hasClass('panel-3')) {
                $('.panel.active').removeClass('active');
                $('.panel-4').addClass('active');
                $('.panel-4 div h4 a').trigger('click');
            }

            this.setHeight();
        },
        setHeight: function setHeight() {
            var _this4 = this;

            this.windowMsgTemplateResize($('.templateDesigner').height(), $('.templateDesigner').width());
            setTimeout(function () {
                _this4.windowMsgTemplateResize($('.templateDesigner').height(), $('.templateDesigner').width());
            }, 1000);
        },
        setActivePanel: function setActivePanel(target, $event) {
            if (target === '.panel-1' && !$(target).hasClass('active')) {
                this.selected.turnaround = null;
                this.selected.method = null;
                $('.panel.active').removeClass('active');
                $(target).addClass('active');
                $(target + ' div h4 a').trigger('click');
            } else if (target === '.panel-2' && !$(target).hasClass('active')) {
                if (!this.selected.product || !this.selected.product_cost || !this.selected.runsize || !this.selected.runsizeDescription) {
                    if (!$('.panel-1').hasClass('active')) {
                        $('.panel.active').removeClass('active');
                        $('.panel-1').addClass('active');
                        $('.panel-1 div h4 a').trigger('click');
                    }
                } else {
                    if (this.selected.turnaround === null) {
                        var comp = this.$refs.shipping;
                        comp.fetchTurnaround();
                    }
                    $('.panel.active').removeClass('active');
                    $(target).addClass('active');
                    $(target + ' div h4 a').trigger('click');
                }
            } else if (target === '.panel-3' && !$(target).hasClass('active')) {
                if (!this.selected.product || !this.selected.product_cost || !this.selected.runsize) {
                    if (!$('.panel-1').hasClass('active')) {
                        $('.panel.active').removeClass('active');
                        $('.panel-1').addClass('active');
                        $('.panel-1 div h4 a').trigger('click');
                    }
                } else if (!this.$store.state.template.eddm_only && (!this.selected.name || !this.selected.turnaround || !this.selected.shipping || !this.selected.method)) {
                    if (!$('.panel-2').hasClass('active')) {
                        if (this.selected.turnaround === null) {
                            var _comp = this.$refs.shipping;
                            _comp.fetchTurnaround();
                        }
                        $('.panel.active').removeClass('active');
                        $('.panel-2').addClass('active');
                        $('.panel-2 div h4 a').trigger('click');
                    }
                } else {
                    $('.panel.active').removeClass('active');
                    $(target).addClass('active');
                    $(target + ' div h4 a').trigger('click');
                }
            }
            this.setHeight();
        },
        downloadFiles: function downloadFiles() {
            this.windowMsgDownloadFiles('https://interface.primoprint.com/v1/files/download/' + btoa(this.$store.state.savedTemplate.id + '|' + this.$auth.user().id));
        },
        addToCart: function addToCart() {
            var _this5 = this;

            if (this.cartButtonText === 'Add to Cart') {
                this.cartButtonText = 'Processing, please wait..';
                var shipping = this.$refs.shipping;

                var data = {
                    template: this.$store.state.savedTemplate.id,
                    u: 1,
                    product: null,
                    runsize: this.selected.runsize,
                    colorspec: this.selected.colorspec,
                    groupship: 0,
                    sets: 1,
                    options: this.selected.options,
                    subtotal: parseFloat(this.calculateCost('product')),
                    design_cost: 0,
                    cat_id: 1,
                    sub_id: 1,
                    setlist: null,
                    files: {},
                    vendor_id: getCurrentVendorID(this.$auth.user(), this.url)

                    // EDDM Product
                };if (this.$store.state.template.eddm_only) {
                    data.product = this.eddmData.product_data.product_uuid;
                    data.setlist = [{
                        name: this.selected.name,
                        ship_to: 0,
                        method: 'EDDM',
                        method_id_eddm: this.eddmData.postage_price,
                        est_delivery: this.selected.date,
                        facility: 'Unknown',
                        set: 0,
                        files: {},
                        blind: 0,
                        eddm: this.eddmData
                    }];
                    // Skip Shipping
                } else if ($('.panel-skip').length > 0) {
                    data.product = this.selected.product.id;
                    data.setlist = [{
                        name: this.selected.name,
                        ship_to: 0,
                        method: 'Direct Mail',
                        method_id: 'eyJpdiI6ImRoXC9kMThpQ0t4OHc4NzRiOHd2V1VRPT0iLCJ2YWx1ZSI6InN1T1pCazRhOU9TSlp0SVFCSDRneGc9PSIsIm1hYyI6IjdlZDIxZGJiNzE3OTZhNmIzOTI3NWQ1YzQyZDFkYjA4NWY2OWNiZWM1YjI0ODY0NmI1MDU2MDkwYjZkY2ZmMDQifQ==',
                        method_id_direct_mail: parseFloat(this.calculateCost('shipping')),
                        facility: 'Unknown',
                        set: 0,
                        files: {},
                        blind: 0
                    }];
                    // Standard Product
                } else {
                    data.product = this.selected.product.id;
                    data.setlist = [{
                        name: this.selected.name,
                        turnaround: this.selected.turnaround.uuid,
                        turnaround_est: parseFloat(this.selected.turnaround.price),
                        est_production: this.selected.method.production,
                        ship_to: this.selected.shipping.id,
                        method: this.selected.method.service_code,
                        method_id: this.selected.method.service_id,
                        est_delivery: this.selected.method.delivery,
                        facility: this.selected.method.facility,
                        set: 0,
                        files: {},
                        blind: this.selected.blind,
                        shipping_options: shipping.getShippingOptions()
                    }];
                }

                this.axios.post('/cart/create', data).then(function (res) {
                    _this5.windowMsgLockWindow(false);
                    setTimeout(function () {
                        if (!window.location.href.includes('localhost')) {
                            window.parent.location.href = 'https://www.primoprint.com/cart';
                        } else {
                            window.parent.location.href = 'http://primoprint.test/cart';
                        }
                    }, 250);
                }).catch(function (err) {
                    Helpers.errorPop('Error', err);
                });
            }
        }
    }
});

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FilePreview',
    data: function data() {
        return {
            files: {
                default: null
            }
        };
    },
    beforeMount: function beforeMount() {
        this.files = this.$store.state.template.files;
    },

    methods: {
        setPreview: function setPreview(file) {
            if (file.includes('front')) {
                $('.viewfront').trigger('click');
            } else if (file.includes('back')) {
                $('.viewback').trigger('click');
            }

            if (file.includes('spot_uv')) {
                $('.previewMask2').removeClass('hide');
                $('#spotuvmask').prop('checked', true);
            } else {
                $('.previewMask2').addClass('hide');
                $('#spotuvmask').prop('checked', false);
            }

            if (file.includes('foil')) {
                $('.previewMask1').removeClass('hide');
                $('#foilmask').prop('checked', true);
            } else {
                $('.previewMask1').addClass('hide');
                $('#foilmask').prop('checked', false);
            }
        },

        /**
         * Get the preview url of a template file
         * @param  {string} File position (front, back, foil_front, foil_back, spot_uv_front, spot_uv_back)
         * @return {string} File preview url
         */
        fileUrl: function fileUrl($position) {
            var url = null;
            var append = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

            if ($position === 'front' && this.files.front !== undefined && this.files.front.preview !== undefined) {
                url = this.files.front.preview.includes('base64') ? this.files.front.preview : this.files.front.preview + '?' + append;
            } else if ($position === 'back' && this.files.back !== undefined && this.files.back.preview !== undefined) {
                url = this.files.back.preview.includes('base64') ? this.files.back.preview : this.files.back.preview + '?' + append;
            } else if ($position === 'spot_uv_front' && this.files.spot_uv_front !== undefined && this.files.spot_uv_front.preview !== undefined) {
                url = this.files.spot_uv_front.preview.includes('base64') ? this.files.spot_uv_front.preview : this.files.spot_uv_front.preview + '?' + append;
            } else if ($position === 'spot_uv_back' && this.files.spot_uv_back !== undefined && this.files.spot_uv_back.preview !== undefined) {
                url = this.files.spot_uv_back.preview.includes('base64') ? this.files.spot_uv_back.preview : this.files.spot_uv_back.preview + '?' + append;
            } else if ($position === 'foil_front' && this.files.foil_front !== undefined && this.files.foil_front.preview !== undefined) {
                url = this.files.foil_front.preview.includes('base64') ? this.files.foil_front.preview : this.files.foil_front.preview + '?' + append;
            } else if ($position === 'foil_back' && this.files.foil_back !== undefined && this.files.foil_back.preview !== undefined) {
                url = this.files.foil_back.preview.includes('base64') ? this.files.foil_back.preview : this.files.foil_back.preview + '?' + append;
            }

            return url;
        },
        /**
         * Check if the template has front files
         * @return {Boolean}
         */
        hasFronts: function hasFronts() {
            if (this.files.front || this.files.foil_front || this.files.spot_uv_front) {
                return true;
            }
            return false;
        },
        /**
         * Check if the template has back files
         * @return {Boolean}
         */
        hasBacks: function hasBacks() {
            if (this.files.back || this.files.foil_back || this.files.spot_uv_back) {
                return true;
            }
            return false;
        },

        toggle: function toggle(target) {
            $(target).toggleClass('hide');
        },

        /**
         * Check if the template has foil files
         * @return {Boolean}
         */
        hasFoil: function hasFoil() {
            if (this.files.foil_front || this.files.foil_back) {
                return true;
            }
            return false;
        },
        /**
         * Check if the template has spot files
         * @return {Boolean}
         */
        hasSpot: function hasSpot() {
            if (this.files.spot_uv_front || this.files.spot_uv_back) {
                return true;
            }
            return false;
        }
    }
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filePreview"
  }, [_c('div', {
    staticClass: "previewPrint"
  }, [_c('div', {
    staticClass: "preview-flip-container p-b-20"
  }, [_c('div', {
    staticClass: "flipper"
  }, [(_vm.hasFronts()) ? _c('div', {
    staticClass: "front"
  }, [_c('div', {
    staticClass: "preview frontpreview"
  }, [_c('div', {
    staticClass: "previewMask1 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('foil_front'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewMask2 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('spot_uv_front'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewTrim boxsize"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('front'),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.hasBacks()) ? _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "preview backpreview"
  }, [_c('div', {
    staticClass: "previewMask1 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('foil_back'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewMask2 boxsize hide"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('spot_uv_back'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "previewTrim boxsize"
  }, [_c('img', {
    staticClass: "auto",
    attrs: {
      "src": _vm.fileUrl('back'),
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e()])]), _vm._v(" "), (_vm.hasFronts() && _vm.hasBacks()) ? _c('div', {
    staticClass: "previewControls group row m-b-20"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e()]), _vm._v(" "), (_vm.hasFoil() || _vm.hasSpot()) ? _c('div', {
    staticClass: "previewViews group"
  }, [(_vm.hasSpot()) ? _c('div', {
    staticClass: "viewBtns m-b-20"
  }, [_c('div', {
    staticClass: "checkbox m-r-15"
  }, [_c('input', {
    staticClass: "spotuvmask",
    attrs: {
      "type": "checkbox",
      "id": "spotuvmask",
      "name": "spotuvmask"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "spotuvmask",
    attrs: {
      "for": "spotuvmask"
    },
    on: {
      "click": function($event) {
        _vm.toggle('.previewMask2')
      }
    }
  }, [_vm._v("\n                    Show Spot UV Mask\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasFoil()) ? _c('div', {
    staticClass: "viewBtns m-b-20"
  }, [_c('div', {
    staticClass: "checkbox m-r-15"
  }, [_c('input', {
    staticClass: "foilmask",
    attrs: {
      "type": "checkbox",
      "id": "foilmask",
      "name": "foilmask"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "foilmask",
    attrs: {
      "for": "foilmask"
    },
    on: {
      "click": function($event) {
        _vm.toggle('.previewMask1')
      }
    }
  }, [_vm._v("\n                    Show Foil Mask\n                ")])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewLabel text-center p-10 block"
  }, [_c('strong', [_vm._v("Front")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewLabel text-center p-10 block"
  }, [_c('strong', [_vm._v("Back")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-success viewfront block"
  }, [_vm._v("View Front")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-primary primarybg hover primaryborder viewback block"
  }, [_vm._v("View Back")])])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7a96d18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FileApproval',
    data: function data() {
        return {
            files: {
                default: null
            },
            fileList: ['front', 'back', 'foil_front', 'foil_back', 'spot_uv_front', 'spot_uv_back'],
            approved: [],
            pending: [],
            description: {
                front: 'The front design file.',
                back: 'The back design file.',
                foil_front: 'The front foil mask. Dark parts of preview will have foil over top of them.',
                foil_back: 'The back foil mask. Dark parts of preview will have foil over top of them.',
                spot_uv_front: 'The front spot uv mask. Dark parts of preview will have spot uv (gloss) printed over top of them.',
                spot_uv_back: 'The back spot uv mask. Dark parts of preview will have spot uv (gloss) printed over top of them.'
            }
        };
    },
    beforeMount: function beforeMount() {
        this.files = this.$store.state.template.files;
    },
    mounted: function mounted() {
        var _this = this;

        var time = 250;

        var _loop = function _loop(file) {
            setTimeout(function () {
                _this.pending.push(_this.fileList[file]);
            }, time);
            time += 250;
        };

        for (var file in this.fileList) {
            _loop(file);
        }
    },

    methods: {
        toggle: function toggle(target) {
            $(target).toggleClass('hide');
        },

        setPreview: function setPreview(file) {
            this.$emit('preview', file);
        },


        hasFile: function hasFile(file) {
            if (file !== undefined) {
                if (this.files[file] === undefined) {
                    var index = this.pending.indexOf(file);

                    if (index > -1) {
                        this.pending.splice(index, 1);
                    }
                    return false;
                }
                return true;
            }
            return false;
        },

        approve: function approve(file) {
            if (this.pending.includes(file)) {
                var index = this.pending.indexOf(file);

                if (index > -1) {
                    this.pending.splice(index, 1);
                }
            }

            if (!this.approved.includes(file)) {
                this.approved.push(file);
            }
        },

        checkProceed: function checkProceed() {
            if (this.pending.length < 1) {
                this.$emit('next');
            }
            return false;
        }
    }
});

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filePreview"
  }, [_c('div', {
    staticClass: "previewPrint"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "m-b-20"
  }, [_vm._v("Please double check all text and spelling for possible errors. If anything looks incorrect, click on \"Back To Designer\" to go back and correct before proceeding. Otherwise, please check and approve each file below:")]), _vm._v(" "), _c('table', {
    staticClass: "table m-0"
  }, [_c('tbody', _vm._l((_vm.fileList), function(file) {
    return (_vm.hasFile(file)) ? _c('tr', {
      on: {
        "mouseover": function($event) {
          _vm.setPreview(file)
        }
      }
    }, [_c('td', [_c('h5', {
      staticClass: "m-b-5"
    }, [_vm._v(_vm._s(file.replace(/_/g, ' ').replace(/v/g, 'V').replace(/\b\w/g, function (l) { return l.toUpperCase(); })))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description[file]))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('transition-group', {
      attrs: {
        "enter-active-class": "animated fadeInRight",
        "leave-active-class": "animated fadeOut"
      }
    }, [(_vm.approved.includes(file)) ? _c('i', {
      key: "1",
      staticClass: "icon-checkmark-circle pull-right m-t-10"
    }) : _vm._e(), _vm._v(" "), (_vm.pending.includes(file)) ? _c('button', {
      key: "2",
      staticClass: "btn btn-warning pull-right m-t-10",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.approve(file)
        }
      }
    }, [_vm._v("\n                                " + _vm._s((_vm.pending.includes(file)) ? 'Approve' : 'Approved') + "\n                            ")]) : _vm._e()])], 1)]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInDown"
    }
  }, [(_vm.pending.length === 0 && _vm.approved.length > 0) ? _c('hr', {
    key: "1",
    staticClass: "m-t-0"
  }) : _vm._e(), _vm._v(" "), (_vm.pending.length === 0 && _vm.approved.length > 0) ? _c('button', {
    key: "2",
    staticClass: "btn btn-success pull-right",
    on: {
      "mouseover": function($event) {
        _vm.setPreview('front')
      },
      "click": function($event) {
        _vm.checkProceed()
      }
    }
  }, [_vm._v("Continue to Product Selection")]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("The file previews displayed to the left are how your files will be sent to print.")])])
}]}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b876ca62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__(15);
//
//
//
//
//
//

// /* global Helpers */


/* harmony default export */ __webpack_exports__["default"] = ({
    components: { BreedingRhombusSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* BreedingRhombusSpinner */] },
    props: {
        domain: { default: 'https://beta.eddmeasy.com' },
        modal: { default: false },
        page: { default: 'default' },
        page_id: { default: 0 },
        timeout: { default: 45000 },
        product_name: { default: 'EDDM' },
        map_class: { default: 'map' },
        reloading: { default: false },
        product: { default: '5c00d75f-058a-49c0-b75e-6346de98882c' },
        runsize: { default: null },
        colorspec: { default: null },
        coating: { default: null },
        bleed: { default: null },
        width: { default: null },
        height: { default: null },
        accessToken: { default: null },
        date: { default: '2018-05-11' },
        pr_up: { default: 'NjA=' },
        po_up: { default: 'My40' },
        se_up: { default: 'MzU=' },
        eddm_button_text: { default: 'Continue to next step' },
        show_eddm_service_price: { default: true }
    },
    data: function data() {
        return {
            productInfo: null,
            productOptions: null,
            routeInfo: null
        };
    },
    mounted: function mounted() {
        this.init();
        this.buildMap();

        var eddmheight = $(window).height() - 120;
        $('.map').css('height', eddmheight);
    },

    methods: {
        init: function init(config) {
            var _this = this;

            // Listen for map events
            window.addEventListener('message', function (e) {
                // If 'message' didn't come from the EDDM Map, do nothing
                if (e.origin !== _this.domain) {
                    return;
                }

                // Do something with e.data
                if (e.data.type === 'login_sync') {
                    if (_this.modal === false && _this.reloading === false) {
                        // Product Page
                        // ProductSelector.nextSet()
                    } else {
                        // Modal
                        _this.reloading = false;
                    }
                }

                if (e.data.type === 'map_event_data_sync') {
                    _this.routeInfo = e.data.data;
                    $('#map').css('opacity', 1.0);
                }

                // Do something with e.data
                if (e.data.type === 'next_button_sync') {
                    console.log('next fire');
                    _this.$emit('saveEddmData', e.data);
                    // if (this.modal === false) {
                    //     // Product Page
                    //     this.eddmPanel()
                    //     this.eddmInfo(e.data.data)

                    //     // $('.' + this.map_class).slideUp('fast')

                    //     // $('.routeContainer, .navToggle').off();

                    //     setTimeout(function () {
                    //         // ProductSelector.nextSet()
                    //     }, 250)
                    // } else {
                    //     // Modal
                    //     // Update Eddm
                    //     $.ajax({
                    //         type: 'POST',
                    //         url: '/ajax/eddm/update-cart',
                    //         timeout: this.timeout,
                    //         data: {id: this.page_id, eddm: e.data.data, token: this.accessToken},
                    //         dataType: 'json',
                    //         success: function (data) {
                    //             location.reload()
                    //         },
                    //         error: function (data) {
                    //             // Growl.showhide('Sorry, we\'re having trouble with our EDDM map at the moment. Please try again later.')
                    //         }
                    //     })
                    //     // Update Route?
                    //     // Update Cart
                    // }
                }
            });
        },
        buildMap: function buildMap() {
            var _this2 = this;

            // product_uuid, token
            // $('#map').remove()

            this.checkRequired();

            // Fetch Eddm Info from Database
            // this.product
            this.axios.post('/eddm/product-options', { product: this.product, token: this.accessToken }).then(function (response) {
                var xOptions = response.data.data;
                _this2.productOptions = response.data.data;

                // this.coating = response.data.data.Coating
                // '5c00d75f-058a-49c0-b75e-6346de98882c'
                // '&options[]=121bb7b5-3b4d-429f-bd8d-bbf80e953313&options[]=13abbda7-1d64-4f25-8bb2-c179b224825d&options[]=8a3a0fd1-38ae-49a0-8736-3fedadc3dc93&options[]=aa0227f0-877e-4ecd-bdfd-d220d74098db&options[]=74c3d2c5-af98-4f3f-9634-d0f91f3c3ea9&options[]=cb84e4f5-cf63-4c25-b3c3-d22fc7dcf09d&options[]=e629d351-623c-48f6-b5ea-db43d1387a97'
                // Init iFrame
                var ifr = $('<iframe/>', {
                    id: 'map',
                    src: _this2.domain,
                    frameborder: 0,
                    width: '100%',
                    load: function load() {
                        var iframe = document.getElementById('map').contentWindow;
                        var productOptions = '&options[]=' + response.data.data.Coating + '&options[]=' + _this2.colorspec + '&options[]=' + _this2.runsize + xOptions.options;

                        var data = {
                            type: 'eddm_start',
                            apiUrl: 'https://api.4over.com',
                            access_token: _this2.accessToken,
                            date: _this2.date,
                            product_uuid: _this2.product,
                            product_options: productOptions,
                            product_name: 'EDDM',
                            map_event_data: _this2.routeInfo,
                            postage_markup_percentage: _this2.decode(_this2.po_up),
                            product_markup_percentage: _this2.decode(_this2.pr_up),
                            eddm_service_markup_percentage: _this2.decode(_this2.se_up),
                            show_eddm_service_price: _this2.show_eddm_service_price,
                            next_button_text: _this2.eddm_button_text
                            //  var data = {
                            //     type: 'eddm_start',
                            //     apiUrl: 'https://api.4over.com',
                            //     access_token: this.accessToken,
                            //     date: this.date,
                            //     product_uuid: this.product,
                            //     product_options: productOptions,
                            //     product_name: this.product_name,
                            //     map_event_data: this.routeInfo,
                            //     postage_markup_percentage: this.decode(this.po_up),
                            //     product_markup_percentage: this.decode(this.pr_up),
                            //     eddm_service_markup_percentage: this.decode(this.se_up),
                            //     show_eddm_service_price: this.show_eddm_service_price,
                            //     next_button_text: this.eddm_button_text
                            // }
                        };console.log(data);
                        iframe.postMessage(data, _this2.domain);

                        var eddmheight = $('.map').height();

                        $('#map').css('height', eddmheight);
                        // $('.productDetails.routeSelection').css('min-height', eddmheight)
                    }
                });

                if (_this2.modal) {
                    console.log(1);
                    // EddmRoutes()
                } else {
                    console.log(2);
                    // this.getRoutes()
                }

                $('.map').append(ifr);
                $('.map').attr('data-bleed', _this2.bleed);

                var productBleedsize = parseFloat(_this2.bleed);
                var productWidthsize = parseFloat(_this2.width) + productBleedsize;
                var productHeightsize = parseFloat(_this2.height) + productBleedsize;

                $('.sizeWidth').html(productWidthsize);
                $('.sizeHeight').html(productHeightsize);
                $('.js-selectorpad').removeClass('d-block').addClass('d-none');
            }).catch(function (err) {
                console.log(err);
                // Helpers.errorPop('Error', err.response.data.message)
            });
        },
        openMap: function openMap(id) {
            var openFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
            var token = arguments[2];

            // Pull and set data for the map
            if (openFrom !== 'default') {
                if (openFrom === 'cart') {
                    this.eddm_button_text = 'Update Cart';
                } else if (openFrom === 'order') {
                    this.eddm_button_text = 'Update Job';
                }

                this.modal = true;
                this.page = openFrom;
                this.page_id = id;

                $.ajax({
                    type: 'POST',
                    url: '/ajax/eddm/fetch-data',
                    timeout: this.timeout,
                    data: { id: id, type: openFrom, token: token },
                    dataType: 'json',
                    success: function success(data) {
                        this.init({
                            product: data.eddm.product_data.product_uuid,
                            runsize: data.eddm.product_data.runsize_uuid,
                            colorspec: data.eddm.product_data.colorspec_uuid,
                            date: data.eddm.delivery_date,
                            accessToken: data.token,
                            pr_up: this.encode(data.eddm.product_markup_percentage.toString()),
                            po_up: this.encode(data.eddm.postage_markup_percentage.toString())
                        });

                        this.productInfo = data.eddm;
                        this.routeInfo = data.eddm.map_event_data;
                        this.injectModal();
                    }
                });

                // Product Page - Just load the map
            } else {
                this.buildMap();
            }
        },
        setMapButton: function setMapButton(text) {
            var iframe = document.getElementById(this.frame_id).contentWindow;

            var data = {
                type: 'next_button_text_update',
                next_button_text: text
            };

            iframe.postMessage(data, this.domain);
        },
        injectModal: function injectModal() {
            var template = '\n                <div class="mapModal"></div>\n            ';

            $('body').append(template);

            this.buildMap();
        },
        eddmPanel: function eddmPanel() {
            $('.scheduleEstimate').show();
            $('.set-buttons a.shipping').html('<span data-icon="" title="shipping"></span> EDDM<span>&reg;</span><b></b>');
            $('.detailstepTwo').remove();
            $('.detailstepThree').show().removeClass('detailstepThree').addClass('detailstepTwo');
        },
        eddmInfo: function eddmInfo(data) {
            this.productInfo = data;

            var $standardPrice = window.productPricing.filter(function (obj) {
                return obj.runsize_uuid === data.product_data.runsize_uuid;
            });

            // $('.eddmDelivery').html(moment(data.delivery_date).format('dddd, MMMM Do YYYY'))
            // $('.eddmResidential').html(data.map_event_data.tot_res)
            // $('.eddmBusiness').html(data.map_event_data.tot_bus)
            // $('.eddmTotalAddresses').html(data.map_event_data.tot_cnt)
            // $('.eddmProdCost').html('$' + this.number_format((data.product_price), 2))
            $('.baseproduct').html('Retail Price: <s><span>$' + $standardPrice[0].base + '</span></s>');
            // $('.eddmProductCost').after('<div class="row"><div class="col-6 pr-0"><label for="estimated" class="mb-0 type-85 vertical-align d-block font-200">EDDM<span class="superscript">&reg;</span> Service Cost</label></div><div class="eddmProdCost totalDays text-right font-500 mb-2 type-150 col-6">$' + this.number_format((data.eddm_service_price), 2) + '</div></div>')
            // $('.eddmShipCost').html('$' + this.number_format(data.postage_price, 2))
            // $('.eddmTotalCost').html('$' + this.number_format(data.total_price, 2))

            $('.js-selectorpad').removeClass('d-none').addClass('d-block');

            // Set Summary Info
            var description = 'test';
            // var description = selectedProds[0].description
            // var runsize = data.friendly_product_data.Runsize
            // var sets = '1'
            var subtotal = data.product_price + data.eddm_service_price;
            var shipping = data.postage_price;
            var design = 0;

            if ($('select[name=artwork]').length) {
                design = parseFloat($('select[name=artwork] option:selected').data('price'));
            }

            $('.summaryProduct').html(description);
            $('.summaryLeft ul li:nth-child(2)').html('<label>Routes Selected:</label><div class="summarySets">' + data.map_event_data.tot_sel + '</div>');
            $('.summaryLeft ul li:nth-child(3)').html('<label>Total Addresses:</label><div class="summarySets">' + data.map_event_data.tot_cnt + '</div>');
            $('.summaryRight ul li:nth-child(2) label').html('Product:');
            $('.summaryRight ul li:nth-child(3) label').html('Postage:');
            $('.summaryRight ul li:nth-child(2)').after('<li class="group"><label class="total">EDDM<span class="superscript">&reg;</span> Service:</label><div class="cost">$' + this.number_format(data.eddm_service_price, 2) + '</div></li>');
            $('.costSubtotal').html('$' + this.number_format(data.product_price + design, 2, '.', ','));
            $('.costShipping').html('$' + this.number_format(shipping, 2, '.', ','));
            $('.costTotal').html('$' + this.number_format(parseFloat(subtotal) + parseFloat(shipping) + design, 2, '.', ','));
        },
        checkRequired: function checkRequired() {
            if (this.product === null) {
                return true;
            } else if (this.runsize === null) {
                return true;
            } else if (this.colorspec === null) {
                return true;
            } else if (this.accessToken === null) {
                return true;
            } else if (this.date === null) {
                return true;
            }
        },


        getRoutes: function getRoutes() {
            var _this3 = this;

            // Make Ajax Call to Fetch
            $.ajax({
                type: 'GET',
                url: this.domain + '/routes',
                dataType: 'json',
                success: function success(data) {
                    // this.$set('routes',routes);
                    _this3.routes = data;
                    //     {"id":1, "name":"Huntersville, NC","routes":7,"residential":1378,"business":652},

                    _this3.routeButtons();

                    $('.updateRoute').on('click', function () {
                        $('.commitSave').attr('data-type', 'update');
                        this.routeSave();
                        return false;
                    });

                    $('.saveRoute').on('click', function () {
                        $('.commitSave').attr('data-type', 'new');
                        this.routeSave();
                        return false;
                    });

                    $('.commitSave').on('click', function () {
                        var type = $(this).data('type');
                        this.saveRoute(type);
                        return false;
                    });

                    $('.cancelSave').on('click', function () {
                        this.routeButtons();
                        return false;
                    });

                    $('input[name=routeName]').keypress(function (e) {
                        if (e.which === 13) {
                            var type = $('.commitSave').data('type');
                            this.saveRoute(type);
                            return false;
                        }
                    });

                    if (_this3.routes.length === 0) {
                        _this3.addTutorial();
                    }
                },
                error: function error(data) {
                    // Growl.showhide('Sorry, there was an error processing your request.', 4000);
                }
            });
        },
        saveRoute: function saveRoute(type) {
            var _this4 = this;

            var url = this.domain + '/route';
            var name = $('input[name=routeName]').val();

            if (this.routeInfo === null || this.routeInfo === undefined) {
                // Growl.showhide('No routes have been selected to save.')
            } else if (name === '') {
                // Growl.showhide('Route group name is required.')
            } else {
                if (type === 'update') {
                    url = url + '/' + $('li.route.active').data('id');
                }

                var send = {
                    name: $('input[name=routeName]').val(),
                    routes: this.routeInfo.tot_sel,
                    residential: this.routeInfo.tot_res,
                    business: this.routeInfo.tot_bus,
                    data: this.routeInfo
                };

                $.ajax({
                    type: 'POST',
                    url: url,
                    dataType: 'json',
                    data: send,
                    success: function success(data) {
                        if (_this4.routes[0].class === 'tutorial') {
                            _this4.routes.splice(0, 1);
                        }

                        _this4.routes.push({ 'id': data.id, 'name': data.name, 'routes': data.routes, 'residential': data.residential, 'business': data.business });
                    },
                    error: function error(data) {
                        // Growl.showhide('Sorry, there was an error processing your request.', 4000);
                    }
                });

                $('input[name=routeName]').val('');
                this.routeButtons();
            }
        },
        routeButtons: function routeButtons() {
            $('.route_functions').removeClass('rSave').addClass('rButtons');
        },
        routeSave: function routeSave() {
            $('.route_functions').removeClass('rButtons').addClass('rSave');
            $('input[name=routeName]').focus();
        },
        addTutorial: function addTutorial() {
            this.routes.push({ 'id': null, 'name': 'Saving Routes:', 'routes': "Here you can save routes to easily manage and reuse on future orders. Save the currently selected routes using the 'Save Route Group' button above, select an exsiting route group to apply it to the map or click the 'X' next to a route group to remove it from the list.", 'class': 'tutorial' });
        },
        select: function select(index) {
            if (this.routes[index].id !== null) {
                $('.routes_list ul li').removeClass('active');
                $('.routes_list ul li:nth-child(' + (index + 1) + ')').addClass('active');

                var id = $('.routes_list ul li:nth-child(' + (index + 1) + ')').data('id');

                this.options.reloading = true;

                this.reOpenMap(id);
            }
        },
        delete: function _delete(index, event) {
            event.preventDefault();

            var $t = this;
            var id = $('.routes_list ul li:nth-child(' + (index + 1) + ')').data('id');

            $.ajax({
                type: 'DELETE',
                url: $t.url + '/route/' + id,
                dataType: 'json',
                success: function success(data) {
                    $t.routes.splice(index, 1);

                    if ($t.routes.length === 0) {
                        $t.addTutorial();
                    }
                },
                error: function error(data) {
                    // Growl.showhide('Sorry, there was an error processing your reques$t.', 4000);
                }
            });

            return false;
        },

        encode: function encode(data) {
            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            var o1;
            var o2;
            var o3 = 0;
            var h1 = 0;
            var h2 = 0;
            var h3 = 0;
            var h4 = 0;
            var bits = 0;
            var i = 0;
            var ac = 0;
            var enc = '';
            var tmpArr = [];

            if (!data) {
                return data;
            }

            do {
                // pack three octets into four hexets
                o1 = data.charCodeAt(i++);
                o2 = data.charCodeAt(i++);
                o3 = data.charCodeAt(i++);

                bits = o1 << 16 | o2 << 8 | o3;

                h1 = bits >> 18 & 0x3f;
                h2 = bits >> 12 & 0x3f;
                h3 = bits >> 6 & 0x3f;
                h4 = bits & 0x3f;

                // use hexets to index into b64, and append result to encoded string
                tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
            } while (i < data.length);

            enc = tmpArr.join('');

            var r = data.length % 3;

            return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
        },
        decode: function decode(data) {
            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            var o1 = 0;
            var o2 = 0;
            var o3 = 0;
            var h1 = 0;
            var h2 = 0;
            var h3 = 0;
            var h4 = 0;
            var bits = 0;
            var i = 0;
            var ac = 0;
            var dec = '';
            var tmpArr = [];

            if (!data) {
                return data;
            }

            data += '';

            do {
                // unpack four hexets into three octets using index points in b64
                h1 = b64.indexOf(data.charAt(i++));
                h2 = b64.indexOf(data.charAt(i++));
                h3 = b64.indexOf(data.charAt(i++));
                h4 = b64.indexOf(data.charAt(i++));

                bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

                o1 = bits >> 16 & 0xff;
                o2 = bits >> 8 & 0xff;
                o3 = bits & 0xff;

                if (h3 === 64) {
                    tmpArr[ac++] = String.fromCharCode(o1);
                } else if (h4 === 64) {
                    tmpArr[ac++] = String.fromCharCode(o1, o2);
                } else {
                    tmpArr[ac++] = String.fromCharCode(o1, o2, o3);
                }
            } while (i < data.length);

            dec = tmpArr.join('');

            return dec;
        },
        number_format: function number_format(number, decimals, decPoint, thousandsSep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');

            var n = !isFinite(+number) ? 0 : +number;
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
            var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
            var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
            var s = '';

            var toFixedFix = function toFixedFix(n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };

            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }

            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }
    }
});

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group map"
  }, [_c('div', {
    staticClass: "productDetails routeSelection"
  })])
}]}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2_dist_sweetalert2_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// HIDE OPTION IF ONLY ONE OPTION IS AVAILABLE
// SHOW OPTIONS COST BEFORE SELECTOR BUILD

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ProductSelector',
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */] },
    props: {
        products: {
            default: function _default() {
                return [];
            }
        },
        eddmDates: {
            default: function _default() {
                return [];
            }
        },
        button: {
            default: 'Add to cart'
        },
        selected: {
            default: {
                product: null,
                product_cost: null,
                runsize: null,
                runsizeDescription: null,
                colorspec: null,
                options: null,
                name: null,
                turnaround: null,
                shipping: null,
                blind: null,
                date: null,
                method: null
            }
        }
    },
    data: function data() {
        return {
            runsize_uuid: '87e09691-ef33-4cf4-8f17-48af06ce84f4',
            colorspec_uuid: '38d33954-5a42-4112-a905-215eb827e62c',
            productsLoaded: false,
            proceed: false,
            optionGroups: {},
            optionGroupSorting: [],
            excludeOptionGroups: [],
            forceSkipOptionGroups: [],
            selected_products: [],
            preselected_options: [],
            selected_options: [],
            runsize_cost: [],
            runsizes: [],
            min_runsize: 0,
            calendar: {
                openDate: '',
                disabledDates: {
                    // to: new Date(2016, 0, 5), // Disable all dates up to specific date
                    // from: new Date(2016, 0, 26), // Disable all dates after specific date
                    days: [6, 0] // Disable Saturday's and Sunday's
                }
            }
        };
    },
    created: function created() {
        var settings = this.$store.state.template.productsettings.data[0];
        var exclude = [];
        // Always Hide EDDM Option
        exclude.push('038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56'); // EDDM Option
        this.forceSkipOptionGroups.push('038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56'); // EDDM Option

        // EDDM - Force No Bundling & EDDM Option
        if (this.$store.state.template.eddm_only) {
            exclude.push('87e09691-ef33-4cf4-8f17-48af06ce84f4'); // Runsize
            exclude.push('254afeea-1fd1-4efb-b5fb-c9c3bf4c13d2'); // Bundling
            this.preselected_options['254afeea-1fd1-4efb-b5fb-c9c3bf4c13d2'] = '58689abb-25c0-461c-a4c3-a80b627d6649';
            this.preselected_options['038bcdd0-0e1a-4de4-ad8c-2c4cc0df7d56'] = 'aa0227f0-877e-4ecd-bdfd-d220d74098db';
        }

        if (this.selected.colorspec) {
            exclude.push('38d33954-5a42-4112-a905-215eb827e62c');
            this.preselected_options['38d33954-5a42-4112-a905-215eb827e62c'] = this.selected.colorspec;
        }

        if (settings.subcategories[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(settings.subcategories)[0]].exclude) {
            var excludeList = settings.subcategories[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(settings.subcategories)[0]].exclude;
            for (var i in excludeList) {
                exclude.push(excludeList[i]);
            }
        }
        this.excludeOptionGroups = exclude;
    },

    watch: {
        products: function products(newVal, oldVal) {
            if (this.productsLoaded === false) {
                this.productsLoaded = true;
                this.init();
            }
        },
        eddmDates: function eddmDates(newVal, oldVal) {
            this.calendar.openDate = new Date(newVal[0]);
            this.calendar.disabledDates.to = new Date(newVal[0]);
            this.calendar.disabledDates.from = new Date(newVal[newVal.length - 1]);
        },
        selected: function selected(newVal, oldVal) {
            this.$emit('updateSelected', newVal);
        }
    },
    methods: {
        /**
         * Loop our products, build out all available options and init our selected prods to start with
         */
        init: function init() {
            // Init our selected products if it hasn't been done.
            if (this.selected_products.length < 1) {
                var products = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.products));
                for (var i in products) {
                    this.selected_products.push(products[i]);
                }
            }

            this.initNextSelector();
        },
        checkProceed: function checkProceed() {
            if (this.proceed) {
                this.$emit('next');
            }
            return false;
        },


        /**
         * Loop over selected products and build option groups
         */
        buildOptions: function buildOptions() {
            var reset = [];
            var touch = +new Date();

            for (var i in this.selected_products) {
                var prod = this.selected_products[i];

                for (var x in prod.option_groups.data) {
                    var optionGroup = prod.option_groups.data[x];

                    // If optiongroup is disabled or undefined
                    if (optionGroup.disabled !== false) {
                        this.optionGroupSorting[optionGroup.sorting] = optionGroup.uuid;

                        // Reset - If option group is set & an option hasn't been selected yet & it hasn't been reset yet
                        if (this.optionGroups.hasOwnProperty(optionGroup.uuid) && this.selected_options[optionGroup.uuid] === null && !reset.includes(optionGroup.uuid)) {
                            reset.push(optionGroup.uuid);
                            this.optionGroups[optionGroup.uuid].options.data = {};
                        }

                        // If Option Group Doesn't Exist
                        if (!this.optionGroups.hasOwnProperty(optionGroup.uuid)) {
                            reset.push(optionGroup.uuid);

                            optionGroup.disabled = true;

                            this.$set(this.optionGroups, optionGroup.uuid, optionGroup);

                            if (!this.selected_options[optionGroup.uuid]) {
                                this.selected_options[optionGroup.uuid] = null;
                            }

                            // Else - Merge options with option group
                        } else {
                            var og = this.optionGroups[optionGroup.uuid];
                            var currentOptionGroups = [];

                            // Build array of existing options
                            var index = 0;
                            var orderedOptions = {}; // reset index of object keys to 0, because was overwriting items on the merge below
                            for (var _x in og.options.data) {
                                currentOptionGroups.push(og.options.data[_x].uuid);
                                orderedOptions[index] = og.options.data[_x];
                                index++;
                            }

                            // Merge in new options if they don't exist
                            for (var _i in optionGroup.options.data) {
                                if (!currentOptionGroups.includes(optionGroup.options.data[_i].uuid)) {
                                    orderedOptions[currentOptionGroups.length] = optionGroup.options.data[_i];
                                    currentOptionGroups.push(optionGroup.options.data[_i].uuid);
                                }
                            }
                            og.options.data = orderedOptions;

                            // Set option group
                            this.$set(this.optionGroups, optionGroup.uuid, og);
                        }

                        // Touch
                        this.optionGroups[optionGroup.uuid].touch = touch;
                    }
                }
            }

            for (var _i2 in this.optionGroups) {
                if (this.optionGroups[_i2].touch < touch) {
                    this.$delete(this.optionGroups, _i2);
                }
            }

            this.cleanOptions(); // Remove Selectors w/ Only 1 Option?
        },


        /**
         * Remove option groups with only 1 option
         */
        cleanOptions: function cleanOptions() {
            for (var i in this.optionGroupSorting) {
                if (this.optionGroups[this.optionGroupSorting[i]] !== undefined) {
                    this.optionGroups[this.optionGroupSorting[i]] = this.filterExcludedOptions(this.optionGroups[this.optionGroupSorting[i]]);

                    // Remove Option Groups
                    if (this.optionGroups[this.optionGroupSorting[i]] && this.optionGroups[this.optionGroupSorting[i]].options.data.length < 2 && this.optionGroupSorting[i] !== '38d33954-5a42-4112-a905-215eb827e62c') {
                        if (this.optionGroups[this.optionGroupSorting[i]].options.data.length > 0) {
                            // Assign only available option if it's not eddm only
                            if (this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid === 'e629d351-623c-48f6-b5ea-db43d1387a97' && this.$store.state.template.eddm_only || this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid !== 'e629d351-623c-48f6-b5ea-db43d1387a97') {
                                this.selected_options[this.optionGroups[this.optionGroupSorting[i]].uuid] = this.optionGroups[this.optionGroupSorting[i]].options.data[0].uuid;
                            }
                        }

                        // Remove option group
                        this.$delete(this.optionGroups, this.optionGroupSorting[i]);
                    }
                }
            }

            var sorted = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.chain(this.optionGroups).map(function (val, key) {
                return { name: key, data: val, sort: parseInt(val.sorting) };
            }).sortBy('sort').keyBy('name').mapValues('data').value();

            this.optionGroups = sorted;

            this.$forceUpdate();
        },


        /**
         * Remove excluded options from the option group
         * @param  {object} optionGroup
         * @return {object} filtered option group
         */
        filterExcludedOptions: function filterExcludedOptions(optionGroup) {
            var optionGroupData = optionGroup.options.data;

            for (var x in optionGroupData) {
                var option = optionGroupData[x];
                if (this.excludeOptionGroups.includes(option.uuid)) {
                    this.$delete(optionGroupData, x);
                }
            }
            optionGroup.options.data = optionGroupData;

            return optionGroup;
        },


        /**
         * Popup a modal for explaining an option group or options function
         * @param  {string} html data to be displayed in modal
         */
        showModal: function showModal(html) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
                html: '<div style="text-align: left;">' + html + '</div>',
                showCloseButton: false
            });
        },


        /**
         * Loop selected options and filter out products based on options selected thus far
         */
        filterProducts: function filterProducts($event) {
            var selector = $event.target;
            if (selector !== undefined) {
                if (selector.options[selector.selectedIndex] !== undefined) {
                    var alert = selector.options[selector.selectedIndex].getAttribute('data-alert');

                    if (alert !== null && alert !== '' && alert.length > 0) {
                        this.showModal(alert);
                    }
                }

                // Reset all selectors below the target
                var clear = false;
                var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.optionGroupSorting);
                var lastIndex = keys.length - 1;
                for (var i in this.optionGroupSorting) {
                    if (this.optionGroupSorting[i] === selector.name) {
                        clear = true;
                        if (keys.indexOf(i) === lastIndex) {
                            if (this.optionGroups[this.optionGroupSorting[i]] !== undefined && this.optionGroups[this.optionGroupSorting[i]].disabled !== undefined) {
                                this.optionGroups[this.optionGroupSorting[i]].disabled = false;
                            }
                            this.buildSelection();
                            this.proceed = true;
                        }
                    } else if (clear === true && (!this.$store.state.template.eddm_only || this.$store.state.template.eddm_only && this.selected.date !== true)) {
                        // && !this.excludeOptionGroups.includes(this.optionGroupSorting[i])
                        this.selected_options[this.optionGroupSorting[i]] = null;
                        if (this.optionGroups[this.optionGroupSorting[i]] !== undefined) {
                            this.optionGroups[this.optionGroupSorting[i]].disabled = true;
                        }
                    } else if (clear === true && this.$store.state.template.eddm_only && this.selected.date === true) {
                        this.proceed = true;
                    }
                }

                // Set the optiongroup pricing
                if (selector.name === this.runsize_uuid) {
                    this.calculateOptionsCost(selector.value);
                } else {
                    this.calculateOptionsCost();
                }

                // Push all available products into the pending list to be filtered
                var products = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.products));
                var filteredProducts = {};
                for (var x in products) {
                    filteredProducts[x] = products[x];
                }

                // Loop selected options so far and remove products that don't match
                for (var _i3 in this.optionGroupSorting) {
                    if (this.selected_options[this.optionGroupSorting[_i3]]) {
                        var option = this.selected_options[this.optionGroupSorting[_i3]];
                        if (option !== null) {
                            for (var p in filteredProducts) {
                                if (!this.findOption(filteredProducts[p], this.optionGroupSorting[_i3], option)) {
                                    delete filteredProducts[p];
                                }
                            }
                        }
                    }
                }

                // Push filtered list into the selected products
                this.selected_products.length = 0;
                for (var _x2 in filteredProducts) {
                    this.selected_products.push(filteredProducts[_x2]);
                }

                if (selector.disabled === false) {
                    this.initNextSelector();
                }
            }
        },


        /**
         * Loop a product to detect if it has a specific option available to it
         * @param  {object} product     Product Data
         * @param  {string} optiongroup Optiongroup UUID
         * @param  {string} option      Option UUID
         * @return {boolean}            Option found?
         */
        findOption: function findOption(product, optiongroup, option) {
            var found = false;

            for (var i in product.option_groups.data) {
                if (product.option_groups.data[i].uuid === optiongroup) {
                    var options = product.option_groups.data[i].options.data;
                    for (var o in options) {
                        if (options[o].uuid === option) {
                            found = true;
                        }
                    }
                }
            }

            return found;
        },


        /**
         * Initialize the next selector and confirm that it's still viable with the selected products
         * @param  {string} uuid Current selector uuid
         */
        initNextSelector: function initNextSelector() {
            var _this = this;

            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            this.buildOptions();
            var nextSelector = false;

            var _loop = function _loop(i) {
                if (_this.optionGroups[_this.optionGroupSorting[i]]) {
                    if (_this.optionGroups[_this.optionGroupSorting[i]].disabled === true && !_this.forceSkipOptionGroups.includes(_this.optionGroups[_this.optionGroupSorting[i]].uuid)) {
                        _this.optionGroups[_this.optionGroupSorting[i]].disabled = false;
                        nextSelector = true;

                        if (_this.preselected_options[_this.optionGroupSorting[i]]) {
                            setTimeout(function () {
                                $('select[name="' + _this.optionGroupSorting[i] + '"]').val(_this.preselected_options[_this.optionGroupSorting[i]]);
                                $('select[name="' + _this.optionGroupSorting[i] + '"]')[0].dispatchEvent(new Event('change', { 'bubbles': true }));
                            }, 500);
                        }

                        // if (this.optionGroups[this.optionGroupSorting[i]] && Object.keys(this.optionGroups[this.optionGroupSorting[i]].options.data).length < 2 && this.optionGroupSorting[i] !== '38d33954-5a42-4112-a905-215eb827e62c') {
                        //     $('select[name="' + this.optionGroupSorting[i] + '"]').val(this.optionGroups[this.optionGroupSorting[i]].options.data[Object.keys(this.optionGroups[this.optionGroupSorting[i]].options.data)[0]].uuid)
                        //     $('select[name="' + this.optionGroupSorting[i] + '"]')[0].dispatchEvent(new Event('change', { 'bubbles': true }))

                        //     this.excludeOptionGroups.push(this.optionGroupSorting[i])
                        //     this.initNextSelector()
                        // }

                        return 'break';
                    }
                }
            };

            for (var i in this.optionGroupSorting) {
                var _ret = _loop(i);

                if (_ret === 'break') break;
            }

            this.calculateOptionsCost();

            if (nextSelector === false && (!this.$store.state.template.eddm_only || this.selected.date === true)) {
                this.buildSelection();
                this.proceed = true;
            }
        },


        /**
         * Build and output the selected product and options
         */
        buildSelection: function buildSelection() {
            var selected = this.selected;
            selected.options = [];
            for (var i in this.optionGroupSorting) {
                if (this.selected_options[this.optionGroupSorting[i]] && this.selected_options[this.optionGroupSorting[i]] !== null) {
                    if (this.optionGroupSorting[i] === this.runsize_uuid) {
                        selected.runsize = this.selected_options[this.optionGroupSorting[i]];
                        selected.runsizeDescription = $('select[name=' + this.optionGroupSorting[i] + '] > option:selected').attr('data-name');
                    } else if (this.optionGroupSorting[i] === this.colorspec_uuid) {
                        selected.colorspec = this.selected_options[this.optionGroupSorting[i]];
                    } else {
                        selected.options.push(this.selected_options[this.optionGroupSorting[i]]);
                    }
                }
            }
            // Update Selected w/ Product
            if (this.selected_products.length < 2) {
                selected.product = this.selected_products[0];
                selected.product_cost = parseFloat(this.estimatedCost().replace('$', ''));
            }

            this.$set(this.selected, selected);
        },


        /**
         * Run and return a cost estimation of the product
         * @return {string} Total calculated cost
         */
        estimatedCost: function estimatedCost() {
            var price = null;
            var options = 0;
            var product = null;
            // Filters
            var runsizeUuid = this.selected_options[this.runsize_uuid];
            var colorspecUuid = this.selected_options[this.colorspec_uuid];

            for (var i in this.selected_products) {
                var prod = this.selected_products[i];

                var filterRunsize = runsizeUuid !== null && runsizeUuid !== undefined ? runsizeUuid : false;
                var filterColorspec = colorspecUuid !== null && colorspecUuid !== undefined ? colorspecUuid : false;

                for (var x in prod.detail.data) {
                    var prodDetail = prod.detail.data[x];

                    if (filterRunsize !== false && filterColorspec !== false) {
                        if (prodDetail.runsize_uuid === runsizeUuid && prodDetail.colorspec_uuid === colorspecUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod;
                                price = prodDetail.price;
                                this.setRunsizeCosts(prod);
                            }
                        }
                    } else if (filterRunsize !== false) {
                        if (prodDetail.runsize_uuid === runsizeUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod;
                                price = prodDetail.price;
                                this.setRunsizeCosts(prod);
                            }
                        }
                    } else if (filterColorspec !== false) {
                        if (prodDetail.colorspec_uuid === colorspecUuid) {
                            if (prodDetail.price <= price || price === null) {
                                product = prod;
                                price = prodDetail.price;
                                this.setRunsizeCosts(prod);
                            }
                        }
                    } else {
                        if (prodDetail.price <= price || price === null) {
                            product = prod;
                            price = prodDetail.price;
                            this.setRunsizeCosts(prod);
                        }
                    }
                }
            }

            // Loop Selected Options & Estimate Options Cost
            if (product !== null) {
                for (var _x4 in this.optionGroups) {
                    var og = this.optionGroups[_x4];
                    if (this.selected_options[og.uuid] !== null) {
                        for (var o in og.options.data) {
                            var option = og.options.data[o];
                            if (this.selected_options[og.uuid] === option.uuid && option.price !== undefined && option.price !== null) {
                                options += option.price;
                            }
                        }
                    }
                }
            }

            if (price > 0 && price !== null) {
                return '$' + (price + options).toFixed(2);
            } else {
                return 'Sorry, an error has occured.';
            }
        },


        /**
         * Calculate total cost of all options
         * @param  {string} uuid Uuid of selected runsize
         * @return {float}
         */
        calculateOptionsCost: function calculateOptionsCost() {
            var uuid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.min_runsize = 0;
            var runsize = this.runsizes[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.runsizes)[0]];

            if (uuid !== null) {
                runsize = this.runsizes[uuid];
            }

            for (var i in this.optionGroups) {
                var og = this.optionGroups[i];
                var options = og.options.data;
                for (var x in options) {
                    var opt = options[x];
                    if (opt.pricing !== undefined) {
                        var pricing = opt.pricing.data;
                        var first = false;
                        for (var p in pricing) {
                            var price = pricing[p];
                            // No runsize is defined - choose minimum
                            if (this.selected_options[og.uuid] === opt.uuid && first === false) {
                                // Set Min Runsize
                                if (this.min_runsize < price.startqty) {
                                    this.min_runsize = price.startqty;
                                }
                                first = true;
                            }

                            // If we fall within the runsize range
                            if (price.startqty !== undefined && price.startqty <= runsize && (price.endqty === undefined || price.endqty >= runsize)) {
                                // Calculate Price
                                if (price.price_per_qty !== undefined) {
                                    opt.price = price.price + runsize / price.qty * price.price_per_qty;
                                } else if (price.price > 0) {
                                    opt.price = price.price;
                                }
                                break;
                            }
                        }
                    }
                }
            }
        },


        /**
         * Set all of the runsize costs of the cheapest available product in selected products
         * this will ultimately be narrowed down to one product and return the correct cost
         * @param {object} prod Product Data
         */
        setRunsizeCosts: function setRunsizeCosts(prod) {
            var colorspecUuid = this.selected_options[this.colorspec_uuid];
            this.runsize_cost.length = 0;

            for (var i in prod.detail.data) {
                var detail = prod.detail.data[i];
                if (detail.runsize >= this.min_runsize && colorspecUuid && colorspecUuid === detail.colorspec_uuid || detail.runsize >= this.min_runsize && !colorspecUuid) {
                    this.runsize_cost[detail.runsize] = detail.price;
                    this.runsizes[detail.runsize_uuid] = detail.runsize;
                }
            }
        }
    }
});

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.optionGroups).length > 0) ? _c('ul', [_vm._l((_vm.optionGroupSorting), function(uuid) {
    return (_vm.optionGroups[uuid]) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.excludeOptionGroups.includes(uuid)),
        expression: "!excludeOptionGroups.includes(uuid)"
      }],
      key: uuid,
      staticClass: "group row m-b-20"
    }, [_c('label', {
      staticClass: "col-sm-5",
      attrs: {
        "for": _vm.optionGroups[uuid].safe_name ? _vm.optionGroups[uuid].safe_name : _vm.optionGroups[uuid].name
      }
    }, [(_vm.optionGroups[uuid].modal_details) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showModal(_vm.optionGroups[uuid].modal_details)
        }
      }
    }, [_vm._v("[?]")]) : _vm._e(), _vm._v(" "), (_vm.optionGroups[uuid].safe_name) ? _c('span', [_vm._v(_vm._s(_vm.optionGroups[uuid].safe_name))]) : _c('span', [_vm._v(_vm._s(_vm.optionGroups[uuid].name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-7"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected_options[_vm.optionGroups[uuid].uuid]),
        expression: "selected_options[optionGroups[uuid].uuid]"
      }],
      staticClass: "form-control",
      attrs: {
        "name": _vm.optionGroups[uuid].uuid,
        "disabled": _vm.optionGroups[uuid].disabled
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selected_options, _vm.optionGroups[uuid].uuid, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.filterProducts($event)
        }]
      }
    }, [(!_vm.selected_options[_vm.optionGroups[uuid].uuid]) ? _c('option', {
      attrs: {
        "value": "null"
      }
    }, [_vm._v("Select One")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.optionGroups[uuid].options.data), function(option) {
      return ((_vm.optionGroups[uuid].uuid !== _vm.runsize_uuid || (_vm.optionGroups[uuid].uuid === _vm.runsize_uuid && _vm.runsize_cost[option.name] !== undefined)) && !_vm.excludeOptionGroups.includes(option.uuid)) ? _c('option', {
        key: option.uuid,
        attrs: {
          "data-name": option.name,
          "data-alert": option.alert
        },
        domProps: {
          "value": option.uuid
        }
      }, [(option.safe_name) ? _c('span', [_vm._v(_vm._s(option.safe_name))]) : _c('span', [_vm._v(_vm._s(option.name))]), _vm._v(" "), (_vm.optionGroups[uuid].uuid === _vm.runsize_uuid && _vm.runsize_cost[option.name]) ? _c('span', [_vm._v(" - $" + _vm._s(_vm.runsize_cost[option.name].toFixed(2)))]) : _vm._e(), _vm._v(" "), (option.price !== null && option.price !== undefined) ? _c('span', [_vm._v(" - $" + _vm._s(option.price.toFixed(2)))]) : _vm._e()]) : _vm._e()
    })], 2)])]) : _vm._e()
  }), _vm._v(" "), (_vm.$store.state.template.eddm_only) ? _c('li', {
    staticClass: "group row m-b-20"
  }, [_c('label', {
    staticClass: "col-sm-5",
    attrs: {
      "for": "turnaround"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal('<p>Choose the date that you wish to have the postcards delivered in the mailboxes. Please note that issues with artwork, files or delays in placing your order today may cause delays.<br /><br />The selected dates are subject to USPS® Mail Service Delivery. The USPS® may deliver the postcards early, late or on the target date at their discretion.</p>')
      }
    }
  }, [_vm._v("[?]")]), _vm._v("\n            In Mailbox Date\n        ")]), _vm._v(" "), (_vm.calendar.openDate !== '') ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('datepicker', {
    attrs: {
      "openDate": _vm.calendar.openDate,
      "disabledDates": _vm.calendar.disabledDates,
      "format": "MM/dd/yyyy",
      "input-class": "form-control"
    },
    on: {
      "selected": function($event) {
        _vm.initNextSelector(true)
      }
    },
    model: {
      value: (_vm.selected.date),
      callback: function($$v) {
        _vm.$set(_vm.selected, "date", $$v)
      },
      expression: "selected.date"
    }
  }), _vm._v(" "), _c('small', [_vm._v("*USPS® may deliver before or after the selected target estimate "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal('<p>Choose the date that you wish to have the postcards delivered in the mailboxes. Please note that issues with artwork, files or delays in placing your order today may cause delays.<br /><br />The selected dates are subject to USPS® Mail Service Delivery. The USPS® may deliver the postcards early, late or on the target date at their discretion.</p>')
      }
    }
  }, [_vm._v("more info")])])], 1) : _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "placeholder": "Loading, please wait.."
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.$store.state.template.eddm_only),
      expression: "!this.$store.state.template.eddm_only"
    }],
    staticClass: "pull-right m-b-20",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.estimatedCost()))])])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    class: {
      disabled: (_vm.proceed !== true)
    },
    on: {
      "click": function($event) {
        _vm.checkProceed()
      }
    }
  }, [_vm._v(_vm._s(_vm.button))])])])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2_dist_sweetalert2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddressModal_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddressModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AddressModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */

// import _ from 'lodash'




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ShippingSelector',
    components: { AddressModal: __WEBPACK_IMPORTED_MODULE_2__AddressModal_vue___default.a },
    props: {
        products: {
            default: []
        },
        button: {
            default: 'Add to cart'
        },
        selected: {
            default: function _default() {
                return {
                    product: null,
                    product_cost: null,
                    runsize: null,
                    runsizeDescription: null,
                    colorspec: null,
                    options: null,
                    name: null,
                    turnaround: null,
                    shipping: null,
                    blind: null,
                    date: null,
                    method: null
                };
            }
        }
    },
    data: function data() {
        return {
            shippingNote: null,
            addressesLoaded: false,
            addressList: [],
            turnaroundOptions: [],
            shippingOptions: [],
            optionGroups: {},
            selected_products: [],
            selected_options: [],
            filtered_products: [],
            runsize_cost: [],
            runsizes: [],
            min_runsize: 0,
            proceed: false
        };
    },
    beforeMount: function beforeMount() {
        this.fetchAddressList();
    },
    mounted: function mounted() {},

    watch: {
        selected: function selected(selectedNew, selectedOld) {
            this.$emit('updateSelected', selectedNew);
            if (selectedNew.runsize !== null && selectedNew.colorspec !== null && selectedNew.product !== null) {
                this.fetchTurnaround();
            }
        }
    },
    methods: {
        /**
         * Loop our products, build out all available options and init our selected prods to start with
         */
        init: function init() {},
        fetchTurnaround: function fetchTurnaround() {
            var _this = this;

            var data = {
                product: this.selected.product.id,
                runsize: this.selected.runsize,
                colorspec: this.selected.colorspec
            };

            this.axios.post('/products/turnaround', data).then(function (res) {
                _this.turnaroundOptions = res.data.data;
            }).catch(function (err) {
                Helpers.errorPop('Error', err);
            });
        },
        fetchAddressList: function fetchAddressList() {
            var _this2 = this;

            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            setTimeout(function () {
                _this2.axios.get('/address/list?limit=500').then(function (res) {
                    _this2.addressList = res.data.data;

                    // If address exists then this was called from the address modal response
                    if (address !== null) {
                        // We found the newly saved address
                        if (_this2.addressList.length > 0) {
                            for (var i in _this2.addressList) {
                                if (_this2.addressList[i].id === address.id) {
                                    _this2.selected.shipping = _this2.addressList[i];
                                }
                            }
                            $('.o_blind').removeAttr('disabled');
                            _this2.fetchShippingOptions();

                            // Address still not saved, try again but delay a little
                        } else {
                            _this2.fetchAddressList(address, timeout + 500);
                        }
                    }
                }).catch(function (err) {
                    Helpers.errorPop('Error', err);
                });
            }, timeout);
        },
        checkProceed: function checkProceed() {
            if (this.proceed) {
                this.$emit('next');
            }
            return false;
        },
        checkProgress: function checkProgress(current, $event) {
            if (current === 'name' && $event.target.value.length > 0) {
                $('.o_turnaround').removeAttr('disabled');
            } else if (current === 'turnaround') {
                $('.o_shipping').removeAttr('disabled');
                if (this.selected.shipping) {
                    this.fetchShippingOptions();
                }
            } else if (current === 'shipping') {
                if ($event.target.value === 'new') {
                    // Popup Shipping Modal
                    this.$modal.show('AddressModal');
                } else {
                    $('.o_blind').removeAttr('disabled');
                    this.fetchShippingOptions();
                }
            } else if (current === 'method') {}

            if (this.selected.name !== null && this.selected.turnaround !== null && this.selected.shipping !== null && this.selected.method !== null) {
                this.proceed = true;
            } else {
                this.proceed = false;
            }
        },
        checkShipping: function checkShipping() {
            if (this.selected.method.group_with_cart) {
                this.shippingNote = 'This set qualifies for group shipping with set ' + this.selected.method.group_with_set + '.<br>Group shipping total will show in the cart.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>';
            } else if (this.selected.method.total_sets > 0) {
                this.shippingNote = 'This set does not qualify for group shipping.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>';
            } else {
                this.shippingNote = null;
            }
        },
        fetchShippingOptions: function fetchShippingOptions() {
            var _this3 = this;

            $('.o_method').attr('disabled', 'disabled');
            $('.o_method > option:first-child').text('Calculating..');
            this.selected.method = null;

            var data = {
                product: this.selected.product.id,
                runsize: this.selected.runsize,
                turnaround: this.selected.turnaround.uuid,
                turnaround_days: this.selected.turnaround.days,
                colorspec: this.selected.colorspec,
                options: this.selected.options,
                sets: '1',
                groupship: '0',
                address: this.selected.shipping.id,
                total: this.selected.product_cost,
                sub_id: '1'
            };

            this.axios.post('/products/shipping', data).then(function (res) {
                _this3.shippingOptions = res.data.data.shipping.job.facilities[0].shipping_options;

                // Inject production estimate and facility code
                for (var i in _this3.shippingOptions) {
                    _this3.shippingOptions[i].facility = res.data.data.shipping.job.facilities[0].address.code;
                    _this3.shippingOptions[i].prod_estimate = res.data.data.shipping.job.facilities[0].production_estimate;

                    if (_this3.shippingOptions[i].group_with_cart) {
                        _this3.shippingNote = 'This set qualifies for group shipping with set ' + _this3.shippingOptions[i].group_with_set + '.<br>Group shipping total will show in the cart.<br><a href="https://support.primoprint.com/shipping/shipping-information" target="_blank">Learn More &gt;</a>';
                    }
                }
                $('.o_method').removeAttr('disabled');
                $('.o_method > option:first-child').text('Please Select');
            }).catch(function (err) {
                Helpers.errorPop('Error', err);
            });
        },
        shippingTotal: function shippingTotal() {
            var total = 0;
            if (this.selected.turnaround && this.selected.turnaround.price) {
                total += parseFloat(this.selected.turnaround.price);
            }
            if (this.selected.method && this.selected.method.service_price) {
                total += parseFloat(this.selected.method.service_price);
            }

            if (this.selected.method && this.selected.method.group_with_cart) {
                return null;
            } else {
                return total.toFixed(2);
            }
        },
        printAddress: function printAddress(address) {
            if (address) {
                var response = '';
                response += address.name ? address.name + '<br />' : '';
                response += address.company ? address.company + '<br />' : '';
                response += address.address1 ? address.address1 + '<br />' : '';
                response += address.address2 ? address.address2 + '<br />' : '';
                response += address.city ? address.city + ', ' : '';
                response += address.state ? address.state + ' ' : '';
                response += address.zip ? address.zip : '';

                return response;
            }
        },


        updateAddressOptions: function updateAddressOptions(selected) {
            this.fetchAddressList(selected, 500);
            this.$modal.hide('AddressModal');
        },

        getShippingOptions: function getShippingOptions() {
            return this.shippingOptions;
        },
        showModal: function showModal(html) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
                html: '<div style="text-align: left;">' + html + '</div>',
                showCloseButton: false
            });
        }
    }
});

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b335fae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Helpers */


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AddressModal',
    components: { VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete___default.a },
    data: function data() {
        return {
            address: {
                default: {
                    title: '',
                    name: '',
                    company: '',
                    address1: '',
                    address2: '',
                    country: '',
                    city: '',
                    state: '',
                    zip: '',
                    phone: ''
                }
            },
            addressOptions: []
        };
    },

    props: {
        height: {
            default: 'auto'
        },
        width: {
            default: 800
        },
        scrollable: {
            default: true
        },
        adaptive: {
            default: true
        }
    },
    beforeMount: function beforeMount() {
        // this.files = this.$store.state.template.files
    },

    methods: {
        checkField: function checkField(field) {
            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (event === null || event !== null && event.type === 'focus') {
                $('label[for=' + field + ']').parent().addClass('active');
            } else if (event.target.value === '') {
                $('label[for=' + field + ']').parent().removeClass('active');
            }
        },
        filterStates: function filterStates(event) {
            var country = event.target.value;
            $('select.newState option').each(function () {
                if ($(this).attr('data-country') !== country && $(this).attr('data-country') !== undefined) {
                    $(this).wrap('<span class="toggleOption" style="display: none;"></span>');
                } else if ($(this).attr('data-country') === country && $(this).parent().is('span')) {
                    $(this).unwrap();
                }
            });
        },

        updateAddress: function updateAddress(addressData, placeResultData, id) {
            this.address.state = addressData.administrative_area_level_1;
            this.address.address1 = addressData.street_number + ' ' + addressData.route;
            this.address.zip = addressData.postal_code;
            this.address.city = addressData.locality;

            if (addressData.country === 'United States') {
                this.address.country = 'US';
            } else if (addressData.country === 'Canada') {
                this.address.country = 'CA';
            }

            $('input[name="address1"]').parent().addClass('active');
            $('input[name="city"]').parent().addClass('active');
            $('input[name="state"]').parent().addClass('active');
            $('input[name="zip"]').parent().addClass('active');
            $('input[name="country"]').parent().addClass('active');

            $('.addressSearch').hide();
            $('.addressDetails').slideDown('fast');

            this.$forceUpdate();
        },
        expandAddress: function expandAddress() {
            $('.addressSearch').hide();
            $('.addressDetails').slideDown('fast');
        },
        selectAddress: function selectAddress(selected) {
            var _this = this;

            var address = {
                label: this.address.title,
                name: this.address.name,
                company: this.address.company,
                address1: selected.address1,
                address2: selected.address2 ? selected.address2 : '',
                city: selected.city,
                state: selected.state,
                zip: selected.zip,
                country: selected.country,
                phone: this.address.phone
                // Save address
            };this.axios.post('/address/create', address).then(function (res) {
                _this.$emit('addressSaved', res.data.data);
            }).catch(function (err) {
                Helpers.errorPop('Error', err);
            });
        },
        confirmRequired: function confirmRequired() {
            var _this2 = this;

            if (this.address.title === '' || this.address.address1 === '' || this.address.city === '' || this.address.zip === '' || this.address.phone === '' || this.address.title === undefined || this.address.address1 === undefined || this.address.city === undefined || this.address.zip === undefined || this.address.phone === undefined) {
                Helpers.errorPop('Error', 'Please fill in all required fields.');
            } else {
                this.axios.post('/address/verify', this.address).then(function (res) {
                    _this2.addressOptions = res.data.data.addresses;
                    $('.enterAddress').slideUp('fast');
                    $('.selectAddress').slideDown('fast');
                }).catch(function (err) {
                    Helpers.errorPop('Error', err);
                });
            }
        }
    }
});

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(355),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_COMPONENTS = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'county',
    country: 'long_name',
    postal_code: 'short_name'
};

var CITIES_TYPE = ['locality', 'administrative_area_level_3'];
var REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueGoogleAutocomplete',

    props: {
        id: {
            type: String,
            required: true
        },

        classname: String,

        placeholder: {
            type: String,
            default: 'Start typing'
        },

        types: {
            type: String,
            default: 'address'
        },

        country: {
            type: [String, Array],
            default: null
        },

        enableGeolocation: {
            type: Boolean,
            default: false
        },

        geolocationOptions: {
            type: Object,
            default: null
        }
    },

    data: function data() {
        return {
            /**
             * The Autocomplete object.
             *
             * @type {Autocomplete}
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,

            /**
             * Autocomplete input text
             * @type {String}
             */
            autocompleteText: '',

            geolocation: {
                /**
                 * Google Geocoder Objet
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,

                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,

                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            }
        };
    },


    watch: {
        autocompleteText: function autocompleteText(newVal, oldVal) {
            this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
        },
        country: function country(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },

    mounted: function mounted() {
        var options = {};

        if (this.types) {
            options.types = [this.types];
        }

        if (this.country) {
            options.componentRestrictions = {
                country: this.country
            };
        }

        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },

    methods: {
        /**
         * When a place changed
         */
        onPlaceChanged: function onPlaceChanged() {
            var place = this.autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                // return returnData object and PlaceResult object
                this.$emit('placechanged', this.formatResult(place), place, this.id);

                // update autocompleteText then emit change event
                this.autocompleteText = document.getElementById(this.id).value;
                this.onChange();
            }
        },


        /**
         * When the input gets focus
         */
        onFocus: function onFocus() {
            this.biasAutocompleteLocation();
            this.$emit('focus');
        },


        /**
         * When the input loses focus
         */
        onBlur: function onBlur() {
            this.$emit('blur');
        },


        /**
         * When the input got changed
         */
        onChange: function onChange() {
            this.$emit('change', this.autocompleteText);
        },


        /**
         * When a key gets pressed
         * @param  {Event} event A keypress event
         */
        onKeyPress: function onKeyPress(event) {
            this.$emit('keypress', event);
        },


        /**
         * When a keyup occurs
         * @param  {Event} event A keyup event
         */
        onKeyUp: function onKeyUp(event) {
            this.$emit('keyup', event);
        },


        /**
         * Clear the input
         */
        clear: function clear() {
            this.autocompleteText = '';
        },


        /**
         * Focus the input
         */
        focus: function focus() {
            this.$refs.autocomplete.focus();
        },


        /**
         * Blur the input
         */
        blur: function blur() {
            this.$refs.autocomplete.blur();
        },


        /**
         * Update the value of the input
         * @param  {String} value
         */
        update: function update(value) {
            this.autocompleteText = value;
        },


        /**
         * Update the coordinates of the input
         * @param  {Coordinates} value
         */
        updateCoordinates: function updateCoordinates(value) {
            var _this = this;

            if (!value && !(value.lat || value.lng)) return;
            if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder();
            this.geolocation.geocoder.geocode({ 'location': value }, function (results, status) {
                if (status === 'OK') {
                    results = _this.filterGeocodeResultTypes(results);
                    if (results[0]) {
                        _this.$emit('placechanged', _this.formatResult(results[0]), results[0], _this.id);
                        _this.update(results[0].formatted_address);
                    } else {
                        _this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    _this.$emit('error', 'error getting address from coords');
                }
            });
        },


        /**
         * Update location based on navigator geolocation
         */
        geolocate: function geolocate() {
            var _this2 = this;

            this.updateGeolocation(function (geolocation, position) {
                _this2.updateCoordinates(geolocation);
            });
        },


        /**
         * Update internal location from navigator geolocation
         * @param  {Function} (geolocation, position)
         */
        updateGeolocation: function updateGeolocation() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (navigator.geolocation) {
                var options = {};
                if (this.geolocationOptions) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, this.geolocationOptions);
                navigator.geolocation.getCurrentPosition(function (position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this3.geolocation.loc = geolocation;
                    _this3.geolocation.position = position;

                    if (callback) callback(geolocation, position);
                }, function (err) {
                    _this3.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },


        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation: function biasAutocompleteLocation() {
            var _this4 = this;

            if (this.enableGeolocation) {
                this.updateGeolocation(function (geolocation, position) {
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    _this4.autocomplete.setBounds(circle.getBounds());
                });
            }
        },


        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function formatResult(place) {
            var returnData = {};
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }

            returnData['latitude'] = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();
            return returnData;
        },


        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes: function filterGeocodeResultTypes(results) {
            if (!results || !this.types) return results;
            var output = [];
            var types = [this.types];
            if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
            if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var t = _step2.value;

                            if (types.includes(t)) {
                                output.push(r);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return output;
        }
    }
});

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocompleteText),
      expression: "autocompleteText"
    }],
    ref: "autocomplete",
    class: _vm.classname,
    attrs: {
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.autocompleteText)
    },
    on: {
      "focus": function($event) {
        _vm.onFocus()
      },
      "blur": function($event) {
        _vm.onBlur()
      },
      "change": _vm.onChange,
      "keypress": _vm.onKeyPress,
      "keyup": _vm.onKeyUp,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocompleteText = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modalPop",
    attrs: {
      "name": "AddressModal",
      "adaptive": _vm.adaptive,
      "scrollable": _vm.scrollable,
      "height": _vm.height,
      "width": _vm.width
    }
  }, [_c('h1', [_vm._v("Add New Address")]), _vm._v(" "), _c('ul', {
    staticClass: "enterAddress"
  }, [_c('li', {
    staticClass: "group row m-b-5"
  }, [_c('h2', [_vm._v("Address Book Title (for your reference only)")])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField"
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Descriptive Title *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.title),
      expression: "address.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.address.title)
    },
    on: {
      "change": function($event) {
        _vm.checkField('title', $event)
      },
      "focus": function($event) {
        _vm.checkField('title', $event)
      },
      "blur": function($event) {
        _vm.checkField('title', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5"
  }, [_c('h2', [_vm._v("Address Information")])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("First & Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.name),
      expression: "address.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.address.name)
    },
    on: {
      "change": function($event) {
        _vm.checkField('name', $event)
      },
      "focus": function($event) {
        _vm.checkField('name', $event)
      },
      "blur": function($event) {
        _vm.checkField('name', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField"
  }, [_c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.company),
      expression: "address.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "company"
    },
    domProps: {
      "value": (_vm.address.company)
    },
    on: {
      "change": function($event) {
        _vm.checkField('company', $event)
      },
      "focus": function($event) {
        _vm.checkField('company', $event)
      },
      "blur": function($event) {
        _vm.checkField('company', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "company", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 addressSearch"
  }, [_c('h2', [_vm._v("Address Search")]), _vm._v(" "), _c('p', [_vm._v("Search your address below, if no appropriate results are"), _c('br'), _vm._v("found press enter to manually enter your address")])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-10 textField addressSearch"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address *")]), _vm._v(" "), _c('vue-google-autocomplete', {
    attrs: {
      "id": "map",
      "classname": "form-control",
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        _vm.checkField('address')
      },
      "focus": function($event) {
        _vm.checkField('address')
      },
      "blur": function($event) {
        _vm.checkField('address')
      },
      "placechanged": _vm.updateAddress,
      "no-results-found": _vm.expandAddress
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "address1"
    }
  }, [_vm._v("Address 1 *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.address1),
      expression: "address.address1"
    }],
    staticClass: "form-control address1",
    attrs: {
      "type": "text",
      "name": "address1"
    },
    domProps: {
      "value": (_vm.address.address1)
    },
    on: {
      "change": function($event) {
        _vm.checkField('address1', $event)
      },
      "focus": function($event) {
        _vm.checkField('address1', $event)
      },
      "blur": function($event) {
        _vm.checkField('address1', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "address1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "address2"
    }
  }, [_vm._v("Address 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.address2),
      expression: "address.address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "address2"
    },
    domProps: {
      "value": (_vm.address.address2)
    },
    on: {
      "change": function($event) {
        _vm.checkField('address2', $event)
      },
      "focus": function($event) {
        _vm.checkField('address2', $event)
      },
      "blur": function($event) {
        _vm.checkField('address2', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "address2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 selectField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "country"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.country),
      expression: "address.country"
    }],
    staticClass: "form-control left newCountry",
    attrs: {
      "name": "country",
      "data-stripe": "address_country"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.filterStates($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please Select")]), _c('option', {
    attrs: {
      "value": "US"
    }
  }, [_vm._v("United States")]), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("Canada")]), _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("-----------------------------")]), _c('option', {
    attrs: {
      "value": "AF"
    }
  }, [_vm._v("Afghanistan")]), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("Albania")]), _c('option', {
    attrs: {
      "value": "DZ"
    }
  }, [_vm._v("Algeria")]), _c('option', {
    attrs: {
      "value": "AS"
    }
  }, [_vm._v("American Samoa")]), _c('option', {
    attrs: {
      "value": "AD"
    }
  }, [_vm._v("Andorra")]), _c('option', {
    attrs: {
      "value": "AO"
    }
  }, [_vm._v("Angola")]), _c('option', {
    attrs: {
      "value": "AI"
    }
  }, [_vm._v("Anguilla")]), _c('option', {
    attrs: {
      "value": "AQ"
    }
  }, [_vm._v("Antarctica")]), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v("Antigua and Barbuda")]), _c('option', {
    attrs: {
      "value": "AR"
    }
  }, [_vm._v("Argentina")]), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("Armenia")]), _c('option', {
    attrs: {
      "value": "AW"
    }
  }, [_vm._v("Aruba")]), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia")]), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria")]), _c('option', {
    attrs: {
      "value": "AZ"
    }
  }, [_vm._v("Azerbaijan")]), _c('option', {
    attrs: {
      "value": "BS"
    }
  }, [_vm._v("Bahamas")]), _c('option', {
    attrs: {
      "value": "BH"
    }
  }, [_vm._v("Bahrain")]), _c('option', {
    attrs: {
      "value": "BD"
    }
  }, [_vm._v("Bangladesh")]), _c('option', {
    attrs: {
      "value": "BB"
    }
  }, [_vm._v("Barbados")]), _c('option', {
    attrs: {
      "value": "BY"
    }
  }, [_vm._v("Belarus")]), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium")]), _c('option', {
    attrs: {
      "value": "BZ"
    }
  }, [_vm._v("Belize")]), _c('option', {
    attrs: {
      "value": "BJ"
    }
  }, [_vm._v("Benin")]), _c('option', {
    attrs: {
      "value": "BM"
    }
  }, [_vm._v("Bermuda")]), _c('option', {
    attrs: {
      "value": "BT"
    }
  }, [_vm._v("Bhutan")]), _c('option', {
    attrs: {
      "value": "BO"
    }
  }, [_vm._v("Bolivia")]), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina")]), _c('option', {
    attrs: {
      "value": "BW"
    }
  }, [_vm._v("Botswana")]), _c('option', {
    attrs: {
      "value": "BV"
    }
  }, [_vm._v("Bouvet Island")]), _c('option', {
    attrs: {
      "value": "BR"
    }
  }, [_vm._v("Brazil")]), _c('option', {
    attrs: {
      "value": "IO"
    }
  }, [_vm._v("British Indian Ocean Territory")]), _c('option', {
    attrs: {
      "value": "VG"
    }
  }, [_vm._v("British Virgin Islands")]), _c('option', {
    attrs: {
      "value": "BN"
    }
  }, [_vm._v("Brunei Darussalam")]), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria")]), _c('option', {
    attrs: {
      "value": "BF"
    }
  }, [_vm._v("Burkina Faso")]), _c('option', {
    attrs: {
      "value": "BI"
    }
  }, [_vm._v("Burundi")]), _c('option', {
    attrs: {
      "value": "KH"
    }
  }, [_vm._v("Cambodia")]), _c('option', {
    attrs: {
      "value": "CM"
    }
  }, [_vm._v("Cameroon")]), _c('option', {
    attrs: {
      "value": "CV"
    }
  }, [_vm._v("Cape Verde")]), _c('option', {
    attrs: {
      "value": "KY"
    }
  }, [_vm._v("Cayman Islands")]), _c('option', {
    attrs: {
      "value": "CF"
    }
  }, [_vm._v("Central African Republic")]), _c('option', {
    attrs: {
      "value": "TD"
    }
  }, [_vm._v("Chad")]), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile")]), _c('option', {
    attrs: {
      "value": "CN"
    }
  }, [_vm._v("China")]), _c('option', {
    attrs: {
      "value": "CX"
    }
  }, [_vm._v("Christmas Island")]), _c('option', {
    attrs: {
      "value": "CC"
    }
  }, [_vm._v("Cocos")]), _c('option', {
    attrs: {
      "value": "CO"
    }
  }, [_vm._v("Colombia")]), _c('option', {
    attrs: {
      "value": "KM"
    }
  }, [_vm._v("Comoros")]), _c('option', {
    attrs: {
      "value": "CG"
    }
  }, [_vm._v("Congo")]), _c('option', {
    attrs: {
      "value": "CK"
    }
  }, [_vm._v("Cook Islands")]), _c('option', {
    attrs: {
      "value": "CR"
    }
  }, [_vm._v("Costa Rica")]), _c('option', {
    attrs: {
      "value": "HR"
    }
  }, [_vm._v("Croatia")]), _c('option', {
    attrs: {
      "value": "CU"
    }
  }, [_vm._v("Cuba")]), _c('option', {
    attrs: {
      "value": "CY"
    }
  }, [_vm._v("Cyprus")]), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech Republic")]), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Denmark")]), _c('option', {
    attrs: {
      "value": "DJ"
    }
  }, [_vm._v("Djibouti")]), _c('option', {
    attrs: {
      "value": "DM"
    }
  }, [_vm._v("Dominica")]), _c('option', {
    attrs: {
      "value": "DO"
    }
  }, [_vm._v("Dominican Republic")]), _c('option', {
    attrs: {
      "value": "TP"
    }
  }, [_vm._v("East Timor")]), _c('option', {
    attrs: {
      "value": "EC"
    }
  }, [_vm._v("Ecuador")]), _c('option', {
    attrs: {
      "value": "EG"
    }
  }, [_vm._v("Egypt")]), _c('option', {
    attrs: {
      "value": "SV"
    }
  }, [_vm._v("El Salvador")]), _c('option', {
    attrs: {
      "value": "GQ"
    }
  }, [_vm._v("Equatorial Guinea")]), _c('option', {
    attrs: {
      "value": "ER"
    }
  }, [_vm._v("Eritrea")]), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia")]), _c('option', {
    attrs: {
      "value": "ET"
    }
  }, [_vm._v("Ethiopia")]), _c('option', {
    attrs: {
      "value": "FK"
    }
  }, [_vm._v("Falkland Islands")]), _c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v("Faroe Islands")]), _c('option', {
    attrs: {
      "value": "FJ"
    }
  }, [_vm._v("Fiji")]), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Finland")]), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France")]), _c('option', {
    attrs: {
      "value": "GF"
    }
  }, [_vm._v("French Guiana")]), _c('option', {
    attrs: {
      "value": "PF"
    }
  }, [_vm._v("French Polynesia")]), _c('option', {
    attrs: {
      "value": "TF"
    }
  }, [_vm._v("French Southern Territories")]), _c('option', {
    attrs: {
      "value": "GA"
    }
  }, [_vm._v("Gabon")]), _c('option', {
    attrs: {
      "value": "GM"
    }
  }, [_vm._v("Gambia")]), _c('option', {
    attrs: {
      "value": "GE"
    }
  }, [_vm._v("Georgia")]), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Germany")]), _c('option', {
    attrs: {
      "value": "GH"
    }
  }, [_vm._v("Ghana")]), _c('option', {
    attrs: {
      "value": "GI"
    }
  }, [_vm._v("Gibraltar")]), _c('option', {
    attrs: {
      "value": "GR"
    }
  }, [_vm._v("Greece")]), _c('option', {
    attrs: {
      "value": "GL"
    }
  }, [_vm._v("Greenland")]), _c('option', {
    attrs: {
      "value": "GD"
    }
  }, [_vm._v("Grenada")]), _c('option', {
    attrs: {
      "value": "GP"
    }
  }, [_vm._v("Guadeloupe")]), _c('option', {
    attrs: {
      "value": "GU"
    }
  }, [_vm._v("Guam")]), _c('option', {
    attrs: {
      "value": "GT"
    }
  }, [_vm._v("Guatemala")]), _c('option', {
    attrs: {
      "value": "GN"
    }
  }, [_vm._v("Guinea")]), _c('option', {
    attrs: {
      "value": "GW"
    }
  }, [_vm._v("Guinea-Bissau")]), _c('option', {
    attrs: {
      "value": "GY"
    }
  }, [_vm._v("Guyana")]), _c('option', {
    attrs: {
      "value": "HT"
    }
  }, [_vm._v("Haiti")]), _c('option', {
    attrs: {
      "value": "HM"
    }
  }, [_vm._v("Heard and McDonald Islands")]), _c('option', {
    attrs: {
      "value": "HN"
    }
  }, [_vm._v("Honduras")]), _c('option', {
    attrs: {
      "value": "HK"
    }
  }, [_vm._v("Hong Kong")]), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Hungary")]), _c('option', {
    attrs: {
      "value": "IS"
    }
  }, [_vm._v("Iceland")]), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India")]), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia")]), _c('option', {
    attrs: {
      "value": "IR"
    }
  }, [_vm._v("Iran")]), _c('option', {
    attrs: {
      "value": "IQ"
    }
  }, [_vm._v("Iraq")]), _c('option', {
    attrs: {
      "value": "IE"
    }
  }, [_vm._v("Ireland")]), _c('option', {
    attrs: {
      "value": "IL"
    }
  }, [_vm._v("Israel")]), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italy")]), _c('option', {
    attrs: {
      "value": "CI"
    }
  }, [_vm._v("Ivory Coast")]), _c('option', {
    attrs: {
      "value": "JM"
    }
  }, [_vm._v("Jamaica")]), _c('option', {
    attrs: {
      "value": "JP"
    }
  }, [_vm._v("Japan")]), _c('option', {
    attrs: {
      "value": "JO"
    }
  }, [_vm._v("Jordan")]), _c('option', {
    attrs: {
      "value": "KZ"
    }
  }, [_vm._v("Kazakhstan")]), _c('option', {
    attrs: {
      "value": "KE"
    }
  }, [_vm._v("Kenya")]), _c('option', {
    attrs: {
      "value": "KI"
    }
  }, [_vm._v("Kiribati")]), _c('option', {
    attrs: {
      "value": "KW"
    }
  }, [_vm._v("Kuwait")]), _c('option', {
    attrs: {
      "value": "KG"
    }
  }, [_vm._v("Kyrgyzstan")]), _c('option', {
    attrs: {
      "value": "LA"
    }
  }, [_vm._v("Laos")]), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia")]), _c('option', {
    attrs: {
      "value": "LB"
    }
  }, [_vm._v("Lebanon")]), _c('option', {
    attrs: {
      "value": "LS"
    }
  }, [_vm._v("Lesotho")]), _c('option', {
    attrs: {
      "value": "LR"
    }
  }, [_vm._v("Liberia")]), _c('option', {
    attrs: {
      "value": "LY"
    }
  }, [_vm._v("Libya")]), _c('option', {
    attrs: {
      "value": "LI"
    }
  }, [_vm._v("Liechtenstein")]), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania")]), _c('option', {
    attrs: {
      "value": "LU"
    }
  }, [_vm._v("Luxembourg")]), _c('option', {
    attrs: {
      "value": "MO"
    }
  }, [_vm._v("Macau")]), _c('option', {
    attrs: {
      "value": "MK"
    }
  }, [_vm._v("Macedonia")]), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("Madagascar")]), _c('option', {
    attrs: {
      "value": "MW"
    }
  }, [_vm._v("Malawi")]), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia")]), _c('option', {
    attrs: {
      "value": "MV"
    }
  }, [_vm._v("Maldives")]), _c('option', {
    attrs: {
      "value": "ML"
    }
  }, [_vm._v("Mali")]), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("Malta")]), _c('option', {
    attrs: {
      "value": "MH"
    }
  }, [_vm._v("Marshall Islands")]), _c('option', {
    attrs: {
      "value": "MQ"
    }
  }, [_vm._v("Martinique")]), _c('option', {
    attrs: {
      "value": "MR"
    }
  }, [_vm._v("Mauritania")]), _c('option', {
    attrs: {
      "value": "MU"
    }
  }, [_vm._v("Mauritius")]), _c('option', {
    attrs: {
      "value": "YT"
    }
  }, [_vm._v("Mayotte")]), _c('option', {
    attrs: {
      "value": "MX"
    }
  }, [_vm._v("Mexico")]), _c('option', {
    attrs: {
      "value": "FM"
    }
  }, [_vm._v("Micronesia")]), _c('option', {
    attrs: {
      "value": "MD"
    }
  }, [_vm._v("Moldova")]), _c('option', {
    attrs: {
      "value": "MC"
    }
  }, [_vm._v("Monaco")]), _c('option', {
    attrs: {
      "value": "MN"
    }
  }, [_vm._v("Mongolia")]), _c('option', {
    attrs: {
      "value": "ME"
    }
  }, [_vm._v("Montenegro")]), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Montserrat")]), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("Morocco")]), _c('option', {
    attrs: {
      "value": "MZ"
    }
  }, [_vm._v("Mozambique")]), _c('option', {
    attrs: {
      "value": "MM"
    }
  }, [_vm._v("Myanmar")]), _c('option', {
    attrs: {
      "value": "NA"
    }
  }, [_vm._v("Namibia")]), _c('option', {
    attrs: {
      "value": "NR"
    }
  }, [_vm._v("Nauru")]), _c('option', {
    attrs: {
      "value": "NP"
    }
  }, [_vm._v("Nepal")]), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Netherlands")]), _c('option', {
    attrs: {
      "value": "AN"
    }
  }, [_vm._v("Netherlands Antilles")]), _c('option', {
    attrs: {
      "value": "NC"
    }
  }, [_vm._v("New Caledonia")]), _c('option', {
    attrs: {
      "value": "NZ"
    }
  }, [_vm._v("New Zealand")]), _c('option', {
    attrs: {
      "value": "NI"
    }
  }, [_vm._v("Nicaragua")]), _c('option', {
    attrs: {
      "value": "NE"
    }
  }, [_vm._v("Niger")]), _c('option', {
    attrs: {
      "value": "NG"
    }
  }, [_vm._v("Nigeria")]), _c('option', {
    attrs: {
      "value": "NU"
    }
  }, [_vm._v("Niue")]), _c('option', {
    attrs: {
      "value": "NF"
    }
  }, [_vm._v("Norfolk Island")]), _c('option', {
    attrs: {
      "value": "KP"
    }
  }, [_vm._v("North Korea")]), _c('option', {
    attrs: {
      "value": "MP"
    }
  }, [_vm._v("Northern Mariana Islands")]), _c('option', {
    attrs: {
      "value": "NO"
    }
  }, [_vm._v("Norway")]), _c('option', {
    attrs: {
      "value": "OM"
    }
  }, [_vm._v("Oman")]), _c('option', {
    attrs: {
      "value": "PK"
    }
  }, [_vm._v("Pakistan")]), _c('option', {
    attrs: {
      "value": "PW"
    }
  }, [_vm._v("Palau")]), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("Panama")]), _c('option', {
    attrs: {
      "value": "PG"
    }
  }, [_vm._v("Papua New Guinea")]), _c('option', {
    attrs: {
      "value": "PY"
    }
  }, [_vm._v("Paraguay")]), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("Peru")]), _c('option', {
    attrs: {
      "value": "PH"
    }
  }, [_vm._v("Philippines")]), _c('option', {
    attrs: {
      "value": "PN"
    }
  }, [_vm._v("Pitcairn")]), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Poland")]), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal")]), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("Puerto Rico")]), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar")]), _c('option', {
    attrs: {
      "value": "RE"
    }
  }, [_vm._v("Reunion")]), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("Romania")]), _c('option', {
    attrs: {
      "value": "RU"
    }
  }, [_vm._v("Russian Federation")]), _c('option', {
    attrs: {
      "value": "RW"
    }
  }, [_vm._v("Rwanda")]), _c('option', {
    attrs: {
      "value": "GS"
    }
  }, [_vm._v("S. Georgia and S. Sandwich Islands")]), _c('option', {
    attrs: {
      "value": "KN"
    }
  }, [_vm._v("Saint Kitts and Nevis")]), _c('option', {
    attrs: {
      "value": "LC"
    }
  }, [_vm._v("Saint Lucia")]), _c('option', {
    attrs: {
      "value": "VC"
    }
  }, [_vm._v("Saint Vincent and The Grenadines")]), _c('option', {
    attrs: {
      "value": "WS"
    }
  }, [_vm._v("Samoa")]), _c('option', {
    attrs: {
      "value": "SM"
    }
  }, [_vm._v("San Marino")]), _c('option', {
    attrs: {
      "value": "ST"
    }
  }, [_vm._v("Sao Tome and Principe")]), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi Arabia")]), _c('option', {
    attrs: {
      "value": "SN"
    }
  }, [_vm._v("Senegal")]), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("Serbia")]), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("Seychelles")]), _c('option', {
    attrs: {
      "value": "SL"
    }
  }, [_vm._v("Sierra Leone")]), _c('option', {
    attrs: {
      "value": "SG"
    }
  }, [_vm._v("Singapore")]), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovakia")]), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia")]), _c('option', {
    attrs: {
      "value": "SB"
    }
  }, [_vm._v("Solomon Islands")]), _c('option', {
    attrs: {
      "value": "SO"
    }
  }, [_vm._v("Somalia")]), _c('option', {
    attrs: {
      "value": "ZA"
    }
  }, [_vm._v("South Africa")]), _c('option', {
    attrs: {
      "value": "KR"
    }
  }, [_vm._v("South Korea")]), _c('option', {
    attrs: {
      "value": "SU"
    }
  }, [_vm._v("Soviet Union")]), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("Spain")]), _c('option', {
    attrs: {
      "value": "LK"
    }
  }, [_vm._v("Sri Lanka")]), _c('option', {
    attrs: {
      "value": "SH"
    }
  }, [_vm._v("St. Helena")]), _c('option', {
    attrs: {
      "value": "PM"
    }
  }, [_vm._v("St. Pierre and Miquelon")]), _c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("Sudan")]), _c('option', {
    attrs: {
      "value": "SR"
    }
  }, [_vm._v("Suriname")]), _c('option', {
    attrs: {
      "value": "SJ"
    }
  }, [_vm._v("Svalbard and Jan Mayen Islands")]), _c('option', {
    attrs: {
      "value": "SZ"
    }
  }, [_vm._v("Swaziland")]), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sweden")]), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland")]), _c('option', {
    attrs: {
      "value": "SY"
    }
  }, [_vm._v("Syria")]), _c('option', {
    attrs: {
      "value": "TW"
    }
  }, [_vm._v("Taiwan")]), _c('option', {
    attrs: {
      "value": "TJ"
    }
  }, [_vm._v("Tajikistan")]), _c('option', {
    attrs: {
      "value": "TZ"
    }
  }, [_vm._v("Tanzania")]), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand")]), _c('option', {
    attrs: {
      "value": "TG"
    }
  }, [_vm._v("Togo")]), _c('option', {
    attrs: {
      "value": "TK"
    }
  }, [_vm._v("Tokelau")]), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("Tonga")]), _c('option', {
    attrs: {
      "value": "TT"
    }
  }, [_vm._v("Trinidad and Tobago")]), _c('option', {
    attrs: {
      "value": "TN"
    }
  }, [_vm._v("Tunisia")]), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey")]), _c('option', {
    attrs: {
      "value": "TM"
    }
  }, [_vm._v("Turkmenistan")]), _c('option', {
    attrs: {
      "value": "TC"
    }
  }, [_vm._v("Turks and Caicos Islands")]), _c('option', {
    attrs: {
      "value": "TV"
    }
  }, [_vm._v("Tuvalu")]), _c('option', {
    attrs: {
      "value": "UG"
    }
  }, [_vm._v("Uganda")]), _c('option', {
    attrs: {
      "value": "UA"
    }
  }, [_vm._v("Ukraine")]), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab Emirates")]), _c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom")]), _c('option', {
    attrs: {
      "value": "UY"
    }
  }, [_vm._v("Uruguay")]), _c('option', {
    attrs: {
      "value": "UM"
    }
  }, [_vm._v("US Minor Outlying Islands")]), _c('option', {
    attrs: {
      "value": "VI"
    }
  }, [_vm._v("US Virgin Islands")]), _c('option', {
    attrs: {
      "value": "UZ"
    }
  }, [_vm._v("Uzbekistan")]), _c('option', {
    attrs: {
      "value": "VU"
    }
  }, [_vm._v("Vanuatu")]), _c('option', {
    attrs: {
      "value": "VE"
    }
  }, [_vm._v("Venezuela")]), _c('option', {
    attrs: {
      "value": "VN"
    }
  }, [_vm._v("Viet Nam")]), _c('option', {
    attrs: {
      "value": "WF"
    }
  }, [_vm._v("Wallis and Futuna Islands")]), _c('option', {
    attrs: {
      "value": "EH"
    }
  }, [_vm._v("Western Sahara")]), _c('option', {
    attrs: {
      "value": "YE"
    }
  }, [_vm._v("Yemen")]), _c('option', {
    attrs: {
      "value": "ZR"
    }
  }, [_vm._v("Zaire")]), _c('option', {
    attrs: {
      "value": "ZM"
    }
  }, [_vm._v("Zambia")]), _c('option', {
    attrs: {
      "value": "ZW"
    }
  }, [_vm._v("Zimbabwe")])])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.city),
      expression: "address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.address.city)
    },
    on: {
      "change": function($event) {
        _vm.checkField('city', $event)
      },
      "focus": function($event) {
        _vm.checkField('city', $event)
      },
      "blur": function($event) {
        _vm.checkField('city', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 selectField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.state),
      expression: "address.state"
    }],
    staticClass: "form-control newState",
    attrs: {
      "name": "state",
      "data-stripe": "address_state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.address, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Please Select")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "AL"
    }
  }, [_vm._v("Alabama")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "AK"
    }
  }, [_vm._v("Alaska")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "AZ"
    }
  }, [_vm._v("Arizona")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "AR"
    }
  }, [_vm._v("Arkansas")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "CA"
    }
  }, [_vm._v("California")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "CO"
    }
  }, [_vm._v("Colorado")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "CT"
    }
  }, [_vm._v("Connecticut")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "DE"
    }
  }, [_vm._v("Delaware")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "DC"
    }
  }, [_vm._v("District of Columbia")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "FL"
    }
  }, [_vm._v("Florida")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "GA"
    }
  }, [_vm._v("Georgia")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "HI"
    }
  }, [_vm._v("Hawaii")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "ID"
    }
  }, [_vm._v("Idaho")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "IL"
    }
  }, [_vm._v("Illinois")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "IN"
    }
  }, [_vm._v("Indiana")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "IA"
    }
  }, [_vm._v("Iowa")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "KS"
    }
  }, [_vm._v("Kansas")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "KY"
    }
  }, [_vm._v("Kentucky")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "LA"
    }
  }, [_vm._v("Louisiana")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "ME"
    }
  }, [_vm._v("Maine")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MD"
    }
  }, [_vm._v("Maryland")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MA"
    }
  }, [_vm._v("Massachusetts")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MI"
    }
  }, [_vm._v("Michigan")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MN"
    }
  }, [_vm._v("Minnesota")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MS"
    }
  }, [_vm._v("Mississippi")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MO"
    }
  }, [_vm._v("Missouri")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "MT"
    }
  }, [_vm._v("Montana")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NE"
    }
  }, [_vm._v("Nebraska")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NV"
    }
  }, [_vm._v("Nevada")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NH"
    }
  }, [_vm._v("New Hampshire")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NJ"
    }
  }, [_vm._v("New Jersey")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NM"
    }
  }, [_vm._v("New Mexico")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NY"
    }
  }, [_vm._v("New York")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "NC"
    }
  }, [_vm._v("North Carolina")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "ND"
    }
  }, [_vm._v("North Dakota")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "OH"
    }
  }, [_vm._v("Ohio")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "OK"
    }
  }, [_vm._v("Oklahoma")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "OR"
    }
  }, [_vm._v("Oregon")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "PA"
    }
  }, [_vm._v("Pennsylvania")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "RI"
    }
  }, [_vm._v("Rhode Island")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "SC"
    }
  }, [_vm._v("South Carolina")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "SD"
    }
  }, [_vm._v("South Dakota")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "TN"
    }
  }, [_vm._v("Tennessee")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "TX"
    }
  }, [_vm._v("Texas")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "UT"
    }
  }, [_vm._v("Utah")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "VT"
    }
  }, [_vm._v("Vermont")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "VA"
    }
  }, [_vm._v("Virginia")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "WA"
    }
  }, [_vm._v("Washington")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "WV"
    }
  }, [_vm._v("West Virginia")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "WI"
    }
  }, [_vm._v("Wisconsin")]), _c('option', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-country": "US",
      "value": "WY"
    }
  }, [_vm._v("Wyoming")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "NT"
    }
  }, [_vm._v("NT")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "SA"
    }
  }, [_vm._v("SA")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "WA"
    }
  }, [_vm._v("WA")]), _c('option', {
    attrs: {
      "data-country": "AU",
      "value": "NZ"
    }
  }, [_vm._v("NZ")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "AB"
    }
  }, [_vm._v("Alberta")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "BC"
    }
  }, [_vm._v("British Columbia")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "MB"
    }
  }, [_vm._v("Manitoba")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "NB"
    }
  }, [_vm._v("New Brunswick")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "NL"
    }
  }, [_vm._v("Newfoundland")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "NT"
    }
  }, [_vm._v("Northwest Territories")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "NS"
    }
  }, [_vm._v("Nova Scotia")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "NU"
    }
  }, [_vm._v("Nunavut")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "ON"
    }
  }, [_vm._v("Ontario")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "PE"
    }
  }, [_vm._v("Prince Edward Island")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "QC"
    }
  }, [_vm._v("Quebec")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "SK"
    }
  }, [_vm._v("Saskatchewan")]), _c('option', {
    attrs: {
      "data-country": "CA",
      "value": "YT"
    }
  }, [_vm._v("Yukon")]), _c('option', {
    attrs: {
      "data-country": "PR",
      "value": "PR"
    }
  }, [_vm._v("Puerto Rico")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "AG"
    }
  }, [_vm._v("Aguascalientes")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "BC"
    }
  }, [_vm._v("Baja California")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "BS"
    }
  }, [_vm._v("Baja California Sur")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "CM"
    }
  }, [_vm._v("Campeche")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "CS"
    }
  }, [_vm._v("Chiapas")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "CH"
    }
  }, [_vm._v("Chihuahua")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "CO"
    }
  }, [_vm._v("Coahuila")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "CL"
    }
  }, [_vm._v("Colima")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "DF"
    }
  }, [_vm._v("Distrito Federal")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "DG"
    }
  }, [_vm._v("Durango")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "GT"
    }
  }, [_vm._v("Guanajuato")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "GR"
    }
  }, [_vm._v("Guerrero")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "HG"
    }
  }, [_vm._v("Hidalgo")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "JA"
    }
  }, [_vm._v("Jalisco")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "EM"
    }
  }, [_vm._v("Mexico")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "MH"
    }
  }, [_vm._v("Michoacan")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "MR"
    }
  }, [_vm._v("Morelos")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "NA"
    }
  }, [_vm._v("Nayarit")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "NL"
    }
  }, [_vm._v("Nuevo Leon")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "OA"
    }
  }, [_vm._v("Oaxaca")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "PU"
    }
  }, [_vm._v("Puebla")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "QA"
    }
  }, [_vm._v("Queretaro")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "QR"
    }
  }, [_vm._v("Quintana Roo")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "SL"
    }
  }, [_vm._v("San Luis Patosi")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "SI"
    }
  }, [_vm._v("Sinaloa")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "SO"
    }
  }, [_vm._v("Sonora")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "TA"
    }
  }, [_vm._v("Tabasco")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "TM"
    }
  }, [_vm._v("Tamaulipas")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "TL"
    }
  }, [_vm._v("Tlaxcala")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "VZ"
    }
  }, [_vm._v("Veracruz")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "YC"
    }
  }, [_vm._v("Yucatan")]), _c('option', {
    attrs: {
      "data-country": "MX",
      "value": "ZT"
    }
  }, [_vm._v("Zacatecas")])])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-5 textField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip Code *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.zip),
      expression: "address.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "zip"
    },
    domProps: {
      "value": (_vm.address.zip)
    },
    on: {
      "change": function($event) {
        _vm.checkField('zip', $event)
      },
      "focus": function($event) {
        _vm.checkField('zip', $event)
      },
      "blur": function($event) {
        _vm.checkField('zip', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "zip", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-10 textField addressDetails"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address.phone),
      expression: "address.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.address.phone)
    },
    on: {
      "change": function($event) {
        _vm.checkField('phone', $event)
      },
      "focus": function($event) {
        _vm.checkField('phone', $event)
      },
      "blur": function($event) {
        _vm.checkField('phone', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.address, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "m-b-10 addressDetails"
  }, [_c('label', {
    staticClass: "confirm"
  }, [_c('input', {
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v("\n                I understand that if the shipping address requires a suite, unit or apartment number it must be entered and visible in the address to assure delivery. Failure to do so may result in additional charges by UPS. Please note: UPS does not deliver to P.O. Boxes.\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "group row"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.confirmRequired()
      }
    }
  }, [_vm._v("Save Address")])])]), _vm._v(" "), _c('ul', {
    staticClass: "selectAddress"
  }, [_c('li', {
    staticClass: "group row m-b-5"
  }, [_c('h2', [_vm._v("Please Select Formatted Address")])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-10"
  }, [_c('p', [_vm._v("The addresses listed below are the validated addresses according to UPS, please review for accuracy and ensure that the address you select contains all of the required information (apartment, suite, floor number).")])]), _vm._v(" "), _vm._l((_vm.addressOptions), function(address, index) {
    return _c('li', {
      staticClass: "addressOption group row m-b-10"
    }, [_c('h3', [_vm._v("UPS Suggestion #1")]), _vm._v("\n            " + _vm._s(address.address1)), _c('br'), _vm._v("\n            " + _vm._s(address.city) + ", " + _vm._s(address.state) + " " + _vm._s(address.zip)), _c('br'), _vm._v("\n            " + _vm._s(address.country) + " - " + _vm._s(address.type)), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-block m-t-10",
      on: {
        "click": function($event) {
          _vm.selectAddress(address)
        }
      }
    }, [_vm._v("Select UPS Verified Address")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "addressOption group row"
  }, [_c('p', [_c('strong', [_vm._v("NOTICE:")]), _vm._v(" If you select your original address and it is undeliverable by UPS, you will be charged a return fee.")]), _vm._v(" "), _c('h4', [_vm._v("Original")]), _vm._v("\n            " + _vm._s(_vm.address.address1)), _c('br'), _vm._v(" "), (_vm.address.address2) ? _c('span', [_vm._v(_vm._s(_vm.address.address2))]) : _vm._e(), (_vm.address.address2) ? _c('br') : _vm._e(), _vm._v("\n            " + _vm._s(_vm.address.city) + ", " + _vm._s(_vm.address.state) + " " + _vm._s(_vm.address.zip)), _c('br'), _vm._v("\n            " + _vm._s(_vm.address.country)), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-grey btn-block m-t-10",
    on: {
      "click": function($event) {
        _vm.selectAddress(_vm.address)
      }
    }
  }, [_vm._v("Select Original Unverified Address")])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "group row m-b-20"
  }, [_c('label', {
    staticClass: "col-sm-5",
    attrs: {
      "for": "turnaround"
    }
  }, [_vm._v("\n            Job Name\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.name),
      expression: "selected.name"
    }],
    staticClass: "form-control job_name o_name",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selected.name)
    },
    on: {
      "keyup": function($event) {
        _vm.checkProgress('name', $event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selected, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-20"
  }, [_c('label', {
    staticClass: "col-sm-5",
    attrs: {
      "for": "turnaround"
    }
  }, [_vm._v("\n            Turnaround\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.turnaround),
      expression: "selected.turnaround"
    }],
    staticClass: "form-control selector o_turnaround",
    attrs: {
      "disabled": "disabled"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selected, "turnaround", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.checkProgress('turnaround', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.turnaroundOptions), function(turn) {
    return _c('option', {
      domProps: {
        "value": turn
      }
    }, [_vm._v(_vm._s(turn.turn) + _vm._s((turn.price > 0) ? '  ($' + parseFloat(turn.price).toFixed(2) + ')' : ''))])
  })], 2)])]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-20"
  }, [_c('label', {
    staticClass: "col-sm-5",
    attrs: {
      "for": "turnaround"
    }
  }, [_vm._v("\n            Shipping Address\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.shipping),
      expression: "selected.shipping"
    }],
    staticClass: "form-control o_shipping",
    attrs: {
      "disabled": "disabled"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selected, "shipping", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.checkProgress('shipping', $event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "new"
    }
  }, [_vm._v("+ New Address")]), _vm._v(" "), _c('option', {
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v("-------------------------------------")]), _vm._v(" "), _vm._l((_vm.addressList), function(address) {
    return _c('option', {
      domProps: {
        "value": address
      }
    }, [_vm._v(_vm._s(address.label))])
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn fast",
      "leave-active-class": "animated fadeOut fast"
    }
  }, [(_vm.selected.shipping !== 'null') ? _c('div', {
    staticClass: "m-l-10 m-t-10",
    domProps: {
      "innerHTML": _vm._s(_vm.printAddress(_vm.selected.shipping))
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-20"
  }, [_c('label', {
    staticClass: "col-sm-5",
    attrs: {
      "for": "turnaround"
    }
  }, [_vm._v("\n            Shipping Method\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.method),
      expression: "selected.method"
    }],
    staticClass: "form-control o_method",
    attrs: {
      "disabled": "disabled"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selected, "method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.checkProgress('method', $event);
        _vm.checkShipping()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.shippingOptions), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                    " + _vm._s((option.group_with_cart) ? 'Group Ship with Set ' + option.group_with_set : option.service_name + '  ($' + option.service_price + ')') + "\n                ")])
  })], 2), _vm._v(" "), (_vm.shippingNote) ? _c('p', {
    staticClass: "shippingNote",
    domProps: {
      "innerHTML": _vm._s(_vm.shippingNote)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li'), _vm._v(" "), (_vm.shippingTotal()) ? _c('li', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "pull-right m-b-20",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("$" + _vm._s(_vm.shippingTotal()))])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    class: {
      disabled: (_vm.proceed !== true)
    },
    on: {
      "click": function($event) {
        _vm.checkProceed()
      }
    }
  }, [_vm._v(_vm._s(_vm.button))])])]), _vm._v(" "), _c('AddressModal', {
    attrs: {
      "width": "500"
    },
    on: {
      "addressSaved": _vm.updateAddressOptions
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templateDesigner group p-20"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutUp"
    }
  }, [(!_vm.showFullService) ? _c('div', {
    staticClass: "design-options p-10 p-b-0 m-b-20 primarybg"
  }, [_c('a', {
    staticClass: "btn btn-outline-primary m-b-10 m-r-5 primaryborder notactive primaryaltbg",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "icon-angle-left m-r-5 primarytext"
  }), _vm._v(" Back to Designer")]), _vm._v(" "), (_vm.$auth.user().vendor) ? _c('button', {
    staticClass: "btn btn-outline-success solid m-b-10 right animated pulse primaryborder m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadFiles()
      }
    }
  }, [_vm._v("Download Files")]) : _vm._e()]) : _c('div', {
    staticClass: "design-options p-10 p-b-0 m-b-20 primarybg"
  }, [_c('h3', [_vm._v("EDDM Route Selection")]), _vm._v(" "), _c('p', {
    staticClass: "right notice"
  }, [_vm._v("Notice: If you leave this page before route selection is complete, you will lose your progress.")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mainSection"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInDown",
      "leave-active-class": "animated fadeOutUp"
    }
  }, [(_vm.showFullService) ? _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "position": "absolute",
      "left": "10px",
      "right": "10px",
      "width": "auto",
      "z-index": "10"
    }
  }, [_c('EddmMap', {
    attrs: {
      "accessToken": _vm.eddm_token,
      "colorspec": _vm.selected.colorspec,
      "date": _vm._f("moment")(_vm.selected.date, 'YYYY-MM-DD'),
      "runsize": _vm.selected.product.detail.data[0].runsize_uuid,
      "product": _vm.selected.product.id
    },
    on: {
      "saveEddmData": _vm.saveEddmData
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 design-preview"
  }, [_c('FilePreview', {
    ref: "preview"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 order-options"
  }, [(!_vm.downloadOnly) ? _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion-group-1"
    }
  }, [_c('div', {
    staticClass: "panel panel-default prod-approval panel-1 active"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-1', $event)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne-1",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('FileApproval', {
    on: {
      "next": _vm.nextAccordion,
      "preview": _vm.setPreview
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default prod-options panel-2"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-2', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseTwo-2",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.selected.product) ? 'Product:' : 'Product Options'))]), _vm._v(" " + _vm._s((_vm.selected.product) ? _vm.selected.product.description : '') + "\n                                    "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.selected.product_cost !== null && !this.$store.state.template.eddm_only) ? _c('span', {
    staticClass: "right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseTwo-2",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.products.length < 1) ? _c('p', {
    staticClass: "m-t-10"
  }, [_c('center', [_c('FulfillingBouncingCircleSpinner', {
    attrs: {
      "animation-duration": 2500,
      "size": 45,
      "color": '#232F4B'
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('ProductSelector', {
    attrs: {
      "products": _vm.products,
      "selected": _vm.selected,
      "eddmDates": _vm.eddm_dates,
      "button": (_vm.$store.state.template.eddm_only) ? 'Select EDDM Routes' : 'Select Shipping Options'
    },
    on: {
      "updateSelected": _vm.updateSelected,
      "next": _vm.nextAccordion
    }
  })], 1)])]), _vm._v(" "), (!this.$store.state.template.eddm_only) ? _c('div', {
    staticClass: "panel panel-default prod-shipping panel-3"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-3', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseThree-3",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v(_vm._s((_vm.selected.method) ? 'Shipping:' : 'Shipping & Turnaround'))]), _vm._v(" " + _vm._s((_vm.selected.method) ? _vm.selected.method.service_name : '') + "\n                                    "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.selected.method || _vm.selected.turnaround) ? _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s((_vm.selected.method && _vm.selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + _vm.calculateCost('shipping')))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseThree-3",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ShippingSelector', {
    ref: "shipping",
    attrs: {
      "products": _vm.products,
      "selected": _vm.selected,
      "button": "Continue to Summary"
    },
    on: {
      "updateSelected": _vm.updateSelected,
      "next": _vm.nextAccordion
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default prod-summary panel-4"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.setActivePanel('.panel-4', $event)
      }
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseFour-4",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v("Quick Summary")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [(_vm.calculateCost() > 0 && !this.$store.state.template.eddm_only) ? _c('span', {
    staticClass: "right"
  }, [_vm._v("Total: $" + _vm._s(_vm.calculateCost()))]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    staticStyle: {
      "height": "0px"
    },
    attrs: {
      "id": "collapseFour-4",
      "aria-expanded": "false"
    }
  }, [(!this.$store.state.template.eddm_only) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "group row m-b-0 "
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v(_vm._s((_vm.selected.product) ? _vm.selected.product.description : ''))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Order Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(new Date(), "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Subtotal: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Quantity: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.selected.runsizeDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_c('span', {
    staticClass: "shipping-type"
  }, [_vm._v("Shipping:")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s((_vm.selected.method && _vm.selected.method.group_with_cart) ? 'Calculated In Cart' : '$' + _vm.calculateCost('shipping')))])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost()))]), _c('br'), _c('small', [_vm._v("(not including tax)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.imagesProcessing.length > 0) ? _c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.stillProcessing()
      }
    }
  }, [_vm._v("Finishing up files, please wait..")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v("Add to Cart")])])])]) : (_vm.eddmData !== null) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "group row m-b-0"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v(_vm._s((_vm.selected.product) ? _vm.selected.product.description : ''))])])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Residential: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_res))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Routes: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_sel))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Business: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_bus))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.eddmData.map_event_data.tot_cnt))])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Order Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(new Date(), "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Product Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('product')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Delivery Date: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.selected.date, "MM/DD/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("EDDM Service Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('eddm_service')))])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Postage Cost: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost('shipping')))])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Total: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("$" + _vm._s(_vm.calculateCost()))]), _c('br'), _c('small', [_vm._v("(not including tax)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.imagesProcessing.length > 0) ? _c('button', {
    staticClass: "btn btn-warning pull-right",
    on: {
      "click": function($event) {
        _vm.stillProcessing()
      }
    }
  }, [_vm._v("Finishing up files, please wait..")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        _vm.addToCart()
      }
    }
  }, [_vm._v(_vm._s(_vm.cartButtonText))])])])]) : _vm._e()])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutRight"
    }
  }, _vm._l((_vm.imagesProcessing), function(item) {
    return (_vm.imagesProcessing.length > 0) ? _c('div', {
      key: item,
      staticClass: "panel panel-success m-t-5"
    }, [_c('div', {
      staticClass: "panel-heading p-l-10"
    }, [_c('h4', {
      staticClass: "panel-title"
    }, [_c('span', {
      staticClass: "left m-r-10 m-t-5"
    }, [_c('SpringSpinner', {
      attrs: {
        "animation-duration": 2000,
        "size": 14,
        "color": '#3C736D'
      }
    })], 1), _vm._v("\n                                    Processing " + _vm._s(item) + " file..\n                                ")])])]) : _vm._e()
  }), 0)], 1)]) : _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion-group-2"
    }
  }, [_c('div', {
    staticClass: "panel panel-default panel-1 active"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne-2",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("\n                                    This template does not yet have any products assigned to it."), _c('br'), _c('br'), _vm._v("\n                                    You can download the print ready files below:"), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-success solid m-b-10 primaryborder animated pulse m-t-20 m-b-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.downloadFiles()
      }
    }
  }, [_vm._v("Download Files")])])])])])])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-1",
      "href": "#collapseOne-1",
      "aria-expanded": "true"
    }
  }, [_c('span', [_vm._v("File Approval")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v("Product:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0 "
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Sets: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "m-t-5"
  }, [_c('h4', {
    staticClass: "m-t-0 m-b-0"
  }, [_vm._v("Full Service EDDM:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group row m-b-0"
  }, [_c('div', {
    staticClass: "col-sm-12 m-t-20"
  }, [_c('h4', [_vm._v("Product Information:")]), _vm._v(" "), _c('hr', {
    staticClass: "m-b-10",
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#fdfdfd"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4', [_vm._v("Sets: "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h4')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-group-2",
      "href": "#collapseOne-2",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                                    Download Files\n                                ")])])])
}]}

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_bootstrap_colorselector_min_js__ = __webpack_require__(388);


/* harmony default export */ __webpack_exports__["a"] = ({
    sytleInputs: function sytleInputs() {
        $('#colorselector').colorselector();
    },
    errorPop: function errorPop(title, message) {
        $.Notification.notify('error', 'top right', title, message);
    },
    successPop: function successPop(title, message) {
        $.Notification.notify('success', 'top right', title, message);
    },
    warningPop: function warningPop(title, message) {
        $.Notification.notify('warning', 'top right', title, message);
    },
    blackPop: function blackPop(title, message) {
        $.Notification.notify('black', 'top right', title, message);
    },
    infoPop: function infoPop(title, message) {
        $.Notification.notify('info', 'top right', title, message);
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/*
 * A colorselector for Twitter Bootstrap which lets you select a color from a predefined set of colors only.
 * https://github.com/flaute/bootstrap-colorselector
 *
 * Copyright (C) 2014 Flaute
 *
 * Licensed under the MIT license
 */
!function (t) {
  "use strict";
  var o = function o(_o, e) {
    this.options = e, this.$select = t(_o), this._init();
  };o.prototype = { constructor: o, _init: function _init() {
      var o = this.options.callback,
          e = this.$select.val(),
          a = this.$select.find("option:selected").data("color"),
          l = t("<ul>").addClass("dropdown-menu").addClass("dropdown-caret"),
          s = t("<div>").addClass("dropdown").addClass("dropdown-colorselector"),
          c = t("<span>").addClass("btn-colorselector").css("background-color", a),
          n = t("<a>").attr("data-toggle", "dropdown").addClass("dropdown-toggle").attr("href", "#").append(c);t("option", this.$select).each(function () {
        var o = t(this),
            a = o.attr("value"),
            s = o.data("color"),
            c = o.text(),
            n = t("<a>").addClass("color-btn");(o.prop("selected") === !0 || e === s) && n.addClass("selected"), n.css("background-color", s), n.attr("href", "#").attr("data-color", s).attr("data-value", a).attr("title", c), l.append(t("<li>").append(n));
      }), s.append(n), s.append(l), this.$select.hide(), this.$selector = t(s).insertAfter(this.$select), this.$select.on("change", function () {
        var e = t(this).val(),
            a = t(this).find("option[value='" + e + "']").data("color"),
            l = t(this).find("option[value='" + e + "']").text();t(this).next().find("ul").find("li").find(".selected").removeClass("selected"), t(this).next().find("ul").find("li").find("a[data-color='" + a + "']").addClass("selected"), t(this).next().find(".btn-colorselector").css("background-color", a), o(e, a, l);
      }), l.on("click.colorselector", t.proxy(this._clickColor, this));
    }, _clickColor: function _clickColor(o) {
      var e = t(o.target);return e.is(".color-btn") ? (this.$select.val(e.data("value")).change(), o.preventDefault(), !0) : !1;
    }, setColor: function setColor(o) {
      var e = t(this.$selector).find("li").find("a[data-color='" + o + "']").data("value");this.setValue(e);
    }, setValue: function setValue(t) {
      this.$select.val(t).change();
    } }, t.fn.colorselector = function (e) {
    var a = Array.apply(null, arguments);return a.shift(), this.each(function () {
      var l = t(this),
          s = l.data("colorselector"),
          c = t.extend({}, t.fn.colorselector.defaults, l.data(), "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) && e);s || l.data("colorselector", s = new o(this, c)), "string" == typeof e && s[e].apply(s, a);
    });
  }, t.fn.colorselector.defaults = { callback: function callback() {}, colorsPerRow: 8 }, t.fn.colorselector.Constructor = o;
}(jQuery, window, document);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init() {
        // View front / back flip toggle
        $('.viewfront').off('click').click(function () {
            $(this).addClass('btn-success').removeClass('btn-primary primarybg hover primaryborder');
            $(this).closest('.previewControls').find('.viewback').removeClass('btn-success').addClass('btn-primary primarybg hover primaryborder');
            $(this).closest('.previewPrint').find('.preview-flip-container').removeClass('hover');
        });

        // View front / back flip toggle
        $('.viewback').off('click').click(function () {
            $(this).addClass('btn-success').removeClass('btn-primary primarybg hover primaryborder');
            $(this).closest('.previewControls').find('.viewfront').removeClass('btn-success').addClass('btn-primary primarybg hover primaryborder');
            $(this).closest('.previewPrint').find('.preview-flip-container').addClass('hover');
        });

        $('.viewguides').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMargins').removeClass('hide');
                $(this).closest('.filePreview').find('.previewPrint').addClass('hide');
            } else {
                $(this).closest('.filePreview').find('.previewMargins').addClass('hide');
                $(this).closest('.filePreview').find('.previewPrint').removeClass('hide');
            }
        });

        // View masks toggle
        $('.spotuvmask').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMask1').removeClass('hide');
            } else {
                $(this).closest('.filePreview').find('.previewMask1').addClass('hide');
            }
        });

        // View masks 2 toggle
        $('.foilmask').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMask2').removeClass('hide');
            } else {
                $(this).closest('.filePreview').find('.previewMask2').addClass('hide');
            }
        });
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(391);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    user: null, // User data of logged in user
    token: null, // Token ID
    mode: 'designer', // Application mode designer, editor, preview
    show: null, // What templates to show on load
    cat: null, // What category to show
    config: {
        hideSideNav: true
    },
    templateList: null, // Full list of templates pulled from url
    fonts: [], // What fonts are available
    activeFonts: [], // What fonts are active in the current template
    fontsLoadedFor: null, // What template uuid the current loaded fonts belong to
    savedTemplate: null, // Saved template data injected into parent template
    templateName: null, // Name of the saved template
    template: null, // Full template data
    activeTemplate: null, // File side of the active template (front, back, etc)
    templateChanges: false, // Have changes been made to the template (bool)
    pickerUrl: null, // Last called url to fetch templates list
    pageUrl: 'https://www.primoprint.com/', // Parent Page URL (calling the iframe)
    pickerPage: 1, // Current page id of template list
    pickerState: { // Current state of filtering for template list
        category: null,
        size: null,
        spot_uv: null,
        foil: null,
        color: null
    }
};

var mutations = {
    user: function user(_user, data) {
        this.state.user = data;
    },
    token: function token(_token, data) {
        this.state.token = data;
    },
    mode: function mode(_mode, data) {
        this.state.mode = data;
    },
    show: function show(_show, data) {
        this.state.show = data;
    },
    cat: function cat(_cat, data) {
        this.state.cat = data;
    },
    templateList: function templateList(_templateList, data) {
        this.state.templateList = data;
    },
    fonts: function fonts(_fonts, data) {
        this.state.fonts = data;
    },
    activeFonts: function activeFonts(_activeFonts, data) {
        this.state.activeFonts = data;
    },
    fontsLoadedFor: function fontsLoadedFor(_fontsLoadedFor, data) {
        this.state.fontsLoadedFor = data;
    },
    template: function template(_template, data) {
        this.state.template = data;
    },
    savedTemplate: function savedTemplate(_savedTemplate, data) {
        this.state.savedTemplate = data;
    },
    activeTemplate: function activeTemplate(_activeTemplate, data) {
        this.state.activeTemplate = data;
    },
    templateName: function templateName(_templateName, data) {
        this.state.templateName = data;
    },
    templateChanges: function templateChanges(_templateChanges, data) {
        this.state.templateChanges = data;
    },
    pickerUrl: function pickerUrl(_pickerUrl, data) {
        this.state.pickerUrl = data;
    },
    pageUrl: function pageUrl(_pageUrl, data) {
        this.state.pageUrl = data;
    },
    pickerPage: function pickerPage(_pickerPage, data) {
        this.state.pickerPage = data;
    },
    pickerState: function pickerState(_pickerState, data) {
        this.state.pickerState = data;
    },
    config: function config(_config, data) {
        this.state.config = data;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    mutations: mutations
}));

/***/ })
],[93]);


// WEBPACK FOOTER //
// static/js/app.2c6a86e202beaebe3b14.js